
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("7AfLj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "DashboardEditable", () => $872b0d98ab184287$export$33b9febc64bdf6bf);
$parcel$export(module.exports, "default", () => $872b0d98ab184287$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2Zxiy = parcelRequire("2Zxiy");

var $9FSw2 = parcelRequire("9FSw2");

var $lL5b5 = parcelRequire("lL5b5");

var $JIPqS = parcelRequire("JIPqS");

var $iyrll = parcelRequire("iyrll");

var $32Vhm = parcelRequire("32Vhm");

var $1rce7 = parcelRequire("1rce7");

var $1CEw6 = parcelRequire("1CEw6");

var $5HxxK = parcelRequire("5HxxK");

var $4kIa4 = parcelRequire("4kIa4");

var $h7J1E = parcelRequire("h7J1E");

var $beRD7 = parcelRequire("beRD7");

var $koVbs = parcelRequire("koVbs");

var $6jY6G = parcelRequire("6jY6G");

var $gh1hi = parcelRequire("gh1hi");

var $9VXkC = parcelRequire("9VXkC");
var $7tQej = parcelRequire("7tQej");

var $8CCTB = parcelRequire("8CCTB");

var $dWAHS = parcelRequire("dWAHS");

var $fkN9I = parcelRequire("fkN9I");

var $1WOL5 = parcelRequire("1WOL5");

var $57x9W = parcelRequire("57x9W");

var $fVBqv = parcelRequire("fVBqv");


var $jd4if = parcelRequire("jd4if");

var $c92ZE = parcelRequire("c92ZE");

var $hsZLS = parcelRequire("hsZLS");
const $872b0d98ab184287$export$33b9febc64bdf6bf = ()=>{
    const { data: data, error: error, loading: loading } = (0, $gh1hi.useDashboardResource)();
    const { registerConnectGadget: registerConnectGadget, unregisterConnectGadget: unregisterConnectGadget, setCustomTitle: setCustomTitle } = (0, $h7J1E.useConnectGadgetTitles)();
    const setLayout = (0, $fkN9I.useLayoutChange)();
    const showLayoutFlag = (0, $hsZLS.useLayoutChangeErrorFlag)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onLayoutHandler = (0, $5uXOq.useCallback)((...args)=>{
        setLayout(...args).catch(showLayoutFlag);
    }, [
        setLayout,
        showLayoutFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4kIa4.DashboardContentContainer), {
        analyticsExperience: (0, $JIPqS.VIEW_DASHBOARD_EDITABLE_EXPERIENCE),
        saveCustomGadgetTitle: setCustomTitle,
        resourceData: {
            data: data,
            error: error,
            loading: loading
        },
        permissionErrorFallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.DashboardKnownErrorsPageAsync), {
            errorCode: (0, $8CCTB.getErrorCode)(error)
        })
    }, data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $32Vhm.DashboardController), {
        id: data.id,
        automaticRefreshMs: data.automaticRefreshMs
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWAHS.RightPanelLayoutContainer), {
        isOpenByDefault: true,
        defaultPanelId: `${(0, $0c49cfa6e72ac9c3$export$39a49c1fbe587c5b)}-0`,
        rightContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVBqv.AsyncAddGadgetPanel), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jd4if.HeaderEditable), {
        data: data,
        banners: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9FSw2.default), {
            appearance: "discovery"
        }, formatMessage((0, $1WOL5.default).editingInfo)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1CEw6.EngagementBanners), {
            gadgets: data.gadgets,
            dashboardId: data.id
        })),
        onLayoutSelected: onLayoutHandler
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5HxxK.ColumnLayout), {
        data: data,
        dnd: {
            DragDropContext: $2Zxiy.DragDropContext,
            Draggable: $2Zxiy.Draggable,
            Droppable: $2Zxiy.Droppable
        },
        columnPlaceholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c92ZE.ColumnPlaceholder), null),
        layoutPlaceholder: null,
        onLayoutReposition: onLayoutHandler
    }, ({ isAnyDragging: isAnyDragging, ...gadgetProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iyrll.DashboardControllerContextConsumer), null, ({ refreshId: refreshId, onMount: onMount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $57x9W.GadgetEditable), {
                ...gadgetProps,
                isConnectDisabled: isAnyDragging,
                dashboardId: data.id,
                refreshId: refreshId,
                onMount: onMount,
                onRegisterConnectGadget: registerConnectGadget,
                onUnregisterConnectGadget: unregisterConnectGadget
            }))))) : null);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$872b0d98ab184287$export$2e2bcd8739ae039 = ()=>{
    const { data: data, error: error, loading: loading } = (0, $gh1hi.useDashboardResource)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { path: viewPath } = (0, $6jY6G.useRouteByName)('dashboard-view') ?? {};
    const { path: systemDashboardPath } = (0, $6jY6G.useRouteByName)('system-dashboard-edit') ?? {};
    const { id: id, title: title } = data ?? {};
    if (id === (0, $JIPqS.SYSTEM_DASHBOARD_ID)) return systemDashboardPath != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: (0, $9VXkC.generatePath)(systemDashboardPath)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.DashboardKnownErrorsPageAsync), {
        errorCode: (0, $8CCTB.getErrorCode)(error)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rce7.DashboardPageContainer), {
        analyticsSourceName: (0, $JIPqS.DASHBOARD_EDIT_SOURCENAME),
        analyticsExperience: (0, $JIPqS.VIEW_DASHBOARD_EDITABLE_EXPERIENCE),
        documentTitle: title ? formatMessage((0, $1WOL5.default).pageTitle, {
            dashboardName: title
        }) : formatMessage((0, $1WOL5.default).pageTitleFallback),
        unauthorisedFallback: viewPath && id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: (0, $9VXkC.generatePath)(viewPath, {
                dashboardId: id
            })
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.DashboardKnownErrorsPageAsync), {
            errorCode: (0, $8CCTB.getErrorCode)(error)
        }),
        unauthenticatedFallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lL5b5.default), null),
        resourceData: {
            data: data,
            error: error,
            loading: loading
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($872b0d98ab184287$export$33b9febc64bdf6bf, null));
};

});
parcelRegister("2Zxiy", function(module, exports) {

$parcel$export(module.exports, "DragDropContext", () => $22db1ba098eb3017$export$237bd83162c14364);
$parcel$export(module.exports, "Draggable", () => $22db1ba098eb3017$export$f2a139e5d18b9882);
$parcel$export(module.exports, "Droppable", () => $22db1ba098eb3017$export$423ec2075359570a);

var $5uXOq = parcelRequire("5uXOq");

var $3YMLK = parcelRequire("3YMLK");

var $1AwyE = parcelRequire("1AwyE");

var $gzM5u = parcelRequire("gzM5u");

var $22j3V = parcelRequire("22j3V");
parcelRequire("i6AsN");
var $AuRrZ = parcelRequire("AuRrZ");
var $9bdMd = parcelRequire("9bdMd");

var $3YKxB = parcelRequire("3YKxB");

var $jQbLg = parcelRequire("jQbLg");

var $i2aN7 = parcelRequire("i2aN7");

var $cs3hJ = parcelRequire("cs3hJ");

var $7qpjg = parcelRequire("7qpjg");

var $3BSY2 = parcelRequire("3BSY2");

var $4iZOV = parcelRequire("4iZOV");

var $7nsd3 = parcelRequire("7nsd3");

var $1DIXK = parcelRequire("1DIXK");
var $22db1ba098eb3017$var$isProduction = true;
var $22db1ba098eb3017$var$spacesAndTabs = /[ \t]{2,}/g;
var $22db1ba098eb3017$var$lineStartWithSpaces = /^[ \t]*/gm;
var $22db1ba098eb3017$var$clean = function clean(value) {
    return value.replace($22db1ba098eb3017$var$spacesAndTabs, ' ').replace($22db1ba098eb3017$var$lineStartWithSpaces, '').trim();
};
var $22db1ba098eb3017$var$getDevMessage = function getDevMessage(message) {
    return $22db1ba098eb3017$var$clean("\n  %creact-beautiful-dnd\n\n  %c" + $22db1ba098eb3017$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n");
};
var $22db1ba098eb3017$var$getFormattedMessage = function getFormattedMessage(message) {
    return [
        $22db1ba098eb3017$var$getDevMessage(message),
        'color: #00C584; font-size: 1.2em; font-weight: bold;',
        'line-height: 1.5',
        'color: #723874;'
    ];
};
var $22db1ba098eb3017$var$isDisabledFlag = '__react-beautiful-dnd-disable-dev-warnings';
function $22db1ba098eb3017$var$log(type, message) {
    var _console;
    if ($22db1ba098eb3017$var$isProduction) return;
    if (typeof window !== 'undefined' && window[$22db1ba098eb3017$var$isDisabledFlag]) return;
    (_console = console)[type].apply(_console, $22db1ba098eb3017$var$getFormattedMessage(message));
}
var $22db1ba098eb3017$var$warning = $22db1ba098eb3017$var$log.bind(null, 'warn');
var $22db1ba098eb3017$var$error = $22db1ba098eb3017$var$log.bind(null, 'error');
function $22db1ba098eb3017$var$noop() {}
function $22db1ba098eb3017$var$getOptions(shared, fromBinding) {
    return (0, $gzM5u.default)({}, shared, fromBinding);
}
function $22db1ba098eb3017$var$bindEvents(el, bindings, sharedOptions) {
    var unbindings = bindings.map(function(binding) {
        var options = $22db1ba098eb3017$var$getOptions(sharedOptions, binding.options);
        el.addEventListener(binding.eventName, binding.fn, options);
        return function unbind() {
            el.removeEventListener(binding.eventName, binding.fn, options);
        };
    });
    return function unbindAll() {
        unbindings.forEach(function(unbind) {
            unbind();
        });
    };
}
var $22db1ba098eb3017$var$isProduction$1 = true;
var $22db1ba098eb3017$var$prefix = 'Invariant failed';
function $22db1ba098eb3017$var$RbdInvariant(message) {
    this.message = message;
}
$22db1ba098eb3017$var$RbdInvariant.prototype.toString = function toString() {
    return this.message;
};
function $22db1ba098eb3017$var$invariant(condition, message) {
    if (condition) return;
    if ($22db1ba098eb3017$var$isProduction$1) throw new $22db1ba098eb3017$var$RbdInvariant($22db1ba098eb3017$var$prefix);
    else throw new $22db1ba098eb3017$var$RbdInvariant($22db1ba098eb3017$var$prefix + ": " + (message || ''));
}
var $22db1ba098eb3017$var$ErrorBoundary = function(_React$Component) {
    (0, $1AwyE.default)(ErrorBoundary, _React$Component);
    function ErrorBoundary() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.callbacks = null;
        _this.unbind = $22db1ba098eb3017$var$noop;
        _this.onWindowError = function(event) {
            var callbacks = _this.getCallbacks();
            if (callbacks.isDragging()) callbacks.tryAbort();
            var err = event.error;
            if (err instanceof $22db1ba098eb3017$var$RbdInvariant) event.preventDefault();
        };
        _this.getCallbacks = function() {
            if (!_this.callbacks) throw new Error('Unable to find AppCallbacks in <ErrorBoundary/>');
            return _this.callbacks;
        };
        _this.setCallbacks = function(callbacks) {
            _this.callbacks = callbacks;
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.unbind = $22db1ba098eb3017$var$bindEvents(window, [
            {
                eventName: 'error',
                fn: this.onWindowError
            }
        ]);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unbind();
    };
    _proto.componentDidCatch = function componentDidCatch(err) {
        if (err instanceof $22db1ba098eb3017$var$RbdInvariant) {
            this.setState({});
            return;
        }
        throw err;
    };
    _proto.render = function render() {
        return this.props.children(this.setCallbacks);
    };
    return ErrorBoundary;
}((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component);
var $22db1ba098eb3017$var$liftInstruction = "Draggable item. Ensure your screen reader is not in browse mode and then press space bar to lift.";
var $22db1ba098eb3017$var$position = function position(index) {
    return index + 1;
};
var $22db1ba098eb3017$var$onDragStart = function onDragStart(start) {
    return "\n  You have lifted an item in position " + $22db1ba098eb3017$var$position(start.source.index) + ".\n  Use the arrow keys to move, space bar to drop, and escape to cancel.\n";
};
var $22db1ba098eb3017$var$withLocation = function withLocation(source, destination) {
    var isInHomeList = source.droppableId === destination.droppableId;
    var startPosition = $22db1ba098eb3017$var$position(source.index);
    var endPosition = $22db1ba098eb3017$var$position(destination.index);
    if (isInHomeList) return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
    return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};
var $22db1ba098eb3017$var$withCombine = function withCombine(id, source, combine) {
    var inHomeList = source.droppableId === combine.droppableId;
    if (inHomeList) return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
    return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};
var $22db1ba098eb3017$var$onDragUpdate = function onDragUpdate(update) {
    var location = update.destination;
    if (location) return $22db1ba098eb3017$var$withLocation(update.source, location);
    var combine = update.combine;
    if (combine) return $22db1ba098eb3017$var$withCombine(update.draggableId, update.source, combine);
    return 'You are over an area that cannot be dropped on';
};
var $22db1ba098eb3017$var$returnedToStart = function returnedToStart(source) {
    return "\n  The item has returned to its starting position\n  of " + $22db1ba098eb3017$var$position(source.index) + "\n";
};
var $22db1ba098eb3017$var$onDragEnd = function onDragEnd(result) {
    if (result.reason === 'CANCEL') return "\n      Movement cancelled.\n      " + $22db1ba098eb3017$var$returnedToStart(result.source) + "\n    ";
    var location = result.destination;
    var combine = result.combine;
    if (location) return "\n      You have dropped the item.\n      " + $22db1ba098eb3017$var$withLocation(result.source, location) + "\n    ";
    if (combine) return "\n      You have dropped the item.\n      " + $22db1ba098eb3017$var$withCombine(result.draggableId, result.source, combine) + "\n    ";
    return "\n    The item has been dropped while not over a drop area.\n    " + $22db1ba098eb3017$var$returnedToStart(result.source) + "\n  ";
};
var $22db1ba098eb3017$var$preset = {
    liftInstruction: $22db1ba098eb3017$var$liftInstruction,
    onDragStart: $22db1ba098eb3017$var$onDragStart,
    onDragUpdate: $22db1ba098eb3017$var$onDragUpdate,
    onDragEnd: $22db1ba098eb3017$var$onDragEnd
};
var $22db1ba098eb3017$var$origin = {
    x: 0,
    y: 0
};
var $22db1ba098eb3017$var$add = function add(point1, point2) {
    return {
        x: point1.x + point2.x,
        y: point1.y + point2.y
    };
};
var $22db1ba098eb3017$var$subtract = function subtract(point1, point2) {
    return {
        x: point1.x - point2.x,
        y: point1.y - point2.y
    };
};
var $22db1ba098eb3017$var$isEqual = function isEqual(point1, point2) {
    return point1.x === point2.x && point1.y === point2.y;
};
var $22db1ba098eb3017$var$negate = function negate(point) {
    return {
        x: point.x !== 0 ? -point.x : 0,
        y: point.y !== 0 ? -point.y : 0
    };
};
var $22db1ba098eb3017$var$patch = function patch(line, value, otherValue) {
    var _ref;
    if (otherValue === void 0) otherValue = 0;
    return _ref = {}, _ref[line] = value, _ref[line === 'x' ? 'y' : 'x'] = otherValue, _ref;
};
var $22db1ba098eb3017$var$distance = function distance(point1, point2) {
    return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var $22db1ba098eb3017$var$closest = function closest(target, points) {
    return Math.min.apply(Math, points.map(function(point) {
        return $22db1ba098eb3017$var$distance(target, point);
    }));
};
var $22db1ba098eb3017$var$apply = function apply(fn) {
    return function(point) {
        return {
            x: fn(point.x),
            y: fn(point.y)
        };
    };
};
var $22db1ba098eb3017$var$executeClip = function(frame, subject) {
    var result = (0, $3YKxB.getRect)({
        top: Math.max(subject.top, frame.top),
        right: Math.min(subject.right, frame.right),
        bottom: Math.min(subject.bottom, frame.bottom),
        left: Math.max(subject.left, frame.left)
    });
    if (result.width <= 0 || result.height <= 0) return null;
    return result;
};
var $22db1ba098eb3017$var$offsetByPosition = function offsetByPosition(spacing, point) {
    return {
        top: spacing.top + point.y,
        left: spacing.left + point.x,
        bottom: spacing.bottom + point.y,
        right: spacing.right + point.x
    };
};
var $22db1ba098eb3017$var$getCorners = function getCorners(spacing) {
    return [
        {
            x: spacing.left,
            y: spacing.top
        },
        {
            x: spacing.right,
            y: spacing.top
        },
        {
            x: spacing.left,
            y: spacing.bottom
        },
        {
            x: spacing.right,
            y: spacing.bottom
        }
    ];
};
var $22db1ba098eb3017$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $22db1ba098eb3017$var$scroll = function scroll(target, frame) {
    if (!frame) return target;
    return $22db1ba098eb3017$var$offsetByPosition(target, frame.scroll.diff.displacement);
};
var $22db1ba098eb3017$var$increase = function increase(target, axis, withPlaceholder) {
    if (withPlaceholder && withPlaceholder.increasedBy) {
        var _extends2;
        return (0, $gzM5u.default)({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
    }
    return target;
};
var $22db1ba098eb3017$var$clip = function clip(target, frame) {
    if (frame && frame.shouldClipSubject) return $22db1ba098eb3017$var$executeClip(frame.pageMarginBox, target);
    return (0, $3YKxB.getRect)(target);
};
var $22db1ba098eb3017$var$getSubject = function(_ref) {
    var page = _ref.page, withPlaceholder = _ref.withPlaceholder, axis = _ref.axis, frame = _ref.frame;
    var scrolled = $22db1ba098eb3017$var$scroll(page.marginBox, frame);
    var increased = $22db1ba098eb3017$var$increase(scrolled, axis, withPlaceholder);
    var clipped = $22db1ba098eb3017$var$clip(increased, frame);
    return {
        page: page,
        withPlaceholder: withPlaceholder,
        active: clipped
    };
};
var $22db1ba098eb3017$var$scrollDroppable = function(droppable, newScroll) {
    !droppable.frame && $22db1ba098eb3017$var$invariant(false);
    var scrollable = droppable.frame;
    var scrollDiff = $22db1ba098eb3017$var$subtract(newScroll, scrollable.scroll.initial);
    var scrollDisplacement = $22db1ba098eb3017$var$negate(scrollDiff);
    var frame = (0, $gzM5u.default)({}, scrollable, {
        scroll: {
            initial: scrollable.scroll.initial,
            current: newScroll,
            diff: {
                value: scrollDiff,
                displacement: scrollDisplacement
            },
            max: scrollable.scroll.max
        }
    });
    var subject = $22db1ba098eb3017$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: droppable.subject.withPlaceholder,
        axis: droppable.axis,
        frame: frame
    });
    var result = (0, $gzM5u.default)({}, droppable, {
        frame: frame,
        subject: subject
    });
    return result;
};
function $22db1ba098eb3017$var$values(map) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($i2aN7)))(map);
}
function $22db1ba098eb3017$var$findIndex(list, predicate) {
    if (list.findIndex) return list.findIndex(predicate);
    for(var i = 0; i < list.length; i++){
        if (predicate(list[i])) return i;
    }
    return -1;
}
function $22db1ba098eb3017$var$find(list, predicate) {
    if (list.find) return list.find(predicate);
    var index = $22db1ba098eb3017$var$findIndex(list, predicate);
    if (index !== -1) return list[index];
    return undefined;
}
function $22db1ba098eb3017$var$toArray(list) {
    return Array.prototype.slice.call(list);
}
var $22db1ba098eb3017$var$toDroppableMap = (0, $jQbLg.default)(function(droppables) {
    return droppables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $22db1ba098eb3017$var$toDraggableMap = (0, $jQbLg.default)(function(draggables) {
    return draggables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $22db1ba098eb3017$var$toDroppableList = (0, $jQbLg.default)(function(droppables) {
    return $22db1ba098eb3017$var$values(droppables);
});
var $22db1ba098eb3017$var$toDraggableList = (0, $jQbLg.default)(function(draggables) {
    return $22db1ba098eb3017$var$values(draggables);
});
var $22db1ba098eb3017$var$getDraggablesInsideDroppable = (0, $jQbLg.default)(function(droppableId, draggables) {
    var result = $22db1ba098eb3017$var$toDraggableList(draggables).filter(function(draggable) {
        return droppableId === draggable.descriptor.droppableId;
    }).sort(function(a, b) {
        return a.descriptor.index - b.descriptor.index;
    });
    return result;
});
function $22db1ba098eb3017$var$tryGetDestination(impact) {
    if (impact.at && impact.at.type === 'REORDER') return impact.at.destination;
    return null;
}
function $22db1ba098eb3017$var$tryGetCombine(impact) {
    if (impact.at && impact.at.type === 'COMBINE') return impact.at.combine;
    return null;
}
var $22db1ba098eb3017$var$removeDraggableFromList = (0, $jQbLg.default)(function(remove, list) {
    return list.filter(function(item) {
        return item.descriptor.id !== remove.descriptor.id;
    });
});
var $22db1ba098eb3017$var$moveToNextCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact;
    if (!destination.isCombineEnabled) return null;
    var location = $22db1ba098eb3017$var$tryGetDestination(previousImpact);
    if (!location) return null;
    function getImpact(target) {
        var at = {
            type: 'COMBINE',
            combine: {
                draggableId: target,
                droppableId: destination.descriptor.id
            }
        };
        return (0, $gzM5u.default)({}, previousImpact, {
            at: at
        });
    }
    var all = previousImpact.displaced.all;
    var closestId = all.length ? all[0] : null;
    if (isMovingForward) return closestId ? getImpact(closestId) : null;
    var withoutDraggable = $22db1ba098eb3017$var$removeDraggableFromList(draggable, insideDestination);
    if (!closestId) {
        if (!withoutDraggable.length) return null;
        var last = withoutDraggable[withoutDraggable.length - 1];
        return getImpact(last.descriptor.id);
    }
    var indexOfClosest = $22db1ba098eb3017$var$findIndex(withoutDraggable, function(d) {
        return d.descriptor.id === closestId;
    });
    !(indexOfClosest !== -1) && $22db1ba098eb3017$var$invariant(false);
    var proposedIndex = indexOfClosest - 1;
    if (proposedIndex < 0) return null;
    var before = withoutDraggable[proposedIndex];
    return getImpact(before.descriptor.id);
};
var $22db1ba098eb3017$var$isHomeOf = function(draggable, destination) {
    return draggable.descriptor.droppableId === destination.descriptor.id;
};
var $22db1ba098eb3017$var$noDisplacedBy = {
    point: $22db1ba098eb3017$var$origin,
    value: 0
};
var $22db1ba098eb3017$var$emptyGroups = {
    invisible: {},
    visible: {},
    all: []
};
var $22db1ba098eb3017$var$noImpact = {
    displaced: $22db1ba098eb3017$var$emptyGroups,
    displacedBy: $22db1ba098eb3017$var$noDisplacedBy,
    at: null
};
var $22db1ba098eb3017$var$isWithin = function(lowerBound, upperBound) {
    return function(value) {
        return lowerBound <= value && value <= upperBound;
    };
};
var $22db1ba098eb3017$var$isPartiallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $22db1ba098eb3017$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $22db1ba098eb3017$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        if (isContained) return true;
        var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
        var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
        var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;
        if (isPartiallyContained) return true;
        var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
        var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
        var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;
        if (isTargetBiggerThanFrame) return true;
        var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
        return isTargetBiggerOnOneAxis;
    };
};
var $22db1ba098eb3017$var$isTotallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $22db1ba098eb3017$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $22db1ba098eb3017$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        return isContained;
    };
};
var $22db1ba098eb3017$var$vertical = {
    direction: 'vertical',
    line: 'y',
    crossAxisLine: 'x',
    start: 'top',
    end: 'bottom',
    size: 'height',
    crossAxisStart: 'left',
    crossAxisEnd: 'right',
    crossAxisSize: 'width'
};
var $22db1ba098eb3017$var$horizontal = {
    direction: 'horizontal',
    line: 'x',
    crossAxisLine: 'y',
    start: 'left',
    end: 'right',
    size: 'width',
    crossAxisStart: 'top',
    crossAxisEnd: 'bottom',
    crossAxisSize: 'height'
};
var $22db1ba098eb3017$var$isTotallyVisibleThroughFrameOnAxis = function(axis) {
    return function(frame) {
        var isWithinVertical = $22db1ba098eb3017$var$isWithin(frame.top, frame.bottom);
        var isWithinHorizontal = $22db1ba098eb3017$var$isWithin(frame.left, frame.right);
        return function(subject) {
            if (axis === $22db1ba098eb3017$var$vertical) return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
            return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        };
    };
};
var $22db1ba098eb3017$var$getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
    var displacement = destination.frame ? destination.frame.scroll.diff.displacement : $22db1ba098eb3017$var$origin;
    return $22db1ba098eb3017$var$offsetByPosition(target, displacement);
};
var $22db1ba098eb3017$var$isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
    if (!destination.subject.active) return false;
    return isVisibleThroughFrameFn(destination.subject.active)(target);
};
var $22db1ba098eb3017$var$isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
    return isVisibleThroughFrameFn(viewport)(target);
};
var $22db1ba098eb3017$var$isVisible = function isVisible(_ref) {
    var toBeDisplaced = _ref.target, destination = _ref.destination, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
    var displacedTarget = withDroppableDisplacement ? $22db1ba098eb3017$var$getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
    return $22db1ba098eb3017$var$isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && $22db1ba098eb3017$var$isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};
var $22db1ba098eb3017$var$isPartiallyVisible = function isPartiallyVisible(args) {
    return $22db1ba098eb3017$var$isVisible((0, $gzM5u.default)({}, args, {
        isVisibleThroughFrameFn: $22db1ba098eb3017$var$isPartiallyVisibleThroughFrame
    }));
};
var $22db1ba098eb3017$var$isTotallyVisible = function isTotallyVisible(args) {
    return $22db1ba098eb3017$var$isVisible((0, $gzM5u.default)({}, args, {
        isVisibleThroughFrameFn: $22db1ba098eb3017$var$isTotallyVisibleThroughFrame
    }));
};
var $22db1ba098eb3017$var$isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
    return $22db1ba098eb3017$var$isVisible((0, $gzM5u.default)({}, args, {
        isVisibleThroughFrameFn: $22db1ba098eb3017$var$isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
    }));
};
var $22db1ba098eb3017$var$getShouldAnimate = function getShouldAnimate(id, last, forceShouldAnimate) {
    if (typeof forceShouldAnimate === 'boolean') return forceShouldAnimate;
    if (!last) return true;
    var invisible = last.invisible, visible = last.visible;
    if (invisible[id]) return false;
    var previous = visible[id];
    return previous ? previous.shouldAnimate : true;
};
function $22db1ba098eb3017$var$getTarget(draggable, displacedBy) {
    var marginBox = draggable.page.marginBox;
    var expandBy = {
        top: displacedBy.point.y,
        right: 0,
        bottom: 0,
        left: displacedBy.point.x
    };
    return (0, $3YKxB.getRect)((0, $3YKxB.expand)(marginBox, expandBy));
}
function $22db1ba098eb3017$var$getDisplacementGroups(_ref) {
    var afterDragging = _ref.afterDragging, destination = _ref.destination, displacedBy = _ref.displacedBy, viewport = _ref.viewport, forceShouldAnimate = _ref.forceShouldAnimate, last = _ref.last;
    return afterDragging.reduce(function process(groups, draggable) {
        var target = $22db1ba098eb3017$var$getTarget(draggable, displacedBy);
        var id = draggable.descriptor.id;
        groups.all.push(id);
        var isVisible = $22db1ba098eb3017$var$isPartiallyVisible({
            target: target,
            destination: destination,
            viewport: viewport,
            withDroppableDisplacement: true
        });
        if (!isVisible) {
            groups.invisible[draggable.descriptor.id] = true;
            return groups;
        }
        var shouldAnimate = $22db1ba098eb3017$var$getShouldAnimate(id, last, forceShouldAnimate);
        var displacement = {
            draggableId: id,
            shouldAnimate: shouldAnimate
        };
        groups.visible[id] = displacement;
        return groups;
    }, {
        all: [],
        visible: {},
        invisible: {}
    });
}
function $22db1ba098eb3017$var$getIndexOfLastItem(draggables, options) {
    if (!draggables.length) return 0;
    var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
    return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}
function $22db1ba098eb3017$var$goAtEnd(_ref) {
    var insideDestination = _ref.insideDestination, inHomeList = _ref.inHomeList, displacedBy = _ref.displacedBy, destination = _ref.destination;
    var newIndex = $22db1ba098eb3017$var$getIndexOfLastItem(insideDestination, {
        inHomeList: inHomeList
    });
    return {
        displaced: $22db1ba098eb3017$var$emptyGroups,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: {
                droppableId: destination.descriptor.id,
                index: newIndex
            }
        }
    };
}
function $22db1ba098eb3017$var$calculateReorderImpact(_ref2) {
    var draggable = _ref2.draggable, insideDestination = _ref2.insideDestination, destination = _ref2.destination, viewport = _ref2.viewport, displacedBy = _ref2.displacedBy, last = _ref2.last, index = _ref2.index, forceShouldAnimate = _ref2.forceShouldAnimate;
    var inHomeList = $22db1ba098eb3017$var$isHomeOf(draggable, destination);
    if (index == null) return $22db1ba098eb3017$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var match = $22db1ba098eb3017$var$find(insideDestination, function(item) {
        return item.descriptor.index === index;
    });
    if (!match) return $22db1ba098eb3017$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var withoutDragging = $22db1ba098eb3017$var$removeDraggableFromList(draggable, insideDestination);
    var sliceFrom = insideDestination.indexOf(match);
    var impacted = withoutDragging.slice(sliceFrom);
    var displaced = $22db1ba098eb3017$var$getDisplacementGroups({
        afterDragging: impacted,
        destination: destination,
        displacedBy: displacedBy,
        last: last,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate
    });
    return {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: {
                droppableId: destination.descriptor.id,
                index: index
            }
        }
    };
}
function $22db1ba098eb3017$var$didStartAfterCritical(draggableId, afterCritical) {
    return Boolean(afterCritical.effected[draggableId]);
}
var $22db1ba098eb3017$var$fromCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, destination = _ref.destination, draggables = _ref.draggables, combine = _ref.combine, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var combineId = combine.draggableId;
    var combineWith = draggables[combineId];
    var combineWithIndex = combineWith.descriptor.index;
    var didCombineWithStartAfterCritical = $22db1ba098eb3017$var$didStartAfterCritical(combineId, afterCritical);
    if (didCombineWithStartAfterCritical) {
        if (isMovingForward) return combineWithIndex;
        return combineWithIndex - 1;
    }
    if (isMovingForward) return combineWithIndex + 1;
    return combineWithIndex;
};
var $22db1ba098eb3017$var$fromReorder = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, insideDestination = _ref.insideDestination, location = _ref.location;
    if (!insideDestination.length) return null;
    var currentIndex = location.index;
    var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
    var firstIndex = insideDestination[0].descriptor.index;
    var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
    var upperBound = isInHomeList ? lastIndex : lastIndex + 1;
    if (proposedIndex < firstIndex) return null;
    if (proposedIndex > upperBound) return null;
    return proposedIndex;
};
var $22db1ba098eb3017$var$moveToNextIndex = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var wasAt = previousImpact.at;
    !wasAt && $22db1ba098eb3017$var$invariant(false);
    if (wasAt.type === 'REORDER') {
        var _newIndex = $22db1ba098eb3017$var$fromReorder({
            isMovingForward: isMovingForward,
            isInHomeList: isInHomeList,
            location: wasAt.destination,
            insideDestination: insideDestination
        });
        if (_newIndex == null) return null;
        return $22db1ba098eb3017$var$calculateReorderImpact({
            draggable: draggable,
            insideDestination: insideDestination,
            destination: destination,
            viewport: viewport,
            last: previousImpact.displaced,
            displacedBy: previousImpact.displacedBy,
            index: _newIndex
        });
    }
    var newIndex = $22db1ba098eb3017$var$fromCombine({
        isMovingForward: isMovingForward,
        destination: destination,
        displaced: previousImpact.displaced,
        draggables: draggables,
        combine: wasAt.combine,
        afterCritical: afterCritical
    });
    if (newIndex == null) return null;
    return $22db1ba098eb3017$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: previousImpact.displaced,
        displacedBy: previousImpact.displacedBy,
        index: newIndex
    });
};
var $22db1ba098eb3017$var$getCombinedItemDisplacement = function(_ref) {
    var displaced = _ref.displaced, afterCritical = _ref.afterCritical, combineWith = _ref.combineWith, displacedBy = _ref.displacedBy;
    var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);
    if ($22db1ba098eb3017$var$didStartAfterCritical(combineWith, afterCritical)) return isDisplaced ? $22db1ba098eb3017$var$origin : $22db1ba098eb3017$var$negate(displacedBy.point);
    return isDisplaced ? displacedBy.point : $22db1ba098eb3017$var$origin;
};
var $22db1ba098eb3017$var$whenCombining = function(_ref) {
    var afterCritical = _ref.afterCritical, impact = _ref.impact, draggables = _ref.draggables;
    var combine = $22db1ba098eb3017$var$tryGetCombine(impact);
    !combine && $22db1ba098eb3017$var$invariant(false);
    var combineWith = combine.draggableId;
    var center = draggables[combineWith].page.borderBox.center;
    var displaceBy = $22db1ba098eb3017$var$getCombinedItemDisplacement({
        displaced: impact.displaced,
        afterCritical: afterCritical,
        combineWith: combineWith,
        displacedBy: impact.displacedBy
    });
    return $22db1ba098eb3017$var$add(center, displaceBy);
};
var $22db1ba098eb3017$var$distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
    return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};
var $22db1ba098eb3017$var$distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
    return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};
var $22db1ba098eb3017$var$getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
    return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};
var $22db1ba098eb3017$var$goAfter = function goAfter(_ref) {
    var axis = _ref.axis, moveRelativeTo = _ref.moveRelativeTo, isMoving = _ref.isMoving;
    return $22db1ba098eb3017$var$patch(axis.line, moveRelativeTo.marginBox[axis.end] + $22db1ba098eb3017$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $22db1ba098eb3017$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $22db1ba098eb3017$var$goBefore = function goBefore(_ref2) {
    var axis = _ref2.axis, moveRelativeTo = _ref2.moveRelativeTo, isMoving = _ref2.isMoving;
    return $22db1ba098eb3017$var$patch(axis.line, moveRelativeTo.marginBox[axis.start] - $22db1ba098eb3017$var$distanceFromEndToBorderBoxCenter(axis, isMoving), $22db1ba098eb3017$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $22db1ba098eb3017$var$goIntoStart = function goIntoStart(_ref3) {
    var axis = _ref3.axis, moveInto = _ref3.moveInto, isMoving = _ref3.isMoving;
    return $22db1ba098eb3017$var$patch(axis.line, moveInto.contentBox[axis.start] + $22db1ba098eb3017$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $22db1ba098eb3017$var$getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};
var $22db1ba098eb3017$var$whenReordering = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, draggables = _ref.draggables, droppable = _ref.droppable, afterCritical = _ref.afterCritical;
    var insideDestination = $22db1ba098eb3017$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var draggablePage = draggable.page;
    var axis = droppable.axis;
    if (!insideDestination.length) return $22db1ba098eb3017$var$goIntoStart({
        axis: axis,
        moveInto: droppable.page,
        isMoving: draggablePage
    });
    var displaced = impact.displaced, displacedBy = impact.displacedBy;
    var closestAfter = displaced.all[0];
    if (closestAfter) {
        var closest = draggables[closestAfter];
        if ($22db1ba098eb3017$var$didStartAfterCritical(closestAfter, afterCritical)) return $22db1ba098eb3017$var$goBefore({
            axis: axis,
            moveRelativeTo: closest.page,
            isMoving: draggablePage
        });
        var withDisplacement = (0, $3YKxB.offset)(closest.page, displacedBy.point);
        return $22db1ba098eb3017$var$goBefore({
            axis: axis,
            moveRelativeTo: withDisplacement,
            isMoving: draggablePage
        });
    }
    var last = insideDestination[insideDestination.length - 1];
    if (last.descriptor.id === draggable.descriptor.id) return draggablePage.borderBox.center;
    if ($22db1ba098eb3017$var$didStartAfterCritical(last.descriptor.id, afterCritical)) {
        var page = (0, $3YKxB.offset)(last.page, $22db1ba098eb3017$var$negate(afterCritical.displacedBy.point));
        return $22db1ba098eb3017$var$goAfter({
            axis: axis,
            moveRelativeTo: page,
            isMoving: draggablePage
        });
    }
    return $22db1ba098eb3017$var$goAfter({
        axis: axis,
        moveRelativeTo: last.page,
        isMoving: draggablePage
    });
};
var $22db1ba098eb3017$var$withDroppableDisplacement = function(droppable, point) {
    var frame = droppable.frame;
    if (!frame) return point;
    return $22db1ba098eb3017$var$add(point, frame.scroll.diff.displacement);
};
var $22db1ba098eb3017$var$getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, afterCritical = _ref.afterCritical;
    var original = draggable.page.borderBox.center;
    var at = impact.at;
    if (!droppable) return original;
    if (!at) return original;
    if (at.type === 'REORDER') return $22db1ba098eb3017$var$whenReordering({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $22db1ba098eb3017$var$whenCombining({
        impact: impact,
        draggables: draggables,
        afterCritical: afterCritical
    });
};
var $22db1ba098eb3017$var$getPageBorderBoxCenterFromImpact = function(args) {
    var withoutDisplacement = $22db1ba098eb3017$var$getResultWithoutDroppableDisplacement(args);
    var droppable = args.droppable;
    var withDisplacement = droppable ? $22db1ba098eb3017$var$withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
    return withDisplacement;
};
var $22db1ba098eb3017$var$scrollViewport = function(viewport, newScroll) {
    var diff = $22db1ba098eb3017$var$subtract(newScroll, viewport.scroll.initial);
    var displacement = $22db1ba098eb3017$var$negate(diff);
    var frame = (0, $3YKxB.getRect)({
        top: newScroll.y,
        bottom: newScroll.y + viewport.frame.height,
        left: newScroll.x,
        right: newScroll.x + viewport.frame.width
    });
    var updated = {
        frame: frame,
        scroll: {
            initial: viewport.scroll.initial,
            max: viewport.scroll.max,
            current: newScroll,
            diff: {
                value: diff,
                displacement: displacement
            }
        }
    };
    return updated;
};
function $22db1ba098eb3017$var$getDraggables(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
function $22db1ba098eb3017$var$tryGetVisible(id, groups) {
    for(var i = 0; i < groups.length; i++){
        var displacement = groups[i].visible[id];
        if (displacement) return displacement;
    }
    return null;
}
var $22db1ba098eb3017$var$speculativelyIncrease = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, destination = _ref.destination, draggables = _ref.draggables, maxScrollChange = _ref.maxScrollChange;
    var scrolledViewport = $22db1ba098eb3017$var$scrollViewport(viewport, $22db1ba098eb3017$var$add(viewport.scroll.current, maxScrollChange));
    var scrolledDroppable = destination.frame ? $22db1ba098eb3017$var$scrollDroppable(destination, $22db1ba098eb3017$var$add(destination.frame.scroll.current, maxScrollChange)) : destination;
    var last = impact.displaced;
    var withViewportScroll = $22db1ba098eb3017$var$getDisplacementGroups({
        afterDragging: $22db1ba098eb3017$var$getDraggables(last.all, draggables),
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: scrolledViewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var withDroppableScroll = $22db1ba098eb3017$var$getDisplacementGroups({
        afterDragging: $22db1ba098eb3017$var$getDraggables(last.all, draggables),
        destination: scrolledDroppable,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var invisible = {};
    var visible = {};
    var groups = [
        last,
        withViewportScroll,
        withDroppableScroll
    ];
    last.all.forEach(function(id) {
        var displacement = $22db1ba098eb3017$var$tryGetVisible(id, groups);
        if (displacement) {
            visible[id] = displacement;
            return;
        }
        invisible[id] = true;
    });
    var newImpact = (0, $gzM5u.default)({}, impact, {
        displaced: {
            all: last.all,
            invisible: invisible,
            visible: visible
        }
    });
    return newImpact;
};
var $22db1ba098eb3017$var$withViewportDisplacement = function(viewport, point) {
    return $22db1ba098eb3017$var$add(viewport.scroll.diff.displacement, point);
};
var $22db1ba098eb3017$var$getClientFromPageBorderBoxCenter = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, draggable = _ref.draggable, viewport = _ref.viewport;
    var withoutPageScrollChange = $22db1ba098eb3017$var$withViewportDisplacement(viewport, pageBorderBoxCenter);
    var offset = $22db1ba098eb3017$var$subtract(withoutPageScrollChange, draggable.page.borderBox.center);
    return $22db1ba098eb3017$var$add(draggable.client.borderBox.center, offset);
};
var $22db1ba098eb3017$var$isTotallyVisibleInNewLocation = function(_ref) {
    var draggable = _ref.draggable, destination = _ref.destination, newPageBorderBoxCenter = _ref.newPageBorderBoxCenter, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, _ref$onlyOnMainAxis = _ref.onlyOnMainAxis, onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
    var changeNeeded = $22db1ba098eb3017$var$subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
    var shifted = $22db1ba098eb3017$var$offsetByPosition(draggable.page.borderBox, changeNeeded);
    var args = {
        target: shifted,
        destination: destination,
        withDroppableDisplacement: withDroppableDisplacement,
        viewport: viewport
    };
    return onlyOnMainAxis ? $22db1ba098eb3017$var$isTotallyVisibleOnAxis(args) : $22db1ba098eb3017$var$isTotallyVisible(args);
};
var $22db1ba098eb3017$var$moveToNextPlace = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, draggables = _ref.draggables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, previousClientSelection = _ref.previousClientSelection, afterCritical = _ref.afterCritical;
    if (!destination.isEnabled) return null;
    var insideDestination = $22db1ba098eb3017$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var isInHomeList = $22db1ba098eb3017$var$isHomeOf(draggable, destination);
    var impact = $22db1ba098eb3017$var$moveToNextCombine({
        isMovingForward: isMovingForward,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact
    }) || $22db1ba098eb3017$var$moveToNextIndex({
        isMovingForward: isMovingForward,
        isInHomeList: isInHomeList,
        draggable: draggable,
        draggables: draggables,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $22db1ba098eb3017$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var isVisibleInNewLocation = $22db1ba098eb3017$var$isTotallyVisibleInNewLocation({
        draggable: draggable,
        destination: destination,
        newPageBorderBoxCenter: pageBorderBoxCenter,
        viewport: viewport.frame,
        withDroppableDisplacement: false,
        onlyOnMainAxis: true
    });
    if (isVisibleInNewLocation) {
        var clientSelection = $22db1ba098eb3017$var$getClientFromPageBorderBoxCenter({
            pageBorderBoxCenter: pageBorderBoxCenter,
            draggable: draggable,
            viewport: viewport
        });
        return {
            clientSelection: clientSelection,
            impact: impact,
            scrollJumpRequest: null
        };
    }
    var distance = $22db1ba098eb3017$var$subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
    var cautious = $22db1ba098eb3017$var$speculativelyIncrease({
        impact: impact,
        viewport: viewport,
        destination: destination,
        draggables: draggables,
        maxScrollChange: distance
    });
    return {
        clientSelection: previousClientSelection,
        impact: cautious,
        scrollJumpRequest: distance
    };
};
var $22db1ba098eb3017$var$getKnownActive = function getKnownActive(droppable) {
    var rect = droppable.subject.active;
    !rect && $22db1ba098eb3017$var$invariant(false);
    return rect;
};
var $22db1ba098eb3017$var$getBestCrossAxisDroppable = function(_ref) {
    var isMovingForward = _ref.isMovingForward, pageBorderBoxCenter = _ref.pageBorderBoxCenter, source = _ref.source, droppables = _ref.droppables, viewport = _ref.viewport;
    var active = source.subject.active;
    if (!active) return null;
    var axis = source.axis;
    var isBetweenSourceClipped = $22db1ba098eb3017$var$isWithin(active[axis.start], active[axis.end]);
    var candidates = $22db1ba098eb3017$var$toDroppableList(droppables).filter(function(droppable) {
        return droppable !== source;
    }).filter(function(droppable) {
        return droppable.isEnabled;
    }).filter(function(droppable) {
        return Boolean(droppable.subject.active);
    }).filter(function(droppable) {
        return $22db1ba098eb3017$var$isPartiallyVisibleThroughFrame(viewport.frame)($22db1ba098eb3017$var$getKnownActive(droppable));
    }).filter(function(droppable) {
        var activeOfTarget = $22db1ba098eb3017$var$getKnownActive(droppable);
        if (isMovingForward) return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
        return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
    }).filter(function(droppable) {
        var activeOfTarget = $22db1ba098eb3017$var$getKnownActive(droppable);
        var isBetweenDestinationClipped = $22db1ba098eb3017$var$isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
        return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
    }).sort(function(a, b) {
        var first = $22db1ba098eb3017$var$getKnownActive(a)[axis.crossAxisStart];
        var second = $22db1ba098eb3017$var$getKnownActive(b)[axis.crossAxisStart];
        if (isMovingForward) return first - second;
        return second - first;
    }).filter(function(droppable, index, array) {
        return $22db1ba098eb3017$var$getKnownActive(droppable)[axis.crossAxisStart] === $22db1ba098eb3017$var$getKnownActive(array[0])[axis.crossAxisStart];
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0];
    var contains = candidates.filter(function(droppable) {
        var isWithinDroppable = $22db1ba098eb3017$var$isWithin($22db1ba098eb3017$var$getKnownActive(droppable)[axis.start], $22db1ba098eb3017$var$getKnownActive(droppable)[axis.end]);
        return isWithinDroppable(pageBorderBoxCenter[axis.line]);
    });
    if (contains.length === 1) return contains[0];
    if (contains.length > 1) return contains.sort(function(a, b) {
        return $22db1ba098eb3017$var$getKnownActive(a)[axis.start] - $22db1ba098eb3017$var$getKnownActive(b)[axis.start];
    })[0];
    return candidates.sort(function(a, b) {
        var first = $22db1ba098eb3017$var$closest(pageBorderBoxCenter, $22db1ba098eb3017$var$getCorners($22db1ba098eb3017$var$getKnownActive(a)));
        var second = $22db1ba098eb3017$var$closest(pageBorderBoxCenter, $22db1ba098eb3017$var$getCorners($22db1ba098eb3017$var$getKnownActive(b)));
        if (first !== second) return first - second;
        return $22db1ba098eb3017$var$getKnownActive(a)[axis.start] - $22db1ba098eb3017$var$getKnownActive(b)[axis.start];
    })[0];
};
var $22db1ba098eb3017$var$getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, afterCritical) {
    var original = draggable.page.borderBox.center;
    return $22db1ba098eb3017$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $22db1ba098eb3017$var$subtract(original, afterCritical.displacedBy.point) : original;
};
var $22db1ba098eb3017$var$getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, afterCritical) {
    var original = draggable.page.borderBox;
    return $22db1ba098eb3017$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $22db1ba098eb3017$var$offsetByPosition(original, $22db1ba098eb3017$var$negate(afterCritical.displacedBy.point)) : original;
};
var $22db1ba098eb3017$var$getClosestDraggable = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, viewport = _ref.viewport, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    var sorted = insideDestination.filter(function(draggable) {
        return $22db1ba098eb3017$var$isTotallyVisible({
            target: $22db1ba098eb3017$var$getCurrentPageBorderBox(draggable, afterCritical),
            destination: destination,
            viewport: viewport.frame,
            withDroppableDisplacement: true
        });
    }).sort(function(a, b) {
        var distanceToA = $22db1ba098eb3017$var$distance(pageBorderBoxCenter, $22db1ba098eb3017$var$withDroppableDisplacement(destination, $22db1ba098eb3017$var$getCurrentPageBorderBoxCenter(a, afterCritical)));
        var distanceToB = $22db1ba098eb3017$var$distance(pageBorderBoxCenter, $22db1ba098eb3017$var$withDroppableDisplacement(destination, $22db1ba098eb3017$var$getCurrentPageBorderBoxCenter(b, afterCritical)));
        if (distanceToA < distanceToB) return -1;
        if (distanceToB < distanceToA) return 1;
        return a.descriptor.index - b.descriptor.index;
    });
    return sorted[0] || null;
};
var $22db1ba098eb3017$var$getDisplacedBy = (0, $jQbLg.default)(function getDisplacedBy(axis, displaceBy) {
    var displacement = displaceBy[axis.line];
    return {
        value: displacement,
        point: $22db1ba098eb3017$var$patch(axis.line, displacement)
    };
});
var $22db1ba098eb3017$var$getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
    var axis = droppable.axis;
    if (droppable.descriptor.mode === 'virtual') return $22db1ba098eb3017$var$patch(axis.line, placeholderSize[axis.line]);
    var availableSpace = droppable.subject.page.contentBox[axis.size];
    var insideDroppable = $22db1ba098eb3017$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var spaceUsed = insideDroppable.reduce(function(sum, dimension) {
        return sum + dimension.client.marginBox[axis.size];
    }, 0);
    var requiredSpace = spaceUsed + placeholderSize[axis.line];
    var needsToGrowBy = requiredSpace - availableSpace;
    if (needsToGrowBy <= 0) return null;
    return $22db1ba098eb3017$var$patch(axis.line, needsToGrowBy);
};
var $22db1ba098eb3017$var$withMaxScroll = function withMaxScroll(frame, max) {
    return (0, $gzM5u.default)({}, frame, {
        scroll: (0, $gzM5u.default)({}, frame.scroll, {
            max: max
        })
    });
};
var $22db1ba098eb3017$var$addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
    var frame = droppable.frame;
    !!$22db1ba098eb3017$var$isHomeOf(draggable, droppable) && $22db1ba098eb3017$var$invariant(false);
    !!droppable.subject.withPlaceholder && $22db1ba098eb3017$var$invariant(false);
    var placeholderSize = $22db1ba098eb3017$var$getDisplacedBy(droppable.axis, draggable.displaceBy).point;
    var requiredGrowth = $22db1ba098eb3017$var$getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
    var added = {
        placeholderSize: placeholderSize,
        increasedBy: requiredGrowth,
        oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
    };
    if (!frame) {
        var _subject = $22db1ba098eb3017$var$getSubject({
            page: droppable.subject.page,
            withPlaceholder: added,
            axis: droppable.axis,
            frame: droppable.frame
        });
        return (0, $gzM5u.default)({}, droppable, {
            subject: _subject
        });
    }
    var maxScroll = requiredGrowth ? $22db1ba098eb3017$var$add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
    var newFrame = $22db1ba098eb3017$var$withMaxScroll(frame, maxScroll);
    var subject = $22db1ba098eb3017$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: added,
        axis: droppable.axis,
        frame: newFrame
    });
    return (0, $gzM5u.default)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $22db1ba098eb3017$var$removePlaceholder = function removePlaceholder(droppable) {
    var added = droppable.subject.withPlaceholder;
    !added && $22db1ba098eb3017$var$invariant(false);
    var frame = droppable.frame;
    if (!frame) {
        var _subject2 = $22db1ba098eb3017$var$getSubject({
            page: droppable.subject.page,
            axis: droppable.axis,
            frame: null,
            withPlaceholder: null
        });
        return (0, $gzM5u.default)({}, droppable, {
            subject: _subject2
        });
    }
    var oldMaxScroll = added.oldFrameMaxScroll;
    !oldMaxScroll && $22db1ba098eb3017$var$invariant(false);
    var newFrame = $22db1ba098eb3017$var$withMaxScroll(frame, oldMaxScroll);
    var subject = $22db1ba098eb3017$var$getSubject({
        page: droppable.subject.page,
        axis: droppable.axis,
        frame: newFrame,
        withPlaceholder: null
    });
    return (0, $gzM5u.default)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $22db1ba098eb3017$var$moveToNewDroppable = function(_ref) {
    var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, moveRelativeTo = _ref.moveRelativeTo, insideDestination = _ref.insideDestination, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    if (!moveRelativeTo) {
        if (insideDestination.length) return null;
        var proposed = {
            displaced: $22db1ba098eb3017$var$emptyGroups,
            displacedBy: $22db1ba098eb3017$var$noDisplacedBy,
            at: {
                type: 'REORDER',
                destination: {
                    droppableId: destination.descriptor.id,
                    index: 0
                }
            }
        };
        var proposedPageBorderBoxCenter = $22db1ba098eb3017$var$getPageBorderBoxCenterFromImpact({
            impact: proposed,
            draggable: draggable,
            droppable: destination,
            draggables: draggables,
            afterCritical: afterCritical
        });
        var withPlaceholder = $22db1ba098eb3017$var$isHomeOf(draggable, destination) ? destination : $22db1ba098eb3017$var$addPlaceholder(destination, draggable, draggables);
        var isVisibleInNewLocation = $22db1ba098eb3017$var$isTotallyVisibleInNewLocation({
            draggable: draggable,
            destination: withPlaceholder,
            newPageBorderBoxCenter: proposedPageBorderBoxCenter,
            viewport: viewport.frame,
            withDroppableDisplacement: false,
            onlyOnMainAxis: true
        });
        return isVisibleInNewLocation ? proposed : null;
    }
    var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);
    var proposedIndex = function() {
        var relativeTo = moveRelativeTo.descriptor.index;
        if (moveRelativeTo.descriptor.id === draggable.descriptor.id) return relativeTo;
        if (isGoingBeforeTarget) return relativeTo;
        return relativeTo + 1;
    }();
    var displacedBy = $22db1ba098eb3017$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    return $22db1ba098eb3017$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        displacedBy: displacedBy,
        last: $22db1ba098eb3017$var$emptyGroups,
        index: proposedIndex
    });
};
var $22db1ba098eb3017$var$moveCrossAxis = function(_ref) {
    var isMovingForward = _ref.isMovingForward, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, draggable = _ref.draggable, isOver = _ref.isOver, draggables = _ref.draggables, droppables = _ref.droppables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var destination = $22db1ba098eb3017$var$getBestCrossAxisDroppable({
        isMovingForward: isMovingForward,
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        source: isOver,
        droppables: droppables,
        viewport: viewport
    });
    if (!destination) return null;
    var insideDestination = $22db1ba098eb3017$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var moveRelativeTo = $22db1ba098eb3017$var$getClosestDraggable({
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        viewport: viewport,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    });
    var impact = $22db1ba098eb3017$var$moveToNewDroppable({
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        destination: destination,
        draggable: draggable,
        draggables: draggables,
        moveRelativeTo: moveRelativeTo,
        insideDestination: insideDestination,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $22db1ba098eb3017$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var clientSelection = $22db1ba098eb3017$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
    return {
        clientSelection: clientSelection,
        impact: impact,
        scrollJumpRequest: null
    };
};
var $22db1ba098eb3017$var$whatIsDraggedOver = function(impact) {
    var at = impact.at;
    if (!at) return null;
    if (at.type === 'REORDER') return at.destination.droppableId;
    return at.combine.droppableId;
};
var $22db1ba098eb3017$var$getDroppableOver = function getDroppableOver(impact, droppables) {
    var id = $22db1ba098eb3017$var$whatIsDraggedOver(impact);
    return id ? droppables[id] : null;
};
var $22db1ba098eb3017$var$moveInDirection = function(_ref) {
    var state = _ref.state, type = _ref.type;
    var isActuallyOver = $22db1ba098eb3017$var$getDroppableOver(state.impact, state.dimensions.droppables);
    var isMainAxisMovementAllowed = Boolean(isActuallyOver);
    var home = state.dimensions.droppables[state.critical.droppable.id];
    var isOver = isActuallyOver || home;
    var direction = isOver.axis.direction;
    var isMovingOnMainAxis = direction === 'vertical' && (type === 'MOVE_UP' || type === 'MOVE_DOWN') || direction === 'horizontal' && (type === 'MOVE_LEFT' || type === 'MOVE_RIGHT');
    if (isMovingOnMainAxis && !isMainAxisMovementAllowed) return null;
    var isMovingForward = type === 'MOVE_DOWN' || type === 'MOVE_RIGHT';
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
    var _state$dimensions = state.dimensions, draggables = _state$dimensions.draggables, droppables = _state$dimensions.droppables;
    return isMovingOnMainAxis ? $22db1ba098eb3017$var$moveToNextPlace({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        destination: isOver,
        draggables: draggables,
        viewport: state.viewport,
        previousClientSelection: state.current.client.selection,
        previousImpact: state.impact,
        afterCritical: state.afterCritical
    }) : $22db1ba098eb3017$var$moveCrossAxis({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        isOver: isOver,
        draggables: draggables,
        droppables: droppables,
        viewport: state.viewport,
        afterCritical: state.afterCritical
    });
};
function $22db1ba098eb3017$var$isMovementAllowed(state) {
    return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
}
function $22db1ba098eb3017$var$isPositionInFrame(frame) {
    var isWithinVertical = $22db1ba098eb3017$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $22db1ba098eb3017$var$isWithin(frame.left, frame.right);
    return function run(point) {
        return isWithinVertical(point.y) && isWithinHorizontal(point.x);
    };
}
function $22db1ba098eb3017$var$getHasOverlap(first, second) {
    return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}
function $22db1ba098eb3017$var$getFurthestAway(_ref) {
    var pageBorderBox = _ref.pageBorderBox, draggable = _ref.draggable, candidates = _ref.candidates;
    var startCenter = draggable.page.borderBox.center;
    var sorted = candidates.map(function(candidate) {
        var axis = candidate.axis;
        var target = $22db1ba098eb3017$var$patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
        return {
            id: candidate.descriptor.id,
            distance: $22db1ba098eb3017$var$distance(startCenter, target)
        };
    }).sort(function(a, b) {
        return b.distance - a.distance;
    });
    return sorted[0] ? sorted[0].id : null;
}
function $22db1ba098eb3017$var$getDroppableOver$1(_ref2) {
    var pageBorderBox = _ref2.pageBorderBox, draggable = _ref2.draggable, droppables = _ref2.droppables;
    var candidates = $22db1ba098eb3017$var$toDroppableList(droppables).filter(function(item) {
        if (!item.isEnabled) return false;
        var active = item.subject.active;
        if (!active) return false;
        if (!$22db1ba098eb3017$var$getHasOverlap(pageBorderBox, active)) return false;
        if ($22db1ba098eb3017$var$isPositionInFrame(active)(pageBorderBox.center)) return true;
        var axis = item.axis;
        var childCenter = active.center[axis.crossAxisLine];
        var crossAxisStart = pageBorderBox[axis.crossAxisStart];
        var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
        var isContained = $22db1ba098eb3017$var$isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
        var isStartContained = isContained(crossAxisStart);
        var isEndContained = isContained(crossAxisEnd);
        if (!isStartContained && !isEndContained) return true;
        if (isStartContained) return crossAxisStart < childCenter;
        return crossAxisEnd > childCenter;
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0].descriptor.id;
    return $22db1ba098eb3017$var$getFurthestAway({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        candidates: candidates
    });
}
var $22db1ba098eb3017$var$offsetRectByPosition = function offsetRectByPosition(rect, point) {
    return (0, $3YKxB.getRect)($22db1ba098eb3017$var$offsetByPosition(rect, point));
};
var $22db1ba098eb3017$var$withDroppableScroll = function(droppable, area) {
    var frame = droppable.frame;
    if (!frame) return area;
    return $22db1ba098eb3017$var$offsetRectByPosition(area, frame.scroll.diff.value);
};
function $22db1ba098eb3017$var$getIsDisplaced(_ref) {
    var displaced = _ref.displaced, id = _ref.id;
    return Boolean(displaced.visible[id] || displaced.invisible[id]);
}
function $22db1ba098eb3017$var$atIndex(_ref) {
    var draggable = _ref.draggable, closest = _ref.closest, inHomeList = _ref.inHomeList;
    if (!closest) return null;
    if (!inHomeList) return closest.descriptor.index;
    if (closest.descriptor.index > draggable.descriptor.index) return closest.descriptor.index - 1;
    return closest.descriptor.index;
}
var $22db1ba098eb3017$var$getReorderImpact = function(_ref2) {
    var targetRect = _ref2.pageBorderBoxWithDroppableScroll, draggable = _ref2.draggable, destination = _ref2.destination, insideDestination = _ref2.insideDestination, last = _ref2.last, viewport = _ref2.viewport, afterCritical = _ref2.afterCritical;
    var axis = destination.axis;
    var displacedBy = $22db1ba098eb3017$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $22db1ba098eb3017$var$removeDraggableFromList(draggable, insideDestination);
    var closest = $22db1ba098eb3017$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childCenter = child.page.borderBox.center[axis.line];
        var didStartAfterCritical$1 = $22db1ba098eb3017$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $22db1ba098eb3017$var$getIsDisplaced({
            displaced: last,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd <= childCenter;
            return targetStart < childCenter - displacement;
        }
        if (isDisplaced) return targetEnd <= childCenter + displacement;
        return targetStart < childCenter;
    });
    var newIndex = $22db1ba098eb3017$var$atIndex({
        draggable: draggable,
        closest: closest,
        inHomeList: $22db1ba098eb3017$var$isHomeOf(draggable, destination)
    });
    return $22db1ba098eb3017$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: last,
        displacedBy: displacedBy,
        index: newIndex
    });
};
var $22db1ba098eb3017$var$combineThresholdDivisor = 4;
var $22db1ba098eb3017$var$getCombineImpact = function(_ref) {
    var draggable = _ref.draggable, targetRect = _ref.pageBorderBoxWithDroppableScroll, previousImpact = _ref.previousImpact, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var axis = destination.axis;
    var displacedBy = $22db1ba098eb3017$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $22db1ba098eb3017$var$removeDraggableFromList(draggable, insideDestination);
    var combineWith = $22db1ba098eb3017$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childRect = child.page.borderBox;
        var childSize = childRect[axis.size];
        var threshold = childSize / $22db1ba098eb3017$var$combineThresholdDivisor;
        var didStartAfterCritical$1 = $22db1ba098eb3017$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $22db1ba098eb3017$var$getIsDisplaced({
            displaced: previousImpact.displaced,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
            return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
        }
        if (isDisplaced) return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
        return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
    });
    if (!combineWith) return null;
    var impact = {
        displacedBy: displacedBy,
        displaced: previousImpact.displaced,
        at: {
            type: 'COMBINE',
            combine: {
                draggableId: combineWith.descriptor.id,
                droppableId: destination.descriptor.id
            }
        }
    };
    return impact;
};
var $22db1ba098eb3017$var$getDragImpact = function(_ref) {
    var pageOffset = _ref.pageOffset, draggable = _ref.draggable, draggables = _ref.draggables, droppables = _ref.droppables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBox = $22db1ba098eb3017$var$offsetRectByPosition(draggable.page.borderBox, pageOffset);
    var destinationId = $22db1ba098eb3017$var$getDroppableOver$1({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        droppables: droppables
    });
    if (!destinationId) return $22db1ba098eb3017$var$noImpact;
    var destination = droppables[destinationId];
    var insideDestination = $22db1ba098eb3017$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var pageBorderBoxWithDroppableScroll = $22db1ba098eb3017$var$withDroppableScroll(destination, pageBorderBox);
    return $22db1ba098eb3017$var$getCombineImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        previousImpact: previousImpact,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    }) || $22db1ba098eb3017$var$getReorderImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        last: previousImpact.displaced,
        viewport: viewport,
        afterCritical: afterCritical
    });
};
var $22db1ba098eb3017$var$patchDroppableMap = function(droppables, updated) {
    var _extends2;
    return (0, $gzM5u.default)({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
};
var $22db1ba098eb3017$var$clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
    var previousImpact = _ref.previousImpact, impact = _ref.impact, droppables = _ref.droppables;
    var last = $22db1ba098eb3017$var$whatIsDraggedOver(previousImpact);
    var now = $22db1ba098eb3017$var$whatIsDraggedOver(impact);
    if (!last) return droppables;
    if (last === now) return droppables;
    var lastDroppable = droppables[last];
    if (!lastDroppable.subject.withPlaceholder) return droppables;
    var updated = $22db1ba098eb3017$var$removePlaceholder(lastDroppable);
    return $22db1ba098eb3017$var$patchDroppableMap(droppables, updated);
};
var $22db1ba098eb3017$var$recomputePlaceholders = function(_ref2) {
    var draggable = _ref2.draggable, draggables = _ref2.draggables, droppables = _ref2.droppables, previousImpact = _ref2.previousImpact, impact = _ref2.impact;
    var cleaned = $22db1ba098eb3017$var$clearUnusedPlaceholder({
        previousImpact: previousImpact,
        impact: impact,
        droppables: droppables
    });
    var isOver = $22db1ba098eb3017$var$whatIsDraggedOver(impact);
    if (!isOver) return cleaned;
    var droppable = droppables[isOver];
    if ($22db1ba098eb3017$var$isHomeOf(draggable, droppable)) return cleaned;
    if (droppable.subject.withPlaceholder) return cleaned;
    var patched = $22db1ba098eb3017$var$addPlaceholder(droppable, draggable, draggables);
    return $22db1ba098eb3017$var$patchDroppableMap(cleaned, patched);
};
var $22db1ba098eb3017$var$update = function(_ref) {
    var state = _ref.state, forcedClientSelection = _ref.clientSelection, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport, forcedImpact = _ref.impact, scrollJumpRequest = _ref.scrollJumpRequest;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var clientSelection = forcedClientSelection || state.current.client.selection;
    var offset = $22db1ba098eb3017$var$subtract(clientSelection, state.initial.client.selection);
    var client = {
        offset: offset,
        selection: clientSelection,
        borderBoxCenter: $22db1ba098eb3017$var$add(state.initial.client.borderBoxCenter, offset)
    };
    var page = {
        selection: $22db1ba098eb3017$var$add(client.selection, viewport.scroll.current),
        borderBoxCenter: $22db1ba098eb3017$var$add(client.borderBoxCenter, viewport.scroll.current),
        offset: $22db1ba098eb3017$var$add(client.offset, viewport.scroll.diff.value)
    };
    var current = {
        client: client,
        page: page
    };
    if (state.phase === 'COLLECTING') return (0, $gzM5u.default)({
        phase: 'COLLECTING'
    }, state, {
        dimensions: dimensions,
        viewport: viewport,
        current: current
    });
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var newImpact = forcedImpact || $22db1ba098eb3017$var$getDragImpact({
        pageOffset: page.offset,
        draggable: draggable,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: state.impact,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    var withUpdatedPlaceholders = $22db1ba098eb3017$var$recomputePlaceholders({
        draggable: draggable,
        impact: newImpact,
        previousImpact: state.impact,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables
    });
    var result = (0, $gzM5u.default)({}, state, {
        current: current,
        dimensions: {
            draggables: dimensions.draggables,
            droppables: withUpdatedPlaceholders
        },
        impact: newImpact,
        viewport: viewport,
        scrollJumpRequest: scrollJumpRequest || null,
        forceShouldAnimate: scrollJumpRequest ? false : null
    });
    return result;
};
function $22db1ba098eb3017$var$getDraggables$1(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
var $22db1ba098eb3017$var$recompute = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, draggables = _ref.draggables, destination = _ref.destination, forceShouldAnimate = _ref.forceShouldAnimate;
    var last = impact.displaced;
    var afterDragging = $22db1ba098eb3017$var$getDraggables$1(last.all, draggables);
    var displaced = $22db1ba098eb3017$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate,
        last: last
    });
    return (0, $gzM5u.default)({}, impact, {
        displaced: displaced
    });
};
var $22db1ba098eb3017$var$getClientBorderBoxCenter = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBoxCenter = $22db1ba098eb3017$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $22db1ba098eb3017$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
};
var $22db1ba098eb3017$var$refreshSnap = function(_ref) {
    var state = _ref.state, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport;
    !(state.movementMode === 'SNAP') && $22db1ba098eb3017$var$invariant(false);
    var needsVisibilityCheck = state.impact;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var draggable = draggables[state.critical.draggable.id];
    var isOver = $22db1ba098eb3017$var$whatIsDraggedOver(needsVisibilityCheck);
    !isOver && $22db1ba098eb3017$var$invariant(false);
    var destination = droppables[isOver];
    var impact = $22db1ba098eb3017$var$recompute({
        impact: needsVisibilityCheck,
        viewport: viewport,
        destination: destination,
        draggables: draggables
    });
    var clientSelection = $22db1ba098eb3017$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    return $22db1ba098eb3017$var$update({
        impact: impact,
        clientSelection: clientSelection,
        state: state,
        dimensions: dimensions,
        viewport: viewport
    });
};
var $22db1ba098eb3017$var$getHomeLocation = function(descriptor) {
    return {
        index: descriptor.index,
        droppableId: descriptor.droppableId
    };
};
var $22db1ba098eb3017$var$getLiftEffect = function(_ref) {
    var draggable = _ref.draggable, home = _ref.home, draggables = _ref.draggables, viewport = _ref.viewport;
    var displacedBy = $22db1ba098eb3017$var$getDisplacedBy(home.axis, draggable.displaceBy);
    var insideHome = $22db1ba098eb3017$var$getDraggablesInsideDroppable(home.descriptor.id, draggables);
    var rawIndex = insideHome.indexOf(draggable);
    !(rawIndex !== -1) && $22db1ba098eb3017$var$invariant(false);
    var afterDragging = insideHome.slice(rawIndex + 1);
    var effected = afterDragging.reduce(function(previous, item) {
        previous[item.descriptor.id] = true;
        return previous;
    }, {});
    var afterCritical = {
        inVirtualList: home.descriptor.mode === 'virtual',
        displacedBy: displacedBy,
        effected: effected
    };
    var displaced = $22db1ba098eb3017$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: home,
        displacedBy: displacedBy,
        last: null,
        viewport: viewport.frame,
        forceShouldAnimate: false
    });
    var impact = {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: $22db1ba098eb3017$var$getHomeLocation(draggable.descriptor)
        }
    };
    return {
        impact: impact,
        afterCritical: afterCritical
    };
};
var $22db1ba098eb3017$var$patchDimensionMap = function(dimensions, updated) {
    return {
        draggables: dimensions.draggables,
        droppables: $22db1ba098eb3017$var$patchDroppableMap(dimensions.droppables, updated)
    };
};
var $22db1ba098eb3017$var$records = {};
var $22db1ba098eb3017$var$isEnabled = false;
var $22db1ba098eb3017$var$isTimingsEnabled = function isTimingsEnabled() {
    return $22db1ba098eb3017$var$isEnabled;
};
var $22db1ba098eb3017$var$start = function start(key) {
    var now;
};
var $22db1ba098eb3017$var$finish = function finish(key) {
    var now, previous, result, rounded, style;
};
var $22db1ba098eb3017$var$offsetDraggable = function(_ref) {
    var draggable = _ref.draggable, offset$1 = _ref.offset, initialWindowScroll = _ref.initialWindowScroll;
    var client = (0, $3YKxB.offset)(draggable.client, offset$1);
    var page = (0, $3YKxB.withScroll)(client, initialWindowScroll);
    var moved = (0, $gzM5u.default)({}, draggable, {
        placeholder: (0, $gzM5u.default)({}, draggable.placeholder, {
            client: client
        }),
        client: client,
        page: page
    });
    return moved;
};
var $22db1ba098eb3017$var$getFrame = function(droppable) {
    var frame = droppable.frame;
    !frame && $22db1ba098eb3017$var$invariant(false);
    return frame;
};
var $22db1ba098eb3017$var$adjustAdditionsForScrollChanges = function(_ref) {
    var additions = _ref.additions, updatedDroppables = _ref.updatedDroppables, viewport = _ref.viewport;
    var windowScrollChange = viewport.scroll.diff.value;
    return additions.map(function(draggable) {
        var droppableId = draggable.descriptor.droppableId;
        var modified = updatedDroppables[droppableId];
        var frame = $22db1ba098eb3017$var$getFrame(modified);
        var droppableScrollChange = frame.scroll.diff.value;
        var totalChange = $22db1ba098eb3017$var$add(windowScrollChange, droppableScrollChange);
        var moved = $22db1ba098eb3017$var$offsetDraggable({
            draggable: draggable,
            offset: totalChange,
            initialWindowScroll: viewport.scroll.initial
        });
        return moved;
    });
};
var $22db1ba098eb3017$var$timingsKey = 'Processing dynamic changes';
var $22db1ba098eb3017$var$publishWhileDraggingInVirtual = function(_ref) {
    var _extends2, _extends3;
    var state = _ref.state, published = _ref.published;
    $22db1ba098eb3017$var$start($22db1ba098eb3017$var$timingsKey);
    var withScrollChange = published.modified.map(function(update) {
        var existing = state.dimensions.droppables[update.droppableId];
        var scrolled = $22db1ba098eb3017$var$scrollDroppable(existing, update.scroll);
        return scrolled;
    });
    var droppables = (0, $gzM5u.default)({}, state.dimensions.droppables, $22db1ba098eb3017$var$toDroppableMap(withScrollChange));
    var updatedAdditions = $22db1ba098eb3017$var$toDraggableMap($22db1ba098eb3017$var$adjustAdditionsForScrollChanges({
        additions: published.additions,
        updatedDroppables: droppables,
        viewport: state.viewport
    }));
    var draggables = (0, $gzM5u.default)({}, state.dimensions.draggables, updatedAdditions);
    published.removals.forEach(function(id) {
        delete draggables[id];
    });
    var dimensions = {
        droppables: droppables,
        draggables: draggables
    };
    var wasOverId = $22db1ba098eb3017$var$whatIsDraggedOver(state.impact);
    var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var home = dimensions.droppables[state.critical.droppable.id];
    var _getLiftEffect = $22db1ba098eb3017$var$getLiftEffect({
        draggable: draggable,
        home: home,
        draggables: draggables,
        viewport: state.viewport
    }), onLiftImpact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
    var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
    var impact = $22db1ba098eb3017$var$getDragImpact({
        pageOffset: state.current.page.offset,
        draggable: dimensions.draggables[state.critical.draggable.id],
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: previousImpact,
        viewport: state.viewport,
        afterCritical: afterCritical
    });
    $22db1ba098eb3017$var$finish($22db1ba098eb3017$var$timingsKey);
    var draggingState = (0, $gzM5u.default)({
        phase: 'DRAGGING'
    }, state, (_extends2 = {}, _extends2["phase"] = 'DRAGGING', _extends2.impact = impact, _extends2.onLiftImpact = onLiftImpact, _extends2.dimensions = dimensions, _extends2.afterCritical = afterCritical, _extends2.forceShouldAnimate = false, _extends2));
    if (state.phase === 'COLLECTING') return draggingState;
    var dropPending = (0, $gzM5u.default)({
        phase: 'DROP_PENDING'
    }, draggingState, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.reason = state.reason, _extends3.isWaiting = false, _extends3));
    return dropPending;
};
var $22db1ba098eb3017$var$isSnapping = function isSnapping(state) {
    return state.movementMode === 'SNAP';
};
var $22db1ba098eb3017$var$postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
    var dimensions = $22db1ba098eb3017$var$patchDimensionMap(state.dimensions, updated);
    if (!$22db1ba098eb3017$var$isSnapping(state) || isEnabledChanging) return $22db1ba098eb3017$var$update({
        state: state,
        dimensions: dimensions
    });
    return $22db1ba098eb3017$var$refreshSnap({
        state: state,
        dimensions: dimensions
    });
};
function $22db1ba098eb3017$var$removeScrollJumpRequest(state) {
    if (state.isDragging && state.movementMode === 'SNAP') return (0, $gzM5u.default)({
        phase: 'DRAGGING'
    }, state, {
        scrollJumpRequest: null
    });
    return state;
}
var $22db1ba098eb3017$var$idle = {
    phase: 'IDLE',
    completed: null,
    shouldFlush: false
};
var $22db1ba098eb3017$var$reducer = function(state, action) {
    if (state === void 0) state = $22db1ba098eb3017$var$idle;
    if (action.type === 'FLUSH') return (0, $gzM5u.default)({}, $22db1ba098eb3017$var$idle, {
        shouldFlush: true
    });
    if (action.type === 'INITIAL_PUBLISH') {
        !(state.phase === 'IDLE') && $22db1ba098eb3017$var$invariant(false);
        var _action$payload = action.payload, critical = _action$payload.critical, clientSelection = _action$payload.clientSelection, viewport = _action$payload.viewport, dimensions = _action$payload.dimensions, movementMode = _action$payload.movementMode;
        var draggable = dimensions.draggables[critical.draggable.id];
        var home = dimensions.droppables[critical.droppable.id];
        var client = {
            selection: clientSelection,
            borderBoxCenter: draggable.client.borderBox.center,
            offset: $22db1ba098eb3017$var$origin
        };
        var initial = {
            client: client,
            page: {
                selection: $22db1ba098eb3017$var$add(client.selection, viewport.scroll.initial),
                borderBoxCenter: $22db1ba098eb3017$var$add(client.selection, viewport.scroll.initial),
                offset: $22db1ba098eb3017$var$add(client.selection, viewport.scroll.diff.value)
            }
        };
        var isWindowScrollAllowed = $22db1ba098eb3017$var$toDroppableList(dimensions.droppables).every(function(item) {
            return !item.isFixedOnPage;
        });
        var _getLiftEffect = $22db1ba098eb3017$var$getLiftEffect({
            draggable: draggable,
            home: home,
            draggables: dimensions.draggables,
            viewport: viewport
        }), impact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
        var result = {
            phase: 'DRAGGING',
            isDragging: true,
            critical: critical,
            movementMode: movementMode,
            dimensions: dimensions,
            initial: initial,
            current: initial,
            isWindowScrollAllowed: isWindowScrollAllowed,
            impact: impact,
            afterCritical: afterCritical,
            onLiftImpact: impact,
            viewport: viewport,
            scrollJumpRequest: null,
            forceShouldAnimate: null
        };
        return result;
    }
    if (action.type === 'COLLECTION_STARTING') {
        var _extends2;
        if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
        !(state.phase === 'DRAGGING') && $22db1ba098eb3017$var$invariant(false);
        var _result = (0, $gzM5u.default)({
            phase: 'COLLECTING'
        }, state, (_extends2 = {}, _extends2["phase"] = 'COLLECTING', _extends2));
        return _result;
    }
    if (action.type === 'PUBLISH_WHILE_DRAGGING') {
        !(state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') && $22db1ba098eb3017$var$invariant(false);
        return $22db1ba098eb3017$var$publishWhileDraggingInVirtual({
            state: state,
            published: action.payload
        });
    }
    if (action.type === 'MOVE') {
        if (state.phase === 'DROP_PENDING') return state;
        !$22db1ba098eb3017$var$isMovementAllowed(state) && $22db1ba098eb3017$var$invariant(false);
        var _clientSelection = action.payload.client;
        if ($22db1ba098eb3017$var$isEqual(_clientSelection, state.current.client.selection)) return state;
        return $22db1ba098eb3017$var$update({
            state: state,
            clientSelection: _clientSelection,
            impact: $22db1ba098eb3017$var$isSnapping(state) ? state.impact : null
        });
    }
    if (action.type === 'UPDATE_DROPPABLE_SCROLL') {
        if (state.phase === 'DROP_PENDING') return $22db1ba098eb3017$var$removeScrollJumpRequest(state);
        if (state.phase === 'COLLECTING') return $22db1ba098eb3017$var$removeScrollJumpRequest(state);
        !$22db1ba098eb3017$var$isMovementAllowed(state) && $22db1ba098eb3017$var$invariant(false);
        var _action$payload2 = action.payload, id = _action$payload2.id, newScroll = _action$payload2.newScroll;
        var target = state.dimensions.droppables[id];
        if (!target) return state;
        var scrolled = $22db1ba098eb3017$var$scrollDroppable(target, newScroll);
        return $22db1ba098eb3017$var$postDroppableChange(state, scrolled, false);
    }
    if (action.type === 'UPDATE_DROPPABLE_IS_ENABLED') {
        if (state.phase === 'DROP_PENDING') return state;
        !$22db1ba098eb3017$var$isMovementAllowed(state) && $22db1ba098eb3017$var$invariant(false);
        var _action$payload3 = action.payload, _id = _action$payload3.id, isEnabled = _action$payload3.isEnabled;
        var _target = state.dimensions.droppables[_id];
        !_target && $22db1ba098eb3017$var$invariant(false);
        !(_target.isEnabled !== isEnabled) && $22db1ba098eb3017$var$invariant(false);
        var updated = (0, $gzM5u.default)({}, _target, {
            isEnabled: isEnabled
        });
        return $22db1ba098eb3017$var$postDroppableChange(state, updated, true);
    }
    if (action.type === 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED') {
        if (state.phase === 'DROP_PENDING') return state;
        !$22db1ba098eb3017$var$isMovementAllowed(state) && $22db1ba098eb3017$var$invariant(false);
        var _action$payload4 = action.payload, _id2 = _action$payload4.id, isCombineEnabled = _action$payload4.isCombineEnabled;
        var _target2 = state.dimensions.droppables[_id2];
        !_target2 && $22db1ba098eb3017$var$invariant(false);
        !(_target2.isCombineEnabled !== isCombineEnabled) && $22db1ba098eb3017$var$invariant(false);
        var _updated = (0, $gzM5u.default)({}, _target2, {
            isCombineEnabled: isCombineEnabled
        });
        return $22db1ba098eb3017$var$postDroppableChange(state, _updated, true);
    }
    if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
        if (state.phase === 'DROP_PENDING' || state.phase === 'DROP_ANIMATING') return state;
        !$22db1ba098eb3017$var$isMovementAllowed(state) && $22db1ba098eb3017$var$invariant(false);
        !state.isWindowScrollAllowed && $22db1ba098eb3017$var$invariant(false);
        var _newScroll = action.payload.newScroll;
        if ($22db1ba098eb3017$var$isEqual(state.viewport.scroll.current, _newScroll)) return $22db1ba098eb3017$var$removeScrollJumpRequest(state);
        var _viewport = $22db1ba098eb3017$var$scrollViewport(state.viewport, _newScroll);
        if ($22db1ba098eb3017$var$isSnapping(state)) return $22db1ba098eb3017$var$refreshSnap({
            state: state,
            viewport: _viewport
        });
        return $22db1ba098eb3017$var$update({
            state: state,
            viewport: _viewport
        });
    }
    if (action.type === 'UPDATE_VIEWPORT_MAX_SCROLL') {
        if (!$22db1ba098eb3017$var$isMovementAllowed(state)) return state;
        var maxScroll = action.payload.maxScroll;
        if ($22db1ba098eb3017$var$isEqual(maxScroll, state.viewport.scroll.max)) return state;
        var withMaxScroll = (0, $gzM5u.default)({}, state.viewport, {
            scroll: (0, $gzM5u.default)({}, state.viewport.scroll, {
                max: maxScroll
            })
        });
        return (0, $gzM5u.default)({
            phase: 'DRAGGING'
        }, state, {
            viewport: withMaxScroll
        });
    }
    if (action.type === 'MOVE_UP' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_RIGHT') {
        if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
        !(state.phase === 'DRAGGING') && $22db1ba098eb3017$var$invariant(false);
        var _result2 = $22db1ba098eb3017$var$moveInDirection({
            state: state,
            type: action.type
        });
        if (!_result2) return state;
        return $22db1ba098eb3017$var$update({
            state: state,
            impact: _result2.impact,
            clientSelection: _result2.clientSelection,
            scrollJumpRequest: _result2.scrollJumpRequest
        });
    }
    if (action.type === 'DROP_PENDING') {
        var _extends3;
        var reason = action.payload.reason;
        !(state.phase === 'COLLECTING') && $22db1ba098eb3017$var$invariant(false);
        var newState = (0, $gzM5u.default)({
            phase: 'DROP_PENDING'
        }, state, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.isWaiting = true, _extends3.reason = reason, _extends3));
        return newState;
    }
    if (action.type === 'DROP_ANIMATE') {
        var _action$payload5 = action.payload, completed = _action$payload5.completed, dropDuration = _action$payload5.dropDuration, newHomeClientOffset = _action$payload5.newHomeClientOffset;
        !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && $22db1ba098eb3017$var$invariant(false);
        var _result3 = {
            phase: 'DROP_ANIMATING',
            completed: completed,
            dropDuration: dropDuration,
            newHomeClientOffset: newHomeClientOffset,
            dimensions: state.dimensions
        };
        return _result3;
    }
    if (action.type === 'DROP_COMPLETE') {
        var _completed = action.payload.completed;
        return {
            phase: 'IDLE',
            completed: _completed,
            shouldFlush: false
        };
    }
    return state;
};
var $22db1ba098eb3017$var$beforeInitialCapture = function beforeInitialCapture(args) {
    return {
        type: 'BEFORE_INITIAL_CAPTURE',
        payload: args
    };
};
var $22db1ba098eb3017$var$lift = function lift(args) {
    return {
        type: 'LIFT',
        payload: args
    };
};
var $22db1ba098eb3017$var$initialPublish = function initialPublish(args) {
    return {
        type: 'INITIAL_PUBLISH',
        payload: args
    };
};
var $22db1ba098eb3017$var$publishWhileDragging = function publishWhileDragging(args) {
    return {
        type: 'PUBLISH_WHILE_DRAGGING',
        payload: args
    };
};
var $22db1ba098eb3017$var$collectionStarting = function collectionStarting() {
    return {
        type: 'COLLECTION_STARTING',
        payload: null
    };
};
var $22db1ba098eb3017$var$updateDroppableScroll = function updateDroppableScroll(args) {
    return {
        type: 'UPDATE_DROPPABLE_SCROLL',
        payload: args
    };
};
var $22db1ba098eb3017$var$updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
    return {
        type: 'UPDATE_DROPPABLE_IS_ENABLED',
        payload: args
    };
};
var $22db1ba098eb3017$var$updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
    return {
        type: 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED',
        payload: args
    };
};
var $22db1ba098eb3017$var$move = function move(args) {
    return {
        type: 'MOVE',
        payload: args
    };
};
var $22db1ba098eb3017$var$moveByWindowScroll = function moveByWindowScroll(args) {
    return {
        type: 'MOVE_BY_WINDOW_SCROLL',
        payload: args
    };
};
var $22db1ba098eb3017$var$updateViewportMaxScroll = function updateViewportMaxScroll(args) {
    return {
        type: 'UPDATE_VIEWPORT_MAX_SCROLL',
        payload: args
    };
};
var $22db1ba098eb3017$var$moveUp = function moveUp() {
    return {
        type: 'MOVE_UP',
        payload: null
    };
};
var $22db1ba098eb3017$var$moveDown = function moveDown() {
    return {
        type: 'MOVE_DOWN',
        payload: null
    };
};
var $22db1ba098eb3017$var$moveRight = function moveRight() {
    return {
        type: 'MOVE_RIGHT',
        payload: null
    };
};
var $22db1ba098eb3017$var$moveLeft = function moveLeft() {
    return {
        type: 'MOVE_LEFT',
        payload: null
    };
};
var $22db1ba098eb3017$var$flush = function flush() {
    return {
        type: 'FLUSH',
        payload: null
    };
};
var $22db1ba098eb3017$var$animateDrop = function animateDrop(args) {
    return {
        type: 'DROP_ANIMATE',
        payload: args
    };
};
var $22db1ba098eb3017$var$completeDrop = function completeDrop(args) {
    return {
        type: 'DROP_COMPLETE',
        payload: args
    };
};
var $22db1ba098eb3017$var$drop = function drop(args) {
    return {
        type: 'DROP',
        payload: args
    };
};
var $22db1ba098eb3017$var$dropPending = function dropPending(args) {
    return {
        type: 'DROP_PENDING',
        payload: args
    };
};
var $22db1ba098eb3017$var$dropAnimationFinished = function dropAnimationFinished() {
    return {
        type: 'DROP_ANIMATION_FINISHED',
        payload: null
    };
};
function $22db1ba098eb3017$var$checkIndexes(insideDestination) {
    if (insideDestination.length <= 1) return;
    var indexes = insideDestination.map(function(d) {
        return d.descriptor.index;
    });
    var errors = {};
    for(var i = 1; i < indexes.length; i++){
        var current = indexes[i];
        var previous = indexes[i - 1];
        if (current !== previous + 1) errors[current] = true;
    }
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cs3hJ)))(errors).length) return;
    var formatted = indexes.map(function(index) {
        var hasError = Boolean(errors[index]);
        return hasError ? "[\uD83D\uDD25" + index + "]" : "" + index;
    }).join(', ');
}
function $22db1ba098eb3017$var$validateDimensions(critical, dimensions) {
    var insideDestination;
}
var $22db1ba098eb3017$var$lift$1 = function(marshal) {
    return function(_ref) {
        var getState = _ref.getState, dispatch = _ref.dispatch;
        return function(next) {
            return function(action) {
                if (action.type !== 'LIFT') {
                    next(action);
                    return;
                }
                var _action$payload = action.payload, id = _action$payload.id, clientSelection = _action$payload.clientSelection, movementMode = _action$payload.movementMode;
                var initial = getState();
                if (initial.phase === 'DROP_ANIMATING') dispatch($22db1ba098eb3017$var$completeDrop({
                    completed: initial.completed
                }));
                !(getState().phase === 'IDLE') && $22db1ba098eb3017$var$invariant(false);
                dispatch($22db1ba098eb3017$var$flush());
                dispatch($22db1ba098eb3017$var$beforeInitialCapture({
                    draggableId: id,
                    movementMode: movementMode
                }));
                var scrollOptions = {
                    shouldPublishImmediately: movementMode === 'SNAP'
                };
                var request = {
                    draggableId: id,
                    scrollOptions: scrollOptions
                };
                var _marshal$startPublish = marshal.startPublishing(request), critical = _marshal$startPublish.critical, dimensions = _marshal$startPublish.dimensions, viewport = _marshal$startPublish.viewport;
                $22db1ba098eb3017$var$validateDimensions(critical, dimensions);
                dispatch($22db1ba098eb3017$var$initialPublish({
                    critical: critical,
                    dimensions: dimensions,
                    clientSelection: clientSelection,
                    movementMode: movementMode,
                    viewport: viewport
                }));
            };
        };
    };
};
var $22db1ba098eb3017$var$style = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'INITIAL_PUBLISH') marshal.dragging();
                if (action.type === 'DROP_ANIMATE') marshal.dropping(action.payload.completed.result.reason);
                if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE') marshal.resting();
                next(action);
            };
        };
    };
};
var $22db1ba098eb3017$var$curves = {
    outOfTheWay: 'cubic-bezier(0.2, 0, 0, 1)',
    drop: 'cubic-bezier(.2,1,.1,1)'
};
var $22db1ba098eb3017$var$combine = {
    opacity: {
        drop: 0,
        combining: 0.7
    },
    scale: {
        drop: 0.75
    }
};
var $22db1ba098eb3017$var$timings = {
    outOfTheWay: 0.2,
    minDropTime: 0.33,
    maxDropTime: 0.55
};
var $22db1ba098eb3017$var$outOfTheWayTiming = $22db1ba098eb3017$var$timings.outOfTheWay + "s " + $22db1ba098eb3017$var$curves.outOfTheWay;
var $22db1ba098eb3017$var$transitions = {
    fluid: "opacity " + $22db1ba098eb3017$var$outOfTheWayTiming,
    snap: "transform " + $22db1ba098eb3017$var$outOfTheWayTiming + ", opacity " + $22db1ba098eb3017$var$outOfTheWayTiming,
    drop: function drop(duration) {
        var timing = duration + "s " + $22db1ba098eb3017$var$curves.drop;
        return "transform " + timing + ", opacity " + timing;
    },
    outOfTheWay: "transform " + $22db1ba098eb3017$var$outOfTheWayTiming,
    placeholder: "height " + $22db1ba098eb3017$var$outOfTheWayTiming + ", width " + $22db1ba098eb3017$var$outOfTheWayTiming + ", margin " + $22db1ba098eb3017$var$outOfTheWayTiming
};
var $22db1ba098eb3017$var$moveTo = function moveTo(offset) {
    return $22db1ba098eb3017$var$isEqual(offset, $22db1ba098eb3017$var$origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};
var $22db1ba098eb3017$var$transforms = {
    moveTo: $22db1ba098eb3017$var$moveTo,
    drop: function drop(offset, isCombining) {
        var translate = $22db1ba098eb3017$var$moveTo(offset);
        if (!translate) return null;
        if (!isCombining) return translate;
        return translate + " scale(" + $22db1ba098eb3017$var$combine.scale.drop + ")";
    }
};
var $22db1ba098eb3017$var$minDropTime = $22db1ba098eb3017$var$timings.minDropTime, $22db1ba098eb3017$var$maxDropTime = $22db1ba098eb3017$var$timings.maxDropTime;
var $22db1ba098eb3017$var$dropTimeRange = $22db1ba098eb3017$var$maxDropTime - $22db1ba098eb3017$var$minDropTime;
var $22db1ba098eb3017$var$maxDropTimeAtDistance = 1500;
var $22db1ba098eb3017$var$cancelDropModifier = 0.6;
var $22db1ba098eb3017$var$getDropDuration = function(_ref) {
    var current = _ref.current, destination = _ref.destination, reason = _ref.reason;
    var distance$1 = $22db1ba098eb3017$var$distance(current, destination);
    if (distance$1 <= 0) return $22db1ba098eb3017$var$minDropTime;
    if (distance$1 >= $22db1ba098eb3017$var$maxDropTimeAtDistance) return $22db1ba098eb3017$var$maxDropTime;
    var percentage = distance$1 / $22db1ba098eb3017$var$maxDropTimeAtDistance;
    var duration = $22db1ba098eb3017$var$minDropTime + $22db1ba098eb3017$var$dropTimeRange * percentage;
    var withDuration = reason === 'CANCEL' ? duration * $22db1ba098eb3017$var$cancelDropModifier : duration;
    return Number(withDuration.toFixed(2));
};
var $22db1ba098eb3017$var$getNewHomeClientOffset = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, dimensions = _ref.dimensions, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var droppableId = $22db1ba098eb3017$var$whatIsDraggedOver(impact);
    var destination = droppableId ? droppables[droppableId] : null;
    var home = droppables[draggable.descriptor.droppableId];
    var newClientCenter = $22db1ba098eb3017$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        afterCritical: afterCritical,
        droppable: destination || home,
        viewport: viewport
    });
    var offset = $22db1ba098eb3017$var$subtract(newClientCenter, draggable.client.borderBox.center);
    return offset;
};
var $22db1ba098eb3017$var$getDropImpact = function(_ref) {
    var draggables = _ref.draggables, reason = _ref.reason, lastImpact = _ref.lastImpact, home = _ref.home, viewport = _ref.viewport, onLiftImpact = _ref.onLiftImpact;
    if (!lastImpact.at || reason !== 'DROP') {
        var recomputedHomeImpact = $22db1ba098eb3017$var$recompute({
            draggables: draggables,
            impact: onLiftImpact,
            destination: home,
            viewport: viewport,
            forceShouldAnimate: true
        });
        return {
            impact: recomputedHomeImpact,
            didDropInsideDroppable: false
        };
    }
    if (lastImpact.at.type === 'REORDER') return {
        impact: lastImpact,
        didDropInsideDroppable: true
    };
    var withoutMovement = (0, $gzM5u.default)({}, lastImpact, {
        displaced: $22db1ba098eb3017$var$emptyGroups
    });
    return {
        impact: withoutMovement,
        didDropInsideDroppable: true
    };
};
var $22db1ba098eb3017$var$drop$1 = function(_ref) {
    var getState = _ref.getState, dispatch = _ref.dispatch;
    return function(next) {
        return function(action) {
            if (action.type !== 'DROP') {
                next(action);
                return;
            }
            var state = getState();
            var reason = action.payload.reason;
            if (state.phase === 'COLLECTING') {
                dispatch($22db1ba098eb3017$var$dropPending({
                    reason: reason
                }));
                return;
            }
            if (state.phase === 'IDLE') return;
            var isWaitingForDrop = state.phase === 'DROP_PENDING' && state.isWaiting;
            !!isWaitingForDrop && $22db1ba098eb3017$var$invariant(false);
            !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && $22db1ba098eb3017$var$invariant(false);
            var critical = state.critical;
            var dimensions = state.dimensions;
            var draggable = dimensions.draggables[state.critical.draggable.id];
            var _getDropImpact = $22db1ba098eb3017$var$getDropImpact({
                reason: reason,
                lastImpact: state.impact,
                afterCritical: state.afterCritical,
                onLiftImpact: state.onLiftImpact,
                home: state.dimensions.droppables[state.critical.droppable.id],
                viewport: state.viewport,
                draggables: state.dimensions.draggables
            }), impact = _getDropImpact.impact, didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;
            var destination = didDropInsideDroppable ? $22db1ba098eb3017$var$tryGetDestination(impact) : null;
            var combine = didDropInsideDroppable ? $22db1ba098eb3017$var$tryGetCombine(impact) : null;
            var source = {
                index: critical.draggable.index,
                droppableId: critical.droppable.id
            };
            var result = {
                draggableId: draggable.descriptor.id,
                type: draggable.descriptor.type,
                source: source,
                reason: reason,
                mode: state.movementMode,
                destination: destination,
                combine: combine
            };
            var newHomeClientOffset = $22db1ba098eb3017$var$getNewHomeClientOffset({
                impact: impact,
                draggable: draggable,
                dimensions: dimensions,
                viewport: state.viewport,
                afterCritical: state.afterCritical
            });
            var completed = {
                critical: state.critical,
                afterCritical: state.afterCritical,
                result: result,
                impact: impact
            };
            var isAnimationRequired = !$22db1ba098eb3017$var$isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);
            if (!isAnimationRequired) {
                dispatch($22db1ba098eb3017$var$completeDrop({
                    completed: completed
                }));
                return;
            }
            var dropDuration = $22db1ba098eb3017$var$getDropDuration({
                current: state.current.client.offset,
                destination: newHomeClientOffset,
                reason: reason
            });
            var args = {
                newHomeClientOffset: newHomeClientOffset,
                dropDuration: dropDuration,
                completed: completed
            };
            dispatch($22db1ba098eb3017$var$animateDrop(args));
        };
    };
};
var $22db1ba098eb3017$var$getWindowScroll = function() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
function $22db1ba098eb3017$var$getWindowScrollBinding(update) {
    return {
        eventName: 'scroll',
        options: {
            passive: true,
            capture: false
        },
        fn: function fn(event) {
            if (event.target !== window && event.target !== window.document) return;
            update();
        }
    };
}
function $22db1ba098eb3017$var$getScrollListener(_ref) {
    var onWindowScroll = _ref.onWindowScroll;
    function updateScroll() {
        onWindowScroll($22db1ba098eb3017$var$getWindowScroll());
    }
    var scheduled = (0, $7qpjg.default)(updateScroll);
    var binding = $22db1ba098eb3017$var$getWindowScrollBinding(scheduled);
    var unbind = $22db1ba098eb3017$var$noop;
    function isActive() {
        return unbind !== $22db1ba098eb3017$var$noop;
    }
    function start() {
        !!isActive() && $22db1ba098eb3017$var$invariant(false);
        unbind = $22db1ba098eb3017$var$bindEvents(window, [
            binding
        ]);
    }
    function stop() {
        !isActive() && $22db1ba098eb3017$var$invariant(false);
        scheduled.cancel();
        unbind();
        unbind = $22db1ba098eb3017$var$noop;
    }
    return {
        start: start,
        stop: stop,
        isActive: isActive
    };
}
var $22db1ba098eb3017$var$shouldEnd = function shouldEnd(action) {
    return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};
var $22db1ba098eb3017$var$scrollListener = function(store) {
    var listener = $22db1ba098eb3017$var$getScrollListener({
        onWindowScroll: function onWindowScroll(newScroll) {
            store.dispatch($22db1ba098eb3017$var$moveByWindowScroll({
                newScroll: newScroll
            }));
        }
    });
    return function(next) {
        return function(action) {
            if (!listener.isActive() && action.type === 'INITIAL_PUBLISH') listener.start();
            if (listener.isActive() && $22db1ba098eb3017$var$shouldEnd(action)) listener.stop();
            next(action);
        };
    };
};
var $22db1ba098eb3017$var$getExpiringAnnounce = function(announce) {
    var wasCalled = false;
    var isExpired = false;
    var timeoutId = setTimeout(function() {
        isExpired = true;
    });
    var result = function result(message) {
        if (wasCalled) return;
        if (isExpired) return;
        wasCalled = true;
        announce(message);
        clearTimeout(timeoutId);
    };
    result.wasCalled = function() {
        return wasCalled;
    };
    return result;
};
var $22db1ba098eb3017$var$getAsyncMarshal = function() {
    var entries = [];
    var execute = function execute(timerId) {
        var index = $22db1ba098eb3017$var$findIndex(entries, function(item) {
            return item.timerId === timerId;
        });
        !(index !== -1) && $22db1ba098eb3017$var$invariant(false);
        var _entries$splice = entries.splice(index, 1), entry = _entries$splice[0];
        entry.callback();
    };
    var add = function add(fn) {
        var timerId = setTimeout(function() {
            return execute(timerId);
        });
        var entry = {
            timerId: timerId,
            callback: fn
        };
        entries.push(entry);
    };
    var flush = function flush() {
        if (!entries.length) return;
        var shallow = [].concat(entries);
        entries.length = 0;
        shallow.forEach(function(entry) {
            clearTimeout(entry.timerId);
            entry.callback();
        });
    };
    return {
        add: add,
        flush: flush
    };
};
var $22db1ba098eb3017$var$areLocationsEqual = function areLocationsEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.droppableId === second.droppableId && first.index === second.index;
};
var $22db1ba098eb3017$var$isCombineEqual = function isCombineEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
var $22db1ba098eb3017$var$isCriticalEqual = function isCriticalEqual(first, second) {
    if (first === second) return true;
    var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
    var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
    return isDraggableEqual && isDroppableEqual;
};
var $22db1ba098eb3017$var$withTimings = function withTimings(key, fn) {
    $22db1ba098eb3017$var$start(key);
    fn();
    $22db1ba098eb3017$var$finish(key);
};
var $22db1ba098eb3017$var$getDragStart = function getDragStart(critical, mode) {
    return {
        draggableId: critical.draggable.id,
        type: critical.droppable.type,
        source: {
            droppableId: critical.droppable.id,
            index: critical.draggable.index
        },
        mode: mode
    };
};
var $22db1ba098eb3017$var$execute = function execute(responder, data, announce, getDefaultMessage) {
    if (!responder) {
        announce(getDefaultMessage(data));
        return;
    }
    var willExpire = $22db1ba098eb3017$var$getExpiringAnnounce(announce);
    var provided = {
        announce: willExpire
    };
    responder(data, provided);
    if (!willExpire.wasCalled()) announce(getDefaultMessage(data));
};
var $22db1ba098eb3017$var$getPublisher = function(getResponders, announce) {
    var asyncMarshal = $22db1ba098eb3017$var$getAsyncMarshal();
    var dragging = null;
    var beforeCapture = function beforeCapture(draggableId, mode) {
        !!dragging && $22db1ba098eb3017$var$invariant(false);
        $22db1ba098eb3017$var$withTimings('onBeforeCapture', function() {
            var fn = getResponders().onBeforeCapture;
            if (fn) {
                var before = {
                    draggableId: draggableId,
                    mode: mode
                };
                fn(before);
            }
        });
    };
    var beforeStart = function beforeStart(critical, mode) {
        !!dragging && $22db1ba098eb3017$var$invariant(false);
        $22db1ba098eb3017$var$withTimings('onBeforeDragStart', function() {
            var fn = getResponders().onBeforeDragStart;
            if (fn) fn($22db1ba098eb3017$var$getDragStart(critical, mode));
        });
    };
    var start = function start(critical, mode) {
        !!dragging && $22db1ba098eb3017$var$invariant(false);
        var data = $22db1ba098eb3017$var$getDragStart(critical, mode);
        dragging = {
            mode: mode,
            lastCritical: critical,
            lastLocation: data.source,
            lastCombine: null
        };
        asyncMarshal.add(function() {
            $22db1ba098eb3017$var$withTimings('onDragStart', function() {
                return $22db1ba098eb3017$var$execute(getResponders().onDragStart, data, announce, $22db1ba098eb3017$var$preset.onDragStart);
            });
        });
    };
    var update = function update(critical, impact) {
        var location = $22db1ba098eb3017$var$tryGetDestination(impact);
        var combine = $22db1ba098eb3017$var$tryGetCombine(impact);
        !dragging && $22db1ba098eb3017$var$invariant(false);
        var hasCriticalChanged = !$22db1ba098eb3017$var$isCriticalEqual(critical, dragging.lastCritical);
        if (hasCriticalChanged) dragging.lastCritical = critical;
        var hasLocationChanged = !$22db1ba098eb3017$var$areLocationsEqual(dragging.lastLocation, location);
        if (hasLocationChanged) dragging.lastLocation = location;
        var hasGroupingChanged = !$22db1ba098eb3017$var$isCombineEqual(dragging.lastCombine, combine);
        if (hasGroupingChanged) dragging.lastCombine = combine;
        if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) return;
        var data = (0, $gzM5u.default)({}, $22db1ba098eb3017$var$getDragStart(critical, dragging.mode), {
            combine: combine,
            destination: location
        });
        asyncMarshal.add(function() {
            $22db1ba098eb3017$var$withTimings('onDragUpdate', function() {
                return $22db1ba098eb3017$var$execute(getResponders().onDragUpdate, data, announce, $22db1ba098eb3017$var$preset.onDragUpdate);
            });
        });
    };
    var flush = function flush() {
        !dragging && $22db1ba098eb3017$var$invariant(false);
        asyncMarshal.flush();
    };
    var drop = function drop(result) {
        !dragging && $22db1ba098eb3017$var$invariant(false);
        dragging = null;
        $22db1ba098eb3017$var$withTimings('onDragEnd', function() {
            return $22db1ba098eb3017$var$execute(getResponders().onDragEnd, result, announce, $22db1ba098eb3017$var$preset.onDragEnd);
        });
    };
    var abort = function abort() {
        if (!dragging) return;
        var result = (0, $gzM5u.default)({}, $22db1ba098eb3017$var$getDragStart(dragging.lastCritical, dragging.mode), {
            combine: null,
            destination: null,
            reason: 'CANCEL'
        });
        drop(result);
    };
    return {
        beforeCapture: beforeCapture,
        beforeStart: beforeStart,
        start: start,
        update: update,
        flush: flush,
        drop: drop,
        abort: abort
    };
};
var $22db1ba098eb3017$var$responders = function(getResponders, announce) {
    var publisher = $22db1ba098eb3017$var$getPublisher(getResponders, announce);
    return function(store) {
        return function(next) {
            return function(action) {
                if (action.type === 'BEFORE_INITIAL_CAPTURE') {
                    publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
                    return;
                }
                if (action.type === 'INITIAL_PUBLISH') {
                    var critical = action.payload.critical;
                    publisher.beforeStart(critical, action.payload.movementMode);
                    next(action);
                    publisher.start(critical, action.payload.movementMode);
                    return;
                }
                if (action.type === 'DROP_COMPLETE') {
                    var result = action.payload.completed.result;
                    publisher.flush();
                    next(action);
                    publisher.drop(result);
                    return;
                }
                next(action);
                if (action.type === 'FLUSH') {
                    publisher.abort();
                    return;
                }
                var state = store.getState();
                if (state.phase === 'DRAGGING') publisher.update(state.critical, state.impact);
            };
        };
    };
};
var $22db1ba098eb3017$var$dropAnimationFinish = function(store) {
    return function(next) {
        return function(action) {
            if (action.type !== 'DROP_ANIMATION_FINISHED') {
                next(action);
                return;
            }
            var state = store.getState();
            !(state.phase === 'DROP_ANIMATING') && $22db1ba098eb3017$var$invariant(false);
            store.dispatch($22db1ba098eb3017$var$completeDrop({
                completed: state.completed
            }));
        };
    };
};
var $22db1ba098eb3017$var$dropAnimationFlushOnScroll = function(store) {
    var unbind = null;
    var frameId = null;
    function clear() {
        if (frameId) {
            cancelAnimationFrame(frameId);
            frameId = null;
        }
        if (unbind) {
            unbind();
            unbind = null;
        }
    }
    return function(next) {
        return function(action) {
            if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATION_FINISHED') clear();
            next(action);
            if (action.type !== 'DROP_ANIMATE') return;
            var binding = {
                eventName: 'scroll',
                options: {
                    capture: true,
                    passive: false,
                    once: true
                },
                fn: function flushDropAnimation() {
                    var state = store.getState();
                    if (state.phase === 'DROP_ANIMATING') store.dispatch($22db1ba098eb3017$var$dropAnimationFinished());
                }
            };
            frameId = requestAnimationFrame(function() {
                frameId = null;
                unbind = $22db1ba098eb3017$var$bindEvents(window, [
                    binding
                ]);
            });
        };
    };
};
var $22db1ba098eb3017$var$dimensionMarshalStopper = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'DROP_COMPLETE' || action.type === 'FLUSH' || action.type === 'DROP_ANIMATE') marshal.stopPublishing();
                next(action);
            };
        };
    };
};
var $22db1ba098eb3017$var$focus = function(marshal) {
    var isWatching = false;
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'INITIAL_PUBLISH') {
                    isWatching = true;
                    marshal.tryRecordFocus(action.payload.critical.draggable.id);
                    next(action);
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                next(action);
                if (!isWatching) return;
                if (action.type === 'FLUSH') {
                    isWatching = false;
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                if (action.type === 'DROP_COMPLETE') {
                    isWatching = false;
                    var result = action.payload.completed.result;
                    if (result.combine) marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
                    marshal.tryRestoreFocusRecorded();
                }
            };
        };
    };
};
var $22db1ba098eb3017$var$shouldStop = function shouldStop(action) {
    return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};
var $22db1ba098eb3017$var$autoScroll = function(autoScroller) {
    return function(store) {
        return function(next) {
            return function(action) {
                if ($22db1ba098eb3017$var$shouldStop(action)) {
                    autoScroller.stop();
                    next(action);
                    return;
                }
                if (action.type === 'INITIAL_PUBLISH') {
                    next(action);
                    var state = store.getState();
                    !(state.phase === 'DRAGGING') && $22db1ba098eb3017$var$invariant(false);
                    autoScroller.start(state);
                    return;
                }
                next(action);
                autoScroller.scroll(store.getState());
            };
        };
    };
};
var $22db1ba098eb3017$var$pendingDrop = function(store) {
    return function(next) {
        return function(action) {
            next(action);
            if (action.type !== 'PUBLISH_WHILE_DRAGGING') return;
            var postActionState = store.getState();
            if (postActionState.phase !== 'DROP_PENDING') return;
            if (postActionState.isWaiting) return;
            store.dispatch($22db1ba098eb3017$var$drop({
                reason: postActionState.reason
            }));
        };
    };
};
var $22db1ba098eb3017$var$composeEnhancers = (0, $22j3V.compose);
var $22db1ba098eb3017$var$createStore = function(_ref) {
    var dimensionMarshal = _ref.dimensionMarshal, focusMarshal = _ref.focusMarshal, styleMarshal = _ref.styleMarshal, getResponders = _ref.getResponders, announce = _ref.announce, autoScroller = _ref.autoScroller;
    return (0, $22j3V.createStore)($22db1ba098eb3017$var$reducer, $22db1ba098eb3017$var$composeEnhancers((0, $22j3V.applyMiddleware)($22db1ba098eb3017$var$style(styleMarshal), $22db1ba098eb3017$var$dimensionMarshalStopper(dimensionMarshal), $22db1ba098eb3017$var$lift$1(dimensionMarshal), $22db1ba098eb3017$var$drop$1, $22db1ba098eb3017$var$dropAnimationFinish, $22db1ba098eb3017$var$dropAnimationFlushOnScroll, $22db1ba098eb3017$var$pendingDrop, $22db1ba098eb3017$var$autoScroll(autoScroller), $22db1ba098eb3017$var$scrollListener, $22db1ba098eb3017$var$focus(focusMarshal), $22db1ba098eb3017$var$responders(getResponders, announce))));
};
var $22db1ba098eb3017$var$clean$1 = function clean() {
    return {
        additions: {},
        removals: {},
        modified: {}
    };
};
var $22db1ba098eb3017$var$timingKey = 'Publish collection from DOM';
function $22db1ba098eb3017$var$createPublisher(_ref) {
    var registry = _ref.registry, callbacks = _ref.callbacks;
    var staging = $22db1ba098eb3017$var$clean$1();
    var frameId = null;
    var collect = function collect() {
        if (frameId) return;
        callbacks.collectionStarting();
        frameId = requestAnimationFrame(function() {
            frameId = null;
            $22db1ba098eb3017$var$start($22db1ba098eb3017$var$timingKey);
            var _staging = staging, additions = _staging.additions, removals = _staging.removals, modified = _staging.modified;
            var added = (0, (/*@__PURE__*/$parcel$interopDefault($cs3hJ)))(additions).map(function(id) {
                return registry.draggable.getById(id).getDimension($22db1ba098eb3017$var$origin);
            }).sort(function(a, b) {
                return a.descriptor.index - b.descriptor.index;
            });
            var updated = (0, (/*@__PURE__*/$parcel$interopDefault($cs3hJ)))(modified).map(function(id) {
                var entry = registry.droppable.getById(id);
                var scroll = entry.callbacks.getScrollWhileDragging();
                return {
                    droppableId: id,
                    scroll: scroll
                };
            });
            var result = {
                additions: added,
                removals: (0, (/*@__PURE__*/$parcel$interopDefault($cs3hJ)))(removals),
                modified: updated
            };
            staging = $22db1ba098eb3017$var$clean$1();
            $22db1ba098eb3017$var$finish($22db1ba098eb3017$var$timingKey);
            callbacks.publish(result);
        });
    };
    var add = function add(entry) {
        var id = entry.descriptor.id;
        staging.additions[id] = entry;
        staging.modified[entry.descriptor.droppableId] = true;
        if (staging.removals[id]) delete staging.removals[id];
        collect();
    };
    var remove = function remove(entry) {
        var descriptor = entry.descriptor;
        staging.removals[descriptor.id] = true;
        staging.modified[descriptor.droppableId] = true;
        if (staging.additions[descriptor.id]) delete staging.additions[descriptor.id];
        collect();
    };
    var stop = function stop() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
        staging = $22db1ba098eb3017$var$clean$1();
    };
    return {
        add: add,
        remove: remove,
        stop: stop
    };
}
var $22db1ba098eb3017$var$getMaxScroll = function(_ref) {
    var scrollHeight = _ref.scrollHeight, scrollWidth = _ref.scrollWidth, height = _ref.height, width = _ref.width;
    var maxScroll = $22db1ba098eb3017$var$subtract({
        x: scrollWidth,
        y: scrollHeight
    }, {
        x: width,
        y: height
    });
    var adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};
var $22db1ba098eb3017$var$getDocumentElement = function() {
    var doc = document.documentElement;
    !doc && $22db1ba098eb3017$var$invariant(false);
    return doc;
};
var $22db1ba098eb3017$var$getMaxWindowScroll = function() {
    var doc = $22db1ba098eb3017$var$getDocumentElement();
    var maxScroll = $22db1ba098eb3017$var$getMaxScroll({
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};
var $22db1ba098eb3017$var$getViewport = function() {
    var scroll = $22db1ba098eb3017$var$getWindowScroll();
    var maxScroll = $22db1ba098eb3017$var$getMaxWindowScroll();
    var top = scroll.y;
    var left = scroll.x;
    var doc = $22db1ba098eb3017$var$getDocumentElement();
    var width = doc.clientWidth;
    var height = doc.clientHeight;
    var right = left + width;
    var bottom = top + height;
    var frame = (0, $3YKxB.getRect)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    var viewport = {
        frame: frame,
        scroll: {
            initial: scroll,
            current: scroll,
            max: maxScroll,
            diff: {
                value: $22db1ba098eb3017$var$origin,
                displacement: $22db1ba098eb3017$var$origin
            }
        }
    };
    return viewport;
};
var $22db1ba098eb3017$var$getInitialPublish = function(_ref) {
    var critical = _ref.critical, scrollOptions = _ref.scrollOptions, registry = _ref.registry;
    var timingKey = 'Initial collection from DOM';
    $22db1ba098eb3017$var$start(timingKey);
    var viewport = $22db1ba098eb3017$var$getViewport();
    var windowScroll = viewport.scroll.current;
    var home = critical.droppable;
    var droppables = registry.droppable.getAllByType(home.type).map(function(entry) {
        return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
    });
    var draggables = registry.draggable.getAllByType(critical.draggable.type).map(function(entry) {
        return entry.getDimension(windowScroll);
    });
    var dimensions = {
        draggables: $22db1ba098eb3017$var$toDraggableMap(draggables),
        droppables: $22db1ba098eb3017$var$toDroppableMap(droppables)
    };
    $22db1ba098eb3017$var$finish(timingKey);
    var result = {
        dimensions: dimensions,
        critical: critical,
        viewport: viewport
    };
    return result;
};
function $22db1ba098eb3017$var$shouldPublishUpdate(registry, dragging, entry) {
    if (entry.descriptor.id === dragging.id) return false;
    if (entry.descriptor.type !== dragging.type) return false;
    var home = registry.droppable.getById(entry.descriptor.droppableId);
    if (home.descriptor.mode !== 'virtual') return false;
    return true;
}
var $22db1ba098eb3017$var$createDimensionMarshal = function(registry, callbacks) {
    var collection = null;
    var publisher = $22db1ba098eb3017$var$createPublisher({
        callbacks: {
            publish: callbacks.publishWhileDragging,
            collectionStarting: callbacks.collectionStarting
        },
        registry: registry
    });
    var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
        !registry.droppable.exists(id) && $22db1ba098eb3017$var$invariant(false);
        if (!collection) return;
        callbacks.updateDroppableIsEnabled({
            id: id,
            isEnabled: isEnabled
        });
    };
    var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
        if (!collection) return;
        !registry.droppable.exists(id) && $22db1ba098eb3017$var$invariant(false);
        callbacks.updateDroppableIsCombineEnabled({
            id: id,
            isCombineEnabled: isCombineEnabled
        });
    };
    var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
        if (!collection) return;
        !registry.droppable.exists(id) && $22db1ba098eb3017$var$invariant(false);
        callbacks.updateDroppableScroll({
            id: id,
            newScroll: newScroll
        });
    };
    var scrollDroppable = function scrollDroppable(id, change) {
        if (!collection) return;
        registry.droppable.getById(id).callbacks.scroll(change);
    };
    var stopPublishing = function stopPublishing() {
        if (!collection) return;
        publisher.stop();
        var home = collection.critical.droppable;
        registry.droppable.getAllByType(home.type).forEach(function(entry) {
            return entry.callbacks.dragStopped();
        });
        collection.unsubscribe();
        collection = null;
    };
    var subscriber = function subscriber(event) {
        !collection && $22db1ba098eb3017$var$invariant(false);
        var dragging = collection.critical.draggable;
        if (event.type === 'ADDITION') {
            if ($22db1ba098eb3017$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.add(event.value);
        }
        if (event.type === 'REMOVAL') {
            if ($22db1ba098eb3017$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.remove(event.value);
        }
    };
    var startPublishing = function startPublishing(request) {
        !!collection && $22db1ba098eb3017$var$invariant(false);
        var entry = registry.draggable.getById(request.draggableId);
        var home = registry.droppable.getById(entry.descriptor.droppableId);
        var critical = {
            draggable: entry.descriptor,
            droppable: home.descriptor
        };
        var unsubscribe = registry.subscribe(subscriber);
        collection = {
            critical: critical,
            unsubscribe: unsubscribe
        };
        return $22db1ba098eb3017$var$getInitialPublish({
            critical: critical,
            registry: registry,
            scrollOptions: request.scrollOptions
        });
    };
    var marshal = {
        updateDroppableIsEnabled: updateDroppableIsEnabled,
        updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
        scrollDroppable: scrollDroppable,
        updateDroppableScroll: updateDroppableScroll,
        startPublishing: startPublishing,
        stopPublishing: stopPublishing
    };
    return marshal;
};
var $22db1ba098eb3017$var$canStartDrag = function(state, id) {
    if (state.phase === 'IDLE') return true;
    if (state.phase !== 'DROP_ANIMATING') return false;
    if (state.completed.result.draggableId === id) return false;
    return state.completed.result.reason === 'DROP';
};
var $22db1ba098eb3017$var$scrollWindow = function(change) {
    window.scrollBy(change.x, change.y);
};
var $22db1ba098eb3017$var$getScrollableDroppables = (0, $jQbLg.default)(function(droppables) {
    return $22db1ba098eb3017$var$toDroppableList(droppables).filter(function(droppable) {
        if (!droppable.isEnabled) return false;
        if (!droppable.frame) return false;
        return true;
    });
});
var $22db1ba098eb3017$var$getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
    var maybe = $22db1ba098eb3017$var$find($22db1ba098eb3017$var$getScrollableDroppables(droppables), function(droppable) {
        !droppable.frame && $22db1ba098eb3017$var$invariant(false);
        return $22db1ba098eb3017$var$isPositionInFrame(droppable.frame.pageMarginBox)(target);
    });
    return maybe;
};
var $22db1ba098eb3017$var$getBestScrollableDroppable = function(_ref) {
    var center = _ref.center, destination = _ref.destination, droppables = _ref.droppables;
    if (destination) {
        var _dimension = droppables[destination];
        if (!_dimension.frame) return null;
        return _dimension;
    }
    var dimension = $22db1ba098eb3017$var$getScrollableDroppableOver(center, droppables);
    return dimension;
};
var $22db1ba098eb3017$var$config = {
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    maxPixelScroll: 28,
    ease: function ease(percentage) {
        return Math.pow(percentage, 2);
    },
    durationDampening: {
        stopDampeningAt: 1200,
        accelerateAt: 360
    }
};
var $22db1ba098eb3017$var$getDistanceThresholds = function(container, axis) {
    var startScrollingFrom = container[axis.size] * $22db1ba098eb3017$var$config.startFromPercentage;
    var maxScrollValueAt = container[axis.size] * $22db1ba098eb3017$var$config.maxScrollAtPercentage;
    var thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var $22db1ba098eb3017$var$getPercentage = function(_ref) {
    var startOfRange = _ref.startOfRange, endOfRange = _ref.endOfRange, current = _ref.current;
    var range = endOfRange - startOfRange;
    if (range === 0) return 0;
    var currentInRange = current - startOfRange;
    var percentage = currentInRange / range;
    return percentage;
};
var $22db1ba098eb3017$var$minScroll = 1;
var $22db1ba098eb3017$var$getValueFromDistance = function(distanceToEdge, thresholds) {
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    if (distanceToEdge <= thresholds.maxScrollValueAt) return $22db1ba098eb3017$var$config.maxPixelScroll;
    if (distanceToEdge === thresholds.startScrollingFrom) return $22db1ba098eb3017$var$minScroll;
    var percentageFromMaxScrollValueAt = $22db1ba098eb3017$var$getPercentage({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    var scroll = $22db1ba098eb3017$var$config.maxPixelScroll * $22db1ba098eb3017$var$config.ease(percentageFromStartScrollingFrom);
    return Math.ceil(scroll);
};
var $22db1ba098eb3017$var$accelerateAt = $22db1ba098eb3017$var$config.durationDampening.accelerateAt;
var $22db1ba098eb3017$var$stopAt = $22db1ba098eb3017$var$config.durationDampening.stopDampeningAt;
var $22db1ba098eb3017$var$dampenValueByTime = function(proposedScroll, dragStartTime) {
    var startOfRange = dragStartTime;
    var endOfRange = $22db1ba098eb3017$var$stopAt;
    var now = (0, (/*@__PURE__*/$parcel$interopDefault($3BSY2)))();
    var runTime = now - startOfRange;
    if (runTime >= $22db1ba098eb3017$var$stopAt) return proposedScroll;
    if (runTime < $22db1ba098eb3017$var$accelerateAt) return $22db1ba098eb3017$var$minScroll;
    var betweenAccelerateAtAndStopAtPercentage = $22db1ba098eb3017$var$getPercentage({
        startOfRange: $22db1ba098eb3017$var$accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    var scroll = proposedScroll * $22db1ba098eb3017$var$config.ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};
var $22db1ba098eb3017$var$getValue = function(_ref) {
    var distanceToEdge = _ref.distanceToEdge, thresholds = _ref.thresholds, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $22db1ba098eb3017$var$getValueFromDistance(distanceToEdge, thresholds);
    if (scroll === 0) return 0;
    if (!shouldUseTimeDampening) return scroll;
    return Math.max($22db1ba098eb3017$var$dampenValueByTime(scroll, dragStartTime), $22db1ba098eb3017$var$minScroll);
};
var $22db1ba098eb3017$var$getScrollOnAxis = function(_ref) {
    var container = _ref.container, distanceToEdges = _ref.distanceToEdges, dragStartTime = _ref.dragStartTime, axis = _ref.axis, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var thresholds = $22db1ba098eb3017$var$getDistanceThresholds(container, axis);
    var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return $22db1ba098eb3017$var$getValue({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return -1 * $22db1ba098eb3017$var$getValue({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
};
var $22db1ba098eb3017$var$adjustForSizeLimits = function(_ref) {
    var container = _ref.container, subject = _ref.subject, proposedScroll = _ref.proposedScroll;
    var isTooBigVertically = subject.height > container.height;
    var isTooBigHorizontally = subject.width > container.width;
    if (!isTooBigHorizontally && !isTooBigVertically) return proposedScroll;
    if (isTooBigHorizontally && isTooBigVertically) return null;
    return {
        x: isTooBigHorizontally ? 0 : proposedScroll.x,
        y: isTooBigVertically ? 0 : proposedScroll.y
    };
};
var $22db1ba098eb3017$var$clean$2 = $22db1ba098eb3017$var$apply(function(value) {
    return value === 0 ? 0 : value;
});
var $22db1ba098eb3017$var$getScroll = function(_ref) {
    var dragStartTime = _ref.dragStartTime, container = _ref.container, subject = _ref.subject, center = _ref.center, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    var y = $22db1ba098eb3017$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $22db1ba098eb3017$var$vertical,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var x = $22db1ba098eb3017$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $22db1ba098eb3017$var$horizontal,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var required = $22db1ba098eb3017$var$clean$2({
        x: x,
        y: y
    });
    if ($22db1ba098eb3017$var$isEqual(required, $22db1ba098eb3017$var$origin)) return null;
    var limited = $22db1ba098eb3017$var$adjustForSizeLimits({
        container: container,
        subject: subject,
        proposedScroll: required
    });
    if (!limited) return null;
    return $22db1ba098eb3017$var$isEqual(limited, $22db1ba098eb3017$var$origin) ? null : limited;
};
var $22db1ba098eb3017$var$smallestSigned = $22db1ba098eb3017$var$apply(function(value) {
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
var $22db1ba098eb3017$var$getOverlap = function() {
    var getRemainder = function getRemainder(target, max) {
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return function(_ref) {
        var current = _ref.current, max = _ref.max, change = _ref.change;
        var targetScroll = $22db1ba098eb3017$var$add(current, change);
        var overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if ($22db1ba098eb3017$var$isEqual(overlap, $22db1ba098eb3017$var$origin)) return null;
        return overlap;
    };
}();
var $22db1ba098eb3017$var$canPartiallyScroll = function canPartiallyScroll(_ref2) {
    var rawMax = _ref2.max, current = _ref2.current, change = _ref2.change;
    var max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    var smallestChange = $22db1ba098eb3017$var$smallestSigned(change);
    var overlap = $22db1ba098eb3017$var$getOverlap({
        max: max,
        current: current,
        change: smallestChange
    });
    if (!overlap) return true;
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
var $22db1ba098eb3017$var$canScrollWindow = function canScrollWindow(viewport, change) {
    return $22db1ba098eb3017$var$canPartiallyScroll({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
};
var $22db1ba098eb3017$var$getWindowOverlap = function getWindowOverlap(viewport, change) {
    if (!$22db1ba098eb3017$var$canScrollWindow(viewport, change)) return null;
    var max = viewport.scroll.max;
    var current = viewport.scroll.current;
    return $22db1ba098eb3017$var$getOverlap({
        current: current,
        max: max,
        change: change
    });
};
var $22db1ba098eb3017$var$canScrollDroppable = function canScrollDroppable(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return false;
    return $22db1ba098eb3017$var$canPartiallyScroll({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $22db1ba098eb3017$var$getDroppableOverlap = function getDroppableOverlap(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return null;
    if (!$22db1ba098eb3017$var$canScrollDroppable(droppable, change)) return null;
    return $22db1ba098eb3017$var$getOverlap({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $22db1ba098eb3017$var$getWindowScrollChange = function(_ref) {
    var viewport = _ref.viewport, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $22db1ba098eb3017$var$getScroll({
        dragStartTime: dragStartTime,
        container: viewport.frame,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $22db1ba098eb3017$var$canScrollWindow(viewport, scroll) ? scroll : null;
};
var $22db1ba098eb3017$var$getDroppableScrollChange = function(_ref) {
    var droppable = _ref.droppable, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var frame = droppable.frame;
    if (!frame) return null;
    var scroll = $22db1ba098eb3017$var$getScroll({
        dragStartTime: dragStartTime,
        container: frame.pageMarginBox,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $22db1ba098eb3017$var$canScrollDroppable(droppable, scroll) ? scroll : null;
};
var $22db1ba098eb3017$var$scroll$1 = function(_ref) {
    var state = _ref.state, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening, scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var center = state.current.page.borderBoxCenter;
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var subject = draggable.page.marginBox;
    if (state.isWindowScrollAllowed) {
        var viewport = state.viewport;
        var _change = $22db1ba098eb3017$var$getWindowScrollChange({
            dragStartTime: dragStartTime,
            viewport: viewport,
            subject: subject,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (_change) {
            scrollWindow(_change);
            return;
        }
    }
    var droppable = $22db1ba098eb3017$var$getBestScrollableDroppable({
        center: center,
        destination: $22db1ba098eb3017$var$whatIsDraggedOver(state.impact),
        droppables: state.dimensions.droppables
    });
    if (!droppable) return;
    var change = $22db1ba098eb3017$var$getDroppableScrollChange({
        dragStartTime: dragStartTime,
        droppable: droppable,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    if (change) scrollDroppable(droppable.descriptor.id, change);
};
var $22db1ba098eb3017$var$createFluidScroller = function(_ref) {
    var scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var scheduleWindowScroll = (0, $7qpjg.default)(scrollWindow);
    var scheduleDroppableScroll = (0, $7qpjg.default)(scrollDroppable);
    var dragging = null;
    var tryScroll = function tryScroll(state) {
        !dragging && $22db1ba098eb3017$var$invariant(false);
        var _dragging = dragging, shouldUseTimeDampening = _dragging.shouldUseTimeDampening, dragStartTime = _dragging.dragStartTime;
        $22db1ba098eb3017$var$scroll$1({
            state: state,
            scrollWindow: scheduleWindowScroll,
            scrollDroppable: scheduleDroppableScroll,
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
    };
    var start$1 = function start$1(state) {
        $22db1ba098eb3017$var$start('starting fluid scroller');
        !!dragging && $22db1ba098eb3017$var$invariant(false);
        var dragStartTime = (0, (/*@__PURE__*/$parcel$interopDefault($3BSY2)))();
        var wasScrollNeeded = false;
        var fakeScrollCallback = function fakeScrollCallback() {
            wasScrollNeeded = true;
        };
        $22db1ba098eb3017$var$scroll$1({
            state: state,
            dragStartTime: 0,
            shouldUseTimeDampening: false,
            scrollWindow: fakeScrollCallback,
            scrollDroppable: fakeScrollCallback
        });
        dragging = {
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: wasScrollNeeded
        };
        $22db1ba098eb3017$var$finish('starting fluid scroller');
        if (wasScrollNeeded) tryScroll(state);
    };
    var stop = function stop() {
        if (!dragging) return;
        scheduleWindowScroll.cancel();
        scheduleDroppableScroll.cancel();
        dragging = null;
    };
    return {
        start: start$1,
        stop: stop,
        scroll: tryScroll
    };
};
var $22db1ba098eb3017$var$createJumpScroller = function(_ref) {
    var move = _ref.move, scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow;
    var moveByOffset = function moveByOffset(state, offset) {
        var client = $22db1ba098eb3017$var$add(state.current.client.selection, offset);
        move({
            client: client
        });
    };
    var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
        if (!$22db1ba098eb3017$var$canScrollDroppable(droppable, change)) return change;
        var overlap = $22db1ba098eb3017$var$getDroppableOverlap(droppable, change);
        if (!overlap) {
            scrollDroppable(droppable.descriptor.id, change);
            return null;
        }
        var whatTheDroppableCanScroll = $22db1ba098eb3017$var$subtract(change, overlap);
        scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
        var remainder = $22db1ba098eb3017$var$subtract(change, whatTheDroppableCanScroll);
        return remainder;
    };
    var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
        if (!isWindowScrollAllowed) return change;
        if (!$22db1ba098eb3017$var$canScrollWindow(viewport, change)) return change;
        var overlap = $22db1ba098eb3017$var$getWindowOverlap(viewport, change);
        if (!overlap) {
            scrollWindow(change);
            return null;
        }
        var whatTheWindowCanScroll = $22db1ba098eb3017$var$subtract(change, overlap);
        scrollWindow(whatTheWindowCanScroll);
        var remainder = $22db1ba098eb3017$var$subtract(change, whatTheWindowCanScroll);
        return remainder;
    };
    var jumpScroller = function jumpScroller(state) {
        var request = state.scrollJumpRequest;
        if (!request) return;
        var destination = $22db1ba098eb3017$var$whatIsDraggedOver(state.impact);
        !destination && $22db1ba098eb3017$var$invariant(false);
        var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);
        if (!droppableRemainder) return;
        var viewport = state.viewport;
        var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);
        if (!windowRemainder) return;
        moveByOffset(state, windowRemainder);
    };
    return jumpScroller;
};
var $22db1ba098eb3017$var$createAutoScroller = function(_ref) {
    var scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow, move = _ref.move;
    var fluidScroller = $22db1ba098eb3017$var$createFluidScroller({
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var jumpScroll = $22db1ba098eb3017$var$createJumpScroller({
        move: move,
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var scroll = function scroll(state) {
        if (state.phase !== 'DRAGGING') return;
        if (state.movementMode === 'FLUID') {
            fluidScroller.scroll(state);
            return;
        }
        if (!state.scrollJumpRequest) return;
        jumpScroll(state);
    };
    var scroller = {
        scroll: scroll,
        start: fluidScroller.start,
        stop: fluidScroller.stop
    };
    return scroller;
};
var $22db1ba098eb3017$var$prefix$1 = 'data-rbd';
var $22db1ba098eb3017$var$dragHandle = function() {
    var base = $22db1ba098eb3017$var$prefix$1 + "-drag-handle";
    return {
        base: base,
        draggableId: base + "-draggable-id",
        contextId: base + "-context-id"
    };
}();
var $22db1ba098eb3017$var$draggable = function() {
    var base = $22db1ba098eb3017$var$prefix$1 + "-draggable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $22db1ba098eb3017$var$droppable = function() {
    var base = $22db1ba098eb3017$var$prefix$1 + "-droppable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $22db1ba098eb3017$var$scrollContainer = {
    contextId: $22db1ba098eb3017$var$prefix$1 + "-scroll-container-context-id"
};
var $22db1ba098eb3017$var$makeGetSelector = function makeGetSelector(context) {
    return function(attribute) {
        return "[" + attribute + "=\"" + context + "\"]";
    };
};
var $22db1ba098eb3017$var$getStyles = function getStyles(rules, property) {
    return rules.map(function(rule) {
        var value = rule.styles[property];
        if (!value) return '';
        return rule.selector + " { " + value + " }";
    }).join(' ');
};
var $22db1ba098eb3017$var$noPointerEvents = 'pointer-events: none;';
var $22db1ba098eb3017$var$getStyles$1 = function(contextId) {
    var getSelector = $22db1ba098eb3017$var$makeGetSelector(contextId);
    var dragHandle$1 = function() {
        var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
        return {
            selector: getSelector($22db1ba098eb3017$var$dragHandle.contextId),
            styles: {
                always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
                resting: grabCursor,
                dragging: $22db1ba098eb3017$var$noPointerEvents,
                dropAnimating: grabCursor
            }
        };
    }();
    var draggable$1 = function() {
        var transition = "\n      transition: " + $22db1ba098eb3017$var$transitions.outOfTheWay + ";\n    ";
        return {
            selector: getSelector($22db1ba098eb3017$var$draggable.contextId),
            styles: {
                dragging: transition,
                dropAnimating: transition,
                userCancel: transition
            }
        };
    }();
    var droppable$1 = {
        selector: getSelector($22db1ba098eb3017$var$droppable.contextId),
        styles: {
            always: "overflow-anchor: none;"
        }
    };
    var body = {
        selector: 'body',
        styles: {
            dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
        }
    };
    var rules = [
        draggable$1,
        dragHandle$1,
        droppable$1,
        body
    ];
    return {
        always: $22db1ba098eb3017$var$getStyles(rules, 'always'),
        resting: $22db1ba098eb3017$var$getStyles(rules, 'resting'),
        dragging: $22db1ba098eb3017$var$getStyles(rules, 'dragging'),
        dropAnimating: $22db1ba098eb3017$var$getStyles(rules, 'dropAnimating'),
        userCancel: $22db1ba098eb3017$var$getStyles(rules, 'userCancel')
    };
};
var $22db1ba098eb3017$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $5uXOq.useLayoutEffect) : (0, $5uXOq.useEffect);
var $22db1ba098eb3017$var$getHead = function getHead() {
    var head = document.querySelector('head');
    !head && $22db1ba098eb3017$var$invariant(false);
    return head;
};
var $22db1ba098eb3017$var$createStyleEl = function createStyleEl(nonce) {
    var el = document.createElement('style');
    if (nonce) el.setAttribute('nonce', nonce);
    el.type = 'text/css';
    return el;
};
function $22db1ba098eb3017$var$useStyleMarshal(contextId, nonce) {
    var styles = (0, $3YMLK.useMemo)(function() {
        return $22db1ba098eb3017$var$getStyles$1(contextId);
    }, [
        contextId
    ]);
    var alwaysRef = (0, $5uXOq.useRef)(null);
    var dynamicRef = (0, $5uXOq.useRef)(null);
    var setDynamicStyle = (0, $3YMLK.useCallback)((0, $jQbLg.default)(function(proposed) {
        var el = dynamicRef.current;
        !el && $22db1ba098eb3017$var$invariant(false);
        el.textContent = proposed;
    }), []);
    var setAlwaysStyle = (0, $3YMLK.useCallback)(function(proposed) {
        var el = alwaysRef.current;
        !el && $22db1ba098eb3017$var$invariant(false);
        el.textContent = proposed;
    }, []);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
        !(!alwaysRef.current && !dynamicRef.current) && $22db1ba098eb3017$var$invariant(false);
        var always = $22db1ba098eb3017$var$createStyleEl(nonce);
        var dynamic = $22db1ba098eb3017$var$createStyleEl(nonce);
        alwaysRef.current = always;
        dynamicRef.current = dynamic;
        always.setAttribute($22db1ba098eb3017$var$prefix$1 + "-always", contextId);
        dynamic.setAttribute($22db1ba098eb3017$var$prefix$1 + "-dynamic", contextId);
        $22db1ba098eb3017$var$getHead().appendChild(always);
        $22db1ba098eb3017$var$getHead().appendChild(dynamic);
        setAlwaysStyle(styles.always);
        setDynamicStyle(styles.resting);
        return function() {
            var remove = function remove(ref) {
                var current = ref.current;
                !current && $22db1ba098eb3017$var$invariant(false);
                $22db1ba098eb3017$var$getHead().removeChild(current);
                ref.current = null;
            };
            remove(alwaysRef);
            remove(dynamicRef);
        };
    }, [
        nonce,
        setAlwaysStyle,
        setDynamicStyle,
        styles.always,
        styles.resting,
        contextId
    ]);
    var dragging = (0, $3YMLK.useCallback)(function() {
        return setDynamicStyle(styles.dragging);
    }, [
        setDynamicStyle,
        styles.dragging
    ]);
    var dropping = (0, $3YMLK.useCallback)(function(reason) {
        if (reason === 'DROP') {
            setDynamicStyle(styles.dropAnimating);
            return;
        }
        setDynamicStyle(styles.userCancel);
    }, [
        setDynamicStyle,
        styles.dropAnimating,
        styles.userCancel
    ]);
    var resting = (0, $3YMLK.useCallback)(function() {
        if (!dynamicRef.current) return;
        setDynamicStyle(styles.resting);
    }, [
        setDynamicStyle,
        styles.resting
    ]);
    var marshal = (0, $3YMLK.useMemo)(function() {
        return {
            dragging: dragging,
            dropping: dropping,
            resting: resting
        };
    }, [
        dragging,
        dropping,
        resting
    ]);
    return marshal;
}
var $22db1ba098eb3017$var$getWindowFromEl = function(el) {
    return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
};
function $22db1ba098eb3017$var$isHtmlElement(el) {
    return el instanceof $22db1ba098eb3017$var$getWindowFromEl(el).HTMLElement;
}
function $22db1ba098eb3017$var$findDragHandle(contextId, draggableId) {
    var selector = "[" + $22db1ba098eb3017$var$dragHandle.contextId + "=\"" + contextId + "\"]";
    var possible = $22db1ba098eb3017$var$toArray(document.querySelectorAll(selector));
    if (!possible.length) return null;
    var handle = $22db1ba098eb3017$var$find(possible, function(el) {
        return el.getAttribute($22db1ba098eb3017$var$dragHandle.draggableId) === draggableId;
    });
    if (!handle) return null;
    if (!$22db1ba098eb3017$var$isHtmlElement(handle)) return null;
    return handle;
}
function $22db1ba098eb3017$var$useFocusMarshal(contextId) {
    var entriesRef = (0, $5uXOq.useRef)({});
    var recordRef = (0, $5uXOq.useRef)(null);
    var restoreFocusFrameRef = (0, $5uXOq.useRef)(null);
    var isMountedRef = (0, $5uXOq.useRef)(false);
    var register = (0, $3YMLK.useCallback)(function register(id, focus) {
        var entry = {
            id: id,
            focus: focus
        };
        entriesRef.current[id] = entry;
        return function unregister() {
            var entries = entriesRef.current;
            var current = entries[id];
            if (current !== entry) delete entries[id];
        };
    }, []);
    var tryGiveFocus = (0, $3YMLK.useCallback)(function tryGiveFocus(tryGiveFocusTo) {
        var handle = $22db1ba098eb3017$var$findDragHandle(contextId, tryGiveFocusTo);
        if (handle && handle !== document.activeElement) handle.focus();
    }, [
        contextId
    ]);
    var tryShiftRecord = (0, $3YMLK.useCallback)(function tryShiftRecord(previous, redirectTo) {
        if (recordRef.current === previous) recordRef.current = redirectTo;
    }, []);
    var tryRestoreFocusRecorded = (0, $3YMLK.useCallback)(function tryRestoreFocusRecorded() {
        if (restoreFocusFrameRef.current) return;
        if (!isMountedRef.current) return;
        restoreFocusFrameRef.current = requestAnimationFrame(function() {
            restoreFocusFrameRef.current = null;
            var record = recordRef.current;
            if (record) tryGiveFocus(record);
        });
    }, [
        tryGiveFocus
    ]);
    var tryRecordFocus = (0, $3YMLK.useCallback)(function tryRecordFocus(id) {
        recordRef.current = null;
        var focused = document.activeElement;
        if (!focused) return;
        if (focused.getAttribute($22db1ba098eb3017$var$dragHandle.draggableId) !== id) return;
        recordRef.current = id;
    }, []);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
        isMountedRef.current = true;
        return function clearFrameOnUnmount() {
            isMountedRef.current = false;
            var frameId = restoreFocusFrameRef.current;
            if (frameId) cancelAnimationFrame(frameId);
        };
    }, []);
    var marshal = (0, $3YMLK.useMemo)(function() {
        return {
            register: register,
            tryRecordFocus: tryRecordFocus,
            tryRestoreFocusRecorded: tryRestoreFocusRecorded,
            tryShiftRecord: tryShiftRecord
        };
    }, [
        register,
        tryRecordFocus,
        tryRestoreFocusRecorded,
        tryShiftRecord
    ]);
    return marshal;
}
function $22db1ba098eb3017$var$createRegistry() {
    var entries = {
        draggables: {},
        droppables: {}
    };
    var subscribers = [];
    function subscribe(cb) {
        subscribers.push(cb);
        return function unsubscribe() {
            var index = subscribers.indexOf(cb);
            if (index === -1) return;
            subscribers.splice(index, 1);
        };
    }
    function notify(event) {
        if (subscribers.length) subscribers.forEach(function(cb) {
            return cb(event);
        });
    }
    function findDraggableById(id) {
        return entries.draggables[id] || null;
    }
    function getDraggableById(id) {
        var entry = findDraggableById(id);
        !entry && $22db1ba098eb3017$var$invariant(false);
        return entry;
    }
    var draggableAPI = {
        register: function register(entry) {
            entries.draggables[entry.descriptor.id] = entry;
            notify({
                type: 'ADDITION',
                value: entry
            });
        },
        update: function update(entry, last) {
            var current = entries.draggables[last.descriptor.id];
            if (!current) return;
            if (current.uniqueId !== entry.uniqueId) return;
            delete entries.draggables[last.descriptor.id];
            entries.draggables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var draggableId = entry.descriptor.id;
            var current = findDraggableById(draggableId);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.draggables[draggableId];
            notify({
                type: 'REMOVAL',
                value: entry
            });
        },
        getById: getDraggableById,
        findById: findDraggableById,
        exists: function exists(id) {
            return Boolean(findDraggableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $22db1ba098eb3017$var$values(entries.draggables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function findDroppableById(id) {
        return entries.droppables[id] || null;
    }
    function getDroppableById(id) {
        var entry = findDroppableById(id);
        !entry && $22db1ba098eb3017$var$invariant(false);
        return entry;
    }
    var droppableAPI = {
        register: function register(entry) {
            entries.droppables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var current = findDroppableById(entry.descriptor.id);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.droppables[entry.descriptor.id];
        },
        getById: getDroppableById,
        findById: findDroppableById,
        exists: function exists(id) {
            return Boolean(findDroppableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $22db1ba098eb3017$var$values(entries.droppables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function clean() {
        entries.draggables = {};
        entries.droppables = {};
        subscribers.length = 0;
    }
    return {
        draggable: draggableAPI,
        droppable: droppableAPI,
        subscribe: subscribe,
        clean: clean
    };
}
function $22db1ba098eb3017$var$useRegistry() {
    var registry = (0, $3YMLK.useMemo)($22db1ba098eb3017$var$createRegistry, []);
    (0, $5uXOq.useEffect)(function() {
        return function unmount() {
            requestAnimationFrame(registry.clean);
        };
    }, [
        registry
    ]);
    return registry;
}
var $22db1ba098eb3017$var$StoreContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(null);
var $22db1ba098eb3017$var$getBodyElement = function() {
    var body = document.body;
    !body && $22db1ba098eb3017$var$invariant(false);
    return body;
};
var $22db1ba098eb3017$var$visuallyHidden = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    margin: '-1px',
    border: '0',
    padding: '0',
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    'clip-path': 'inset(100%)'
};
var $22db1ba098eb3017$var$getId = function getId(contextId) {
    return "rbd-announcement-" + contextId;
};
function $22db1ba098eb3017$var$useAnnouncer(contextId) {
    var id = (0, $3YMLK.useMemo)(function() {
        return $22db1ba098eb3017$var$getId(contextId);
    }, [
        contextId
    ]);
    var ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(function setup() {
        var el = document.createElement('div');
        ref.current = el;
        el.id = id;
        el.setAttribute('aria-live', 'assertive');
        el.setAttribute('role', 'log');
        el.setAttribute('aria-atomic', 'true');
        (0, (/*@__PURE__*/$parcel$interopDefault($4iZOV)))(el.style, $22db1ba098eb3017$var$visuallyHidden);
        $22db1ba098eb3017$var$getBodyElement().appendChild(el);
        return function cleanup() {
            setTimeout(function remove() {
                $22db1ba098eb3017$var$getBodyElement().removeChild(el);
                if (el === ref.current) ref.current = null;
            });
        };
    }, [
        id
    ]);
    var announce = (0, $3YMLK.useCallback)(function(message) {
        var el = ref.current;
        if (el) {
            el.textContent = message;
            return;
        }
    }, []);
    return announce;
}
var $22db1ba098eb3017$var$getId$1 = function getId(contextId) {
    return "rbd-lift-instruction-" + contextId;
};
function $22db1ba098eb3017$var$useLiftInstruction(contextId, liftInstruction) {
    var id = (0, $3YMLK.useMemo)(function() {
        return $22db1ba098eb3017$var$getId$1(contextId);
    }, [
        contextId
    ]);
    (0, $5uXOq.useEffect)(function mount() {
        var el = document.createElement('div');
        el.id = id;
        el.textContent = liftInstruction;
        (0, (/*@__PURE__*/$parcel$interopDefault($4iZOV)))(el.style, {
            display: 'none'
        });
        $22db1ba098eb3017$var$getBodyElement().appendChild(el);
        return function unmount() {
            $22db1ba098eb3017$var$getBodyElement().removeChild(el);
        };
    }, [
        id,
        liftInstruction
    ]);
    return id;
}
var $22db1ba098eb3017$var$AppContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(null);
var $22db1ba098eb3017$var$peerDependencies = {
    react: "^16.8.5",
    "react-dom": "^16.8.5"
};
var $22db1ba098eb3017$var$semver = /(\d+)\.(\d+)\.(\d+)/;
var $22db1ba098eb3017$var$getVersion = function getVersion(value) {
    var result = $22db1ba098eb3017$var$semver.exec(value);
    !(result != null) && $22db1ba098eb3017$var$invariant(false);
    var major = Number(result[1]);
    var minor = Number(result[2]);
    var patch = Number(result[3]);
    return {
        major: major,
        minor: minor,
        patch: patch,
        raw: value
    };
};
var $22db1ba098eb3017$var$isSatisfied = function isSatisfied(expected, actual) {
    if (actual.major > expected.major) return true;
    if (actual.major < expected.major) return false;
    if (actual.minor > expected.minor) return true;
    if (actual.minor < expected.minor) return false;
    return actual.patch >= expected.patch;
};
var $22db1ba098eb3017$var$checkReactVersion = function(peerDepValue, actualValue) {
    var peerDep = $22db1ba098eb3017$var$getVersion(peerDepValue);
    var actual = $22db1ba098eb3017$var$getVersion(actualValue);
    if ($22db1ba098eb3017$var$isSatisfied(peerDep, actual)) return;
};
var $22db1ba098eb3017$var$suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var $22db1ba098eb3017$var$checkDoctype = function(doc) {
    var doctype = doc.doctype;
    if (!doctype) return;
    doctype.name.toLowerCase();
    doctype.publicId;
};
function $22db1ba098eb3017$var$useDev(useHook) {}
function $22db1ba098eb3017$var$useDevSetupWarning(fn, inputs) {
    $22db1ba098eb3017$var$useDev(function() {
        (0, $5uXOq.useEffect)(function() {
            try {
                fn();
            } catch (e) {
                $22db1ba098eb3017$var$error("\n          A setup problem was encountered.\n\n          > " + e.message + "\n        ");
            }
        }, inputs);
    });
}
function $22db1ba098eb3017$var$useStartupValidation() {
    $22db1ba098eb3017$var$useDevSetupWarning(function() {
        $22db1ba098eb3017$var$checkReactVersion($22db1ba098eb3017$var$peerDependencies.react, (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).version);
        $22db1ba098eb3017$var$checkDoctype(document);
    }, []);
}
function $22db1ba098eb3017$var$usePrevious(current) {
    var ref = (0, $5uXOq.useRef)(current);
    (0, $5uXOq.useEffect)(function() {
        ref.current = current;
    });
    return ref;
}
function $22db1ba098eb3017$var$create() {
    var lock = null;
    function isClaimed() {
        return Boolean(lock);
    }
    function isActive(value) {
        return value === lock;
    }
    function claim(abandon) {
        !!lock && $22db1ba098eb3017$var$invariant(false);
        var newLock = {
            abandon: abandon
        };
        lock = newLock;
        return newLock;
    }
    function release() {
        !lock && $22db1ba098eb3017$var$invariant(false);
        lock = null;
    }
    function tryAbandon() {
        if (lock) {
            lock.abandon();
            release();
        }
    }
    return {
        isClaimed: isClaimed,
        isActive: isActive,
        claim: claim,
        release: release,
        tryAbandon: tryAbandon
    };
}
var $22db1ba098eb3017$var$tab = 9;
var $22db1ba098eb3017$var$enter = 13;
var $22db1ba098eb3017$var$escape = 27;
var $22db1ba098eb3017$var$space = 32;
var $22db1ba098eb3017$var$pageUp = 33;
var $22db1ba098eb3017$var$pageDown = 34;
var $22db1ba098eb3017$var$end = 35;
var $22db1ba098eb3017$var$home = 36;
var $22db1ba098eb3017$var$arrowLeft = 37;
var $22db1ba098eb3017$var$arrowUp = 38;
var $22db1ba098eb3017$var$arrowRight = 39;
var $22db1ba098eb3017$var$arrowDown = 40;
var $22db1ba098eb3017$var$_preventedKeys;
var $22db1ba098eb3017$var$preventedKeys = ($22db1ba098eb3017$var$_preventedKeys = {}, $22db1ba098eb3017$var$_preventedKeys[$22db1ba098eb3017$var$enter] = true, $22db1ba098eb3017$var$_preventedKeys[$22db1ba098eb3017$var$tab] = true, $22db1ba098eb3017$var$_preventedKeys);
var $22db1ba098eb3017$var$preventStandardKeyEvents = function(event) {
    if ($22db1ba098eb3017$var$preventedKeys[event.keyCode]) event.preventDefault();
};
var $22db1ba098eb3017$var$supportedEventName = function() {
    var base = 'visibilitychange';
    if (typeof document === 'undefined') return base;
    var candidates = [
        base,
        "ms" + base,
        "webkit" + base,
        "moz" + base,
        "o" + base
    ];
    var supported = $22db1ba098eb3017$var$find(candidates, function(eventName) {
        return "on" + eventName in document;
    });
    return supported || base;
}();
var $22db1ba098eb3017$var$primaryButton = 0;
var $22db1ba098eb3017$var$sloppyClickThreshold = 5;
function $22db1ba098eb3017$var$isSloppyClickThresholdExceeded(original, current) {
    return Math.abs(current.x - original.x) >= $22db1ba098eb3017$var$sloppyClickThreshold || Math.abs(current.y - original.y) >= $22db1ba098eb3017$var$sloppyClickThreshold;
}
var $22db1ba098eb3017$var$idle$1 = {
    type: 'IDLE'
};
function $22db1ba098eb3017$var$getCaptureBindings(_ref) {
    var cancel = _ref.cancel, completed = _ref.completed, getPhase = _ref.getPhase, setPhase = _ref.setPhase;
    return [
        {
            eventName: 'mousemove',
            fn: function fn(event) {
                var button = event.button, clientX = event.clientX, clientY = event.clientY;
                if (button !== $22db1ba098eb3017$var$primaryButton) return;
                var point = {
                    x: clientX,
                    y: clientY
                };
                var phase = getPhase();
                if (phase.type === 'DRAGGING') {
                    event.preventDefault();
                    phase.actions.move(point);
                    return;
                }
                !(phase.type === 'PENDING') && $22db1ba098eb3017$var$invariant(false);
                var pending = phase.point;
                if (!$22db1ba098eb3017$var$isSloppyClickThresholdExceeded(pending, point)) return;
                event.preventDefault();
                var actions = phase.actions.fluidLift(point);
                setPhase({
                    type: 'DRAGGING',
                    actions: actions
                });
            }
        },
        {
            eventName: 'mouseup',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: 'mousedown',
            fn: function fn(event) {
                if (getPhase().type === 'DRAGGING') event.preventDefault();
                cancel();
            }
        },
        {
            eventName: 'keydown',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type === 'PENDING') {
                    cancel();
                    return;
                }
                if (event.keyCode === $22db1ba098eb3017$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                $22db1ba098eb3017$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'scroll',
            options: {
                passive: true,
                capture: false
            },
            fn: function fn() {
                if (getPhase().type === 'PENDING') cancel();
            }
        },
        {
            eventName: 'webkitmouseforcedown',
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== 'IDLE') && $22db1ba098eb3017$var$invariant(false);
                if (phase.actions.shouldRespectForcePress()) {
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $22db1ba098eb3017$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $22db1ba098eb3017$var$useMouseSensor(api) {
    var phaseRef = (0, $5uXOq.useRef)($22db1ba098eb3017$var$idle$1);
    var unbindEventsRef = (0, $5uXOq.useRef)($22db1ba098eb3017$var$noop);
    var startCaptureBinding = (0, $3YMLK.useMemo)(function() {
        return {
            eventName: 'mousedown',
            fn: function onMouseDown(event) {
                if (event.defaultPrevented) return;
                if (event.button !== $22db1ba098eb3017$var$primaryButton) return;
                if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                event.preventDefault();
                var point = {
                    x: event.clientX,
                    y: event.clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var preventForcePressBinding = (0, $3YMLK.useMemo)(function() {
        return {
            eventName: 'webkitmouseforcewillbegin',
            fn: function fn(event) {
                if (event.defaultPrevented) return;
                var id = api.findClosestDraggableId(event);
                if (!id) return;
                var options = api.findOptionsForDraggable(id);
                if (!options) return;
                if (options.shouldRespectForcePress) return;
                if (!api.canGetLock(id)) return;
                event.preventDefault();
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $3YMLK.useCallback)(function listenForCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $22db1ba098eb3017$var$bindEvents(window, [
            preventForcePressBinding,
            startCaptureBinding
        ], options);
    }, [
        preventForcePressBinding,
        startCaptureBinding
    ]);
    var stop = (0, $3YMLK.useCallback)(function() {
        var current = phaseRef.current;
        if (current.type === 'IDLE') return;
        phaseRef.current = $22db1ba098eb3017$var$idle$1;
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture
    ]);
    var cancel = (0, $3YMLK.useCallback)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === 'DRAGGING') phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === 'PENDING') phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $3YMLK.useCallback)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var bindings = $22db1ba098eb3017$var$getCaptureBindings({
            cancel: cancel,
            completed: stop,
            getPhase: function getPhase() {
                return phaseRef.current;
            },
            setPhase: function setPhase(phase) {
                phaseRef.current = phase;
            }
        });
        unbindEventsRef.current = $22db1ba098eb3017$var$bindEvents(window, bindings, options);
    }, [
        cancel,
        stop
    ]);
    var startPendingDrag = (0, $3YMLK.useCallback)(function startPendingDrag(actions, point) {
        !(phaseRef.current.type === 'IDLE') && $22db1ba098eb3017$var$invariant(false);
        phaseRef.current = {
            type: 'PENDING',
            point: point,
            actions: actions
        };
        bindCapturingEvents();
    }, [
        bindCapturingEvents
    ]);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $22db1ba098eb3017$var$_scrollJumpKeys;
function $22db1ba098eb3017$var$noop$1() {}
var $22db1ba098eb3017$var$scrollJumpKeys = ($22db1ba098eb3017$var$_scrollJumpKeys = {}, $22db1ba098eb3017$var$_scrollJumpKeys[$22db1ba098eb3017$var$pageDown] = true, $22db1ba098eb3017$var$_scrollJumpKeys[$22db1ba098eb3017$var$pageUp] = true, $22db1ba098eb3017$var$_scrollJumpKeys[$22db1ba098eb3017$var$home] = true, $22db1ba098eb3017$var$_scrollJumpKeys[$22db1ba098eb3017$var$end] = true, $22db1ba098eb3017$var$_scrollJumpKeys);
function $22db1ba098eb3017$var$getDraggingBindings(actions, stop) {
    function cancel() {
        stop();
        actions.cancel();
    }
    function drop() {
        stop();
        actions.drop();
    }
    return [
        {
            eventName: 'keydown',
            fn: function fn(event) {
                if (event.keyCode === $22db1ba098eb3017$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                if (event.keyCode === $22db1ba098eb3017$var$space) {
                    event.preventDefault();
                    drop();
                    return;
                }
                if (event.keyCode === $22db1ba098eb3017$var$arrowDown) {
                    event.preventDefault();
                    actions.moveDown();
                    return;
                }
                if (event.keyCode === $22db1ba098eb3017$var$arrowUp) {
                    event.preventDefault();
                    actions.moveUp();
                    return;
                }
                if (event.keyCode === $22db1ba098eb3017$var$arrowRight) {
                    event.preventDefault();
                    actions.moveRight();
                    return;
                }
                if (event.keyCode === $22db1ba098eb3017$var$arrowLeft) {
                    event.preventDefault();
                    actions.moveLeft();
                    return;
                }
                if ($22db1ba098eb3017$var$scrollJumpKeys[event.keyCode]) {
                    event.preventDefault();
                    return;
                }
                $22db1ba098eb3017$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: 'mousedown',
            fn: cancel
        },
        {
            eventName: 'mouseup',
            fn: cancel
        },
        {
            eventName: 'click',
            fn: cancel
        },
        {
            eventName: 'touchstart',
            fn: cancel
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'wheel',
            fn: cancel,
            options: {
                passive: true
            }
        },
        {
            eventName: $22db1ba098eb3017$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $22db1ba098eb3017$var$useKeyboardSensor(api) {
    var unbindEventsRef = (0, $5uXOq.useRef)($22db1ba098eb3017$var$noop$1);
    var startCaptureBinding = (0, $3YMLK.useMemo)(function() {
        return {
            eventName: 'keydown',
            fn: function onKeyDown(event) {
                if (event.defaultPrevented) return;
                if (event.keyCode !== $22db1ba098eb3017$var$space) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var preDrag = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!preDrag) return;
                event.preventDefault();
                var isCapturing = true;
                var actions = preDrag.snapLift();
                unbindEventsRef.current();
                function stop() {
                    !isCapturing && $22db1ba098eb3017$var$invariant(false);
                    isCapturing = false;
                    unbindEventsRef.current();
                    listenForCapture();
                }
                unbindEventsRef.current = $22db1ba098eb3017$var$bindEvents(window, $22db1ba098eb3017$var$getDraggingBindings(actions, stop), {
                    capture: true,
                    passive: false
                });
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $3YMLK.useCallback)(function tryStartCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $22db1ba098eb3017$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $22db1ba098eb3017$var$idle$2 = {
    type: 'IDLE'
};
var $22db1ba098eb3017$var$timeForLongPress = 120;
var $22db1ba098eb3017$var$forcePressThreshold = 0.15;
function $22db1ba098eb3017$var$getWindowBindings(_ref) {
    var cancel = _ref.cancel, getPhase = _ref.getPhase;
    return [
        {
            eventName: 'orientationchange',
            fn: cancel
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'contextmenu',
            fn: function fn(event) {
                event.preventDefault();
            }
        },
        {
            eventName: 'keydown',
            fn: function fn(event) {
                if (getPhase().type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                if (event.keyCode === $22db1ba098eb3017$var$escape) event.preventDefault();
                cancel();
            }
        },
        {
            eventName: $22db1ba098eb3017$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $22db1ba098eb3017$var$getHandleBindings(_ref2) {
    var cancel = _ref2.cancel, completed = _ref2.completed, getPhase = _ref2.getPhase;
    return [
        {
            eventName: 'touchmove',
            options: {
                capture: false
            },
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                phase.hasMoved = true;
                var _event$touches$ = event.touches[0], clientX = _event$touches$.clientX, clientY = _event$touches$.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                event.preventDefault();
                phase.actions.move(point);
            }
        },
        {
            eventName: 'touchend',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: 'touchcancel',
            fn: function fn(event) {
                if (getPhase().type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                cancel();
            }
        },
        {
            eventName: 'touchforcechange',
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== 'IDLE') && $22db1ba098eb3017$var$invariant(false);
                var touch = event.touches[0];
                if (!touch) return;
                var isForcePress = touch.force >= $22db1ba098eb3017$var$forcePressThreshold;
                if (!isForcePress) return;
                var shouldRespect = phase.actions.shouldRespectForcePress();
                if (phase.type === 'PENDING') {
                    if (shouldRespect) cancel();
                    return;
                }
                if (shouldRespect) {
                    if (phase.hasMoved) {
                        event.preventDefault();
                        return;
                    }
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $22db1ba098eb3017$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $22db1ba098eb3017$var$useMouseSensor$1(api) {
    var phaseRef = (0, $5uXOq.useRef)($22db1ba098eb3017$var$idle$2);
    var unbindEventsRef = (0, $5uXOq.useRef)($22db1ba098eb3017$var$noop);
    var getPhase = (0, $3YMLK.useCallback)(function getPhase() {
        return phaseRef.current;
    }, []);
    var setPhase = (0, $3YMLK.useCallback)(function setPhase(phase) {
        phaseRef.current = phase;
    }, []);
    var startCaptureBinding = (0, $3YMLK.useMemo)(function() {
        return {
            eventName: 'touchstart',
            fn: function onTouchStart(event) {
                if (event.defaultPrevented) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                var touch = event.touches[0];
                var clientX = touch.clientX, clientY = touch.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $3YMLK.useCallback)(function listenForCapture() {
        var options = {
            capture: true,
            passive: false
        };
        unbindEventsRef.current = $22db1ba098eb3017$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    var stop = (0, $3YMLK.useCallback)(function() {
        var current = phaseRef.current;
        if (current.type === 'IDLE') return;
        if (current.type === 'PENDING') clearTimeout(current.longPressTimerId);
        setPhase($22db1ba098eb3017$var$idle$2);
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture,
        setPhase
    ]);
    var cancel = (0, $3YMLK.useCallback)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === 'DRAGGING') phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === 'PENDING') phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $3YMLK.useCallback)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var args = {
            cancel: cancel,
            completed: stop,
            getPhase: getPhase
        };
        var unbindTarget = $22db1ba098eb3017$var$bindEvents(window, $22db1ba098eb3017$var$getHandleBindings(args), options);
        var unbindWindow = $22db1ba098eb3017$var$bindEvents(window, $22db1ba098eb3017$var$getWindowBindings(args), options);
        unbindEventsRef.current = function unbindAll() {
            unbindTarget();
            unbindWindow();
        };
    }, [
        cancel,
        getPhase,
        stop
    ]);
    var startDragging = (0, $3YMLK.useCallback)(function startDragging() {
        var phase = getPhase();
        !(phase.type === 'PENDING') && $22db1ba098eb3017$var$invariant(false);
        var actions = phase.actions.fluidLift(phase.point);
        setPhase({
            type: 'DRAGGING',
            actions: actions,
            hasMoved: false
        });
    }, [
        getPhase,
        setPhase
    ]);
    var startPendingDrag = (0, $3YMLK.useCallback)(function startPendingDrag(actions, point) {
        !(getPhase().type === 'IDLE') && $22db1ba098eb3017$var$invariant(false);
        var longPressTimerId = setTimeout(startDragging, $22db1ba098eb3017$var$timeForLongPress);
        setPhase({
            type: 'PENDING',
            point: point,
            actions: actions,
            longPressTimerId: longPressTimerId
        });
        bindCapturingEvents();
    }, [
        bindCapturingEvents,
        getPhase,
        setPhase,
        startDragging
    ]);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
            var phase = getPhase();
            if (phase.type === 'PENDING') {
                clearTimeout(phase.longPressTimerId);
                setPhase($22db1ba098eb3017$var$idle$2);
            }
        };
    }, [
        getPhase,
        listenForCapture,
        setPhase
    ]);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function webkitHack() {
        var unbind = $22db1ba098eb3017$var$bindEvents(window, [
            {
                eventName: 'touchmove',
                fn: function fn() {},
                options: {
                    capture: false,
                    passive: false
                }
            }
        ]);
        return unbind;
    }, []);
}
function $22db1ba098eb3017$var$useValidateSensorHooks(sensorHooks) {
    $22db1ba098eb3017$var$useDev(function() {
        var previousRef = $22db1ba098eb3017$var$usePrevious(sensorHooks);
        $22db1ba098eb3017$var$useDevSetupWarning(function() {
            !(previousRef.current.length === sensorHooks.length) && $22db1ba098eb3017$var$invariant(false);
        });
    });
}
var $22db1ba098eb3017$var$interactiveTagNames = {
    input: true,
    button: true,
    textarea: true,
    select: true,
    option: true,
    optgroup: true,
    video: true,
    audio: true
};
function $22db1ba098eb3017$var$isAnInteractiveElement(parent, current) {
    if (current == null) return false;
    var hasAnInteractiveTag = Boolean($22db1ba098eb3017$var$interactiveTagNames[current.tagName.toLowerCase()]);
    if (hasAnInteractiveTag) return true;
    var attribute = current.getAttribute('contenteditable');
    if (attribute === 'true' || attribute === '') return true;
    if (current === parent) return false;
    return $22db1ba098eb3017$var$isAnInteractiveElement(parent, current.parentElement);
}
function $22db1ba098eb3017$var$isEventInInteractiveElement(draggable, event) {
    var target = event.target;
    if (!$22db1ba098eb3017$var$isHtmlElement(target)) return false;
    return $22db1ba098eb3017$var$isAnInteractiveElement(draggable, target);
}
var $22db1ba098eb3017$var$getBorderBoxCenterPosition = function(el) {
    return (0, $3YKxB.getRect)(el.getBoundingClientRect()).center;
};
function $22db1ba098eb3017$var$isElement(el) {
    return el instanceof $22db1ba098eb3017$var$getWindowFromEl(el).Element;
}
var $22db1ba098eb3017$var$supportedMatchesName = function() {
    var base = 'matches';
    if (typeof document === 'undefined') return base;
    var candidates = [
        base,
        'msMatchesSelector',
        'webkitMatchesSelector'
    ];
    var value = $22db1ba098eb3017$var$find(candidates, function(name) {
        return name in Element.prototype;
    });
    return value || base;
}();
function $22db1ba098eb3017$var$closestPonyfill(el, selector) {
    if (el == null) return null;
    if (el[$22db1ba098eb3017$var$supportedMatchesName](selector)) return el;
    return $22db1ba098eb3017$var$closestPonyfill(el.parentElement, selector);
}
function $22db1ba098eb3017$var$closest$1(el, selector) {
    if (el.closest) return el.closest(selector);
    return $22db1ba098eb3017$var$closestPonyfill(el, selector);
}
function $22db1ba098eb3017$var$getSelector(contextId) {
    return "[" + $22db1ba098eb3017$var$dragHandle.contextId + "=\"" + contextId + "\"]";
}
function $22db1ba098eb3017$var$findClosestDragHandleFromEvent(contextId, event) {
    var target = event.target;
    if (!$22db1ba098eb3017$var$isElement(target)) return null;
    var selector = $22db1ba098eb3017$var$getSelector(contextId);
    var handle = $22db1ba098eb3017$var$closest$1(target, selector);
    if (!handle) return null;
    if (!$22db1ba098eb3017$var$isHtmlElement(handle)) return null;
    return handle;
}
function $22db1ba098eb3017$var$tryGetClosestDraggableIdFromEvent(contextId, event) {
    var handle = $22db1ba098eb3017$var$findClosestDragHandleFromEvent(contextId, event);
    if (!handle) return null;
    return handle.getAttribute($22db1ba098eb3017$var$dragHandle.draggableId);
}
function $22db1ba098eb3017$var$findDraggable(contextId, draggableId) {
    var selector = "[" + $22db1ba098eb3017$var$draggable.contextId + "=\"" + contextId + "\"]";
    var possible = $22db1ba098eb3017$var$toArray(document.querySelectorAll(selector));
    var draggable$1 = $22db1ba098eb3017$var$find(possible, function(el) {
        return el.getAttribute($22db1ba098eb3017$var$draggable.id) === draggableId;
    });
    if (!draggable$1) return null;
    if (!$22db1ba098eb3017$var$isHtmlElement(draggable$1)) return null;
    return draggable$1;
}
function $22db1ba098eb3017$var$preventDefault(event) {
    event.preventDefault();
}
function $22db1ba098eb3017$var$_isActive(_ref) {
    var expected = _ref.expected, phase = _ref.phase, isLockActive = _ref.isLockActive, shouldWarn = _ref.shouldWarn;
    if (!isLockActive()) {
        shouldWarn;
        return false;
    }
    if (expected !== phase) {
        shouldWarn;
        return false;
    }
    return true;
}
function $22db1ba098eb3017$var$canStart(_ref2) {
    var lockAPI = _ref2.lockAPI, store = _ref2.store, registry = _ref2.registry, draggableId = _ref2.draggableId;
    if (lockAPI.isClaimed()) return false;
    var entry = registry.draggable.findById(draggableId);
    if (!entry) return false;
    if (!entry.options.isEnabled) return false;
    if (!$22db1ba098eb3017$var$canStartDrag(store.getState(), draggableId)) return false;
    return true;
}
function $22db1ba098eb3017$var$tryStart(_ref3) {
    var lockAPI = _ref3.lockAPI, contextId = _ref3.contextId, store = _ref3.store, registry = _ref3.registry, draggableId = _ref3.draggableId, forceSensorStop = _ref3.forceSensorStop, sourceEvent = _ref3.sourceEvent;
    var shouldStart = $22db1ba098eb3017$var$canStart({
        lockAPI: lockAPI,
        store: store,
        registry: registry,
        draggableId: draggableId
    });
    if (!shouldStart) return null;
    var entry = registry.draggable.getById(draggableId);
    var el = $22db1ba098eb3017$var$findDraggable(contextId, entry.descriptor.id);
    if (!el) return null;
    if (sourceEvent && !entry.options.canDragInteractiveElements && $22db1ba098eb3017$var$isEventInInteractiveElement(el, sourceEvent)) return null;
    var lock = lockAPI.claim(forceSensorStop || $22db1ba098eb3017$var$noop);
    var phase = 'PRE_DRAG';
    function getShouldRespectForcePress() {
        return entry.options.shouldRespectForcePress;
    }
    function isLockActive() {
        return lockAPI.isActive(lock);
    }
    function tryDispatch(expected, getAction) {
        if ($22db1ba098eb3017$var$_isActive({
            expected: expected,
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        })) store.dispatch(getAction());
    }
    var tryDispatchWhenDragging = tryDispatch.bind(this, 'DRAGGING');
    function lift$1(args) {
        function completed() {
            lockAPI.release();
            phase = 'COMPLETED';
        }
        if (phase !== 'PRE_DRAG') {
            completed();
            !(phase === 'PRE_DRAG') && $22db1ba098eb3017$var$invariant(false);
        }
        store.dispatch($22db1ba098eb3017$var$lift(args.liftActionArgs));
        phase = 'DRAGGING';
        function finish(reason, options) {
            if (options === void 0) options = {
                shouldBlockNextClick: false
            };
            args.cleanup();
            if (options.shouldBlockNextClick) {
                var unbind = $22db1ba098eb3017$var$bindEvents(window, [
                    {
                        eventName: 'click',
                        fn: $22db1ba098eb3017$var$preventDefault,
                        options: {
                            once: true,
                            passive: false,
                            capture: true
                        }
                    }
                ]);
                setTimeout(unbind);
            }
            completed();
            store.dispatch($22db1ba098eb3017$var$drop({
                reason: reason
            }));
        }
        return (0, $gzM5u.default)({
            isActive: function isActive() {
                return $22db1ba098eb3017$var$_isActive({
                    expected: 'DRAGGING',
                    phase: phase,
                    isLockActive: isLockActive,
                    shouldWarn: false
                });
            },
            shouldRespectForcePress: getShouldRespectForcePress,
            drop: function drop(options) {
                return finish('DROP', options);
            },
            cancel: function cancel(options) {
                return finish('CANCEL', options);
            }
        }, args.actions);
    }
    function fluidLift(clientSelection) {
        var move$1 = (0, $7qpjg.default)(function(client) {
            tryDispatchWhenDragging(function() {
                return $22db1ba098eb3017$var$move({
                    client: client
                });
            });
        });
        var api = lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: clientSelection,
                movementMode: 'FLUID'
            },
            cleanup: function cleanup() {
                return move$1.cancel();
            },
            actions: {
                move: move$1
            }
        });
        return (0, $gzM5u.default)({}, api, {
            move: move$1
        });
    }
    function snapLift() {
        var actions = {
            moveUp: function moveUp$1() {
                return tryDispatchWhenDragging($22db1ba098eb3017$var$moveUp);
            },
            moveRight: function moveRight$1() {
                return tryDispatchWhenDragging($22db1ba098eb3017$var$moveRight);
            },
            moveDown: function moveDown$1() {
                return tryDispatchWhenDragging($22db1ba098eb3017$var$moveDown);
            },
            moveLeft: function moveLeft$1() {
                return tryDispatchWhenDragging($22db1ba098eb3017$var$moveLeft);
            }
        };
        return lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: $22db1ba098eb3017$var$getBorderBoxCenterPosition(el),
                movementMode: 'SNAP'
            },
            cleanup: $22db1ba098eb3017$var$noop,
            actions: actions
        });
    }
    function abortPreDrag() {
        var shouldRelease = $22db1ba098eb3017$var$_isActive({
            expected: 'PRE_DRAG',
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        });
        if (shouldRelease) lockAPI.release();
    }
    var preDrag = {
        isActive: function isActive() {
            return $22db1ba098eb3017$var$_isActive({
                expected: 'PRE_DRAG',
                phase: phase,
                isLockActive: isLockActive,
                shouldWarn: false
            });
        },
        shouldRespectForcePress: getShouldRespectForcePress,
        fluidLift: fluidLift,
        snapLift: snapLift,
        abort: abortPreDrag
    };
    return preDrag;
}
var $22db1ba098eb3017$var$defaultSensors = [
    $22db1ba098eb3017$var$useMouseSensor,
    $22db1ba098eb3017$var$useKeyboardSensor,
    $22db1ba098eb3017$var$useMouseSensor$1
];
function $22db1ba098eb3017$var$useSensorMarshal(_ref4) {
    var contextId = _ref4.contextId, store = _ref4.store, registry = _ref4.registry, customSensors = _ref4.customSensors, enableDefaultSensors = _ref4.enableDefaultSensors;
    var useSensors = [].concat(enableDefaultSensors ? $22db1ba098eb3017$var$defaultSensors : [], customSensors || []);
    var lockAPI = (0, $5uXOq.useState)(function() {
        return $22db1ba098eb3017$var$create();
    })[0];
    var tryAbandonLock = (0, $3YMLK.useCallback)(function tryAbandonLock(previous, current) {
        if (previous.isDragging && !current.isDragging) lockAPI.tryAbandon();
    }, [
        lockAPI
    ]);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function listenToStore() {
        var previous = store.getState();
        var unsubscribe = store.subscribe(function() {
            var current = store.getState();
            tryAbandonLock(previous, current);
            previous = current;
        });
        return unsubscribe;
    }, [
        lockAPI,
        store,
        tryAbandonLock
    ]);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
        return lockAPI.tryAbandon;
    }, [
        lockAPI.tryAbandon
    ]);
    var canGetLock = (0, $3YMLK.useCallback)(function(draggableId) {
        return $22db1ba098eb3017$var$canStart({
            lockAPI: lockAPI,
            registry: registry,
            store: store,
            draggableId: draggableId
        });
    }, [
        lockAPI,
        registry,
        store
    ]);
    var tryGetLock = (0, $3YMLK.useCallback)(function(draggableId, forceStop, options) {
        return $22db1ba098eb3017$var$tryStart({
            lockAPI: lockAPI,
            registry: registry,
            contextId: contextId,
            store: store,
            draggableId: draggableId,
            forceSensorStop: forceStop,
            sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
        });
    }, [
        contextId,
        lockAPI,
        registry,
        store
    ]);
    var findClosestDraggableId = (0, $3YMLK.useCallback)(function(event) {
        return $22db1ba098eb3017$var$tryGetClosestDraggableIdFromEvent(contextId, event);
    }, [
        contextId
    ]);
    var findOptionsForDraggable = (0, $3YMLK.useCallback)(function(id) {
        var entry = registry.draggable.findById(id);
        return entry ? entry.options : null;
    }, [
        registry.draggable
    ]);
    var tryReleaseLock = (0, $3YMLK.useCallback)(lockAPI.tryAbandon, [
        lockAPI
    ]);
    var isLockClaimed = (0, $3YMLK.useCallback)(lockAPI.isClaimed, [
        lockAPI
    ]);
    var api = (0, $3YMLK.useMemo)(function() {
        return {
            canGetLock: canGetLock,
            tryGetLock: tryGetLock,
            findClosestDraggableId: findClosestDraggableId,
            findOptionsForDraggable: findOptionsForDraggable,
            tryReleaseLock: tryReleaseLock,
            isLockClaimed: isLockClaimed
        };
    }, [
        canGetLock,
        tryGetLock,
        findClosestDraggableId,
        findOptionsForDraggable,
        tryReleaseLock,
        isLockClaimed
    ]);
    $22db1ba098eb3017$var$useValidateSensorHooks(useSensors);
    for(var i = 0; i < useSensors.length; i++)useSensors[i](api);
}
var $22db1ba098eb3017$var$createResponders = function createResponders(props) {
    return {
        onBeforeCapture: props.onBeforeCapture,
        onBeforeDragStart: props.onBeforeDragStart,
        onDragStart: props.onDragStart,
        onDragEnd: props.onDragEnd,
        onDragUpdate: props.onDragUpdate
    };
};
function $22db1ba098eb3017$var$getStore(lazyRef) {
    !lazyRef.current && $22db1ba098eb3017$var$invariant(false);
    return lazyRef.current;
}
function $22db1ba098eb3017$var$App(props) {
    var contextId = props.contextId, setCallbacks = props.setCallbacks, sensors = props.sensors, nonce = props.nonce, liftInstruction = props.liftInstruction;
    var lazyStoreRef = (0, $5uXOq.useRef)(null);
    $22db1ba098eb3017$var$useStartupValidation();
    var lastPropsRef = $22db1ba098eb3017$var$usePrevious(props);
    var getResponders = (0, $3YMLK.useCallback)(function() {
        return $22db1ba098eb3017$var$createResponders(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    var announce = $22db1ba098eb3017$var$useAnnouncer(contextId);
    var liftInstructionId = $22db1ba098eb3017$var$useLiftInstruction(contextId, liftInstruction);
    var styleMarshal = $22db1ba098eb3017$var$useStyleMarshal(contextId, nonce);
    var lazyDispatch = (0, $3YMLK.useCallback)(function(action) {
        $22db1ba098eb3017$var$getStore(lazyStoreRef).dispatch(action);
    }, []);
    var marshalCallbacks = (0, $3YMLK.useMemo)(function() {
        return (0, $22j3V.bindActionCreators)({
            publishWhileDragging: $22db1ba098eb3017$var$publishWhileDragging,
            updateDroppableScroll: $22db1ba098eb3017$var$updateDroppableScroll,
            updateDroppableIsEnabled: $22db1ba098eb3017$var$updateDroppableIsEnabled,
            updateDroppableIsCombineEnabled: $22db1ba098eb3017$var$updateDroppableIsCombineEnabled,
            collectionStarting: $22db1ba098eb3017$var$collectionStarting
        }, lazyDispatch);
    }, [
        lazyDispatch
    ]);
    var registry = $22db1ba098eb3017$var$useRegistry();
    var dimensionMarshal = (0, $3YMLK.useMemo)(function() {
        return $22db1ba098eb3017$var$createDimensionMarshal(registry, marshalCallbacks);
    }, [
        registry,
        marshalCallbacks
    ]);
    var autoScroller = (0, $3YMLK.useMemo)(function() {
        return $22db1ba098eb3017$var$createAutoScroller((0, $gzM5u.default)({
            scrollWindow: $22db1ba098eb3017$var$scrollWindow,
            scrollDroppable: dimensionMarshal.scrollDroppable
        }, (0, $22j3V.bindActionCreators)({
            move: $22db1ba098eb3017$var$move
        }, lazyDispatch)));
    }, [
        dimensionMarshal.scrollDroppable,
        lazyDispatch
    ]);
    var focusMarshal = $22db1ba098eb3017$var$useFocusMarshal(contextId);
    var store = (0, $3YMLK.useMemo)(function() {
        return $22db1ba098eb3017$var$createStore({
            announce: announce,
            autoScroller: autoScroller,
            dimensionMarshal: dimensionMarshal,
            focusMarshal: focusMarshal,
            getResponders: getResponders,
            styleMarshal: styleMarshal
        });
    }, [
        announce,
        autoScroller,
        dimensionMarshal,
        focusMarshal,
        getResponders,
        styleMarshal
    ]);
    lazyStoreRef.current = store;
    var tryResetStore = (0, $3YMLK.useCallback)(function() {
        var current = $22db1ba098eb3017$var$getStore(lazyStoreRef);
        var state = current.getState();
        if (state.phase !== 'IDLE') current.dispatch($22db1ba098eb3017$var$flush());
    }, []);
    var isDragging = (0, $3YMLK.useCallback)(function() {
        var state = $22db1ba098eb3017$var$getStore(lazyStoreRef).getState();
        return state.isDragging || state.phase === 'DROP_ANIMATING';
    }, []);
    var appCallbacks = (0, $3YMLK.useMemo)(function() {
        return {
            isDragging: isDragging,
            tryAbort: tryResetStore
        };
    }, [
        isDragging,
        tryResetStore
    ]);
    setCallbacks(appCallbacks);
    var getCanLift = (0, $3YMLK.useCallback)(function(id) {
        return $22db1ba098eb3017$var$canStartDrag($22db1ba098eb3017$var$getStore(lazyStoreRef).getState(), id);
    }, []);
    var getIsMovementAllowed = (0, $3YMLK.useCallback)(function() {
        return $22db1ba098eb3017$var$isMovementAllowed($22db1ba098eb3017$var$getStore(lazyStoreRef).getState());
    }, []);
    var appContext = (0, $3YMLK.useMemo)(function() {
        return {
            marshal: dimensionMarshal,
            focus: focusMarshal,
            contextId: contextId,
            canLift: getCanLift,
            isMovementAllowed: getIsMovementAllowed,
            liftInstructionId: liftInstructionId,
            registry: registry
        };
    }, [
        contextId,
        dimensionMarshal,
        focusMarshal,
        getCanLift,
        getIsMovementAllowed,
        liftInstructionId,
        registry
    ]);
    $22db1ba098eb3017$var$useSensorMarshal({
        contextId: contextId,
        store: store,
        registry: registry,
        customSensors: sensors,
        enableDefaultSensors: props.enableDefaultSensors !== false
    });
    (0, $5uXOq.useEffect)(function() {
        return tryResetStore;
    }, [
        tryResetStore
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$AppContext.Provider, {
        value: appContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9bdMd.default), {
        context: $22db1ba098eb3017$var$StoreContext,
        store: store
    }, props.children));
}
var $22db1ba098eb3017$var$instanceCount = 0;
function $22db1ba098eb3017$export$2bfe52350fc0150d() {
    $22db1ba098eb3017$var$instanceCount = 0;
}
function $22db1ba098eb3017$export$237bd83162c14364(props) {
    var contextId = (0, $3YMLK.useMemo)(function() {
        return "" + $22db1ba098eb3017$var$instanceCount++;
    }, []);
    var liftInstruction = props.liftInstruction || $22db1ba098eb3017$var$preset.liftInstruction;
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$ErrorBoundary, null, function(setCallbacks) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$App, {
            nonce: props.nonce,
            contextId: contextId,
            setCallbacks: setCallbacks,
            liftInstruction: liftInstruction,
            enableDefaultSensors: props.enableDefaultSensors,
            sensors: props.sensors,
            onBeforeCapture: props.onBeforeCapture,
            onBeforeDragStart: props.onBeforeDragStart,
            onDragStart: props.onDragStart,
            onDragUpdate: props.onDragUpdate,
            onDragEnd: props.onDragEnd
        }, props.children);
    });
}
var $22db1ba098eb3017$var$isEqual$1 = function isEqual(base) {
    return function(value) {
        return base === value;
    };
};
var $22db1ba098eb3017$var$isScroll = $22db1ba098eb3017$var$isEqual$1('scroll');
var $22db1ba098eb3017$var$isAuto = $22db1ba098eb3017$var$isEqual$1('auto');
var $22db1ba098eb3017$var$isVisible$1 = $22db1ba098eb3017$var$isEqual$1('visible');
var $22db1ba098eb3017$var$isEither = function isEither(overflow, fn) {
    return fn(overflow.overflowX) || fn(overflow.overflowY);
};
var $22db1ba098eb3017$var$isBoth = function isBoth(overflow, fn) {
    return fn(overflow.overflowX) && fn(overflow.overflowY);
};
var $22db1ba098eb3017$var$isElementScrollable = function isElementScrollable(el) {
    var style = window.getComputedStyle(el);
    var overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $22db1ba098eb3017$var$isEither(overflow, $22db1ba098eb3017$var$isScroll) || $22db1ba098eb3017$var$isEither(overflow, $22db1ba098eb3017$var$isAuto);
};
var $22db1ba098eb3017$var$isBodyScrollable = function isBodyScrollable() {
    var body, html, htmlStyle, htmlOverflow;
    return false;
};
var $22db1ba098eb3017$var$getClosestScrollable = function getClosestScrollable(el) {
    if (el == null) return null;
    if (el === document.body) return $22db1ba098eb3017$var$isBodyScrollable() ? el : null;
    if (el === document.documentElement) return null;
    if (!$22db1ba098eb3017$var$isElementScrollable(el)) return getClosestScrollable(el.parentElement);
    return el;
};
var $22db1ba098eb3017$var$checkForNestedScrollContainers = function(scrollable) {
    if (!scrollable) return;
    var anotherScrollParent = $22db1ba098eb3017$var$getClosestScrollable(scrollable.parentElement);
    if (!anotherScrollParent) return;
};
var $22db1ba098eb3017$var$getScroll$1 = function(el) {
    return {
        x: el.scrollLeft,
        y: el.scrollTop
    };
};
var $22db1ba098eb3017$var$getIsFixed = function getIsFixed(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.position === 'fixed') return true;
    return getIsFixed(el.parentElement);
};
var $22db1ba098eb3017$var$getEnv = function(start) {
    var closestScrollable = $22db1ba098eb3017$var$getClosestScrollable(start);
    var isFixedOnPage = $22db1ba098eb3017$var$getIsFixed(start);
    return {
        closestScrollable: closestScrollable,
        isFixedOnPage: isFixedOnPage
    };
};
var $22db1ba098eb3017$var$getDroppableDimension = function(_ref) {
    var descriptor = _ref.descriptor, isEnabled = _ref.isEnabled, isCombineEnabled = _ref.isCombineEnabled, isFixedOnPage = _ref.isFixedOnPage, direction = _ref.direction, client = _ref.client, page = _ref.page, closest = _ref.closest;
    var frame = function() {
        if (!closest) return null;
        var scrollSize = closest.scrollSize, frameClient = closest.client;
        var maxScroll = $22db1ba098eb3017$var$getMaxScroll({
            scrollHeight: scrollSize.scrollHeight,
            scrollWidth: scrollSize.scrollWidth,
            height: frameClient.paddingBox.height,
            width: frameClient.paddingBox.width
        });
        return {
            pageMarginBox: closest.page.marginBox,
            frameClient: frameClient,
            scrollSize: scrollSize,
            shouldClipSubject: closest.shouldClipSubject,
            scroll: {
                initial: closest.scroll,
                current: closest.scroll,
                max: maxScroll,
                diff: {
                    value: $22db1ba098eb3017$var$origin,
                    displacement: $22db1ba098eb3017$var$origin
                }
            }
        };
    }();
    var axis = direction === 'vertical' ? $22db1ba098eb3017$var$vertical : $22db1ba098eb3017$var$horizontal;
    var subject = $22db1ba098eb3017$var$getSubject({
        page: page,
        withPlaceholder: null,
        axis: axis,
        frame: frame
    });
    var dimension = {
        descriptor: descriptor,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: isFixedOnPage,
        axis: axis,
        isEnabled: isEnabled,
        client: client,
        page: page,
        frame: frame,
        subject: subject
    };
    return dimension;
};
var $22db1ba098eb3017$var$getClient = function getClient(targetRef, closestScrollable) {
    var base = (0, $3YKxB.getBox)(targetRef);
    if (!closestScrollable) return base;
    if (targetRef !== closestScrollable) return base;
    var top = base.paddingBox.top - closestScrollable.scrollTop;
    var left = base.paddingBox.left - closestScrollable.scrollLeft;
    var bottom = top + closestScrollable.scrollHeight;
    var right = left + closestScrollable.scrollWidth;
    var paddingBox = {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
    var borderBox = (0, $3YKxB.expand)(paddingBox, base.border);
    var client = (0, $3YKxB.createBox)({
        borderBox: borderBox,
        margin: base.margin,
        border: base.border,
        padding: base.padding
    });
    return client;
};
var $22db1ba098eb3017$var$getDimension = function(_ref) {
    var ref = _ref.ref, descriptor = _ref.descriptor, env = _ref.env, windowScroll = _ref.windowScroll, direction = _ref.direction, isDropDisabled = _ref.isDropDisabled, isCombineEnabled = _ref.isCombineEnabled, shouldClipSubject = _ref.shouldClipSubject;
    var closestScrollable = env.closestScrollable;
    var client = $22db1ba098eb3017$var$getClient(ref, closestScrollable);
    var page = (0, $3YKxB.withScroll)(client, windowScroll);
    var closest = function() {
        if (!closestScrollable) return null;
        var frameClient = (0, $3YKxB.getBox)(closestScrollable);
        var scrollSize = {
            scrollHeight: closestScrollable.scrollHeight,
            scrollWidth: closestScrollable.scrollWidth
        };
        return {
            client: frameClient,
            page: (0, $3YKxB.withScroll)(frameClient, windowScroll),
            scroll: $22db1ba098eb3017$var$getScroll$1(closestScrollable),
            scrollSize: scrollSize,
            shouldClipSubject: shouldClipSubject
        };
    }();
    var dimension = $22db1ba098eb3017$var$getDroppableDimension({
        descriptor: descriptor,
        isEnabled: !isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: env.isFixedOnPage,
        direction: direction,
        client: client,
        page: page,
        closest: closest
    });
    return dimension;
};
var $22db1ba098eb3017$var$immediate = {
    passive: false
};
var $22db1ba098eb3017$var$delayed = {
    passive: true
};
var $22db1ba098eb3017$var$getListenerOptions = function(options) {
    return options.shouldPublishImmediately ? $22db1ba098eb3017$var$immediate : $22db1ba098eb3017$var$delayed;
};
function $22db1ba098eb3017$var$useRequiredContext(Context) {
    var result = (0, $5uXOq.useContext)(Context);
    !result && $22db1ba098eb3017$var$invariant(false);
    return result;
}
var $22db1ba098eb3017$var$count = 0;
function $22db1ba098eb3017$var$useUniqueId(prefix) {
    var countRef = (0, $5uXOq.useRef)($22db1ba098eb3017$var$count++);
    return prefix + "::" + countRef.current;
}
var $22db1ba098eb3017$var$getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
    return dragging && dragging.env.closestScrollable || null;
};
function $22db1ba098eb3017$var$useDroppablePublisher(args) {
    var whileDraggingRef = (0, $5uXOq.useRef)(null);
    var appContext = $22db1ba098eb3017$var$useRequiredContext($22db1ba098eb3017$var$AppContext);
    var uniqueId = $22db1ba098eb3017$var$useUniqueId('droppable');
    var registry = appContext.registry, marshal = appContext.marshal;
    var previousRef = $22db1ba098eb3017$var$usePrevious(args);
    var descriptor = (0, $3YMLK.useMemo)(function() {
        return {
            id: args.droppableId,
            type: args.type,
            mode: args.mode
        };
    }, [
        args.droppableId,
        args.mode,
        args.type
    ]);
    var publishedDescriptorRef = (0, $5uXOq.useRef)(descriptor);
    var memoizedUpdateScroll = (0, $3YMLK.useMemo)(function() {
        return (0, $jQbLg.default)(function(x, y) {
            !whileDraggingRef.current && $22db1ba098eb3017$var$invariant(false);
            var scroll = {
                x: x,
                y: y
            };
            marshal.updateDroppableScroll(descriptor.id, scroll);
        });
    }, [
        descriptor.id,
        marshal
    ]);
    var getClosestScroll = (0, $3YMLK.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        if (!dragging || !dragging.env.closestScrollable) return $22db1ba098eb3017$var$origin;
        return $22db1ba098eb3017$var$getScroll$1(dragging.env.closestScrollable);
    }, []);
    var updateScroll = (0, $3YMLK.useCallback)(function() {
        var scroll = getClosestScroll();
        memoizedUpdateScroll(scroll.x, scroll.y);
    }, [
        getClosestScroll,
        memoizedUpdateScroll
    ]);
    var scheduleScrollUpdate = (0, $3YMLK.useMemo)(function() {
        return (0, $7qpjg.default)(updateScroll);
    }, [
        updateScroll
    ]);
    var onClosestScroll = (0, $3YMLK.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $22db1ba098eb3017$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $22db1ba098eb3017$var$invariant(false);
        var options = dragging.scrollOptions;
        if (options.shouldPublishImmediately) {
            updateScroll();
            return;
        }
        scheduleScrollUpdate();
    }, [
        scheduleScrollUpdate,
        updateScroll
    ]);
    var getDimensionAndWatchScroll = (0, $3YMLK.useCallback)(function(windowScroll, options) {
        !!whileDraggingRef.current && $22db1ba098eb3017$var$invariant(false);
        var previous = previousRef.current;
        var ref = previous.getDroppableRef();
        !ref && $22db1ba098eb3017$var$invariant(false);
        var env = $22db1ba098eb3017$var$getEnv(ref);
        var dragging = {
            ref: ref,
            descriptor: descriptor,
            env: env,
            scrollOptions: options
        };
        whileDraggingRef.current = dragging;
        var dimension = $22db1ba098eb3017$var$getDimension({
            ref: ref,
            descriptor: descriptor,
            env: env,
            windowScroll: windowScroll,
            direction: previous.direction,
            isDropDisabled: previous.isDropDisabled,
            isCombineEnabled: previous.isCombineEnabled,
            shouldClipSubject: !previous.ignoreContainerClipping
        });
        var scrollable = env.closestScrollable;
        if (scrollable) {
            scrollable.setAttribute($22db1ba098eb3017$var$scrollContainer.contextId, appContext.contextId);
            scrollable.addEventListener('scroll', onClosestScroll, $22db1ba098eb3017$var$getListenerOptions(dragging.scrollOptions));
        }
        return dimension;
    }, [
        appContext.contextId,
        descriptor,
        onClosestScroll,
        previousRef
    ]);
    var getScrollWhileDragging = (0, $3YMLK.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $22db1ba098eb3017$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $22db1ba098eb3017$var$invariant(false);
        return $22db1ba098eb3017$var$getScroll$1(closest);
    }, []);
    var dragStopped = (0, $3YMLK.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        !dragging && $22db1ba098eb3017$var$invariant(false);
        var closest = $22db1ba098eb3017$var$getClosestScrollableFromDrag(dragging);
        whileDraggingRef.current = null;
        if (!closest) return;
        scheduleScrollUpdate.cancel();
        closest.removeAttribute($22db1ba098eb3017$var$scrollContainer.contextId);
        closest.removeEventListener('scroll', onClosestScroll, $22db1ba098eb3017$var$getListenerOptions(dragging.scrollOptions));
    }, [
        onClosestScroll,
        scheduleScrollUpdate
    ]);
    var scroll = (0, $3YMLK.useCallback)(function(change) {
        var dragging = whileDraggingRef.current;
        !dragging && $22db1ba098eb3017$var$invariant(false);
        var closest = $22db1ba098eb3017$var$getClosestScrollableFromDrag(dragging);
        !closest && $22db1ba098eb3017$var$invariant(false);
        closest.scrollTop += change.y;
        closest.scrollLeft += change.x;
    }, []);
    var callbacks = (0, $3YMLK.useMemo)(function() {
        return {
            getDimensionAndWatchScroll: getDimensionAndWatchScroll,
            getScrollWhileDragging: getScrollWhileDragging,
            dragStopped: dragStopped,
            scroll: scroll
        };
    }, [
        dragStopped,
        getDimensionAndWatchScroll,
        getScrollWhileDragging,
        scroll
    ]);
    var entry = (0, $3YMLK.useMemo)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            callbacks: callbacks
        };
    }, [
        callbacks,
        descriptor,
        uniqueId
    ]);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
        publishedDescriptorRef.current = entry.descriptor;
        registry.droppable.register(entry);
        return function() {
            if (whileDraggingRef.current) dragStopped();
            registry.droppable.unregister(entry);
        };
    }, [
        callbacks,
        descriptor,
        dragStopped,
        entry,
        marshal,
        registry.droppable
    ]);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
    }, [
        args.isDropDisabled,
        marshal
    ]);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
    }, [
        args.isCombineEnabled,
        marshal
    ]);
}
function $22db1ba098eb3017$var$noop$2() {}
var $22db1ba098eb3017$var$empty = {
    width: 0,
    height: 0,
    margin: $22db1ba098eb3017$var$noSpacing
};
var $22db1ba098eb3017$var$getSize = function getSize(_ref) {
    var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount, placeholder = _ref.placeholder, animate = _ref.animate;
    if (isAnimatingOpenOnMount) return $22db1ba098eb3017$var$empty;
    if (animate === 'close') return $22db1ba098eb3017$var$empty;
    return {
        height: placeholder.client.borderBox.height,
        width: placeholder.client.borderBox.width,
        margin: placeholder.client.margin
    };
};
var $22db1ba098eb3017$var$getStyle = function getStyle(_ref2) {
    var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount, placeholder = _ref2.placeholder, animate = _ref2.animate;
    var size = $22db1ba098eb3017$var$getSize({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        placeholder: placeholder,
        animate: animate
    });
    return {
        display: placeholder.display,
        boxSizing: 'border-box',
        width: size.width,
        height: size.height,
        marginTop: size.margin.top,
        marginRight: size.margin.right,
        marginBottom: size.margin.bottom,
        marginLeft: size.margin.left,
        flexShrink: '0',
        flexGrow: '0',
        pointerEvents: 'none',
        transition: animate !== 'none' ? $22db1ba098eb3017$var$transitions.placeholder : null
    };
};
function $22db1ba098eb3017$var$Placeholder(props) {
    var animateOpenTimerRef = (0, $5uXOq.useRef)(null);
    var tryClearAnimateOpenTimer = (0, $3YMLK.useCallback)(function() {
        if (!animateOpenTimerRef.current) return;
        clearTimeout(animateOpenTimerRef.current);
        animateOpenTimerRef.current = null;
    }, []);
    var animate = props.animate, onTransitionEnd = props.onTransitionEnd, onClose = props.onClose, contextId = props.contextId;
    var _useState = (0, $5uXOq.useState)(props.animate === 'open'), isAnimatingOpenOnMount = _useState[0], setIsAnimatingOpenOnMount = _useState[1];
    (0, $5uXOq.useEffect)(function() {
        if (!isAnimatingOpenOnMount) return $22db1ba098eb3017$var$noop$2;
        if (animate !== 'open') {
            tryClearAnimateOpenTimer();
            setIsAnimatingOpenOnMount(false);
            return $22db1ba098eb3017$var$noop$2;
        }
        if (animateOpenTimerRef.current) return $22db1ba098eb3017$var$noop$2;
        animateOpenTimerRef.current = setTimeout(function() {
            animateOpenTimerRef.current = null;
            setIsAnimatingOpenOnMount(false);
        });
        return tryClearAnimateOpenTimer;
    }, [
        animate,
        isAnimatingOpenOnMount,
        tryClearAnimateOpenTimer
    ]);
    var onSizeChangeEnd = (0, $3YMLK.useCallback)(function(event) {
        if (event.propertyName !== 'height') return;
        onTransitionEnd();
        if (animate === 'close') onClose();
    }, [
        animate,
        onClose,
        onTransitionEnd
    ]);
    var style = $22db1ba098eb3017$var$getStyle({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        animate: props.animate,
        placeholder: props.placeholder
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(props.placeholder.tagName, {
        style: style,
        'data-rbd-placeholder-context-id': contextId,
        onTransitionEnd: onSizeChangeEnd,
        ref: props.innerRef
    });
}
var $22db1ba098eb3017$var$Placeholder$1 = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo($22db1ba098eb3017$var$Placeholder);
var $22db1ba098eb3017$var$DroppableContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(null);
function $22db1ba098eb3017$var$checkIsValidInnerRef(el) {
    !(el && $22db1ba098eb3017$var$isHtmlElement(el)) && $22db1ba098eb3017$var$invariant(false);
}
function $22db1ba098eb3017$var$isBoolean(value) {
    return typeof value === 'boolean';
}
function $22db1ba098eb3017$var$runChecks(args, checks) {
    checks.forEach(function(check) {
        return check(args);
    });
}
var $22db1ba098eb3017$var$shared = [
    function required(_ref) {
        var props = _ref.props;
        !props.droppableId && $22db1ba098eb3017$var$invariant(false);
        !(typeof props.droppableId === 'string') && $22db1ba098eb3017$var$invariant(false);
    },
    function _boolean(_ref2) {
        var props = _ref2.props;
        !$22db1ba098eb3017$var$isBoolean(props.isDropDisabled) && $22db1ba098eb3017$var$invariant(false);
        !$22db1ba098eb3017$var$isBoolean(props.isCombineEnabled) && $22db1ba098eb3017$var$invariant(false);
        !$22db1ba098eb3017$var$isBoolean(props.ignoreContainerClipping) && $22db1ba098eb3017$var$invariant(false);
    },
    function ref(_ref3) {
        var getDroppableRef = _ref3.getDroppableRef;
        $22db1ba098eb3017$var$checkIsValidInnerRef(getDroppableRef());
    }
];
var $22db1ba098eb3017$var$standard = [
    function placeholder(_ref4) {
        var props = _ref4.props, getPlaceholderRef = _ref4.getPlaceholderRef;
        if (!props.placeholder) return;
        var ref = getPlaceholderRef();
        if (ref) return;
    }
];
var $22db1ba098eb3017$var$virtual = [
    function hasClone(_ref5) {
        var props = _ref5.props;
        !props.renderClone && $22db1ba098eb3017$var$invariant(false);
    },
    function hasNoPlaceholder(_ref6) {
        var getPlaceholderRef = _ref6.getPlaceholderRef;
        !!getPlaceholderRef() && $22db1ba098eb3017$var$invariant(false);
    }
];
function $22db1ba098eb3017$var$useValidation(args) {
    $22db1ba098eb3017$var$useDevSetupWarning(function() {
        $22db1ba098eb3017$var$runChecks(args, $22db1ba098eb3017$var$shared);
        if (args.props.mode === 'standard') $22db1ba098eb3017$var$runChecks(args, $22db1ba098eb3017$var$standard);
        if (args.props.mode === 'virtual') $22db1ba098eb3017$var$runChecks(args, $22db1ba098eb3017$var$virtual);
    });
}
var $22db1ba098eb3017$var$AnimateInOut = function(_React$PureComponent) {
    (0, $1AwyE.default)(AnimateInOut, _React$PureComponent);
    function AnimateInOut() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$PureComponent.call.apply(_React$PureComponent, [
            this
        ].concat(args)) || this;
        _this.state = {
            isVisible: Boolean(_this.props.on),
            data: _this.props.on,
            animate: _this.props.shouldAnimate && _this.props.on ? 'open' : 'none'
        };
        _this.onClose = function() {
            if (_this.state.animate !== 'close') return;
            _this.setState({
                isVisible: false
            });
        };
        return _this;
    }
    AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (!props.shouldAnimate) return {
            isVisible: Boolean(props.on),
            data: props.on,
            animate: 'none'
        };
        if (props.on) return {
            isVisible: true,
            data: props.on,
            animate: 'open'
        };
        if (state.isVisible) return {
            isVisible: true,
            data: state.data,
            animate: 'close'
        };
        return {
            isVisible: false,
            animate: 'close',
            data: null
        };
    };
    var _proto = AnimateInOut.prototype;
    _proto.render = function render() {
        if (!this.state.isVisible) return null;
        var provided = {
            onClose: this.onClose,
            data: this.state.data,
            animate: this.state.animate
        };
        return this.props.children(provided);
    };
    return AnimateInOut;
}((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent);
var $22db1ba098eb3017$var$zIndexOptions = {
    dragging: 5000,
    dropAnimating: 4500
};
var $22db1ba098eb3017$var$getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
    if (dropping) return $22db1ba098eb3017$var$transitions.drop(dropping.duration);
    if (shouldAnimateDragMovement) return $22db1ba098eb3017$var$transitions.snap;
    return $22db1ba098eb3017$var$transitions.fluid;
};
var $22db1ba098eb3017$var$getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
    if (!isCombining) return null;
    return isDropAnimating ? $22db1ba098eb3017$var$combine.opacity.drop : $22db1ba098eb3017$var$combine.opacity.combining;
};
var $22db1ba098eb3017$var$getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
    if (dragging.forceShouldAnimate != null) return dragging.forceShouldAnimate;
    return dragging.mode === 'SNAP';
};
function $22db1ba098eb3017$var$getDraggingStyle(dragging) {
    var dimension = dragging.dimension;
    var box = dimension.client;
    var offset = dragging.offset, combineWith = dragging.combineWith, dropping = dragging.dropping;
    var isCombining = Boolean(combineWith);
    var shouldAnimate = $22db1ba098eb3017$var$getShouldDraggingAnimate(dragging);
    var isDropAnimating = Boolean(dropping);
    var transform = isDropAnimating ? $22db1ba098eb3017$var$transforms.drop(offset, isCombining) : $22db1ba098eb3017$var$transforms.moveTo(offset);
    var style = {
        position: 'fixed',
        top: box.marginBox.top,
        left: box.marginBox.left,
        boxSizing: 'border-box',
        width: box.borderBox.width,
        height: box.borderBox.height,
        transition: $22db1ba098eb3017$var$getDraggingTransition(shouldAnimate, dropping),
        transform: transform,
        opacity: $22db1ba098eb3017$var$getDraggingOpacity(isCombining, isDropAnimating),
        zIndex: isDropAnimating ? $22db1ba098eb3017$var$zIndexOptions.dropAnimating : $22db1ba098eb3017$var$zIndexOptions.dragging,
        pointerEvents: 'none'
    };
    return style;
}
function $22db1ba098eb3017$var$getSecondaryStyle(secondary) {
    return {
        transform: $22db1ba098eb3017$var$transforms.moveTo(secondary.offset),
        transition: secondary.shouldAnimateDisplacement ? null : 'none'
    };
}
function $22db1ba098eb3017$var$getStyle$1(mapped) {
    return mapped.type === 'DRAGGING' ? $22db1ba098eb3017$var$getDraggingStyle(mapped) : $22db1ba098eb3017$var$getSecondaryStyle(mapped);
}
function $22db1ba098eb3017$var$getDimension$1(descriptor, el, windowScroll) {
    if (windowScroll === void 0) windowScroll = $22db1ba098eb3017$var$origin;
    var computedStyles = window.getComputedStyle(el);
    var borderBox = el.getBoundingClientRect();
    var client = (0, $3YKxB.calculateBox)(borderBox, computedStyles);
    var page = (0, $3YKxB.withScroll)(client, windowScroll);
    var placeholder = {
        client: client,
        tagName: el.tagName.toLowerCase(),
        display: computedStyles.display
    };
    var displaceBy = {
        x: client.marginBox.width,
        y: client.marginBox.height
    };
    var dimension = {
        descriptor: descriptor,
        placeholder: placeholder,
        displaceBy: displaceBy,
        client: client,
        page: page
    };
    return dimension;
}
function $22db1ba098eb3017$var$useDraggablePublisher(args) {
    var uniqueId = $22db1ba098eb3017$var$useUniqueId('draggable');
    var descriptor = args.descriptor, registry = args.registry, getDraggableRef = args.getDraggableRef, canDragInteractiveElements = args.canDragInteractiveElements, shouldRespectForcePress = args.shouldRespectForcePress, isEnabled = args.isEnabled;
    var options = (0, $3YMLK.useMemo)(function() {
        return {
            canDragInteractiveElements: canDragInteractiveElements,
            shouldRespectForcePress: shouldRespectForcePress,
            isEnabled: isEnabled
        };
    }, [
        canDragInteractiveElements,
        isEnabled,
        shouldRespectForcePress
    ]);
    var getDimension = (0, $3YMLK.useCallback)(function(windowScroll) {
        var el = getDraggableRef();
        !el && $22db1ba098eb3017$var$invariant(false);
        return $22db1ba098eb3017$var$getDimension$1(descriptor, el, windowScroll);
    }, [
        descriptor,
        getDraggableRef
    ]);
    var entry = (0, $3YMLK.useMemo)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            options: options,
            getDimension: getDimension
        };
    }, [
        descriptor,
        getDimension,
        options,
        uniqueId
    ]);
    var publishedRef = (0, $5uXOq.useRef)(entry);
    var isFirstPublishRef = (0, $5uXOq.useRef)(true);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
        registry.draggable.register(publishedRef.current);
        return function() {
            return registry.draggable.unregister(publishedRef.current);
        };
    }, [
        registry.draggable
    ]);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
        if (isFirstPublishRef.current) {
            isFirstPublishRef.current = false;
            return;
        }
        var last = publishedRef.current;
        publishedRef.current = entry;
        registry.draggable.update(entry, last);
    }, [
        entry,
        registry.draggable
    ]);
}
function $22db1ba098eb3017$var$useValidation$1(props, contextId, getRef) {
    $22db1ba098eb3017$var$useDevSetupWarning(function() {
        function prefix(id) {
            return "Draggable[id: " + id + "]: ";
        }
        var id = props.draggableId;
        !id && $22db1ba098eb3017$var$invariant(false);
        !(typeof id === 'string') && $22db1ba098eb3017$var$invariant(false);
        !(0, (/*@__PURE__*/$parcel$interopDefault($1DIXK)))(props.index) && $22db1ba098eb3017$var$invariant(false);
        if (props.mapped.type === 'DRAGGING') return;
        $22db1ba098eb3017$var$checkIsValidInnerRef(getRef());
        if (props.isEnabled) !$22db1ba098eb3017$var$findDragHandle(contextId, id) && $22db1ba098eb3017$var$invariant(false);
    });
}
function $22db1ba098eb3017$var$useClonePropValidation(isClone) {
    $22db1ba098eb3017$var$useDev(function() {
        var initialRef = (0, $5uXOq.useRef)(isClone);
        $22db1ba098eb3017$var$useDevSetupWarning(function() {
            !(isClone === initialRef.current) && $22db1ba098eb3017$var$invariant(false);
        }, [
            isClone
        ]);
    });
}
function $22db1ba098eb3017$var$preventHtml5Dnd(event) {
    event.preventDefault();
}
function $22db1ba098eb3017$var$Draggable(props) {
    var ref = (0, $5uXOq.useRef)(null);
    var setRef = (0, $3YMLK.useCallback)(function(el) {
        ref.current = el;
    }, []);
    var getRef = (0, $3YMLK.useCallback)(function() {
        return ref.current;
    }, []);
    var _useRequiredContext = $22db1ba098eb3017$var$useRequiredContext($22db1ba098eb3017$var$AppContext), contextId = _useRequiredContext.contextId, liftInstructionId = _useRequiredContext.liftInstructionId, registry = _useRequiredContext.registry;
    var _useRequiredContext2 = $22db1ba098eb3017$var$useRequiredContext($22db1ba098eb3017$var$DroppableContext), type = _useRequiredContext2.type, droppableId = _useRequiredContext2.droppableId;
    var descriptor = (0, $3YMLK.useMemo)(function() {
        return {
            id: props.draggableId,
            index: props.index,
            type: type,
            droppableId: droppableId
        };
    }, [
        props.draggableId,
        props.index,
        type,
        droppableId
    ]);
    var children = props.children, draggableId = props.draggableId, isEnabled = props.isEnabled, shouldRespectForcePress = props.shouldRespectForcePress, canDragInteractiveElements = props.canDragInteractiveElements, isClone = props.isClone, mapped = props.mapped, dropAnimationFinishedAction = props.dropAnimationFinished;
    $22db1ba098eb3017$var$useValidation$1(props, contextId, getRef);
    $22db1ba098eb3017$var$useClonePropValidation(isClone);
    if (!isClone) {
        var forPublisher = (0, $3YMLK.useMemo)(function() {
            return {
                descriptor: descriptor,
                registry: registry,
                getDraggableRef: getRef,
                canDragInteractiveElements: canDragInteractiveElements,
                shouldRespectForcePress: shouldRespectForcePress,
                isEnabled: isEnabled
            };
        }, [
            descriptor,
            registry,
            getRef,
            canDragInteractiveElements,
            shouldRespectForcePress,
            isEnabled
        ]);
        $22db1ba098eb3017$var$useDraggablePublisher(forPublisher);
    }
    var dragHandleProps = (0, $3YMLK.useMemo)(function() {
        return isEnabled ? {
            tabIndex: 0,
            'data-rbd-drag-handle-draggable-id': draggableId,
            'data-rbd-drag-handle-context-id': contextId,
            'aria-labelledby': liftInstructionId,
            draggable: false,
            onDragStart: $22db1ba098eb3017$var$preventHtml5Dnd
        } : null;
    }, [
        contextId,
        draggableId,
        isEnabled,
        liftInstructionId
    ]);
    var onMoveEnd = (0, $3YMLK.useCallback)(function(event) {
        if (mapped.type !== 'DRAGGING') return;
        if (!mapped.dropping) return;
        if (event.propertyName !== 'transform') return;
        dropAnimationFinishedAction();
    }, [
        dropAnimationFinishedAction,
        mapped
    ]);
    var provided = (0, $3YMLK.useMemo)(function() {
        var style = $22db1ba098eb3017$var$getStyle$1(mapped);
        var onTransitionEnd = mapped.type === 'DRAGGING' && mapped.dropping ? onMoveEnd : null;
        var result = {
            innerRef: setRef,
            draggableProps: {
                'data-rbd-draggable-context-id': contextId,
                'data-rbd-draggable-id': draggableId,
                style: style,
                onTransitionEnd: onTransitionEnd
            },
            dragHandleProps: dragHandleProps
        };
        return result;
    }, [
        contextId,
        dragHandleProps,
        draggableId,
        mapped,
        onMoveEnd,
        setRef
    ]);
    var rubric = (0, $3YMLK.useMemo)(function() {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    }, [
        descriptor.droppableId,
        descriptor.id,
        descriptor.index,
        descriptor.type
    ]);
    return children(provided, mapped.snapshot, rubric);
}
var $22db1ba098eb3017$var$isStrictEqual = function(a, b) {
    return a === b;
};
var $22db1ba098eb3017$var$whatIsDraggedOverFromResult = function(result) {
    var combine = result.combine, destination = result.destination;
    if (destination) return destination.droppableId;
    if (combine) return combine.droppableId;
    return null;
};
var $22db1ba098eb3017$var$getCombineWithFromResult = function getCombineWithFromResult(result) {
    return result.combine ? result.combine.draggableId : null;
};
var $22db1ba098eb3017$var$getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
    return impact.at && impact.at.type === 'COMBINE' ? impact.at.combine.draggableId : null;
};
function $22db1ba098eb3017$var$getDraggableSelector() {
    var memoizedOffset = (0, $jQbLg.default)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $jQbLg.default)(function(mode, isClone, draggingOver, combineWith, dropping) {
        return {
            isDragging: true,
            isClone: isClone,
            isDropAnimating: Boolean(dropping),
            dropAnimation: dropping,
            mode: mode,
            draggingOver: draggingOver,
            combineWith: combineWith,
            combineTargetFor: null
        };
    });
    var getMemoizedProps = (0, $jQbLg.default)(function(offset, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
        return {
            mapped: {
                type: 'DRAGGING',
                dropping: null,
                draggingOver: draggingOver,
                combineWith: combineWith,
                mode: mode,
                offset: offset,
                dimension: dimension,
                forceShouldAnimate: forceShouldAnimate,
                snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
            }
        };
    });
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id !== ownProps.draggableId) return null;
            var offset = state.current.client.offset;
            var dimension = state.dimensions.draggables[ownProps.draggableId];
            var draggingOver = $22db1ba098eb3017$var$whatIsDraggedOver(state.impact);
            var combineWith = $22db1ba098eb3017$var$getCombineWithFromImpact(state.impact);
            var forceShouldAnimate = state.forceShouldAnimate;
            return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (completed.result.draggableId !== ownProps.draggableId) return null;
            var isClone = ownProps.isClone;
            var _dimension = state.dimensions.draggables[ownProps.draggableId];
            var result = completed.result;
            var mode = result.mode;
            var _draggingOver = $22db1ba098eb3017$var$whatIsDraggedOverFromResult(result);
            var _combineWith = $22db1ba098eb3017$var$getCombineWithFromResult(result);
            var duration = state.dropDuration;
            var dropping = {
                duration: duration,
                curve: $22db1ba098eb3017$var$curves.drop,
                moveTo: state.newHomeClientOffset,
                opacity: _combineWith ? $22db1ba098eb3017$var$combine.opacity.drop : null,
                scale: _combineWith ? $22db1ba098eb3017$var$combine.scale.drop : null
            };
            return {
                mapped: {
                    type: 'DRAGGING',
                    offset: state.newHomeClientOffset,
                    dimension: _dimension,
                    dropping: dropping,
                    draggingOver: _draggingOver,
                    combineWith: _combineWith,
                    mode: mode,
                    forceShouldAnimate: null,
                    snapshot: getMemoizedSnapshot(mode, isClone, _draggingOver, _combineWith, dropping)
                }
            };
        }
        return null;
    };
    return selector;
}
function $22db1ba098eb3017$var$getSecondarySnapshot(combineTargetFor) {
    return {
        isDragging: false,
        isDropAnimating: false,
        isClone: false,
        dropAnimation: null,
        mode: null,
        draggingOver: null,
        combineTargetFor: combineTargetFor,
        combineWith: null
    };
}
var $22db1ba098eb3017$var$atRest = {
    mapped: {
        type: 'SECONDARY',
        offset: $22db1ba098eb3017$var$origin,
        combineTargetFor: null,
        shouldAnimateDisplacement: true,
        snapshot: $22db1ba098eb3017$var$getSecondarySnapshot(null)
    }
};
function $22db1ba098eb3017$var$getSecondarySelector() {
    var memoizedOffset = (0, $jQbLg.default)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $jQbLg.default)($22db1ba098eb3017$var$getSecondarySnapshot);
    var getMemoizedProps = (0, $jQbLg.default)(function(offset, combineTargetFor, shouldAnimateDisplacement) {
        if (combineTargetFor === void 0) combineTargetFor = null;
        return {
            mapped: {
                type: 'SECONDARY',
                offset: offset,
                combineTargetFor: combineTargetFor,
                shouldAnimateDisplacement: shouldAnimateDisplacement,
                snapshot: getMemoizedSnapshot(combineTargetFor)
            }
        };
    });
    var getFallback = function getFallback(combineTargetFor) {
        return combineTargetFor ? getMemoizedProps($22db1ba098eb3017$var$origin, combineTargetFor, true) : null;
    };
    var getProps = function getProps(ownId, draggingId, impact, afterCritical) {
        var visualDisplacement = impact.displaced.visible[ownId];
        var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
        var combine = $22db1ba098eb3017$var$tryGetCombine(impact);
        var combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;
        if (!visualDisplacement) {
            if (!isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
            if (impact.displaced.invisible[ownId]) return null;
            var change = $22db1ba098eb3017$var$negate(afterCritical.displacedBy.point);
            var _offset = memoizedOffset(change.x, change.y);
            return getMemoizedProps(_offset, combineTargetFor, true);
        }
        if (isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
        var displaceBy = impact.displacedBy.point;
        var offset = memoizedOffset(displaceBy.x, displaceBy.y);
        return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
    };
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (completed.result.draggableId === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
        }
        return null;
    };
    return selector;
}
var $22db1ba098eb3017$var$makeMapStateToProps = function makeMapStateToProps() {
    var draggingSelector = $22db1ba098eb3017$var$getDraggableSelector();
    var secondarySelector = $22db1ba098eb3017$var$getSecondarySelector();
    var selector = function selector(state, ownProps) {
        return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || $22db1ba098eb3017$var$atRest;
    };
    return selector;
};
var $22db1ba098eb3017$var$mapDispatchToProps = {
    dropAnimationFinished: $22db1ba098eb3017$var$dropAnimationFinished
};
var $22db1ba098eb3017$var$ConnectedDraggable = (0, $AuRrZ.default)($22db1ba098eb3017$var$makeMapStateToProps, $22db1ba098eb3017$var$mapDispatchToProps, null, {
    context: $22db1ba098eb3017$var$StoreContext,
    pure: true,
    areStatePropsEqual: $22db1ba098eb3017$var$isStrictEqual
})($22db1ba098eb3017$var$Draggable);
function $22db1ba098eb3017$var$PrivateDraggable(props) {
    var droppableContext = $22db1ba098eb3017$var$useRequiredContext($22db1ba098eb3017$var$DroppableContext);
    var isUsingCloneFor = droppableContext.isUsingCloneFor;
    if (isUsingCloneFor === props.draggableId && !props.isClone) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$ConnectedDraggable, props);
}
function $22db1ba098eb3017$export$f2a139e5d18b9882(props) {
    var isEnabled = typeof props.isDragDisabled === 'boolean' ? !props.isDragDisabled : true;
    var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
    var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$PrivateDraggable, (0, $gzM5u.default)({}, props, {
        isClone: false,
        isEnabled: isEnabled,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress
    }));
}
function $22db1ba098eb3017$var$Droppable(props) {
    var appContext = (0, $5uXOq.useContext)($22db1ba098eb3017$var$AppContext);
    !appContext && $22db1ba098eb3017$var$invariant(false);
    var contextId = appContext.contextId, isMovementAllowed = appContext.isMovementAllowed;
    var droppableRef = (0, $5uXOq.useRef)(null);
    var placeholderRef = (0, $5uXOq.useRef)(null);
    var children = props.children, droppableId = props.droppableId, type = props.type, mode = props.mode, direction = props.direction, ignoreContainerClipping = props.ignoreContainerClipping, isDropDisabled = props.isDropDisabled, isCombineEnabled = props.isCombineEnabled, snapshot = props.snapshot, useClone = props.useClone, updateViewportMaxScroll = props.updateViewportMaxScroll, getContainerForClone = props.getContainerForClone;
    var getDroppableRef = (0, $3YMLK.useCallback)(function() {
        return droppableRef.current;
    }, []);
    var setDroppableRef = (0, $3YMLK.useCallback)(function(value) {
        droppableRef.current = value;
    }, []);
    var getPlaceholderRef = (0, $3YMLK.useCallback)(function() {
        return placeholderRef.current;
    }, []);
    var setPlaceholderRef = (0, $3YMLK.useCallback)(function(value) {
        placeholderRef.current = value;
    }, []);
    $22db1ba098eb3017$var$useValidation({
        props: props,
        getDroppableRef: getDroppableRef,
        getPlaceholderRef: getPlaceholderRef
    });
    var onPlaceholderTransitionEnd = (0, $3YMLK.useCallback)(function() {
        if (isMovementAllowed()) updateViewportMaxScroll({
            maxScroll: $22db1ba098eb3017$var$getMaxWindowScroll()
        });
    }, [
        isMovementAllowed,
        updateViewportMaxScroll
    ]);
    $22db1ba098eb3017$var$useDroppablePublisher({
        droppableId: droppableId,
        type: type,
        mode: mode,
        direction: direction,
        isDropDisabled: isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        ignoreContainerClipping: ignoreContainerClipping,
        getDroppableRef: getDroppableRef
    });
    var placeholder = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$AnimateInOut, {
        on: props.placeholder,
        shouldAnimate: props.shouldAnimatePlaceholder
    }, function(_ref) {
        var onClose = _ref.onClose, data = _ref.data, animate = _ref.animate;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$Placeholder$1, {
            placeholder: data,
            onClose: onClose,
            innerRef: setPlaceholderRef,
            animate: animate,
            contextId: contextId,
            onTransitionEnd: onPlaceholderTransitionEnd
        });
    });
    var provided = (0, $3YMLK.useMemo)(function() {
        return {
            innerRef: setDroppableRef,
            placeholder: placeholder,
            droppableProps: {
                'data-rbd-droppable-id': droppableId,
                'data-rbd-droppable-context-id': contextId
            }
        };
    }, [
        contextId,
        droppableId,
        placeholder,
        setDroppableRef
    ]);
    var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
    var droppableContext = (0, $3YMLK.useMemo)(function() {
        return {
            droppableId: droppableId,
            type: type,
            isUsingCloneFor: isUsingCloneFor
        };
    }, [
        droppableId,
        isUsingCloneFor,
        type
    ]);
    function getClone() {
        if (!useClone) return null;
        var dragging = useClone.dragging, render = useClone.render;
        var node = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$PrivateDraggable, {
            draggableId: dragging.draggableId,
            index: dragging.source.index,
            isClone: true,
            isEnabled: true,
            shouldRespectForcePress: false,
            canDragInteractiveElements: true
        }, function(draggableProvided, draggableSnapshot) {
            return render(draggableProvided, draggableSnapshot, dragging);
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).createPortal(node, getContainerForClone());
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$DroppableContext.Provider, {
        value: droppableContext
    }, children(provided, snapshot), getClone());
}
var $22db1ba098eb3017$var$isMatchingType = function isMatchingType(type, critical) {
    return type === critical.droppable.type;
};
var $22db1ba098eb3017$var$getDraggable = function getDraggable(critical, dimensions) {
    return dimensions.draggables[critical.draggable.id];
};
var $22db1ba098eb3017$var$makeMapStateToProps$1 = function makeMapStateToProps() {
    var idleWithAnimation = {
        placeholder: null,
        shouldAnimatePlaceholder: true,
        snapshot: {
            isDraggingOver: false,
            draggingOverWith: null,
            draggingFromThisWith: null,
            isUsingPlaceholder: false
        },
        useClone: null
    };
    var idleWithoutAnimation = (0, $gzM5u.default)({}, idleWithAnimation, {
        shouldAnimatePlaceholder: false
    });
    var getDraggableRubric = (0, $jQbLg.default)(function(descriptor) {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    });
    var getMapProps = (0, $jQbLg.default)(function(id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
        var draggableId = dragging.descriptor.id;
        var isHome = dragging.descriptor.droppableId === id;
        if (isHome) {
            var useClone = renderClone ? {
                render: renderClone,
                dragging: getDraggableRubric(dragging.descriptor)
            } : null;
            var _snapshot = {
                isDraggingOver: isDraggingOverForConsumer,
                draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
                draggingFromThisWith: draggableId,
                isUsingPlaceholder: true
            };
            return {
                placeholder: dragging.placeholder,
                shouldAnimatePlaceholder: false,
                snapshot: _snapshot,
                useClone: useClone
            };
        }
        if (!isEnabled) return idleWithoutAnimation;
        if (!isDraggingOverForImpact) return idleWithAnimation;
        var snapshot = {
            isDraggingOver: isDraggingOverForConsumer,
            draggingOverWith: draggableId,
            draggingFromThisWith: null,
            isUsingPlaceholder: true
        };
        return {
            placeholder: dragging.placeholder,
            shouldAnimatePlaceholder: true,
            snapshot: snapshot,
            useClone: null
        };
    });
    var selector = function selector(state, ownProps) {
        var id = ownProps.droppableId;
        var type = ownProps.type;
        var isEnabled = !ownProps.isDropDisabled;
        var renderClone = ownProps.renderClone;
        if (state.isDragging) {
            var critical = state.critical;
            if (!$22db1ba098eb3017$var$isMatchingType(type, critical)) return idleWithoutAnimation;
            var dragging = $22db1ba098eb3017$var$getDraggable(critical, state.dimensions);
            var isDraggingOver = $22db1ba098eb3017$var$whatIsDraggedOver(state.impact) === id;
            return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (!$22db1ba098eb3017$var$isMatchingType(type, completed.critical)) return idleWithoutAnimation;
            var _dragging = $22db1ba098eb3017$var$getDraggable(completed.critical, state.dimensions);
            return getMapProps(id, isEnabled, $22db1ba098eb3017$var$whatIsDraggedOverFromResult(completed.result) === id, $22db1ba098eb3017$var$whatIsDraggedOver(completed.impact) === id, _dragging, renderClone);
        }
        if (state.phase === 'IDLE' && state.completed && !state.shouldFlush) {
            var _completed = state.completed;
            if (!$22db1ba098eb3017$var$isMatchingType(type, _completed.critical)) return idleWithoutAnimation;
            var wasOver = $22db1ba098eb3017$var$whatIsDraggedOver(_completed.impact) === id;
            var wasCombining = Boolean(_completed.impact.at && _completed.impact.at.type === 'COMBINE');
            var isHome = _completed.critical.droppable.id === id;
            if (wasOver) return wasCombining ? idleWithAnimation : idleWithoutAnimation;
            if (isHome) return idleWithAnimation;
            return idleWithoutAnimation;
        }
        return idleWithoutAnimation;
    };
    return selector;
};
var $22db1ba098eb3017$var$mapDispatchToProps$1 = {
    updateViewportMaxScroll: $22db1ba098eb3017$var$updateViewportMaxScroll
};
function $22db1ba098eb3017$var$getBody() {
    !document.body && $22db1ba098eb3017$var$invariant(false);
    return document.body;
}
var $22db1ba098eb3017$var$defaultProps = {
    mode: 'standard',
    type: 'DEFAULT',
    direction: 'vertical',
    isDropDisabled: false,
    isCombineEnabled: false,
    ignoreContainerClipping: false,
    renderClone: null,
    getContainerForClone: $22db1ba098eb3017$var$getBody
};
var $22db1ba098eb3017$export$423ec2075359570a = (0, $AuRrZ.default)($22db1ba098eb3017$var$makeMapStateToProps$1, $22db1ba098eb3017$var$mapDispatchToProps$1, null, {
    context: $22db1ba098eb3017$var$StoreContext,
    pure: true,
    areStatePropsEqual: $22db1ba098eb3017$var$isStrictEqual
})($22db1ba098eb3017$var$Droppable);
$22db1ba098eb3017$export$423ec2075359570a.defaultProps = $22db1ba098eb3017$var$defaultProps;

});
parcelRegister("1AwyE", function(module, exports) {

$parcel$export(module.exports, "default", () => $128268946ec0acb0$export$2e2bcd8739ae039);

var $dG4Ay = parcelRequire("dG4Ay");

var $blzS6 = parcelRequire("blzS6");
function $128268946ec0acb0$export$2e2bcd8739ae039(t, o) {
    t.prototype = (0, (/*@__PURE__*/$parcel$interopDefault($dG4Ay)))(o.prototype), t.prototype.constructor = t, (0, $blzS6.default)(t, o);
}

});
parcelRegister("dG4Ay", function(module, exports) {
parcelRequire("bAALv");

var $4KXzV = parcelRequire("4KXzV");
var $9f52c1cdbf61a0ea$require$$Object = $4KXzV.Object;
module.exports = function create(P, D) {
    return $9f52c1cdbf61a0ea$require$$Object.create(P, D);
};

});
parcelRegister("bAALv", function(module, exports) {

var $fNMIk = parcelRequire("fNMIk");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$fNMIk($fNMIk.S, 'Object', {
    create: (parcelRequire("221nn"))
});

});
parcelRegister("fNMIk", function(module, exports) {

var $4tgdI = parcelRequire("4tgdI");

var $4KXzV = parcelRequire("4KXzV");

var $85v89 = parcelRequire("85v89");

var $9TfYC = parcelRequire("9TfYC");

var $8cV4K = parcelRequire("8cV4K");
var $b811382cedb7c9d6$var$PROTOTYPE = 'prototype';
var $b811382cedb7c9d6$var$$export = function(type, name, source) {
    var IS_FORCED = type & $b811382cedb7c9d6$var$$export.F;
    var IS_GLOBAL = type & $b811382cedb7c9d6$var$$export.G;
    var IS_STATIC = type & $b811382cedb7c9d6$var$$export.S;
    var IS_PROTO = type & $b811382cedb7c9d6$var$$export.P;
    var IS_BIND = type & $b811382cedb7c9d6$var$$export.B;
    var IS_WRAP = type & $b811382cedb7c9d6$var$$export.W;
    var exports = IS_GLOBAL ? $4KXzV : $4KXzV[name] || ($4KXzV[name] = {});
    var expProto = exports[$b811382cedb7c9d6$var$PROTOTYPE];
    var target = IS_GLOBAL ? $4tgdI : IS_STATIC ? $4tgdI[name] : ($4tgdI[name] || {})[$b811382cedb7c9d6$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $8cV4K(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $85v89(out, $4tgdI) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$b811382cedb7c9d6$var$PROTOTYPE] = C[$b811382cedb7c9d6$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? $85v89(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $b811382cedb7c9d6$var$$export.R && expProto && !expProto[key]) $9TfYC(expProto, key, out);
        }
    }
};
// type bitmap
$b811382cedb7c9d6$var$$export.F = 1; // forced
$b811382cedb7c9d6$var$$export.G = 2; // global
$b811382cedb7c9d6$var$$export.S = 4; // static
$b811382cedb7c9d6$var$$export.P = 8; // proto
$b811382cedb7c9d6$var$$export.B = 16; // bind
$b811382cedb7c9d6$var$$export.W = 32; // wrap
$b811382cedb7c9d6$var$$export.U = 64; // safe
$b811382cedb7c9d6$var$$export.R = 128; // real proto method for `library`
module.exports = $b811382cedb7c9d6$var$$export;

});
parcelRegister("4tgdI", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $341673df947a4fac$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $341673df947a4fac$var$global; // eslint-disable-line no-undef

});

parcelRegister("4KXzV", function(module, exports) {
var $3769ac535e8faf09$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $3769ac535e8faf09$var$core; // eslint-disable-line no-undef

});

parcelRegister("85v89", function(module, exports) {
// optional / simple context binding

var $6fe4N = parcelRequire("6fe4N");
module.exports = function(fn, that, length) {
    $6fe4N(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("6fe4N", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});


parcelRegister("9TfYC", function(module, exports) {

var $2J4Nu = parcelRequire("2J4Nu");

var $azl1x = parcelRequire("azl1x");

module.exports = (parcelRequire("aPbfY")) ? function(object, key, value) {
    return $2J4Nu.f(object, key, $azl1x(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("2J4Nu", function(module, exports) {

$parcel$export(module.exports, "f", () => $1fc38158650d0be0$export$2d1720544b23b823, (v) => $1fc38158650d0be0$export$2d1720544b23b823 = v);
var $1fc38158650d0be0$export$2d1720544b23b823;

var $1J67F = parcelRequire("1J67F");

var $7fdxi = parcelRequire("7fdxi");

var $feF34 = parcelRequire("feF34");
var $1fc38158650d0be0$var$dP = Object.defineProperty;

$1fc38158650d0be0$export$2d1720544b23b823 = (parcelRequire("aPbfY")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $1J67F(O);
    P = $feF34(P, true);
    $1J67F(Attributes);
    if ($7fdxi) try {
        return $1fc38158650d0be0$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("1J67F", function(module, exports) {

var $dxLeJ = parcelRequire("dxLeJ");
module.exports = function(it) {
    if (!$dxLeJ(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("dxLeJ", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("7fdxi", function(module, exports) {



module.exports = !(parcelRequire("aPbfY")) && !(parcelRequire("cKvWG"))(function() {
    return Object.defineProperty((parcelRequire("8IahC"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("aPbfY", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("cKvWG"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("cKvWG", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("8IahC", function(module, exports) {

var $dxLeJ = parcelRequire("dxLeJ");

var $4tgdI = parcelRequire("4tgdI");
var $657a68d5e7e8fca9$require$document = $4tgdI.document;
// typeof document.createElement is 'object' in old IE
var $657a68d5e7e8fca9$var$is = $dxLeJ($657a68d5e7e8fca9$require$document) && $dxLeJ($657a68d5e7e8fca9$require$document.createElement);
module.exports = function(it) {
    return $657a68d5e7e8fca9$var$is ? $657a68d5e7e8fca9$require$document.createElement(it) : {};
};

});


parcelRegister("feF34", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $dxLeJ = parcelRequire("dxLeJ");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$dxLeJ(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$dxLeJ(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$dxLeJ(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$dxLeJ(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("azl1x", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("8cV4K", function(module, exports) {
var $5f9bb7be8775a474$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $5f9bb7be8775a474$var$hasOwnProperty.call(it, key);
};

});


parcelRegister("221nn", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $1J67F = parcelRequire("1J67F");

var $aRCm2 = parcelRequire("aRCm2");

var $8LIl9 = parcelRequire("8LIl9");

var $17acd5ea8a458e2a$var$IE_PROTO = (parcelRequire("fZhMi"))('IE_PROTO');
var $17acd5ea8a458e2a$var$Empty = function() {};
var $17acd5ea8a458e2a$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $17acd5ea8a458e2a$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("8IahC"))('iframe');
    var i = $8LIl9.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("jcava")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $17acd5ea8a458e2a$var$createDict = iframeDocument.F;
    while(i--)delete $17acd5ea8a458e2a$var$createDict[$17acd5ea8a458e2a$var$PROTOTYPE][$8LIl9[i]];
    return $17acd5ea8a458e2a$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $17acd5ea8a458e2a$var$Empty[$17acd5ea8a458e2a$var$PROTOTYPE] = $1J67F(O);
        result = new $17acd5ea8a458e2a$var$Empty();
        $17acd5ea8a458e2a$var$Empty[$17acd5ea8a458e2a$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$17acd5ea8a458e2a$var$IE_PROTO] = O;
    } else result = $17acd5ea8a458e2a$var$createDict();
    return Properties === undefined ? result : $aRCm2(result, Properties);
};

});
parcelRegister("aRCm2", function(module, exports) {

var $2J4Nu = parcelRequire("2J4Nu");

var $1J67F = parcelRequire("1J67F");

var $iTod0 = parcelRequire("iTod0");

module.exports = (parcelRequire("aPbfY")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $1J67F(O);
    var keys = $iTod0(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$2J4Nu.f(O, P = keys[i++], Properties[P]);
    return O;
};

});
parcelRegister("iTod0", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $vYsY4 = parcelRequire("vYsY4");

var $8LIl9 = parcelRequire("8LIl9");
module.exports = Object.keys || function keys(O) {
    return $vYsY4(O, $8LIl9);
};

});
parcelRegister("vYsY4", function(module, exports) {

var $8cV4K = parcelRequire("8cV4K");

var $ehxEQ = parcelRequire("ehxEQ");

var $0601ccb297d1ed28$var$arrayIndexOf = (parcelRequire("80pUB"))(false);

var $0601ccb297d1ed28$var$IE_PROTO = (parcelRequire("fZhMi"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $ehxEQ(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $0601ccb297d1ed28$var$IE_PROTO) $8cV4K(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($8cV4K(O, key = names[i++])) ~$0601ccb297d1ed28$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("ehxEQ", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $45UmF = parcelRequire("45UmF");

var $3BBLi = parcelRequire("3BBLi");
module.exports = function(it) {
    return $45UmF($3BBLi(it));
};

});
parcelRegister("45UmF", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $g8809 = parcelRequire("g8809");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $g8809(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("g8809", function(module, exports) {
var $bbe399a4209a50a6$var$toString = {}.toString;
module.exports = function(it) {
    return $bbe399a4209a50a6$var$toString.call(it).slice(8, -1);
};

});


parcelRegister("3BBLi", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("80pUB", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $ehxEQ = parcelRequire("ehxEQ");

var $fVjkK = parcelRequire("fVjkK");

var $eh5pH = parcelRequire("eh5pH");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $ehxEQ($this);
        var length = $fVjkK(O.length);
        var index = $eh5pH(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("fVjkK", function(module, exports) {
// 7.1.15 ToLength

var $9E260 = parcelRequire("9E260");
var $b97b2d25065ac7b9$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $b97b2d25065ac7b9$var$min($9E260(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});
parcelRegister("9E260", function(module, exports) {
// 7.1.4 ToInteger
var $705979a7eeb2722c$var$ceil = Math.ceil;
var $705979a7eeb2722c$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $705979a7eeb2722c$var$floor : $705979a7eeb2722c$var$ceil)(it);
};

});


parcelRegister("eh5pH", function(module, exports) {

var $9E260 = parcelRequire("9E260");
var $a646da372e065330$var$max = Math.max;
var $a646da372e065330$var$min = Math.min;
module.exports = function(index, length) {
    index = $9E260(index);
    return index < 0 ? $a646da372e065330$var$max(index + length, 0) : $a646da372e065330$var$min(index, length);
};

});


parcelRegister("fZhMi", function(module, exports) {

var $ba3a57d696ea3f5e$var$shared = (parcelRequire("51eCU"))('keys');

var $6oFvJ = parcelRequire("6oFvJ");
module.exports = function(key) {
    return $ba3a57d696ea3f5e$var$shared[key] || ($ba3a57d696ea3f5e$var$shared[key] = $6oFvJ(key));
};

});
parcelRegister("51eCU", function(module, exports) {

var $4KXzV = parcelRequire("4KXzV");

var $4tgdI = parcelRequire("4tgdI");
var $3a78644a27e09ff7$var$SHARED = '__core-js_shared__';
var $3a78644a27e09ff7$var$store = $4tgdI[$3a78644a27e09ff7$var$SHARED] || ($4tgdI[$3a78644a27e09ff7$var$SHARED] = {});

(module.exports = function(key, value) {
    return $3a78644a27e09ff7$var$store[key] || ($3a78644a27e09ff7$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $4KXzV.version,
    mode: (parcelRequire("fQqAk")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("fQqAk", function(module, exports) {
module.exports = true;

});


parcelRegister("6oFvJ", function(module, exports) {
var $4a852f27f31a7144$var$id = 0;
var $4a852f27f31a7144$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$4a852f27f31a7144$var$id + $4a852f27f31a7144$var$px).toString(36));
};

});



parcelRegister("8LIl9", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});



parcelRegister("jcava", function(module, exports) {

var $4tgdI = parcelRequire("4tgdI");
var $df9748b6b5115090$require$document = $4tgdI.document;
module.exports = $df9748b6b5115090$require$document && $df9748b6b5115090$require$document.documentElement;

});




parcelRegister("blzS6", function(module, exports) {

$parcel$export(module.exports, "default", () => $0221c40d50c91a18$export$2e2bcd8739ae039);

var $54tg9 = parcelRequire("54tg9");
function $0221c40d50c91a18$export$2e2bcd8739ae039(t, e) {
    return $0221c40d50c91a18$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($54tg9))) ? (0, (/*@__PURE__*/$parcel$interopDefault($54tg9))).bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0221c40d50c91a18$export$2e2bcd8739ae039(t, e);
}

});
parcelRegister("54tg9", function(module, exports) {
parcelRequire("lLIVa");

module.exports = (parcelRequire("4KXzV")).Object.setPrototypeOf;

});
parcelRegister("lLIVa", function(module, exports) {
// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $fNMIk = parcelRequire("fNMIk");

$fNMIk($fNMIk.S, 'Object', {
    setPrototypeOf: (parcelRequire("j14FP")).set
});

});
parcelRegister("j14FP", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $dxLeJ = parcelRequire("dxLeJ");

var $1J67F = parcelRequire("1J67F");
var $dd81bc62c5518cb8$var$check = function(O, proto) {
    $1J67F(O);
    if (!$dxLeJ(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("85v89"))(Function.call, (parcelRequire("fZ4ki")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $dd81bc62c5518cb8$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $dd81bc62c5518cb8$var$check
};

});
parcelRegister("fZ4ki", function(module, exports) {

$parcel$export(module.exports, "f", () => $ba2fe8a7b47b04c8$export$2d1720544b23b823, (v) => $ba2fe8a7b47b04c8$export$2d1720544b23b823 = v);
var $ba2fe8a7b47b04c8$export$2d1720544b23b823;

var $1paSc = parcelRequire("1paSc");

var $azl1x = parcelRequire("azl1x");

var $ehxEQ = parcelRequire("ehxEQ");

var $feF34 = parcelRequire("feF34");

var $8cV4K = parcelRequire("8cV4K");

var $7fdxi = parcelRequire("7fdxi");
var $ba2fe8a7b47b04c8$var$gOPD = Object.getOwnPropertyDescriptor;

$ba2fe8a7b47b04c8$export$2d1720544b23b823 = (parcelRequire("aPbfY")) ? $ba2fe8a7b47b04c8$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $ehxEQ(O);
    P = $feF34(P, true);
    if ($7fdxi) try {
        return $ba2fe8a7b47b04c8$var$gOPD(O, P);
    } catch (e) {}
    if ($8cV4K(O, P)) return $azl1x(!$1paSc.f.call(O, P), O[P]);
};

});
parcelRegister("1paSc", function(module, exports) {

$parcel$export(module.exports, "f", () => $10608f6e292983ab$export$2d1720544b23b823, (v) => $10608f6e292983ab$export$2d1720544b23b823 = v);
var $10608f6e292983ab$export$2d1720544b23b823;
$10608f6e292983ab$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});







parcelRegister("gzM5u", function(module, exports) {

$parcel$export(module.exports, "default", () => $c115376b03ce6805$export$2e2bcd8739ae039);

var $jSAle = parcelRequire("jSAle");
function $c115376b03ce6805$export$2e2bcd8739ae039() {
    return $c115376b03ce6805$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($jSAle))) ? (0, (/*@__PURE__*/$parcel$interopDefault($jSAle))).bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c115376b03ce6805$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("jSAle", function(module, exports) {
parcelRequire("gGoAI");

module.exports = (parcelRequire("4KXzV")).Object.assign;

});
parcelRegister("gGoAI", function(module, exports) {
// 19.1.3.1 Object.assign(target, source)

var $fNMIk = parcelRequire("fNMIk");

$fNMIk($fNMIk.S + $fNMIk.F, 'Object', {
    assign: (parcelRequire("f40xK"))
});

});
parcelRegister("f40xK", function(module, exports) {
'use strict';

var $aPbfY = parcelRequire("aPbfY");

var $iTod0 = parcelRequire("iTod0");

var $8SJ8c = parcelRequire("8SJ8c");

var $1paSc = parcelRequire("1paSc");

var $llAOy = parcelRequire("llAOy");

var $45UmF = parcelRequire("45UmF");
var $af77a69d8871d271$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$af77a69d8871d271$var$$assign || (parcelRequire("cKvWG"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $af77a69d8871d271$var$$assign({}, A)[S] != 7 || Object.keys($af77a69d8871d271$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $llAOy(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $8SJ8c.f;
    var isEnum = $1paSc.f;
    while(aLen > index){
        var S = $45UmF(arguments[index++]);
        var keys = getSymbols ? $iTod0(S).concat(getSymbols(S)) : $iTod0(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$aPbfY || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $af77a69d8871d271$var$$assign;

});
parcelRegister("8SJ8c", function(module, exports) {

$parcel$export(module.exports, "f", () => $67765ffbebba3db3$export$2d1720544b23b823, (v) => $67765ffbebba3db3$export$2d1720544b23b823 = v);
var $67765ffbebba3db3$export$2d1720544b23b823;
$67765ffbebba3db3$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("llAOy", function(module, exports) {
// 7.1.13 ToObject(argument)

var $3BBLi = parcelRequire("3BBLi");
module.exports = function(it) {
    return Object($3BBLi(it));
};

});





parcelRegister("22j3V", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $17ba8e0cb3c50187$export$f51a9068ac82ea43);
$parcel$export(module.exports, "combineReducers", () => $17ba8e0cb3c50187$export$66e4520cdb265d18);
$parcel$export(module.exports, "bindActionCreators", () => $17ba8e0cb3c50187$export$aea084d96e84da92);
$parcel$export(module.exports, "compose", () => $17ba8e0cb3c50187$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "applyMiddleware", () => $17ba8e0cb3c50187$export$9ff26e0402cc7b7);

var $d56Hw = parcelRequire("d56Hw");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $17ba8e0cb3c50187$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $17ba8e0cb3c50187$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $17ba8e0cb3c50187$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $17ba8e0cb3c50187$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $17ba8e0cb3c50187$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $17ba8e0cb3c50187$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $17ba8e0cb3c50187$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $17ba8e0cb3c50187$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $17ba8e0cb3c50187$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($17ba8e0cb3c50187$var$isDate(val)) return 'date';
    if ($17ba8e0cb3c50187$var$isError(val)) return 'error';
    var constructorName = $17ba8e0cb3c50187$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $17ba8e0cb3c50187$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $17ba8e0cb3c50187$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $17ba8e0cb3c50187$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $17ba8e0cb3c50187$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $17ba8e0cb3c50187$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(1));
        return enhancer($17ba8e0cb3c50187$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$17ba8e0cb3c50187$var$isPlainObject(action)) throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $17ba8e0cb3c50187$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$17ba8e0cb3c50187$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $17ba8e0cb3c50187$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$17ba8e0cb3c50187$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $17ba8e0cb3c50187$export$8928921ea2d3b126 = $17ba8e0cb3c50187$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $17ba8e0cb3c50187$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $17ba8e0cb3c50187$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $17ba8e0cb3c50187$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$17ba8e0cb3c50187$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $17ba8e0cb3c50187$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $17ba8e0cb3c50187$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $17ba8e0cb3c50187$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $17ba8e0cb3c50187$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $17ba8e0cb3c50187$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $17ba8e0cb3c50187$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $17ba8e0cb3c50187$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $17ba8e0cb3c50187$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $17ba8e0cb3c50187$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $17ba8e0cb3c50187$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $17ba8e0cb3c50187$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $17ba8e0cb3c50187$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $17ba8e0cb3c50187$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $17ba8e0cb3c50187$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $d56Hw.default)((0, $d56Hw.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("d56Hw", function(module, exports) {

$parcel$export(module.exports, "default", () => $9860f0a512598bc6$export$2e2bcd8739ae039);

var $eHiP8 = parcelRequire("eHiP8");
function $9860f0a512598bc6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9860f0a512598bc6$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9860f0a512598bc6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eHiP8.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9860f0a512598bc6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});


parcelRegister("i6AsN", function(module, exports) {
$parcel$export(module.exports, "connect", () => (parcelRequire("AuRrZ")).default);
$parcel$export(module.exports, "Provider", () => (parcelRequire("9bdMd")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("616sH")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("6S8MB")).useSelector);
parcelRequire("dDvQ8");
parcelRequire("8mhVE");
var $7nsd3 = parcelRequire("7nsd3");

var $297cv = parcelRequire("297cv");
// with standard React renderers (ReactDOM, React Native)
(0, $297cv.setBatch)((0, $7nsd3.unstable_batchedUpdates));

});
parcelRegister("dDvQ8", function(module, exports) {

$parcel$export(module.exports, "Provider", () => (parcelRequire("9bdMd")).default);
$parcel$export(module.exports, "connect", () => (parcelRequire("AuRrZ")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("616sH")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("6S8MB")).useSelector);

var $9bdMd = parcelRequire("9bdMd");

var $evQWN = parcelRequire("evQWN");

var $eZhPT = parcelRequire("eZhPT");

var $AuRrZ = parcelRequire("AuRrZ");

var $616sH = parcelRequire("616sH");

var $6S8MB = parcelRequire("6S8MB");

var $5sekt = parcelRequire("5sekt");

var $ggTLx = parcelRequire("ggTLx");

});
parcelRegister("9bdMd", function(module, exports) {

$parcel$export(module.exports, "default", () => $6aefd3e4140316d1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");


var $eZhPT = parcelRequire("eZhPT");

var $arhzp = parcelRequire("arhzp");

var $gneWW = parcelRequire("gneWW");
function $6aefd3e4140316d1$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $5uXOq.useMemo)(function() {
        var subscription = (0, $arhzp.createSubscription)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $5uXOq.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $gneWW.useIsomorphicLayoutEffect)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $eZhPT.ReactReduxContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $6aefd3e4140316d1$export$2e2bcd8739ae039 = $6aefd3e4140316d1$var$Provider;

});
parcelRegister("eZhPT", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", () => $ae9499069f1e06d6$export$cc80c08dc91f1c00);

var $5uXOq = parcelRequire("5uXOq");
var $ae9499069f1e06d6$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(null);
var $ae9499069f1e06d6$export$2e2bcd8739ae039 = $ae9499069f1e06d6$export$cc80c08dc91f1c00;

});

parcelRegister("arhzp", function(module, exports) {

$parcel$export(module.exports, "createSubscription", () => $799a0e0be31b1662$export$d567d2b9af322f8f);

var $297cv = parcelRequire("297cv");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $799a0e0be31b1662$var$createListenerCollection() {
    var batch = (0, $297cv.getBatch)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $799a0e0be31b1662$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $799a0e0be31b1662$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $799a0e0be31b1662$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $799a0e0be31b1662$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $799a0e0be31b1662$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}

});
parcelRegister("297cv", function(module, exports) {

$parcel$export(module.exports, "setBatch", () => $190201f2d37d6502$export$4b9874722d0da7bc);
$parcel$export(module.exports, "getBatch", () => $190201f2d37d6502$export$fc47d4c0ba3bd2c6);
// Default to a dummy "batch" implementation that just runs the callback
function $190201f2d37d6502$var$defaultNoopBatch(callback) {
    callback();
}
var $190201f2d37d6502$var$batch = $190201f2d37d6502$var$defaultNoopBatch; // Allow injecting another batching function later
var $190201f2d37d6502$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $190201f2d37d6502$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $190201f2d37d6502$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $190201f2d37d6502$var$batch;
};

});


parcelRegister("gneWW", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $beba64068692f8ee$export$700979bc83e7db82);

var $5uXOq = parcelRequire("5uXOq");
var $beba64068692f8ee$export$700979bc83e7db82 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $5uXOq.useLayoutEffect) : (0, $5uXOq.useEffect);

});


parcelRegister("evQWN", function(module, exports) {

$parcel$export(module.exports, "default", () => $a90d08332793f660$export$2e2bcd8739ae039);

var $bS32t = parcelRequire("bS32t");

var $ddEsc = parcelRequire("ddEsc");

var $dY8Js = parcelRequire("dY8Js");

var $5uXOq = parcelRequire("5uXOq");

var $bCzx0 = parcelRequire("bCzx0");

var $arhzp = parcelRequire("arhzp");

var $gneWW = parcelRequire("gneWW");

var $eZhPT = parcelRequire("eZhPT");
var $a90d08332793f660$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $a90d08332793f660$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $a90d08332793f660$var$EMPTY_ARRAY = [];
var $a90d08332793f660$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $a90d08332793f660$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $a90d08332793f660$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $a90d08332793f660$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $gneWW.useIsomorphicLayoutEffect)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $a90d08332793f660$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $a90d08332793f660$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: 'STORE_UPDATED',
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $a90d08332793f660$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $a90d08332793f660$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $eZhPT.ReactReduxContext) : _ref2$context, connectOptions = (0, $ddEsc.default)(_ref2, $a90d08332793f660$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $bS32t.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $5uXOq.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $5uXOq.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $ddEsc.default)(props, $a90d08332793f660$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $5uXOq.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $bCzx0.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $5uXOq.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $5uXOq.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $5uXOq.useMemo)(function() {
                if (!shouldHandleStateChanges) return $a90d08332793f660$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $arhzp.createSubscription)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $5uXOq.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $bS32t.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $5uXOq.useReducer)($a90d08332793f660$var$storeStateUpdatesReducer, $a90d08332793f660$var$EMPTY_ARRAY, $a90d08332793f660$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $5uXOq.useRef)();
            var lastWrapperProps = (0, $5uXOq.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $5uXOq.useRef)();
            var renderIsScheduled = (0, $5uXOq.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $a90d08332793f660$var$useIsomorphicLayoutEffectWithArgs($a90d08332793f660$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $a90d08332793f660$var$useIsomorphicLayoutEffectWithArgs($a90d08332793f660$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $5uXOq.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, (0, $bS32t.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $5uXOq.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Connect, (0, $bS32t.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(Connect, WrappedComponent);
    };
}

});
parcelRegister("bCzx0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dJaa4"));

});
parcelRegister("dJaa4", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $9fe75c2c5f477da2$export$a7c73072b1a182ae, (v) => $9fe75c2c5f477da2$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $9fe75c2c5f477da2$export$9f27bc3417b4524d, (v) => $9fe75c2c5f477da2$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $9fe75c2c5f477da2$export$db77ccec0bb4ccac, (v) => $9fe75c2c5f477da2$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $9fe75c2c5f477da2$export$8392c0c9d3dcbd35, (v) => $9fe75c2c5f477da2$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $9fe75c2c5f477da2$export$ffb0004e005737fa, (v) => $9fe75c2c5f477da2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $9fe75c2c5f477da2$export$b624eff549462981, (v) => $9fe75c2c5f477da2$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $9fe75c2c5f477da2$export$7897aa7841a5380c, (v) => $9fe75c2c5f477da2$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $9fe75c2c5f477da2$export$602eac185826482c, (v) => $9fe75c2c5f477da2$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $9fe75c2c5f477da2$export$e2c29f18771995cb, (v) => $9fe75c2c5f477da2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $9fe75c2c5f477da2$export$5f8d39834fd61797, (v) => $9fe75c2c5f477da2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $9fe75c2c5f477da2$export$74bf444e3cd11ea5, (v) => $9fe75c2c5f477da2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $9fe75c2c5f477da2$export$92387174baf9b227, (v) => $9fe75c2c5f477da2$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $9fe75c2c5f477da2$export$ec112efeb987d9c6, (v) => $9fe75c2c5f477da2$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $9fe75c2c5f477da2$export$b706b080d889d2c9, (v) => $9fe75c2c5f477da2$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $9fe75c2c5f477da2$export$5be5a87408f70ddc, (v) => $9fe75c2c5f477da2$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $9fe75c2c5f477da2$export$45a5e7f76e0caa8d, (v) => $9fe75c2c5f477da2$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $9fe75c2c5f477da2$export$455c2e768291efa6, (v) => $9fe75c2c5f477da2$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $9fe75c2c5f477da2$export$9522e17588c12572, (v) => $9fe75c2c5f477da2$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $9fe75c2c5f477da2$export$2110ac352bb060b9, (v) => $9fe75c2c5f477da2$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $9fe75c2c5f477da2$export$56885ab8b9c456ab, (v) => $9fe75c2c5f477da2$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $9fe75c2c5f477da2$export$d927fcb6adf8f9de, (v) => $9fe75c2c5f477da2$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $9fe75c2c5f477da2$export$b82d16f27459e05a, (v) => $9fe75c2c5f477da2$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $9fe75c2c5f477da2$export$522c17b4f5e123e8, (v) => $9fe75c2c5f477da2$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $9fe75c2c5f477da2$export$1aabd8a0274ecfd6, (v) => $9fe75c2c5f477da2$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $9fe75c2c5f477da2$export$9b621391a187a31a, (v) => $9fe75c2c5f477da2$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $9fe75c2c5f477da2$export$f5bbd400c2f4426f, (v) => $9fe75c2c5f477da2$export$f5bbd400c2f4426f = v);
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9fe75c2c5f477da2$export$a7c73072b1a182ae;
var $9fe75c2c5f477da2$export$9f27bc3417b4524d;
var $9fe75c2c5f477da2$export$db77ccec0bb4ccac;
var $9fe75c2c5f477da2$export$8392c0c9d3dcbd35;
var $9fe75c2c5f477da2$export$ffb0004e005737fa;
var $9fe75c2c5f477da2$export$b624eff549462981;
var $9fe75c2c5f477da2$export$7897aa7841a5380c;
var $9fe75c2c5f477da2$export$602eac185826482c;
var $9fe75c2c5f477da2$export$e2c29f18771995cb;
var $9fe75c2c5f477da2$export$5f8d39834fd61797;
var $9fe75c2c5f477da2$export$74bf444e3cd11ea5;
var $9fe75c2c5f477da2$export$92387174baf9b227;
var $9fe75c2c5f477da2$export$ec112efeb987d9c6;
var $9fe75c2c5f477da2$export$b706b080d889d2c9;
var $9fe75c2c5f477da2$export$5be5a87408f70ddc;
var $9fe75c2c5f477da2$export$45a5e7f76e0caa8d;
var $9fe75c2c5f477da2$export$455c2e768291efa6;
var $9fe75c2c5f477da2$export$9522e17588c12572;
var $9fe75c2c5f477da2$export$2110ac352bb060b9;
var $9fe75c2c5f477da2$export$56885ab8b9c456ab;
var $9fe75c2c5f477da2$export$d927fcb6adf8f9de;
var $9fe75c2c5f477da2$export$b82d16f27459e05a;
var $9fe75c2c5f477da2$export$522c17b4f5e123e8;
var $9fe75c2c5f477da2$export$1aabd8a0274ecfd6;
var $9fe75c2c5f477da2$export$9b621391a187a31a;
var $9fe75c2c5f477da2$export$f5bbd400c2f4426f;
'use strict';
var $9fe75c2c5f477da2$var$b = 60103, $9fe75c2c5f477da2$var$c = 60106, $9fe75c2c5f477da2$var$d = 60107, $9fe75c2c5f477da2$var$e = 60108, $9fe75c2c5f477da2$var$f = 60114, $9fe75c2c5f477da2$var$g = 60109, $9fe75c2c5f477da2$var$h = 60110, $9fe75c2c5f477da2$var$k = 60112, $9fe75c2c5f477da2$var$l = 60113, $9fe75c2c5f477da2$var$m = 60120, $9fe75c2c5f477da2$var$n = 60115, $9fe75c2c5f477da2$var$p = 60116, $9fe75c2c5f477da2$var$q = 60121, $9fe75c2c5f477da2$var$r = 60122, $9fe75c2c5f477da2$var$u = 60117, $9fe75c2c5f477da2$var$v = 60129, $9fe75c2c5f477da2$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $9fe75c2c5f477da2$var$x = Symbol.for;
    $9fe75c2c5f477da2$var$b = $9fe75c2c5f477da2$var$x("react.element");
    $9fe75c2c5f477da2$var$c = $9fe75c2c5f477da2$var$x("react.portal");
    $9fe75c2c5f477da2$var$d = $9fe75c2c5f477da2$var$x("react.fragment");
    $9fe75c2c5f477da2$var$e = $9fe75c2c5f477da2$var$x("react.strict_mode");
    $9fe75c2c5f477da2$var$f = $9fe75c2c5f477da2$var$x("react.profiler");
    $9fe75c2c5f477da2$var$g = $9fe75c2c5f477da2$var$x("react.provider");
    $9fe75c2c5f477da2$var$h = $9fe75c2c5f477da2$var$x("react.context");
    $9fe75c2c5f477da2$var$k = $9fe75c2c5f477da2$var$x("react.forward_ref");
    $9fe75c2c5f477da2$var$l = $9fe75c2c5f477da2$var$x("react.suspense");
    $9fe75c2c5f477da2$var$m = $9fe75c2c5f477da2$var$x("react.suspense_list");
    $9fe75c2c5f477da2$var$n = $9fe75c2c5f477da2$var$x("react.memo");
    $9fe75c2c5f477da2$var$p = $9fe75c2c5f477da2$var$x("react.lazy");
    $9fe75c2c5f477da2$var$q = $9fe75c2c5f477da2$var$x("react.block");
    $9fe75c2c5f477da2$var$r = $9fe75c2c5f477da2$var$x("react.server.block");
    $9fe75c2c5f477da2$var$u = $9fe75c2c5f477da2$var$x("react.fundamental");
    $9fe75c2c5f477da2$var$v = $9fe75c2c5f477da2$var$x("react.debug_trace_mode");
    $9fe75c2c5f477da2$var$w = $9fe75c2c5f477da2$var$x("react.legacy_hidden");
}
function $9fe75c2c5f477da2$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $9fe75c2c5f477da2$var$b:
                switch(a = a.type, a){
                    case $9fe75c2c5f477da2$var$d:
                    case $9fe75c2c5f477da2$var$f:
                    case $9fe75c2c5f477da2$var$e:
                    case $9fe75c2c5f477da2$var$l:
                    case $9fe75c2c5f477da2$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $9fe75c2c5f477da2$var$h:
                            case $9fe75c2c5f477da2$var$k:
                            case $9fe75c2c5f477da2$var$p:
                            case $9fe75c2c5f477da2$var$n:
                            case $9fe75c2c5f477da2$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $9fe75c2c5f477da2$var$c:
                return t;
        }
    }
}
var $9fe75c2c5f477da2$var$z = $9fe75c2c5f477da2$var$g, $9fe75c2c5f477da2$var$A = $9fe75c2c5f477da2$var$b, $9fe75c2c5f477da2$var$B = $9fe75c2c5f477da2$var$k, $9fe75c2c5f477da2$var$C = $9fe75c2c5f477da2$var$d, $9fe75c2c5f477da2$var$D = $9fe75c2c5f477da2$var$p, $9fe75c2c5f477da2$var$E = $9fe75c2c5f477da2$var$n, $9fe75c2c5f477da2$var$F = $9fe75c2c5f477da2$var$c, $9fe75c2c5f477da2$var$G = $9fe75c2c5f477da2$var$f, $9fe75c2c5f477da2$var$H = $9fe75c2c5f477da2$var$e, $9fe75c2c5f477da2$var$I = $9fe75c2c5f477da2$var$l;
$9fe75c2c5f477da2$export$a7c73072b1a182ae = $9fe75c2c5f477da2$var$h;
$9fe75c2c5f477da2$export$9f27bc3417b4524d = $9fe75c2c5f477da2$var$z;
$9fe75c2c5f477da2$export$db77ccec0bb4ccac = $9fe75c2c5f477da2$var$A;
$9fe75c2c5f477da2$export$8392c0c9d3dcbd35 = $9fe75c2c5f477da2$var$B;
$9fe75c2c5f477da2$export$ffb0004e005737fa = $9fe75c2c5f477da2$var$C;
$9fe75c2c5f477da2$export$b624eff549462981 = $9fe75c2c5f477da2$var$D;
$9fe75c2c5f477da2$export$7897aa7841a5380c = $9fe75c2c5f477da2$var$E;
$9fe75c2c5f477da2$export$602eac185826482c = $9fe75c2c5f477da2$var$F;
$9fe75c2c5f477da2$export$e2c29f18771995cb = $9fe75c2c5f477da2$var$G;
$9fe75c2c5f477da2$export$5f8d39834fd61797 = $9fe75c2c5f477da2$var$H;
$9fe75c2c5f477da2$export$74bf444e3cd11ea5 = $9fe75c2c5f477da2$var$I;
$9fe75c2c5f477da2$export$92387174baf9b227 = function() {
    return !1;
};
$9fe75c2c5f477da2$export$ec112efeb987d9c6 = function() {
    return !1;
};
$9fe75c2c5f477da2$export$b706b080d889d2c9 = function(a) {
    return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$h;
};
$9fe75c2c5f477da2$export$5be5a87408f70ddc = function(a) {
    return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$g;
};
$9fe75c2c5f477da2$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $9fe75c2c5f477da2$var$b;
};
$9fe75c2c5f477da2$export$455c2e768291efa6 = function(a) {
    return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$k;
};
$9fe75c2c5f477da2$export$9522e17588c12572 = function(a) {
    return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$d;
};
$9fe75c2c5f477da2$export$2110ac352bb060b9 = function(a) {
    return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$p;
};
$9fe75c2c5f477da2$export$56885ab8b9c456ab = function(a) {
    return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$n;
};
$9fe75c2c5f477da2$export$d927fcb6adf8f9de = function(a) {
    return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$c;
};
$9fe75c2c5f477da2$export$b82d16f27459e05a = function(a) {
    return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$f;
};
$9fe75c2c5f477da2$export$522c17b4f5e123e8 = function(a) {
    return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$e;
};
$9fe75c2c5f477da2$export$1aabd8a0274ecfd6 = function(a) {
    return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$l;
};
$9fe75c2c5f477da2$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $9fe75c2c5f477da2$var$d || a === $9fe75c2c5f477da2$var$f || a === $9fe75c2c5f477da2$var$v || a === $9fe75c2c5f477da2$var$e || a === $9fe75c2c5f477da2$var$l || a === $9fe75c2c5f477da2$var$m || a === $9fe75c2c5f477da2$var$w || "object" === typeof a && null !== a && (a.$$typeof === $9fe75c2c5f477da2$var$p || a.$$typeof === $9fe75c2c5f477da2$var$n || a.$$typeof === $9fe75c2c5f477da2$var$g || a.$$typeof === $9fe75c2c5f477da2$var$h || a.$$typeof === $9fe75c2c5f477da2$var$k || a.$$typeof === $9fe75c2c5f477da2$var$u || a.$$typeof === $9fe75c2c5f477da2$var$q || a[0] === $9fe75c2c5f477da2$var$r) ? !0 : !1;
};
$9fe75c2c5f477da2$export$f5bbd400c2f4426f = $9fe75c2c5f477da2$var$y;

});



parcelRegister("AuRrZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $06db4d47a421a2eb$export$2e2bcd8739ae039);

var $bS32t = parcelRequire("bS32t");

var $ddEsc = parcelRequire("ddEsc");

var $evQWN = parcelRequire("evQWN");

var $ggTLx = parcelRequire("ggTLx");

var $aRR2I = parcelRequire("aRR2I");

var $li0D7 = parcelRequire("li0D7");

var $3zSL8 = parcelRequire("3zSL8");

var $aQWN9 = parcelRequire("aQWN9");
var $06db4d47a421a2eb$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $06db4d47a421a2eb$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $06db4d47a421a2eb$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $06db4d47a421a2eb$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $evQWN.default) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $li0D7.default) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $aRR2I.default) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $3zSL8.default) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $aQWN9.default) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $06db4d47a421a2eb$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $ggTLx.default) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $ggTLx.default) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $ggTLx.default) : _ref3$areMergedPropsE, extraOptions = (0, $ddEsc.default)(_ref3, $06db4d47a421a2eb$var$_excluded);
        var initMapStateToProps = $06db4d47a421a2eb$var$match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
        var initMapDispatchToProps = $06db4d47a421a2eb$var$match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
        var initMergeProps = $06db4d47a421a2eb$var$match(mergeProps, mergePropsFactories, 'mergeProps');
        return connectHOC(selectorFactory, (0, $bS32t.default)({
            // used in error messages
            methodName: 'connect',
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $06db4d47a421a2eb$export$2e2bcd8739ae039 = /*#__PURE__*/ $06db4d47a421a2eb$export$9f9feb656dec1fc4();

});
parcelRegister("ggTLx", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd8965e05453892e$export$2e2bcd8739ae039);
function $bd8965e05453892e$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $bd8965e05453892e$export$2e2bcd8739ae039(objA, objB) {
    if ($bd8965e05453892e$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$bd8965e05453892e$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});

parcelRegister("aRR2I", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e97ffd151087114$export$2e2bcd8739ae039);

var $a37gJ = parcelRequire("a37gJ");

var $8EqLJ = parcelRequire("8EqLJ");
function $7e97ffd151087114$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === 'function' ? (0, $8EqLJ.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function $7e97ffd151087114$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $8EqLJ.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $7e97ffd151087114$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $8EqLJ.wrapMapToPropsConstant)(function(dispatch) {
        return (0, $a37gJ.default)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $7e97ffd151087114$export$2e2bcd8739ae039 = [
    $7e97ffd151087114$export$a9f27b4b187c1166,
    $7e97ffd151087114$export$ba20d1a7aa0c4a90,
    $7e97ffd151087114$export$94a6e55709d4d961
];

});
parcelRegister("a37gJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $750fd2a673ba963c$export$2e2bcd8739ae039);
function $750fd2a673ba963c$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}

});

parcelRegister("8EqLJ", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", () => $64c6d2e3c8e9f263$export$710f7c60f68acd3e);
$parcel$export(module.exports, "wrapMapToPropsFunc", () => $64c6d2e3c8e9f263$export$8d46c7f53c8c602f);
parcelRequire("1prLO");
function $64c6d2e3c8e9f263$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $64c6d2e3c8e9f263$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $64c6d2e3c8e9f263$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $64c6d2e3c8e9f263$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $64c6d2e3c8e9f263$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("1prLO", function(module, exports) {

var $im3MO = parcelRequire("im3MO");

var $kb4xC = parcelRequire("kb4xC");
function $106daad597fc23e6$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $im3MO.default)(value)) (0, $kb4xC.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}

});
parcelRegister("im3MO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5cd37f6759c7272$export$2e2bcd8739ae039);
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $d5cd37f6759c7272$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});

parcelRegister("kb4xC", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb085b81b2733980$export$2e2bcd8739ae039);
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $eb085b81b2733980$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});




parcelRegister("li0D7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7fbc484b4e9d2ee$export$2e2bcd8739ae039);

var $8EqLJ = parcelRequire("8EqLJ");
function $f7fbc484b4e9d2ee$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === 'function' ? (0, $8EqLJ.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
}
function $f7fbc484b4e9d2ee$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $8EqLJ.wrapMapToPropsConstant)(function() {
        return {};
    }) : undefined;
}
var $f7fbc484b4e9d2ee$export$2e2bcd8739ae039 = [
    $f7fbc484b4e9d2ee$export$23fc470827b14aa,
    $f7fbc484b4e9d2ee$export$514bc8c1a53c1d66
];

});

parcelRegister("3zSL8", function(module, exports) {

$parcel$export(module.exports, "default", () => $29af1e0b3bc3959e$export$2e2bcd8739ae039);

var $bS32t = parcelRequire("bS32t");
parcelRequire("1prLO");
function $29af1e0b3bc3959e$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $bS32t.default)({}, ownProps, stateProps, dispatchProps);
}
function $29af1e0b3bc3959e$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $29af1e0b3bc3959e$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === 'function' ? $29af1e0b3bc3959e$export$5b105939c84b5234(mergeProps) : undefined;
}
function $29af1e0b3bc3959e$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $29af1e0b3bc3959e$export$691c327fc30bc857;
    } : undefined;
}
var $29af1e0b3bc3959e$export$2e2bcd8739ae039 = [
    $29af1e0b3bc3959e$export$d61b680184bc3f00,
    $29af1e0b3bc3959e$export$a13ba70ef50dda6d
];

});

parcelRegister("aQWN9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e6c5d8bc061ff2f$export$2e2bcd8739ae039);

var $ddEsc = parcelRequire("ddEsc");
parcelRequire("8XVVW");
var $7e6c5d8bc061ff2f$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $7e6c5d8bc061ff2f$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $7e6c5d8bc061ff2f$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $7e6c5d8bc061ff2f$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $ddEsc.default)(_ref2, $7e6c5d8bc061ff2f$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $7e6c5d8bc061ff2f$export$d20c0c2ca6eb2b6f : $7e6c5d8bc061ff2f$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("8XVVW", function(module, exports) {

var $kb4xC = parcelRequire("kb4xC");
function $6870c5d2f9dd91da$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $kb4xC.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $6870c5d2f9dd91da$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $6870c5d2f9dd91da$var$verify(mapStateToProps, 'mapStateToProps', displayName);
    $6870c5d2f9dd91da$var$verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
    $6870c5d2f9dd91da$var$verify(mergeProps, 'mergeProps', displayName);
}

});



parcelRegister("616sH", function(module, exports) {

$parcel$export(module.exports, "useDispatch", () => $4617d947d89cb783$export$8ad76b76a4c905f8);

var $eZhPT = parcelRequire("eZhPT");

var $5sekt = parcelRequire("5sekt");
function $4617d947d89cb783$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $eZhPT.ReactReduxContext);
    var useStore = context === (0, $eZhPT.ReactReduxContext) ? (0, $5sekt.useStore) : (0, $5sekt.createStoreHook)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $4617d947d89cb783$export$8ad76b76a4c905f8 = /*#__PURE__*/ $4617d947d89cb783$export$bc9b55530897c558();

});
parcelRegister("5sekt", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", () => $3f8aaec7bfa91a5f$export$671dba69185d0304);
$parcel$export(module.exports, "useStore", () => $3f8aaec7bfa91a5f$export$6ccbb43953eebf8);

var $5uXOq = parcelRequire("5uXOq");

var $eZhPT = parcelRequire("eZhPT");

var $i2tgo = parcelRequire("i2tgo");
function $3f8aaec7bfa91a5f$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $eZhPT.ReactReduxContext);
    var useReduxContext = context === (0, $eZhPT.ReactReduxContext) ? (0, $i2tgo.useReduxContext) : function() {
        return (0, $5uXOq.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $3f8aaec7bfa91a5f$export$6ccbb43953eebf8 = /*#__PURE__*/ $3f8aaec7bfa91a5f$export$671dba69185d0304();

});
parcelRegister("i2tgo", function(module, exports) {

$parcel$export(module.exports, "useReduxContext", () => $d21f1d0198d74b68$export$c1275ca9a6fd3ec5);

var $5uXOq = parcelRequire("5uXOq");

var $eZhPT = parcelRequire("eZhPT");
function $d21f1d0198d74b68$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $5uXOq.useContext)((0, $eZhPT.ReactReduxContext));
    return contextValue;
}

});



parcelRegister("6S8MB", function(module, exports) {

$parcel$export(module.exports, "useSelector", () => $500e9950191b49f8$export$2105062e25df4afe);

var $5uXOq = parcelRequire("5uXOq");

var $i2tgo = parcelRequire("i2tgo");

var $arhzp = parcelRequire("arhzp");

var $gneWW = parcelRequire("gneWW");

var $eZhPT = parcelRequire("eZhPT");
var $500e9950191b49f8$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $500e9950191b49f8$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $5uXOq.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $5uXOq.useMemo)(function() {
        return (0, $arhzp.createSubscription)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $5uXOq.useRef)();
    var latestSelector = (0, $5uXOq.useRef)();
    var latestStoreState = (0, $5uXOq.useRef)();
    var latestSelectedState = (0, $5uXOq.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $gneWW.useIsomorphicLayoutEffect)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $gneWW.useIsomorphicLayoutEffect)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $500e9950191b49f8$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $eZhPT.ReactReduxContext);
    var useReduxContext = context === (0, $eZhPT.ReactReduxContext) ? (0, $i2tgo.useReduxContext) : function() {
        return (0, $5uXOq.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $500e9950191b49f8$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $500e9950191b49f8$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $5uXOq.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $500e9950191b49f8$export$2105062e25df4afe = /*#__PURE__*/ $500e9950191b49f8$export$2b53f90d2bd1cbfb();

});


parcelRegister("8mhVE", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", () => (parcelRequire("7nsd3")).unstable_batchedUpdates);
/* eslint-disable import/no-unresolved */ 
var $7nsd3 = parcelRequire("7nsd3");

});


parcelRegister("3YKxB", function(module, exports) {

$parcel$export(module.exports, "getRect", () => $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe);
$parcel$export(module.exports, "expand", () => $2e5b13c1f6ee9f8a$export$9f77e0932fb78f72);
$parcel$export(module.exports, "createBox", () => $2e5b13c1f6ee9f8a$export$6459fc9e86be362e);
$parcel$export(module.exports, "offset", () => $2e5b13c1f6ee9f8a$export$cc800923e997bb8);
$parcel$export(module.exports, "withScroll", () => $2e5b13c1f6ee9f8a$export$1d0caec378d7d0ae);
$parcel$export(module.exports, "calculateBox", () => $2e5b13c1f6ee9f8a$export$b8dfc5d4e552b8e1);
$parcel$export(module.exports, "getBox", () => $2e5b13c1f6ee9f8a$export$34928e660d2a8702);

var $3joPi = parcelRequire("3joPi");
var $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var $2e5b13c1f6ee9f8a$export$9f77e0932fb78f72 = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var $2e5b13c1f6ee9f8a$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var $2e5b13c1f6ee9f8a$var$shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var $2e5b13c1f6ee9f8a$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $2e5b13c1f6ee9f8a$export$6459fc9e86be362e = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $2e5b13c1f6ee9f8a$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $2e5b13c1f6ee9f8a$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $2e5b13c1f6ee9f8a$var$noSpacing : _ref2$padding;
    var marginBox = $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe($2e5b13c1f6ee9f8a$export$9f77e0932fb78f72(borderBox, margin));
    var paddingBox = $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe($2e5b13c1f6ee9f8a$export$8b1f3092f5e28575(borderBox, border));
    var contentBox = $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe($2e5b13c1f6ee9f8a$export$8b1f3092f5e28575(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var $2e5b13c1f6ee9f8a$var$parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== 'px') return 0;
    var result = Number(value);
    !!isNaN(result) && (0, $3joPi.default)(false);
    return result;
};
var $2e5b13c1f6ee9f8a$var$getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var $2e5b13c1f6ee9f8a$export$cc800923e997bb8 = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = $2e5b13c1f6ee9f8a$var$shift(borderBox, change);
    return $2e5b13c1f6ee9f8a$export$6459fc9e86be362e({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var $2e5b13c1f6ee9f8a$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = $2e5b13c1f6ee9f8a$var$getWindowScroll();
    return $2e5b13c1f6ee9f8a$export$cc800923e997bb8(original, scroll);
};
var $2e5b13c1f6ee9f8a$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
    var margin = {
        top: $2e5b13c1f6ee9f8a$var$parse(styles.marginTop),
        right: $2e5b13c1f6ee9f8a$var$parse(styles.marginRight),
        bottom: $2e5b13c1f6ee9f8a$var$parse(styles.marginBottom),
        left: $2e5b13c1f6ee9f8a$var$parse(styles.marginLeft)
    };
    var padding = {
        top: $2e5b13c1f6ee9f8a$var$parse(styles.paddingTop),
        right: $2e5b13c1f6ee9f8a$var$parse(styles.paddingRight),
        bottom: $2e5b13c1f6ee9f8a$var$parse(styles.paddingBottom),
        left: $2e5b13c1f6ee9f8a$var$parse(styles.paddingLeft)
    };
    var border = {
        top: $2e5b13c1f6ee9f8a$var$parse(styles.borderTopWidth),
        right: $2e5b13c1f6ee9f8a$var$parse(styles.borderRightWidth),
        bottom: $2e5b13c1f6ee9f8a$var$parse(styles.borderBottomWidth),
        left: $2e5b13c1f6ee9f8a$var$parse(styles.borderLeftWidth)
    };
    return $2e5b13c1f6ee9f8a$export$6459fc9e86be362e({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var $2e5b13c1f6ee9f8a$export$34928e660d2a8702 = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return $2e5b13c1f6ee9f8a$export$b8dfc5d4e552b8e1(borderBox, styles);
};

});

parcelRegister("jQbLg", function(module, exports) {

$parcel$export(module.exports, "default", () => $e71bff38ed0f3653$export$2e2bcd8739ae039);
var $e71bff38ed0f3653$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $e71bff38ed0f3653$var$isEqual(first, second) {
    if (first === second) return true;
    if ($e71bff38ed0f3653$var$safeIsNaN(first) && $e71bff38ed0f3653$var$safeIsNaN(second)) return true;
    return false;
}
function $e71bff38ed0f3653$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$e71bff38ed0f3653$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e71bff38ed0f3653$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $e71bff38ed0f3653$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $e71bff38ed0f3653$export$2e2bcd8739ae039 = $e71bff38ed0f3653$var$memoizeOne;

});

parcelRegister("i2aN7", function(module, exports) {

module.exports = (parcelRequire("jptOl"));

});
parcelRegister("jptOl", function(module, exports) {
parcelRequire("a0Ixs");

module.exports = (parcelRequire("4KXzV")).Object.values;

});
parcelRegister("a0Ixs", function(module, exports) {
// https://github.com/tc39/proposal-object-values-entries

var $fNMIk = parcelRequire("fNMIk");

var $749c73ef0828bdd4$var$$values = (parcelRequire("kQXku"))(false);
$fNMIk($fNMIk.S, 'Object', {
    values: function values(it) {
        return $749c73ef0828bdd4$var$$values(it);
    }
});

});
parcelRegister("kQXku", function(module, exports) {

var $aPbfY = parcelRequire("aPbfY");

var $iTod0 = parcelRequire("iTod0");

var $ehxEQ = parcelRequire("ehxEQ");

var $1paSc = parcelRequire("1paSc");
var $f2e6af8f0a9cbb36$require$isEnum = $1paSc.f;
module.exports = function(isEntries) {
    return function(it) {
        var O = $ehxEQ(it);
        var keys = $iTod0(O);
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;
        while(length > i){
            key = keys[i++];
            if (!$aPbfY || $f2e6af8f0a9cbb36$require$isEnum.call(O, key)) result.push(isEntries ? [
                key,
                O[key]
            ] : O[key]);
        }
        return result;
    };
};

});




parcelRegister("cs3hJ", function(module, exports) {

module.exports = (parcelRequire("gtqo2"));

});
parcelRegister("gtqo2", function(module, exports) {
parcelRequire("jgnqd");

module.exports = (parcelRequire("4KXzV")).Object.keys;

});
parcelRegister("jgnqd", function(module, exports) {
// 19.1.2.14 Object.keys(O)

var $llAOy = parcelRequire("llAOy");

var $iTod0 = parcelRequire("iTod0");

(parcelRequire("4BA40"))('keys', function() {
    return function keys(it) {
        return $iTod0($llAOy(it));
    };
});

});
parcelRegister("4BA40", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $fNMIk = parcelRequire("fNMIk");

var $4KXzV = parcelRequire("4KXzV");

var $cKvWG = parcelRequire("cKvWG");
module.exports = function(KEY, exec) {
    var fn = ($4KXzV.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $fNMIk($fNMIk.S + $fNMIk.F * $cKvWG(function() {
        fn(1);
    }), 'Object', exp);
};

});




parcelRegister("7qpjg", function(module, exports) {

$parcel$export(module.exports, "default", () => $567e981b5ef77433$export$2e2bcd8739ae039);
var $567e981b5ef77433$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $567e981b5ef77433$export$2e2bcd8739ae039 = $567e981b5ef77433$var$rafSchd;

});

parcelRegister("3BSY2", function(module, exports) {

module.exports = (parcelRequire("4JOv4"));

});
parcelRegister("4JOv4", function(module, exports) {
parcelRequire("ixUy6");

module.exports = (parcelRequire("4KXzV")).Date.now;

});
parcelRegister("ixUy6", function(module, exports) {
// 20.3.3.1 / 15.9.4.4 Date.now()

var $fNMIk = parcelRequire("fNMIk");
$fNMIk($fNMIk.S, 'Date', {
    now: function() {
        return new Date().getTime();
    }
});

});



parcelRegister("4iZOV", function(module, exports) {

module.exports = (parcelRequire("jSAle"));

});

parcelRegister("1DIXK", function(module, exports) {

module.exports = (parcelRequire("izccK"));

});
parcelRegister("izccK", function(module, exports) {
parcelRequire("bwyHq");

module.exports = (parcelRequire("4KXzV")).Number.isInteger;

});
parcelRegister("bwyHq", function(module, exports) {
// 20.1.2.3 Number.isInteger(number)

var $fNMIk = parcelRequire("fNMIk");

$fNMIk($fNMIk.S, 'Number', {
    isInteger: (parcelRequire("dFLKl"))
});

});
parcelRegister("dFLKl", function(module, exports) {
// 20.1.2.3 Number.isInteger(number)

var $dxLeJ = parcelRequire("dxLeJ");
var $9f4424297502c7e8$var$floor = Math.floor;
module.exports = function isInteger(it) {
    return !$dxLeJ(it) && isFinite(it) && $9f4424297502c7e8$var$floor(it) === it;
};

});





parcelRegister("lL5b5", function(module, exports) {

$parcel$export(module.exports, "default", () => $07c2532655d93687$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $j0xEB = parcelRequire("j0xEB");

var $j2Jlg = parcelRequire("j2Jlg");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$07c2532655d93687$export$2e2bcd8739ae039 = ()=>{
    const { href: href = null } = (0, $j0xEB.default)() || {};
    if (href && !href.includes('login.jsp')) {
        const encodedRedirectUrl = encodeURIComponent(href);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j2Jlg.default), {
            url: `/login.jsp?os_destination=${encodedRedirectUrl}`
        });
    }
    return null;
};

});
parcelRegister("j2Jlg", function(module, exports) {

$parcel$export(module.exports, "default", () => $773e6f988af77e5c$export$2e2bcd8739ae039);

var $gKZoD = parcelRequire("gKZoD");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$773e6f988af77e5c$export$2e2bcd8739ae039 = ({ url: url })=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.assign(url);
    return null;
};

});


parcelRegister("iyrll", function(module, exports) {

$parcel$export(module.exports, "DashboardControllerContextProvider", () => $669a1fafb8f4566e$export$36eb228a17cae64d);
$parcel$export(module.exports, "DashboardControllerContextConsumer", () => $669a1fafb8f4566e$export$4ce01c0dbab5bb18);
$parcel$export(module.exports, "useDashboardRefresh", () => $669a1fafb8f4566e$export$71d14892f68b2430);
$parcel$export(module.exports, "useOnAddedGadget", () => $669a1fafb8f4566e$export$2471f3ee3e3601fe);

var $jnkfq = parcelRequire("jnkfq");
const { createUseContextField: $669a1fafb8f4566e$export$3fb47a2904db1f37, Provider: $669a1fafb8f4566e$export$36eb228a17cae64d, Consumer: $669a1fafb8f4566e$export$4ce01c0dbab5bb18 } = (0, $jnkfq.createRendererContext)();
const $669a1fafb8f4566e$export$71d14892f68b2430 = $669a1fafb8f4566e$export$3fb47a2904db1f37('onRefresh');
const $669a1fafb8f4566e$export$2471f3ee3e3601fe = $669a1fafb8f4566e$export$3fb47a2904db1f37('onAddedGadget');

});
parcelRegister("jnkfq", function(module, exports) {

$parcel$export(module.exports, "createRendererContext", () => $2cbc9584a68b4b0d$export$ac09db0e74937f7f);

var $5uXOq = parcelRequire("5uXOq");

var $9pe79 = parcelRequire("9pe79");
const $2cbc9584a68b4b0d$export$ac09db0e74937f7f = ()=>{
    const _UnmemoisedContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { Provider: UnmemoisedProvider, Consumer: Consumer } = _UnmemoisedContext;
    const Provider = /*#__PURE__*/ (0, $5uXOq.memo)(UnmemoisedProvider, ({ value: valueA, ...propsA }, { value: valueB, ...propsB })=>(0, $9pe79.default)(valueA, valueB) && (0, $9pe79.default)(propsA, propsB));
    const createRenderFunction = (children)=>(value)=>children != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Provider, {
                value: value
            }, typeof children === 'function' ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Consumer, null, children) : children) : null;
    const createUseContextField = (key)=>()=>{
            const value = (0, $5uXOq.useContext)(_UnmemoisedContext);
            if (value == null) throw new Error('context not found');
            return value[key];
        };
    return {
        _UnmemoisedContext: _UnmemoisedContext,
        Provider: Provider,
        Consumer: Consumer,
        createRenderFunction: createRenderFunction,
        createUseContextField: createUseContextField
    };
};

});


parcelRegister("32Vhm", function(module, exports) {

$parcel$export(module.exports, "DashboardController", () => $5e7fb5d7d6929ddb$export$b9771780c6ecf3f);

var $5uXOq = parcelRequire("5uXOq");

var $kwTKp = parcelRequire("kwTKp");

var $flEgL = parcelRequire("flEgL");

var $JIPqS = parcelRequire("JIPqS");

var $iyrll = parcelRequire("iyrll");
const $5e7fb5d7d6929ddb$export$d7eb50fb85f631d = ({ automaticRefreshMs: automaticRefreshMs })=>{
    const [refreshId, setRefreshId] = (0, $5uXOq.useState)(Date.now());
    const [, setMostRecentlyAddedGadgetId] = (0, $5uXOq.useState)(null);
    const onRefresh = (0, $5uXOq.useCallback)(()=>{
        (0, $kwTKp.emit)((0, $JIPqS.FORGE_JIRA_DASHBOARD_GADGET_REFRESH_EVENT), {
            origin: 'dashboard'
        });
        (0, $flEgL.default)((0, $JIPqS.CONNECT_GADGET_REFRESH_REQUEST_EVENT), {}, {
            origin: 'dashboard'
        });
        setRefreshId(Date.now());
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (automaticRefreshMs == null || automaticRefreshMs < 1) return ()=>undefined;
        // The interval is stored in a signed 32-bit int so any number above 2**31-1 would
        // become negative which will cause the callback to infinitely loop without any delay.
        // https://stackoverflow.com/a/12633556/1104483
        const refreshIntervalMs = Math.min(automaticRefreshMs, Math.pow(2, 31) - 1);
        const interval = setInterval(onRefresh, refreshIntervalMs);
        return ()=>{
            clearInterval(interval);
        };
    }, [
        automaticRefreshMs,
        onRefresh
    ]);
    const onMount = (0, $5uXOq.useCallback)((gadgetId, focusCallback)=>{
        setMostRecentlyAddedGadgetId((mostRecentlyAddedGadgetId)=>{
            if (gadgetId === mostRecentlyAddedGadgetId) {
                focusCallback();
                return null;
            }
            return mostRecentlyAddedGadgetId;
        });
    }, []);
    return {
        onRefresh: onRefresh,
        refreshId: refreshId,
        onAddedGadget: setMostRecentlyAddedGadgetId,
        onMount: onMount
    };
};
const $5e7fb5d7d6929ddb$export$b9771780c6ecf3f = ({ children: children, ...props })=>{
    const value = $5e7fb5d7d6929ddb$export$d7eb50fb85f631d(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iyrll.DashboardControllerContextProvider), {
        value: value
    }, children);
};

});
parcelRegister("kwTKp", function(module, exports) {

$parcel$export(module.exports, "on", () => $95a2c74ee009333c$export$af631764ddc44097);
$parcel$export(module.exports, "emit", () => $95a2c74ee009333c$export$8f35fbd5db0f3634);
// This prefix is also used in ConfigPanelFieldsLoader.tsx in the
// @atlaskit/editor-plugin-extension package. The Editor package is public, so it
// cannot import this constant from @atlassian/forge-ui. Do not update this prefix
// without also doing so in the Editor package.
const $95a2c74ee009333c$var$EVENT_PREFIX = 'forge.bridge.';
function $95a2c74ee009333c$export$af631764ddc44097(event, callback, extension) {
    const wrappedCallback = (e)=>{
        if (!extension || !e.detail?.extension || extension.id === e.detail?.extension?.id && extension.installationId === e.detail?.extension?.installationId) callback(e.detail?.payload, e.detail?.extension);
    };
    window.document.addEventListener(`${$95a2c74ee009333c$var$EVENT_PREFIX}${event}`, wrappedCallback);
    return {
        unsubscribe: ()=>window.document.removeEventListener(`${$95a2c74ee009333c$var$EVENT_PREFIX}${event}`, wrappedCallback)
    };
}
function $95a2c74ee009333c$export$8f35fbd5db0f3634(event, payload, extension) {
    const newEvent = new CustomEvent(`${$95a2c74ee009333c$var$EVENT_PREFIX}${event}`, {
        detail: {
            extension: extension,
            payload: payload
        }
    });
    window.document.dispatchEvent(newEvent);
}

});

parcelRegister("flEgL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d28f43dbb1e0cb29$export$2e2bcd8739ae039);

var $hrlU6 = parcelRequire("hrlU6");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d28f43dbb1e0cb29$export$2e2bcd8739ae039 = (eventName, addonFilter, eventData)=>{
    (0, $hrlU6.withConnectHost)((host)=>{
        host && host.broadcastEvent(eventName, addonFilter, eventData);
    });
};

});


parcelRegister("1rce7", function(module, exports) {

$parcel$export(module.exports, "DashboardPageContainer", () => $e6660bef9b59d455$export$8aeaeff803e753cd);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2i4sA = parcelRequire("2i4sA");

var $id7K0 = parcelRequire("id7K0");

var $iXVV6 = parcelRequire("iXVV6");

var $9dbF6 = parcelRequire("9dbF6");

var $bVDE5 = parcelRequire("bVDE5");

var $9OXo1 = parcelRequire("9OXo1");

var $cRaE8 = parcelRequire("cRaE8");

var $he6UQ = parcelRequire("he6UQ");
const $e6660bef9b59d455$export$8aeaeff803e753cd = ({ children: children, analyticsSourceName: analyticsSourceName, analyticsExperience: analyticsExperience, unauthenticatedFallback: unauthenticatedFallback, unauthorisedFallback: unauthorisedFallback, documentTitle: documentTitle, resourceData: resourceData })=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { data: data, loading: loading } = resourceData;
    const [{ isInitialRender: isInitialRender }] = (0, $bVDE5.useSpaStateTransition)();
    const ref = (0, $he6UQ.useDashboardRef)();
    if (!tenantContext) return null;
    if (!tenantContext.atlassianAccountId && !loading && !data) return unauthenticatedFallback;
    if (unauthorisedFallback != null && data && !data.writable) return unauthorisedFallback;
    /**
   * we need to also mark this with the 'dashboardScreen' analytics source.
   * Otherwise, the source will default to 'navigationNextScreen'.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: analyticsSourceName,
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        containerId: data?.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: documentTitle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "platform"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e6660bef9b59d455$var$PageLayout, {
        ref: ref
    }, !isInitialRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cRaE8.PrefetchLinks), {
        dashboardId: data?.id ?? 'pending'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        id: "dashboard",
        // Need className for some of some gadgets, e.g. Filter Count
        // Please always make sure the wrapper dom id and class are in the html response
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "dashboard",
        "data-testid": "dashboard-internal-common.ui.container.div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2i4sA.ViewExperienceTrackingProvider), {
        experienceId: data?.id,
        experience: analyticsExperience,
        analyticsSource: "dashboard",
        edition: null,
        application: null
    }, children))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $e6660bef9b59d455$var$PageLayout = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1jfw _otyridpf _18u01jfw _kqswh2mm _1pbyb4wl",
            __cmplp.className
        ])
    });
});

});
parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});

// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $3iTiR = parcelRequire("3iTiR");

var $ero6m = parcelRequire("ero6m");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $ero6m.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("ero6m", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $0997694844c8a9e7$export$b1fe420ed15dff7b);

var $16v4H = parcelRequire("16v4H");
const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $16v4H.subProductFromProjectType)(projectType);
};

});

parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $2YZCu = parcelRequire("2YZCu");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $7T84i.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $2YZCu.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});


parcelRegister("cRaE8", function(module, exports) {

$parcel$export(module.exports, "PrefetchLinks", () => $956d4da8aa4ae614$export$b64797ad00b7bd3c);

var $5uXOq = parcelRequire("5uXOq");

var $JIPqS = parcelRequire("JIPqS");

var $83oax = parcelRequire("83oax");

var $gh1hi = parcelRequire("gh1hi");

var $bVDE5 = parcelRequire("bVDE5");
const $956d4da8aa4ae614$export$b64797ad00b7bd3c = ({ dashboardId: dashboardId })=>{
    const [{ isInitialRender: isInitialRender }] = (0, $bVDE5.useSpaStateTransition)();
    const { data: data } = (0, $gh1hi.useDashboardResource)();
    const prefetches = (0, $5uXOq.useMemo)(()=>data ? (0, $83oax.getPrefetches)(data) : [], [
        data
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (!isInitialRender && window && window[0, $JIPqS.PRELOADED_GADGET_DATA_KEY]) // cleanup preloaded data on window, which is only used on initial load
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        delete window[0, $JIPqS.PRELOADED_GADGET_DATA_KEY];
    }, [
        isInitialRender
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, prefetches.map((prefetch)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("link", {
            key: `${dashboardId}-${prefetch.url}`,
            rel: isInitialRender ? prefetch.priority : 'prefetch',
            as: "fetch",
            href: prefetch.url
        })));
};

});

parcelRegister("he6UQ", function(module, exports) {

$parcel$export(module.exports, "useDashboardRef", () => $7859c7156387c1ba$export$a52b4118d451e93c);

var $5uXOq = parcelRequire("5uXOq");
const $7859c7156387c1ba$export$a52b4118d451e93c = ()=>{
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const originalGetDashboard = window.AG?.DashboardManager?.getDashboard;
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.AG = {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                ...window.AG,
                DashboardManager: {
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    ...window.AG?.DashboardManager,
                    getDashboard: originalGetDashboard
                }
            };
        };
    }, []);
    return (0, $5uXOq.useCallback)((node)=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.AG = {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            ...window.AG,
            DashboardManager: {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                ...window.AG?.DashboardManager,
                getDashboard: ()=>node
            }
        };
    }, []);
};

});


parcelRegister("1CEw6", function(module, exports) {

$parcel$export(module.exports, "EngagementBanners", () => $ea6f1e008ef29904$export$eaa8218767cf0103);

var $5uXOq = parcelRequire("5uXOq");

var $JIPqS = parcelRequire("JIPqS");

var $7YQcX = parcelRequire("7YQcX");

var $fqDbq = parcelRequire("fqDbq");

var $ho8bY = parcelRequire("ho8bY");

var $4R6GH = parcelRequire("4R6GH");
const $ea6f1e008ef29904$export$a38d2dae548e4826 = {
    endeavour_gadget_deprecation_banner_v1: {
        bannerDismissedId: (0, $JIPqS.DEPRECATION_BANNER_V1_DISMISS),
        component: (0, $7YQcX.DeprecationBannerV1),
        gadgetTypeMap: (0, $JIPqS.DEPRECATED_GADGETS_MAP)
    }
};
const $ea6f1e008ef29904$export$eaa8218767cf0103 = ({ gadgets: gadgets, dashboardId: dashboardId })=>{
    const gadgetDeprecationBannerV1State = (0, $fqDbq.useDashboardBannerState)($ea6f1e008ef29904$export$a38d2dae548e4826.endeavour_gadget_deprecation_banner_v1.bannerDismissedId, dashboardId, true);
    const bannerConfigs = [
        {
            id: 'endeavour_gadget_deprecation_banner_v1',
            condition: (0, $ho8bY.useDashboardHasGadgetType)(gadgets, $ea6f1e008ef29904$export$a38d2dae548e4826.endeavour_gadget_deprecation_banner_v1.gadgetTypeMap) && (0, $4R6GH.fg)('endeavour_gadget_deprecation_banner_v1'),
            isDismissed: gadgetDeprecationBannerV1State.isDashboardBannerDismissed,
            onDismiss: gadgetDeprecationBannerV1State.onDashboardBannerDismiss
        }
    ];
    const activeBannerConfig = bannerConfigs.find((config)=>config.condition && !config.isDismissed);
    if (!activeBannerConfig) return null; // No banner to show
    const BannerComponent = $ea6f1e008ef29904$export$a38d2dae548e4826[activeBannerConfig.id].component;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BannerComponent, {
        onDismiss: activeBannerConfig.onDismiss
    });
};

});
parcelRegister("7YQcX", function(module, exports) {

$parcel$export(module.exports, "DeprecationBannerV1", () => $fb1cba861a89581f$export$b10eedc6ae25381c);

var $5uXOq = parcelRequire("5uXOq");

var $8zIDr = parcelRequire("8zIDr");

var $9FSw2 = parcelRequire("9FSw2");
var $82qqY = parcelRequire("82qqY");

var $koVbs = parcelRequire("koVbs");

var $JIPqS = parcelRequire("JIPqS");

var $2O7o7 = parcelRequire("2O7o7");
const $fb1cba861a89581f$export$b10eedc6ae25381c = ({ onDismiss: onDismiss })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9FSw2.default), {
        appearance: "warning",
        actions: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $82qqY.default), {
                key: (0, $JIPqS.DEPRECATION_BANNER_V1_DISMISS),
                onClick: onDismiss
            }, formatMessage((0, $2O7o7.default).gadgetDeprecationMessageDismissV1))
        ],
        title: formatMessage((0, $2O7o7.default).gadgetDeprecationTitleV1)
    }, formatMessage((0, $2O7o7.default).gadgetDeprecationMessageV1, {
        Link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8zIDr.default), {
                href: "https://community.atlassian.com/t5/Jira-articles/Update-We-re-ending-support-for-five-dashboard-gadgets-in-May/ba-p/2844556"
            }, chunks),
        br: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null))
    }));
};

});
parcelRegister("2O7o7", function(module, exports) {

$parcel$export(module.exports, "default", () => $681e6c098aed09e5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $681e6c098aed09e5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    gadgetDeprecationTitleV1: {
        "id": "dashboard-internal-common.common.gadget.deprecation-banner-v1.gadget-deprecation-title.non-final",
        "defaultMessage": "Extended timeline: We're no longer supporting five of your gadgets starting May 2025"
    },
    gadgetDeprecationMessageV1: {
        "id": "dashboard-internal-common.common.gadget.deprecation-banner-v1.gadget-deprecation-message.non-final",
        "defaultMessage": "Starting May 2025, we're removing the functionality of the Jira Road Map, Bubble Chart, Heat Map, Projects, and Labels gadgets. If you don't delete them before then, they'll no longer work, and you won't be able to reference them for the available alternatives. <Link>More about the gadgets and the extended timeline</Link>"
    },
    gadgetDeprecationMessageDismissV1: {
        "id": "dashboard-internal-common.common.gadget.deprecation-banner-v1.gadget-deprecation-message-dismiss.non-final",
        "defaultMessage": "Dismiss"
    }
});

});


parcelRegister("fqDbq", function(module, exports) {

$parcel$export(module.exports, "useDashboardBannerState", () => $4f48e547e1849b1c$export$fcf5ad86b72b3dfe);

var $5uXOq = parcelRequire("5uXOq");

var $bSSG7 = parcelRequire("bSSG7");
const $4f48e547e1849b1c$export$fcf5ad86b72b3dfe = (dashboardBannerStorageKey, dashboardId, bannerPerDashboard)=>{
    const [isDashboardBannerDismissed, setIsDashboardBannerDismissed] = (0, $5uXOq.useState)(false);
    // Would change to 'jira-dashboard-banner-state' but then local storage
    // for previous deprecation dismissal would be ignored. Should be temporary anyways
    const store = (0, $bSSG7.createLocalStorageProvider)('jira-dashboard-deprecation-banner-state');
    (0, $5uXOq.useEffect)(()=>{
        const localDashbaordBannersState = store.get(dashboardBannerStorageKey);
        if (localDashbaordBannersState) {
            if (bannerPerDashboard) {
                const bannerIsDismissed = localDashbaordBannersState.includes(dashboardId);
                setIsDashboardBannerDismissed(bannerIsDismissed);
            } else setIsDashboardBannerDismissed(true);
        }
    }, [
        dashboardId,
        dashboardBannerStorageKey,
        store,
        bannerPerDashboard
    ]);
    const onDashboardBannerDismiss = ()=>{
        setIsDashboardBannerDismissed(true);
        const localDashbaordBannersState = store.get(dashboardBannerStorageKey);
        if (bannerPerDashboard) {
            if (localDashbaordBannersState) {
                localDashbaordBannersState.push(dashboardId);
                store.set(dashboardBannerStorageKey, localDashbaordBannersState);
            } else store.set(dashboardBannerStorageKey, [
                dashboardId
            ]);
        } else if (!localDashbaordBannersState) store.set(dashboardBannerStorageKey, true);
    };
    return {
        isDashboardBannerDismissed: isDashboardBannerDismissed,
        onDashboardBannerDismiss: onDashboardBannerDismiss
    };
};

});

parcelRegister("ho8bY", function(module, exports) {

$parcel$export(module.exports, "useDashboardHasGadgetType", () => $a5d04ee035eacf17$export$e22f1de23679f695);

var $5uXOq = parcelRequire("5uXOq");

var $b3IiT = parcelRequire("b3IiT");
const $a5d04ee035eacf17$export$e22f1de23679f695 = (gadgets, webResourceMap)=>{
    const [dashboardHasGadgetType, setDashboardHasGadgetType] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        setDashboardHasGadgetType($a5d04ee035eacf17$var$checkDashboardHasGadgetType(webResourceMap, gadgets));
    }, [
        gadgets,
        webResourceMap
    ]);
    return dashboardHasGadgetType;
};
const $a5d04ee035eacf17$var$checkDashboardHasGadgetType = (webResourceMap, gadgets)=>{
    return gadgets.some((gadget)=>(0, $b3IiT.checkGadgetType)(webResourceMap, gadget.amdModule));
};

});
parcelRegister("b3IiT", function(module, exports) {

$parcel$export(module.exports, "checkGadgetType", () => $31e3249d62ee71f8$export$6834c500b0f301a7);
const $31e3249d62ee71f8$export$6834c500b0f301a7 = (webResourceMap, gadgetResource)=>{
    return gadgetResource !== undefined && (gadgetResource in webResourceMap || Object.values(webResourceMap).includes(gadgetResource));
};

});



parcelRegister("5HxxK", function(module, exports) {

$parcel$export(module.exports, "ColumnPlaceholderContextConsumer", () => $42fb06f36f97089d$export$efa1c423df3eb8d9);
$parcel$export(module.exports, "ColumnLayout", () => $42fb06f36f97089d$export$c7e5bac7049eee2a);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cigQb = parcelRequire("cigQb");
var $4KBRy = parcelRequire("4KBRy");

var $bbkUF = parcelRequire("bbkUF");

var $6hp8I = parcelRequire("6hp8I");

var $1oaeD = parcelRequire("1oaeD");

var $jnkfq = parcelRequire("jnkfq");

var $6fab6 = parcelRequire("6fab6");

var $bfdYn = parcelRequire("bfdYn");

var $h6EHU = parcelRequire("h6EHU");
const { createRenderFunction: $42fb06f36f97089d$var$createPlaceholderRender, Provider: $42fb06f36f97089d$export$e3a62d26c35df0c2, Consumer: $42fb06f36f97089d$export$efa1c423df3eb8d9 } = (0, $jnkfq.createRendererContext)();
const { createRenderFunction: $42fb06f36f97089d$var$createGadgetRender, Provider: $42fb06f36f97089d$export$de8f6456a7a635a7, Consumer: $42fb06f36f97089d$export$599894a5533c31ef } = (0, $jnkfq.createRendererContext)();
const $42fb06f36f97089d$export$c7e5bac7049eee2a = ({ data: data, dnd: dnd, columnPlaceholder: columnPlaceholder, layoutPlaceholder: // placeholder for a column when it is empty (no gadgets in the column)
layoutPlaceholder, onLayoutReposition: // placeholder for the whole layout when dashboard is empty (no gadgets in all columns)
onLayoutReposition, children: children })=>{
    const { layout: layout, writable: writable, gadgets: gadgets } = data;
    const { DragDropContext: DragDropContext = (0, $bfdYn.DegenerateDragDropContext), Draggable: Draggable = (0, $bfdYn.DegenerateDraggable), Droppable: Droppable = (0, $bfdYn.DegenerateDroppable) } = dnd ?? {};
    const { getPropsByGadgetId: getPropsByGadgetId, getPropsByColumnIndex: getPropsByColumnIndex } = (0, $1oaeD.useMaximizedGadget)(gadgets);
    const [isAnyDragging, setIsAnyDragging] = (0, $5uXOq.useState)(false);
    const columns = (0, $5uXOq.useMemo)(()=>(0, $6fab6.toColumns)(gadgets, layout), [
        gadgets,
        layout
    ]);
    const width = (0, $bbkUF.useDebouncedWindowWidth)();
    const onDragEnd = (0, $5uXOq.useCallback)((result)=>{
        if (!writable || !onLayoutReposition) return;
        const { destination: destination, source: source } = result;
        if (destination && destination.droppableId != null) {
            const moved = columns[+source.droppableId].splice(source.index, 1)[0];
            columns[+destination.droppableId].splice(destination.index, 0, moved);
            moved.column = +destination.droppableId;
        }
        onLayoutReposition(layout, columns);
        setIsAnyDragging(false);
    }, [
        columns,
        layout,
        writable,
        onLayoutReposition
    ]);
    const onDragStart = (0, $5uXOq.useCallback)(()=>{
        setIsAnyDragging(true);
    }, []);
    const renderColumnPlaceholder = $42fb06f36f97089d$var$createPlaceholderRender(columnPlaceholder);
    const renderGadget = $42fb06f36f97089d$var$createGadgetRender(children);
    if (!gadgets.length && layoutPlaceholder != null) return layoutPlaceholder;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DragDropContext, {
        onDragEnd: onDragEnd,
        onDragStart: onDragStart
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($42fb06f36f97089d$var$ContainerWrapper, {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.layout.container-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6hp8I.DimensionsProvider), {
        value: `${layout}-${width}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cigQb.default), {
        layout: "fluid"
    }, columns.map((items, columnIndex)=>{
        const columnWidth = (0, $h6EHU.getColumnWidth)(columnIndex, layout, getPropsByColumnIndex(columnIndex).display);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4KBRy.default), {
            key: columnIndex,
            medium: columnWidth,
            testId: "dashboard-internal-common.ui.dashboard-content.layout.column"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Droppable, {
            droppableId: columnIndex.toString()
        }, ({ innerRef: columnRef, droppableProps: droppableProps, placeholder: dndPlaceholder }, { isDraggingOver: isDraggingOver })=>{
            const isNonEmptyCol = items.length > 0;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($42fb06f36f97089d$var$ContentWrapper, {
                ...droppableProps,
                ref: columnRef,
                isDimmed: isNonEmptyCol && isDraggingOver,
                isHidden: columnWidth === 0
            }, isNonEmptyCol ? items.map((gadgetData, rowIndex)=>{
                const { isDraggable: isMaybeDraggable, ...gadgetProps } = getPropsByGadgetId(gadgetData.id);
                const isDraggable = dnd != null && isMaybeDraggable;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Draggable, {
                    key: gadgetData.id,
                    draggableId: gadgetData.id,
                    index: rowIndex,
                    isDragDisabled: !isDraggable
                }, ({ innerRef: rowRef, dragHandleProps: dragHandleProps, draggableProps: draggableProps }, { isDragging: isDragging })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                        ...draggableProps,
                        ref: rowRef
                    }, renderGadget({
                        data: gadgetData,
                        dragHandleProps: dragHandleProps,
                        isDraggable: isDraggable,
                        isDragging: isDragging,
                        isAnyDragging: isAnyDragging,
                        ...gadgetProps
                    })));
            }) : renderColumnPlaceholder({
                columnIndex: columnIndex,
                isDraggingOver: isDraggingOver
            }), dndPlaceholder);
        }));
    })))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $42fb06f36f97089d$var$ContainerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "main", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _otyridpf _18u0mgjw _2hwxmgjw",
            __cmplp.className
        ])
    });
});
const $42fb06f36f97089d$var$ContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDimmed: isDimmed, isHidden: isHidden, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoftgi _v564mfn2 _1bsb1osq",
            __cmplp.isDimmed ? "_11q7qbzx" : "_11q7vuon",
            __cmplp.isHidden && "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cigQb", function(module, exports) {

$parcel$export(module.exports, "default", () => $be71958c43737a5a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ggIgZ = parcelRequire("ggIgZ");

var $gUAUI = parcelRequire("gUAUI");

var $4KBRy = parcelRequire("4KBRy");

var $4VG9W = parcelRequire("4VG9W");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $be71958c43737a5a$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $5uXOq.useContext)((0, $4VG9W.GridContext));
    const { medium: medium } = (0, $5uXOq.useContext)((0, $4KBRy.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $ggIgZ.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $ggIgZ.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4VG9W.GridContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gUAUI.Grid), {
            layout: layout,
            testId: testId,
            children: children
        })
    });
};
var $be71958c43737a5a$export$2e2bcd8739ae039 = $be71958c43737a5a$var$GridWrapper;

});
parcelRegister("ggIgZ", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", () => $fdd4dd9b7cc1a587$export$74797698e12f8baa);
$parcel$export(module.exports, "defaultGridColumnWidth", () => $fdd4dd9b7cc1a587$export$b8241a1616ab1b96);
$parcel$export(module.exports, "spacingMapping", () => $fdd4dd9b7cc1a587$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $fdd4dd9b7cc1a587$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $fdd4dd9b7cc1a587$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $fdd4dd9b7cc1a587$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $fdd4dd9b7cc1a587$export$2303d2bd9eeff99a);
$parcel$export(module.exports, "varColumnsNum", () => $fdd4dd9b7cc1a587$export$9ddc3632bbfb8966);
$parcel$export(module.exports, "varColumnSpan", () => $fdd4dd9b7cc1a587$export$8b7e31f391e6e681);
$parcel$export(module.exports, "varGridSpacing", () => $fdd4dd9b7cc1a587$export$936829b4511db3e4);
const $fdd4dd9b7cc1a587$var$defaultGridSize = 8;
const $fdd4dd9b7cc1a587$export$74797698e12f8baa = 12;
const $fdd4dd9b7cc1a587$export$b8241a1616ab1b96 = $fdd4dd9b7cc1a587$var$defaultGridSize * 10;
const $fdd4dd9b7cc1a587$export$2a89a65a43bab52d = {
    comfortable: $fdd4dd9b7cc1a587$var$defaultGridSize * 5,
    cosy: $fdd4dd9b7cc1a587$var$defaultGridSize * 2,
    compact: $fdd4dd9b7cc1a587$var$defaultGridSize * 0.5
};
const $fdd4dd9b7cc1a587$export$8ec7372efd74b753 = 'cosy';
const $fdd4dd9b7cc1a587$export$d77f83c3d17a7b8a = 52;
const $fdd4dd9b7cc1a587$export$f8725d21f81f3e01 = 0;
const $fdd4dd9b7cc1a587$export$2303d2bd9eeff99a = 'fixed';
const $fdd4dd9b7cc1a587$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $fdd4dd9b7cc1a587$export$8b7e31f391e6e681 = '--ds-column-span';
const $fdd4dd9b7cc1a587$export$936829b4511db3e4 = '--ds-grid-spacing';

});

parcelRegister("gUAUI", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $dfafdfc07e588f65$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ggIgZ = parcelRequire("ggIgZ");

var $4VG9W = parcelRequire("4VG9W");
function $dfafdfc07e588f65$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dfafdfc07e588f65$var$gridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 calc(var(${(0, $ggIgZ.varGridSpacing)}) / 2)`,
    position: 'relative',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
});
const $dfafdfc07e588f65$var$gridLayoutStyles = {
    fixed: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(var(${(0, $ggIgZ.varColumnsNum)}) * ${(0, $ggIgZ.defaultGridColumnWidth)}px)`
    }),
    fluid: {
        name: "qhxz92",
        styles: "max-width:100%"
    }
};
const $dfafdfc07e588f65$var$nestedGridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(-1 * var(${(0, $ggIgZ.varGridSpacing)}))`
});
const $dfafdfc07e588f65$export$ef2184bd89960b14 = ({ layout: layout = (0, $ggIgZ.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $5uXOq.useContext)((0, $4VG9W.GridContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $dfafdfc07e588f65$var$gridStyles,
            $dfafdfc07e588f65$var$gridLayoutStyles[layout],
            isNested && $dfafdfc07e588f65$var$nestedGridStyles
        ],
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $ggIgZ.varColumnsNum)]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $ggIgZ.varGridSpacing)]: `${(0, $ggIgZ.spacingMapping)[spacing]}px`
        },
        "data-testid": testId
    }, children);
};

});
parcelRegister("4VG9W", function(module, exports) {

$parcel$export(module.exports, "GridContext", () => $6da7ed7449613c9c$export$11cae3e04ab99fae);

var $5uXOq = parcelRequire("5uXOq");

var $ggIgZ = parcelRequire("ggIgZ");
const $6da7ed7449613c9c$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $ggIgZ.defaultSpacing),
    columns: (0, $ggIgZ.defaultGridColumns)
});

});


parcelRegister("4KBRy", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", () => $da4ea2268815c5f0$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $da4ea2268815c5f0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ggIgZ = parcelRequire("ggIgZ");

var $4VG9W = parcelRequire("4VG9W");
/**
 * Determines the method by which column width is calculated.
 */ var $da4ea2268815c5f0$var$ColumnVariant = /*#__PURE__*/ function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
    return ColumnVariant;
}($da4ea2268815c5f0$var$ColumnVariant || {});
const $da4ea2268815c5f0$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $ggIgZ.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $da4ea2268815c5f0$var$availableWidth = '99.9999%';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $da4ea2268815c5f0$var$singleColumnWidth = `(${$da4ea2268815c5f0$var$availableWidth} / var(${(0, $ggIgZ.varColumnsNum)}))`;
const $da4ea2268815c5f0$var$gridColumnStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `calc(${$da4ea2268815c5f0$var$singleColumnWidth} - var(${(0, $ggIgZ.varGridSpacing)}))`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(var(${(0, $ggIgZ.varGridSpacing)}) / 2)`,
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: 'break-word'
});
const $da4ea2268815c5f0$var$gridColumnWidthStyles = {
    ["auto"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $ggIgZ.varGridSpacing)}))`,
        flexBasis: `auto`
    }),
    ["bounded"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(${$da4ea2268815c5f0$var$singleColumnWidth} *  var(${(0, $ggIgZ.varColumnSpan)}) - var(${(0, $ggIgZ.varGridSpacing)}))`,
        flexBasis: `100%`
    }),
    ["fullWidth"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $ggIgZ.varGridSpacing)}))`,
        flexBasis: `100%`
    })
};
const $da4ea2268815c5f0$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    medium: (0, $ggIgZ.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $da4ea2268815c5f0$var$GridColumn = ({ medium: medium = (0, $ggIgZ.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $5uXOq.useContext)((0, $4VG9W.GridContext));
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $da4ea2268815c5f0$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($da4ea2268815c5f0$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $da4ea2268815c5f0$var$gridColumnStyles,
            $da4ea2268815c5f0$var$gridColumnWidthStyles[variant]
        ],
        style: {
            /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $ggIgZ.varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
        },
        "data-testid": testId
    }, children));
};
var $da4ea2268815c5f0$export$2e2bcd8739ae039 = $da4ea2268815c5f0$var$GridColumn;

});


parcelRegister("bbkUF", function(module, exports) {

$parcel$export(module.exports, "useDebouncedWindowWidth", () => $c482c1c1fc6dfb26$export$4b69c5ad33ff59ee);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");
const $c482c1c1fc6dfb26$export$4b69c5ad33ff59ee = (ms = 100)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const [width, setWidth] = (0, $5uXOq.useState)(window.innerWidth);
    const debounced = (0, $5uXOq.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((w)=>setWidth(w), ms));
    (0, $5uXOq.useEffect)(()=>{
        const handleResize = ()=>{
            const { innerWidth: innerWidth } = window;
            if (innerWidth !== width) debounced.current(innerWidth);
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('resize', handleResize);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('resize', handleResize);
        };
    }, [
        width
    ]);
    return width;
};

});

parcelRegister("6hp8I", function(module, exports) {

$parcel$export(module.exports, "DimensionsProvider", () => $096975c907c9ee30$export$a31e22a91fd34dd9);
$parcel$export(module.exports, "useDimensions", () => $096975c907c9ee30$export$d04af0e501fb729f);

var $5uXOq = parcelRequire("5uXOq");
const $096975c907c9ee30$var$DimensionsContext = /*#__PURE__*/ (0, $5uXOq.createContext)('');
const $096975c907c9ee30$export$a31e22a91fd34dd9 = $096975c907c9ee30$var$DimensionsContext.Provider;
const $096975c907c9ee30$export$d04af0e501fb729f = ()=>(0, $5uXOq.useContext)($096975c907c9ee30$var$DimensionsContext);

});

parcelRegister("1oaeD", function(module, exports) {

$parcel$export(module.exports, "useMaximizedGadget", () => $3f7e0a0376bf6236$export$23a0742f39986cba);

var $5uXOq = parcelRequire("5uXOq");

var $JIPqS = parcelRequire("JIPqS");

var $4oDnX = parcelRequire("4oDnX");

var $ieDtd = parcelRequire("ieDtd");
var $doZTA = parcelRequire("doZTA");
const $3f7e0a0376bf6236$export$23a0742f39986cba = (gadgetsData)=>{
    const [{ location: { hash: hash } }] = (0, $doZTA.useRouter)();
    const [maximizedQueryParam, setMaximizedQueryParam] = (0, $ieDtd.useQueryParam)((0, $JIPqS.MAXIMIZED_PARAM));
    const [, { setAppReady: setAppReady }] = (0, $4oDnX.useSpaStateActions)();
    // The regex matches any character (except a newline character)
    // zero or more times .* followed by a '/'. The (?<id>\d+) part is a
    // named capturing group which matches one or more digits and assigns
    // the group to an id value accessible through .groups.id
    // We are using a backup hash decodedId for legacy URLs in case users have
    // bookmarked a legacy URL. Legacy URLs used '#' instead of '?maximized='
    // (e.g. https://.../jira/dashboards/{dashboardId}#{some-text}/{gadgetId})
    const decodedId = hash.match(/.*\/(?<id>\d+)/)?.groups?.id ?? null;
    const idFromHashOrQuery = maximizedQueryParam != null ? maximizedQueryParam : decodedId;
    const gadget = idFromHashOrQuery != null && gadgetsData?.find(({ id: id })=>id === idFromHashOrQuery) || null;
    const maximizedId = gadget?.isMaximizable ? idFromHashOrQuery : null;
    const getMaximisedGadgetId = (0, $5uXOq.useMemo)(()=>maximizedId, [
        maximizedId
    ]);
    const getPropsByColumnIndex = (0, $5uXOq.useCallback)((column)=>{
        const maximizedGadget = maximizedId !== null ? gadgetsData?.find(({ id: id })=>id === maximizedId) : null;
        const { column: maximizedColumn = null } = maximizedGadget ?? {};
        const display = maximizedColumn === null && (0, $JIPqS.GADGET_DISPLAY).NORMAL || maximizedColumn === column && (0, $JIPqS.GADGET_DISPLAY).MAXIMIZED || (0, $JIPqS.GADGET_DISPLAY).HIDDEN;
        return {
            display: display
        };
    }, [
        maximizedId,
        gadgetsData
    ]);
    // create curried callbacks once in the memoized scope
    const maximizedLookup = (0, $5uXOq.useMemo)(()=>Object.fromEntries(gadgetsData?.filter(({ isMaximizable: isMaximizable })=>isMaximizable).map((data)=>[
                data.id,
                (doMaximizeNotRestore)=>{
                    if (maximizedId === (doMaximizeNotRestore ? data.id : null)) return;
                    setMaximizedQueryParam(doMaximizeNotRestore ? data.id : undefined);
                    setTimeout(setAppReady);
                }
            ]) ?? []), [
        gadgetsData,
        maximizedId,
        setAppReady,
        setMaximizedQueryParam
    ]);
    const getPropsByGadgetId = (0, $5uXOq.useCallback)((id)=>{
        // Get display by gadget ID
        const display = maximizedId === null && (0, $JIPqS.GADGET_DISPLAY).NORMAL || maximizedId === id && (0, $JIPqS.GADGET_DISPLAY).MAXIMIZED || (0, $JIPqS.GADGET_DISPLAY).HIDDEN;
        // Get isDraggable by gadget ID
        const isDraggable = id !== maximizedId;
        // Get onMaximizeOrRestore by gadget ID
        const onMaximizeOrRestore = maximizedLookup[id] ?? (()=>undefined);
        return {
            display: display,
            isDraggable: isDraggable,
            onMaximizeOrRestore: onMaximizeOrRestore
        };
    }, [
        maximizedId,
        maximizedLookup
    ]);
    return {
        getMaximisedGadgetId: getMaximisedGadgetId,
        getPropsByGadgetId: getPropsByGadgetId,
        getPropsByColumnIndex: getPropsByColumnIndex
    };
};

});

parcelRegister("6fab6", function(module, exports) {

$parcel$export(module.exports, "toColumns", () => $78db23f50316c14c$export$755ca66aa40344da);
const $78db23f50316c14c$export$755ca66aa40344da = (gadgets, layout)=>{
    const getGadgetsForCol = (col)=>gadgets.filter((gadget)=>gadget.column === col);
    switch(layout){
        case 'A':
            return [
                getGadgetsForCol(0)
            ];
        case 'AA':
        case 'AB':
        case 'BA':
            return [
                getGadgetsForCol(0),
                getGadgetsForCol(1)
            ];
        case 'AAA':
            return [
                getGadgetsForCol(0),
                getGadgetsForCol(1),
                getGadgetsForCol(2)
            ];
        default:
            throw new Error('Unexpected layout was provided');
    }
};

});

parcelRegister("bfdYn", function(module, exports) {

$parcel$export(module.exports, "DegenerateDragDropContext", () => $b11313e6244f86bc$export$cc74aca994b0ed41);
$parcel$export(module.exports, "DegenerateDraggable", () => $b11313e6244f86bc$export$c114e58211833c77);
$parcel$export(module.exports, "DegenerateDroppable", () => $b11313e6244f86bc$export$50925b5bb72c3049);
// eslint-disable-next-line @atlaskit/design-system/no-unsupported-drag-and-drop-libraries
const $b11313e6244f86bc$var$providedDraggable = {
    innerRef: ()=>undefined,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    draggableProps: {},
    dragHandleProps: undefined
};
const $b11313e6244f86bc$var$snapshotDraggable = {
    isDragging: false,
    isDropAnimating: false,
    dropAnimation: undefined,
    draggingOver: undefined,
    combineWith: undefined,
    combineTargetFor: undefined,
    mode: undefined,
    isClone: false
};
const $b11313e6244f86bc$var$providedDroppable = {
    innerRef: ()=>undefined,
    placeholder: undefined,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    droppableProps: {}
};
const $b11313e6244f86bc$var$snapshotDroppable = {
    isDraggingOver: false,
    draggingOverWith: undefined,
    draggingFromThisWith: undefined,
    isUsingPlaceholder: false
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $b11313e6244f86bc$var$rubricDraggable = {};
const $b11313e6244f86bc$export$cc74aca994b0ed41 = ({ children: children })=>children;
const $b11313e6244f86bc$export$c114e58211833c77 = ({ children: children })=>children($b11313e6244f86bc$var$providedDraggable, $b11313e6244f86bc$var$snapshotDraggable, $b11313e6244f86bc$var$rubricDraggable);
const $b11313e6244f86bc$export$50925b5bb72c3049 = ({ children: children })=>children($b11313e6244f86bc$var$providedDroppable, $b11313e6244f86bc$var$snapshotDroppable);

});

parcelRegister("h6EHU", function(module, exports) {

$parcel$export(module.exports, "getColumnWidth", () => $3e20f2a7b6f0ea06$export$dfa11a34ceba822);

var $JIPqS = parcelRequire("JIPqS");
const $3e20f2a7b6f0ea06$export$dfa11a34ceba822 = (index, layout, display)=>{
    if (display === (0, $JIPqS.GADGET_DISPLAY).HIDDEN) return 0;
    if (layout === 'A' || display === (0, $JIPqS.GADGET_DISPLAY).MAXIMIZED) return 12;
    if (layout === 'AA') return 6;
    if (layout === 'AAA') return 4;
    if (layout === 'AB') return index === 0 ? 8 : 4;
    return index === 0 ? 4 : 8;
};

});


parcelRegister("4kIa4", function(module, exports) {

$parcel$export(module.exports, "DashboardContentContainer", () => $e519b350b77b4296$export$b49692a976fb3d05);

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $g0Gtc = parcelRequire("g0Gtc");

var $2YZCu = parcelRequire("2YZCu");

var $beRD7 = parcelRequire("beRD7");


var $gh1hi = parcelRequire("gh1hi");

var $fZneA = parcelRequire("fZneA");

var $1yBXu = parcelRequire("1yBXu");

var $i7Ldp = parcelRequire("i7Ldp");

var $bOnpg = parcelRequire("bOnpg");

var $8h45R = parcelRequire("8h45R");

var $6IxJi = parcelRequire("6IxJi");

var $h5Jym = parcelRequire("h5Jym");

var $5jJ3W = parcelRequire("5jJ3W");

var $8CCTB = parcelRequire("8CCTB");

var $1Bx5m = parcelRequire("1Bx5m");

var $7v0Ei = parcelRequire("7v0Ei");

var $fxC6K = parcelRequire("fxC6K");

var $kUwqK = parcelRequire("kUwqK");

var $hwuTz = parcelRequire("hwuTz");
const $e519b350b77b4296$var$HALF_HOUR = 1800000;
const $e519b350b77b4296$export$d3a4cb300c572c66 = ({ data: { id: id, gadgets: gadgets, layout: layout }, saveCustomGadgetTitle: saveCustomGadgetTitle })=>{
    (0, $h5Jym.useSpaStatePageReady)();
    (0, $kUwqK.usePageStatusLogger)($e519b350b77b4296$var$HALF_HOUR);
    (0, $6IxJi.useGadgetMetricsBridge)(id, gadgets, layout);
    (0, $i7Ldp.useConnectApi)({
        saveCustomGadgetTitle: saveCustomGadgetTitle
    });
    return null;
};
const $e519b350b77b4296$var$AMD_RESOURCE_RETRY_LIMIT = 2;
const $e519b350b77b4296$export$b49692a976fb3d05 = ({ children: children, customHeight: customHeight, analyticsExperience: analyticsExperience, saveCustomGadgetTitle: saveCustomGadgetTitle = ()=>Promise.resolve(), resourceData: resourceData, permissionErrorFallback: permissionErrorFallback })=>{
    const { data: configData, error: configError, loading: configLoading } = resourceData;
    const { loading: amdLoading, data: amdData, error: amdError, refresh: amdRefresh } = (0, $gh1hi.useDashboardAMDModulesResource)();
    const [amdResourceRetries, setAmdResourceRetries] = (0, $5uXOq.useState)(0);
    const fireAnalytics = (0, $bOnpg.useDashboardAnalytics)();
    const eventSent = (0, $5uXOq.useRef)(null);
    const isAmdResourceUnhealthy = configData != null && amdData == null && amdError != null || amdData?.amdModules != null && Object.values(amdData?.amdModules).some((v)=>v == null);
    const isAmdResourceRetriesExceeded = !amdLoading && amdResourceRetries >= $e519b350b77b4296$var$AMD_RESOURCE_RETRY_LIMIT;
    (0, $5uXOq.useEffect)(()=>{
        if (false || configLoading || configData == null || eventSent.current === Number(configData.id)) return;
        fireAnalytics({
            eventType: (0, $4d5e0871c06cee03$export$f1d537d508d2945a),
            actionSubjectId: 'dashboard',
            actionSubject: 'dashboardScreen',
            action: 'viewed'
        });
        (0, $5jJ3W.addDashboardToRecents)(configData.id);
        eventSent.current = Number(configData.id);
    }, [
        configData,
        fireAnalytics,
        configLoading
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (false) return;
        if (amdLoading) {
            // NOTE - reset retries when resource changes
            !isAmdResourceUnhealthy && setAmdResourceRetries(0);
            return;
        }
        if (!isAmdResourceUnhealthy) (0, $2YZCu.default).safeInfoWithoutCustomerData('spa-apps.dashboard.content-container', `AMD resource loaded, after retries [${amdResourceRetries}]`);
        else if (isAmdResourceRetriesExceeded) {
            const [failedCount, totalCount] = Object.values(amdData?.amdModules ?? []).reduce(([f], v, i, arr)=>[
                    f + (v == null ? 1 : 0),
                    arr.length
                ], [
                0,
                0
            ]);
            (0, $2YZCu.default).safeErrorWithoutCustomerData('spa-apps.dashboard.content-container', amdError ? `AMD resource error [${String(amdError.message)}]` : `AMD resource degraded, failed [${failedCount}] of [${totalCount}] gadgets`);
        } else {
            (0, $2YZCu.default).safeWarnWithoutCustomerData('spa-apps.dashboard.content-container', `Retrying AMD resource, retry [${amdResourceRetries + 1}]`);
            setAmdResourceRetries((n)=>n + 1);
            amdRefresh();
        }
    }, [
        amdResourceRetries,
        amdLoading,
        amdError,
        amdData,
        isAmdResourceUnhealthy,
        isAmdResourceRetriesExceeded,
        amdRefresh
    ]);
    if (false || configLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1yBXu.GenericLoadingView), {
        customHeight: customHeight
    });
    if (configError != null || configData == null) {
        const errorCode = (0, $8CCTB.getErrorCode)(configError);
        if (errorCode && (0, $fxC6K.DASHBOARD_PERMISSION_ERROR_CODE_LIST).includes(errorCode) || (0, $fZneA.isClientFetchError)(configError)) return permissionErrorFallback;
        if (configData == null) (0, $2YZCu.default).safeErrorWithoutCustomerData('spa-apps.dashboard.content-container', 'configData is null');
        (0, $2YZCu.default).unsafeErrorWithCustomerData('spa-apps.dashboard.content-container', `[Inline Error] Error with experience ${analyticsExperience}: ${configError}`);
        (0, $2YZCu.default).unsafeErrorWithCustomerData('spa-apps.dashboard.content-container', `[Attached Error] Error with experience ${analyticsExperience}`, configError || {});
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceFailureTracker), {
            location: analyticsExperience,
            failureEventAttributes: {
                error: configError ? configError.message : 'unknown error'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.JSErrorPageAsync), null));
    }
    if (isAmdResourceRetriesExceeded && amdError != null && amdData == null) {
        (0, $2YZCu.default).unsafeErrorWithCustomerData('spa-apps.dashboard.content-container', 'Amd resource retries exceeded', amdError);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceFailureTracker), {
            location: analyticsExperience,
            failureEventAttributes: {
                error: `AMD resource error [${String(amdError.message)}]`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.JSErrorPageAsync), null));
    }
    return(// ThemeProvider will no longer be used in later versions of Atlaskit Grid
    // Remove when @atlaskit/page is updated
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $47bDC.ThemeProvider), {
        theme: {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceSuccessTracker), {
        location: analyticsExperience
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7v0Ei.AmdGadgetMonolithOverrideStyles), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Bx5m.AboveTheFoldContainer), {
        dashboardId: configData.id,
        layout: configData.layout,
        gadgets: configData.gadgets
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8h45R.GadgetAdditionalStateContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e519b350b77b4296$export$d3a4cb300c572c66, {
        data: configData,
        saveCustomGadgetTitle: saveCustomGadgetTitle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hwuTz.RouteResourceValidator), null), children)))));
};

});
parcelRegister("1yBXu", function(module, exports) {

$parcel$export(module.exports, "GenericLoadingView", () => $1052d375f7549967$export$901c7e24ef786b0f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8iquX = parcelRequire("8iquX");
const $1052d375f7549967$export$901c7e24ef786b0f = ({ customHeight: customHeight })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8iquX.default), {
        name: "generic-loading-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1052d375f7549967$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1052d375f7549967$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1052d375f7549967$var$Title, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1052d375f7549967$var$Button, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1052d375f7549967$var$Button, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1052d375f7549967$var$ContainerWrapper, {
        customHeight: customHeight
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1052d375f7549967$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _4cvr1y6m _1e0c1txw _1n261g80 _p12f1osq _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $1052d375f7549967$var$ContainerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { customHeight: customHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_6y8cer": (0, $lD23V.default)(__cmplp.customHeight)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhkn82g _1bsb1osq _1pbyb4wl",
            __cmplp.customHeight != null ? "_4t3i1hh3" : "_4t3i1wef",
            __cmplp.className
        ])
    });
});
const $1052d375f7549967$var$Header = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bsb1osq _19pk1ejb _2hwxidpf _otyr1ejb _18u0idpf _1okqidpf _142fidpf _kdjlidpf _1octidpf",
            __cmplp.className
        ])
    });
});
const $1052d375f7549967$var$Title = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwx1wug _bfhkn82g _4t3izwfg _1bsbclpc",
            __cmplp.className
        ])
    });
});
const $1052d375f7549967$var$Button = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxu2gc _bfhkn82g _4t3izwfg _1bsbzwfg",
            __cmplp.className
        ])
    });
});

});

parcelRegister("i7Ldp", function(module, exports) {

$parcel$export(module.exports, "useConnectApi", () => $5ce347994b87c55a$export$521765443e759ceb);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $JIPqS = parcelRequire("JIPqS");

var $gh1hi = parcelRequire("gh1hi");

var $19nfo = parcelRequire("19nfo");

var $8h45R = parcelRequire("8h45R");
const $5ce347994b87c55a$export$521765443e759ceb = ({ saveCustomGadgetTitle: saveCustomGadgetTitle })=>{
    const { data: data, update: update } = (0, $gh1hi.useDashboardResource)();
    const debouncedHeightRef = (0, $5uXOq.useRef)({});
    const [, { addNonRenamable: addNonRenamable, addForcedHeight: addForcedHeight }] = (0, $8h45R.useGadgetAdditionalStateActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (!data) return;
        const setGadgetTitle = async (id, title)=>{
            if (data.gadgets.some((g)=>g.id === id)) {
                saveCustomGadgetTitle(id, title);
                addNonRenamable(id);
            }
        };
        const setGadgetHeight = (id, height)=>{
            if (debouncedHeightRef.current[id] == null) debouncedHeightRef.current[id] = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((debouncedHeight)=>{
                (0, $19nfo.updateLocalStorageHeight)(data.id, id, debouncedHeight);
                addForcedHeight(id, debouncedHeight);
            }, (0, $JIPqS.GADGET_HEIGHT_UPDATE_WAIT_TIME));
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            debouncedHeightRef.current[id](height);
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const isGadgetConfigurable = (id)=>{
            const gadget = data.gadgets.find((g)=>g.id === id);
            const { configurable: configurable, hasNonHiddenUserPrefs: hasNonHiddenUserPrefs, renderedGadgetUrl: renderedGadgetUrl } = gadget || {};
            return data.writable && (configurable || hasNonHiddenUserPrefs || Boolean(renderedGadgetUrl));
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.dashboardSpaBridge = {
            setGadgetTitle: setGadgetTitle,
            setGadgetHeight: setGadgetHeight,
            isGadgetConfigurable: isGadgetConfigurable
        };
    }, [
        data,
        addNonRenamable,
        addForcedHeight,
        saveCustomGadgetTitle,
        update
    ]);
};

});
parcelRegister("19nfo", function(module, exports) {

$parcel$export(module.exports, "getGadgetDataFromLocalStorage", () => $bf0cad76c08ceb09$export$9d44840cd06e000d);
$parcel$export(module.exports, "putGadgetDataFromLocalStorage", () => $bf0cad76c08ceb09$export$bfbe102b0a9ddb0b);
$parcel$export(module.exports, "deleteGadgetDataFromLocalStorage", () => $bf0cad76c08ceb09$export$d0ed0cab2f2757a9);
$parcel$export(module.exports, "updateLocalStorageHeight", () => $bf0cad76c08ceb09$export$2e93c23f060e835b);
$parcel$export(module.exports, "getLocalStorageHeight", () => $bf0cad76c08ceb09$export$e31e30011965d5e7);
$parcel$export(module.exports, "getAllLocalStorageHeights", () => $bf0cad76c08ceb09$export$2590d76ae5192a56);

var $bSSG7 = parcelRequire("bSSG7");

var $JIPqS = parcelRequire("JIPqS");

var $4R6GH = parcelRequire("4R6GH");
const $bf0cad76c08ceb09$export$6bac6bdc21b646b4 = (cookieData)=>{
    if (!cookieData) return {};
    const cookieInfos = cookieData.split('|').filter((cookieInfo)=>cookieInfo.trim().length);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return cookieInfos.reduce((acc, cookieInfo)=>{
        const COOKIE_INFO_PATTERN = /(?<cookieKey>.*)=(?<cookieValue>.*)/;
        const matchRes = cookieInfo.match(COOKIE_INFO_PATTERN);
        if (!matchRes) return acc;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { cookieKey: cookieKey, cookieValue: cookieValue } = matchRes.groups;
        if (cookieKey.includes(':')) {
            const [gadgetId, gadgetAttributeName] = cookieKey.split(':');
            acc[gadgetId] = acc[gadgetId] || {};
            acc[gadgetId][gadgetAttributeName] = cookieValue;
        } else if (cookieKey.includes('-')) {
            const [, gadgetId, gadgetAttributeName] = cookieKey.split('-');
            acc[gadgetId] = acc[gadgetId] || {};
            acc[gadgetId][gadgetAttributeName] = cookieValue;
        }
        return acc;
    }, {});
};
const $bf0cad76c08ceb09$export$20a3a47cb251067e = (mappedCookieInfo)=>{
    let res = '';
    if (typeof mappedCookieInfo !== 'object') return res;
    Object.keys(mappedCookieInfo).forEach((id)=>{
        const attributeNames = mappedCookieInfo[id];
        if (typeof attributeNames !== 'object') return;
        Object.keys(attributeNames).forEach((attributeName)=>{
            const attributeValue = attributeNames[attributeName];
            if (!attributeValue) return;
            // If res already has contents add the separator
            if (res.length) res += '|';
            if (attributeName.includes('fh')) res += `gadget-${id}-${attributeName}=${attributeValue}`;
            else res += `${id}:${attributeName}=${attributeValue}`;
        });
    });
    return res;
};
const $bf0cad76c08ceb09$export$ad3e452a397f8ecc = ()=>{
    const localStorage = (0, $4R6GH.fg)('hot_116772_dashboard_local_storage_prefix') ? (0, $bSSG7.createLocalStorageProvider)('dashboard') : (0, $bSSG7.createLocalStorageProvider)('');
    const cookieData = localStorage.get((0, $JIPqS.GADGET_LOCAL_STORAGE_NAME));
    if (typeof cookieData !== 'string') return '';
    // TODO: Remove when monolith manipulation of gadget local storage is removed.
    // In particular around frame heights of gadgets coming from AG.Cookie.js
    // Issue is the FE local storage provider adds leading and trailing quotations
    // while the old local storage value does not have it. This causes issues when
    // the local storage is dynamically updated by the old monolith code
    // Eg. Might end up with something like '"foo=1"|bar=2'
    // To handle this for now, we remove all quotations
    return cookieData.replace(/"/g, '');
};
const $bf0cad76c08ceb09$export$9d44840cd06e000d = (id, gadgetDataKey)=>{
    const cleanedCookieData = $bf0cad76c08ceb09$export$ad3e452a397f8ecc();
    const mappedCookieInfo = $bf0cad76c08ceb09$export$6bac6bdc21b646b4(cleanedCookieData);
    const gadgetInfo = mappedCookieInfo[id];
    return gadgetInfo?.[gadgetDataKey];
};
const $bf0cad76c08ceb09$export$bfbe102b0a9ddb0b = (id, gadgetDataKey, value)=>{
    const cleanedCookieData = $bf0cad76c08ceb09$export$ad3e452a397f8ecc();
    const mappedCookieInfo = $bf0cad76c08ceb09$export$6bac6bdc21b646b4(cleanedCookieData);
    mappedCookieInfo[id] = mappedCookieInfo[id] ?? {};
    if (mappedCookieInfo[id]) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    mappedCookieInfo[id][gadgetDataKey] = value;
    const updatedCookieData = $bf0cad76c08ceb09$export$20a3a47cb251067e(mappedCookieInfo);
    const localStorage = (0, $4R6GH.fg)('hot_116772_dashboard_local_storage_prefix') ? (0, $bSSG7.createLocalStorageProvider)('dashboard') : (0, $bSSG7.createLocalStorageProvider)('');
    localStorage.set((0, $JIPqS.GADGET_LOCAL_STORAGE_NAME), updatedCookieData);
};
const $bf0cad76c08ceb09$export$d0ed0cab2f2757a9 = (id, gadgetDataKey)=>{
    const cleanedCookieData = $bf0cad76c08ceb09$export$ad3e452a397f8ecc();
    const mappedCookieInfo = $bf0cad76c08ceb09$export$6bac6bdc21b646b4(cleanedCookieData);
    if (mappedCookieInfo[id]) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    delete mappedCookieInfo[id][gadgetDataKey];
    const updatedCookieData = $bf0cad76c08ceb09$export$20a3a47cb251067e(mappedCookieInfo);
    const localStorage = (0, $4R6GH.fg)('hot_116772_dashboard_local_storage_prefix') ? (0, $bSSG7.createLocalStorageProvider)('dashboard') : (0, $bSSG7.createLocalStorageProvider)('');
    localStorage.set((0, $JIPqS.GADGET_LOCAL_STORAGE_NAME), updatedCookieData);
};
const $bf0cad76c08ceb09$export$2e93c23f060e835b = (dashboardId, gadgetId, height)=>{
    if (dashboardId == null || height == null) return;
    const heightAsInt = Math.round(height);
    const localStorage = (0, $4R6GH.fg)('hot_116772_dashboard_local_storage_prefix') ? (0, $bSSG7.createLocalStorageProvider)('dashboard') : (0, $bSSG7.createLocalStorageProvider)('');
    let dashboardLocalData = localStorage.get((0, $JIPqS.DASHBOARD_LOCAL_STORAGE_KEY_NAME)) ?? {};
    if (typeof dashboardLocalData !== 'object' && (0, $4R6GH.fg)('hot_116772_dashboard_local_storage_prefix')) dashboardLocalData = {};
    dashboardLocalData[dashboardId] = dashboardLocalData[dashboardId] ?? {};
    const dashboardData = dashboardLocalData[dashboardId];
    dashboardData[gadgetId] = dashboardData[gadgetId] ?? {};
    const gadgetData = dashboardData[gadgetId];
    const storedHeight = gadgetData.height;
    if (storedHeight === heightAsInt) return;
    gadgetData.height = heightAsInt;
    localStorage.set((0, $JIPqS.DASHBOARD_LOCAL_STORAGE_KEY_NAME), dashboardLocalData);
};
const $bf0cad76c08ceb09$export$e31e30011965d5e7 = (dashboardId, gadgetId)=>{
    const localStorage = (0, $4R6GH.fg)('hot_116772_dashboard_local_storage_prefix') ? (0, $bSSG7.createLocalStorageProvider)('dashboard') : (0, $bSSG7.createLocalStorageProvider)('');
    const dashboardLocalData = localStorage.get((0, $JIPqS.DASHBOARD_LOCAL_STORAGE_KEY_NAME));
    const gadgetLocalHeight = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    dashboardLocalData?.[dashboardId]?.[gadgetId]?.height;
    return gadgetLocalHeight !== 0 && gadgetLocalHeight != null ? gadgetLocalHeight : (0, $JIPqS.GADGET_DEFAULT_HEIGHT);
};
const $bf0cad76c08ceb09$export$2590d76ae5192a56 = (dashboardId)=>{
    const localStorage = (0, $4R6GH.fg)('hot_116772_dashboard_local_storage_prefix') ? (0, $bSSG7.createLocalStorageProvider)('dashboard') : (0, $bSSG7.createLocalStorageProvider)('');
    const dashboardLocalData = localStorage.get((0, $JIPqS.DASHBOARD_LOCAL_STORAGE_KEY_NAME));
    return dashboardLocalData?.[dashboardId] ?? {};
};

});

parcelRegister("8h45R", function(module, exports) {

$parcel$export(module.exports, "useIsRenamable", () => $424d7b25bd304486$export$99680f47796b1368);
$parcel$export(module.exports, "useForcedHeight", () => $424d7b25bd304486$export$6286e5c3de90c7ce);
$parcel$export(module.exports, "useGadgetAdditionalStateActions", () => $424d7b25bd304486$export$7050d853cb5c3b12);
$parcel$export(module.exports, "GadgetAdditionalStateContainer", () => $424d7b25bd304486$export$c59b94948beb035f);
/* eslint-disable @typescript-eslint/no-unnecessary-type-constraint */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $424d7b25bd304486$var$actions = {
    addNonRenamable: (id)=>({ setState: setState, getState: getState })=>{
            const gadgetIdToStateMap = getState().idToStateMap;
            const newIds = new Map(gadgetIdToStateMap.set(id, {
                ...gadgetIdToStateMap.get(id),
                isNonRenamable: true
            }));
            setState({
                idToStateMap: newIds
            });
        },
    addForcedHeight: (id, forcedHeight)=>({ setState: setState, getState: getState })=>{
            const gadgetIdToStateMap = getState().idToStateMap;
            const newGadgetIdToStateMap = new Map(gadgetIdToStateMap.set(id, {
                ...gadgetIdToStateMap.get(id),
                forcedHeight: forcedHeight
            }));
            setState({
                idToStateMap: newGadgetIdToStateMap
            });
        },
    remove: (id)=>({ setState: setState, getState: getState })=>{
            if (!getState().idToStateMap.has(id)) return;
            const newGadgetIdToStateMap = new Map(getState().idToStateMap);
            newGadgetIdToStateMap.delete(id);
            setState({
                idToStateMap: newGadgetIdToStateMap
            });
        }
};
const $424d7b25bd304486$var$Store = (0, $iXqE5.createStore)({
    name: 'gadget-additional-state',
    initialState: {
        idToStateMap: new Map()
    },
    actions: $424d7b25bd304486$var$actions
});
const $424d7b25bd304486$export$b8a31aa234db5dc9 = (// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
hook)=>(args)=>{
        // eslint-disable-next-line @atlassian/eng-health/code-evolution/ts-migration-4.9-5.4
        // @ts-expect-error([Part of upgrade 4.9-5.4]) - Argument of type '[PR]' is not assignable to parameter of type 'void'.
        const [value] = hook(args);
        return value;
    };
const $424d7b25bd304486$export$99680f47796b1368 = $424d7b25bd304486$export$b8a31aa234db5dc9((0, $3sQ5x.createHook)($424d7b25bd304486$var$Store, {
    selector: (state, id)=>!state.idToStateMap.get(id)?.isNonRenamable
}));
const $424d7b25bd304486$export$6286e5c3de90c7ce = $424d7b25bd304486$export$b8a31aa234db5dc9((0, $3sQ5x.createHook)($424d7b25bd304486$var$Store, {
    selector: (state, id)=>state.idToStateMap.get(id)?.forcedHeight
}));
const $424d7b25bd304486$export$7050d853cb5c3b12 = (0, $3sQ5x.createHook)($424d7b25bd304486$var$Store, {
    selector: null
});
const $424d7b25bd304486$export$c59b94948beb035f = (0, $gg7kZ.createContainer)($424d7b25bd304486$var$Store);

});


parcelRegister("bOnpg", function(module, exports) {

$parcel$export(module.exports, "useDashboardAnalytics", () => $d2709a7a4ffbbf0c$export$6da6d2b3a61f8861);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");
const $d2709a7a4ffbbf0c$export$6da6d2b3a61f8861 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)(({ eventType: eventType, actionSubject: actionSubject, action: action, actionSubjectId: actionSubjectId, attributes: attributes = {} })=>{
        let fireAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        // All of the events have exactly the same signature and transformations underneath.
        switch(eventType){
            case 0, $4d5e0871c06cee03$export$947dac6c72b26f81:
                fireAnalytics = (0, $8zOmE.fireTrackAnalytics);
                break;
            case 0, $4d5e0871c06cee03$export$12346a674644c156:
                fireAnalytics = (0, $8zOmE.fireOperationalAnalytics);
                break;
            case 0, $4d5e0871c06cee03$export$a1562d08625f5d7e:
                fireAnalytics = (0, $8zOmE.fireUIAnalytics);
                break;
            case 0, $4d5e0871c06cee03$export$f1d537d508d2945a:
                fireAnalytics = (0, $8zOmE.fireScreenAnalytics);
                break;
            default:
                fireAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        }
        fireAnalytics(createAnalyticsEvent({}), `${actionSubject} ${action}`, actionSubjectId, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        attributes);
    }, [
        createAnalyticsEvent
    ]);
};

});

parcelRegister("6IxJi", function(module, exports) {

$parcel$export(module.exports, "useGadgetMetricsBridge", () => $d46d9a3e27973a8e$export$a81a90ecebb273c6);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");

var $JIPqS = parcelRequire("JIPqS");

var $6jY6G = parcelRequire("6jY6G");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $bVDE5 = parcelRequire("bVDE5");

var $6fab6 = parcelRequire("6fab6");

var $8UPoO = parcelRequire("8UPoO");

var $1oaeD = parcelRequire("1oaeD");

var $i0rkS = parcelRequire("i0rkS");

var $5TsWX = parcelRequire("5TsWX");

var $7FHsN = parcelRequire("7FHsN");

var $gW6vr = parcelRequire("gW6vr");
const $d46d9a3e27973a8e$var$OVERALL_TIMEOUT = 60000;
const $d46d9a3e27973a8e$var$buildEventKey = (event)=>{
    if (event.eventType !== (0, $5TsWX.GADGET_MARK_EVENT_PREFIX) || event.markName == null || event.markStage == null) return event.eventType;
    return `${0, $5TsWX.GADGET_MARK_EVENT_PREFIX}-${event.markName}-${event.markStage}`;
};
const $d46d9a3e27973a8e$export$b70b6efb2347a731 = (gadgetMetricsEvents, gadgetId, event)=>{
    let recorded = gadgetMetricsEvents.get(gadgetId);
    if (recorded == null) {
        recorded = {
            contentType: 'Unspecified',
            source: event.source,
            events: new Map()
        };
        gadgetMetricsEvents.set(gadgetId, recorded);
    }
    if (recorded.contentType !== 'ErrorMessage' && event.contentType !== 'Unspecified') recorded.contentType = event.contentType;
    const record = {
        spaTime: Date.now()
    };
    if (!recorded.events.has($d46d9a3e27973a8e$var$buildEventKey(event))) recorded.events.set($d46d9a3e27973a8e$var$buildEventKey(event), record);
};
const $d46d9a3e27973a8e$export$8aed66d0a3a7041d = (gadgets)=>gadgets.filter((item)=>item.amdModule != null || item.forge != null || item.reactKey != null)// Include only gadgets in the inclusion list
    .filter((item)=>// report all forge and react gadgets
        item.forge != null || item.reactKey != null || (0, $gW6vr.GADGETS_TO_REPORT).has(item.amdModule ?? '')).map((gadget)=>gadget.id);
const $d46d9a3e27973a8e$export$b2ee8eefeb9c97ce = (gadgets)=>gadgets// Include only WRM gadget
    .filter((item)=>item.amdModule != null)// exclude connect gadgets
    .filter((item)=>!(0, $5TsWX.CONNECT_MODULE_PATTERN).test(item.amdModule || ''))// find gadgets not in either inclusion list or exclusion list
    .filter((item)=>!(0, $gW6vr.GADGETS_TO_REPORT).has(item.amdModule ?? '') && !(0, $gW6vr.GADGETS_IGNORED).has(item.amdModule ?? ''));
// Currently WRM gadget does not send render finish event in Config mode so we don't have accurate TTI for it
const $d46d9a3e27973a8e$var$shouldSendGadgetMetrics = (event)=>!(event.source === (0, $5TsWX.WRM_GADGET_METRICS) && event.contentType === 'Config');
const $d46d9a3e27973a8e$export$a81a90ecebb273c6 = (dashboardId, gadgets, layout)=>{
    const currentDashboardId = (0, $5uXOq.useRef)(null);
    // Metrics context in the a dashboard lifecycle.
    const dashboardMetricsContext = (0, $5uXOq.useRef)(null);
    const [, { registerListener: registerMessageListener, unregisterListener: unregisterMessageListener, broadcastMessage: broadcastMessageListener }] = (0, $i0rkS.useMessageBus)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { sendGadgetMetrics: sendGadgetMetrics, sendOverallGadgetMetrics: sendOverallGadgetMetrics, onAboveTheFoldGadgetsRender: onAboveTheFoldGadgetsRender, resetScrollStartMetrics: resetScrollStartMetrics } = (0, $7FHsN.useGadgetMetricsAnalytics)(dashboardId);
    const [, { onGadgetRender: onGadgetRender }] = (0, $8UPoO.useRenderAboveTheFold)();
    const [{ isInitialRender: isInitialRender, lastTransitionStartTime: lastTransitionStartTime, navigationStart: navigationStart, currentPageId: currentPageId }] = (0, $bVDE5.useSpaStateTransition)();
    const { name: routeName } = (0, $6jY6G.useCurrentRoute)();
    const { getMaximisedGadgetId: getMaximisedGadgetId } = (0, $1oaeD.useMaximizedGadget)(gadgets);
    const maximizedId = getMaximisedGadgetId;
    if (currentDashboardId.current == null || currentDashboardId.current !== dashboardId) {
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'dashboardMetricsContext renewed', {
            dashboardId: dashboardId,
            previousDashboardId: currentDashboardId.current,
            currentPageId: currentPageId
        });
        resetScrollStartMetrics();
        // Dashboard reinitialised or changed
        currentDashboardId.current = dashboardId;
        if (dashboardMetricsContext.current?.metricsTimeout != null) clearTimeout(dashboardMetricsContext.current.metricsTimeout);
        const extractedGadgets = $d46d9a3e27973a8e$export$8aed66d0a3a7041d(maximizedId ? gadgets.filter((gadget)=>gadget.id === maximizedId) : gadgets);
        const allAboveTheFoldGadgets = (0, $8UPoO.getAboveTheFoldGadgets)((0, $6fab6.toColumns)(gadgets, layout), dashboardId);
        dashboardMetricsContext.current = {
            gadgetMetricsEvents: new Map(),
            gadgetIdsInOverallAnalytics: extractedGadgets,
            gadgetIdsInTti: extractedGadgets.filter((gadgetId)=>allAboveTheFoldGadgets.has(gadgetId)),
            allGadgetIds: gadgets.map((item)=>item.id),
            overallMetricsSent: false,
            atfMetricsSent: false,
            implicitlyIgnoredGadgetLogged: false,
            gadgetRenderStartTime: Date.now(),
            metricsTimeout: setTimeout(()=>{
                broadcastMessageListener((0, $JIPqS.GADGET_METRICS_TYPE).TIMEOUT, {}, {});
            }, $d46d9a3e27973a8e$var$OVERALL_TIMEOUT),
            timestamps: {
                created: Date.now(),
                pnow: performance?.now(),
                currentPageId: currentPageId,
                lastTransitionStartTime: lastTransitionStartTime,
                navigationStart: navigationStart,
                navStart: (0, $7FHsN.getNavStart)(isInitialRender, lastTransitionStartTime, navigationStart)
            }
        };
    }
    const gadgetMetricsTimeout = (0, $5uXOq.useCallback)(()=>{
        const context = dashboardMetricsContext.current;
        if (context == null) return;
        if (context.overallMetricsSent) return;
        context.metricsTimeout = undefined;
        // Set up the overall flag so that gadgetMetricsListener will stop handling gadget events
        context.overallMetricsSent = true;
        // Send metrics for timed out gadget that sent at least one event.
        context.gadgetMetricsEvents.forEach((item, id)=>{
            if (item.allEventHandled !== true) {
                // eslint-disable-next-line no-param-reassign
                item.timedOut = true;
                sendGadgetMetrics(id, item);
            }
        });
        // Send metrics for idle gadgets that haven't sent any event
        context.gadgetIdsInOverallAnalytics.filter((id)=>!context.gadgetMetricsEvents.has(id)).forEach((id)=>{
            sendGadgetMetrics(id, {
                source: (0, $5TsWX.IDLE_GADGET_SOURCE),
                timedOut: true,
                events: new Map()
            });
        });
        onAboveTheFoldGadgetsRender(context.gadgetIdsInOverallAnalytics, context.gadgetMetricsEvents, context.gadgetRenderStartTime, context.timestamps, true);
        sendOverallGadgetMetrics(context.gadgetIdsInOverallAnalytics, context.gadgetMetricsEvents, true);
    }, [
        sendGadgetMetrics,
        sendOverallGadgetMetrics,
        onAboveTheFoldGadgetsRender
    ]);
    const onAllGadgetHandled = (0, $5uXOq.useCallback)(()=>{
        // Set up the overall flag so that gadgetMetricsListener will stop handling gadget events
        const context = dashboardMetricsContext.current;
        if (context == null) return;
        context.overallMetricsSent = true;
        if (context.metricsTimeout != null) {
            clearTimeout(context.metricsTimeout);
            context.metricsTimeout = undefined;
        }
        sendOverallGadgetMetrics(context.gadgetIdsInOverallAnalytics, context.gadgetMetricsEvents, false);
    }, [
        sendOverallGadgetMetrics
    ]);
    const onAboveTheFoldGadgetsHandled = (0, $5uXOq.useCallback)(()=>{
        const context = dashboardMetricsContext.current;
        if (context == null) return;
        onAboveTheFoldGadgetsRender(context.gadgetIdsInOverallAnalytics, context.gadgetMetricsEvents, context.gadgetRenderStartTime, context.timestamps, false);
        context.atfMetricsSent = true;
    }, [
        onAboveTheFoldGadgetsRender
    ]);
    const gadgetMetricsListener = (0, $5uXOq.useCallback)((gid, command, ...args)=>{
        if (command !== 'metrics_event' || !args[0]) return;
        const context = dashboardMetricsContext.current;
        if (context == null) return;
        if (context.overallMetricsSent) return;
        const eventData = args[0];
        const eventsPerGadget = (0, $7FHsN.getAllEventHandlers)(eventData.source, eventData.contentType);
        const { pageId: pageIdInEvent } = eventData;
        // If the gadget id for the event is not in the current gadgetIds list, it is from a stale gadget of the previous dashboard
        if (currentPageId !== pageIdInEvent || context.allGadgetIds.every((id)=>id !== gid)) {
            (0, $2YZCu.default).safeWarnWithoutCustomerData('spa-apps.dashboard.gadget.metrics', `Page [${currentPageId ?? ''}] recieved staled gadget metrics event [${eventData.eventType}] from gadget [${gid}] in page [${pageIdInEvent ?? ''}]`);
            return;
        }
        // Check if all expected events for a gadget are triggered and handled
        const isAllGadgetEventsHandled = (gadgetEvents)=>gadgetEvents?.allEventHandled === true || gadgetEvents?.timedOut === true || eventsPerGadget.every((e)=>gadgetEvents?.events.has(e));
        // Check if all gadgets has been handled
        const isAllGadgetHandled = (gadgetIds)=>gadgetIds.every((id)=>context.gadgetMetricsEvents.get(id)?.allEventHandled);
        if (context.gadgetMetricsEvents.has(gid)) {
            if (isAllGadgetEventsHandled(context.gadgetMetricsEvents.get(gid))) // gadget has been handled
            return;
            if (context.gadgetMetricsEvents.get(gid)?.events.has($d46d9a3e27973a8e$var$buildEventKey(eventData))) // event has been handled
            return;
        }
        $d46d9a3e27973a8e$export$b70b6efb2347a731(context.gadgetMetricsEvents, gid, eventData);
        const event = context.gadgetMetricsEvents.get(gid);
        if (event != null && isAllGadgetEventsHandled(event)) {
            event.allEventHandled = true;
            if ($d46d9a3e27973a8e$var$shouldSendGadgetMetrics(event)) {
                onGadgetRender(gid);
                sendGadgetMetrics(gid, event);
            }
            // if all above the fold gadgets are handled,  send gadgets metrics
            if (context.atfMetricsSent === false) {
                if (isAllGadgetHandled(context.gadgetIdsInTti)) onAboveTheFoldGadgetsHandled();
            }
            // if all gadgets are handled, send overall metrics
            if (isAllGadgetHandled(context.gadgetIdsInOverallAnalytics)) {
                onAllGadgetHandled();
                if (context.atfMetricsSent === false) onAboveTheFoldGadgetsHandled();
            }
        }
    }, [
        currentPageId,
        onAboveTheFoldGadgetsHandled,
        onAllGadgetHandled,
        sendGadgetMetrics,
        onGadgetRender
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            // NOTE - This is temporary until we fix metrics for wallboard
            if (routeName === 'dashboard-wallboard') return;
            if (dashboardMetricsContext.current?.metricsTimeout != null) {
                clearTimeout(dashboardMetricsContext.current.metricsTimeout);
                dashboardMetricsContext.current.metricsTimeout = undefined;
            }
        }, [
        routeName
    ]);
    const gadgetMetricsMessageBusListenerAdaptor = (0, $5uXOq.useCallback)((type, message, context)=>{
        if (type !== (0, $JIPqS.GADGET_METRICS_TYPE).REPORT) return;
        const { gadgetId: gid, pageId: pageId } = context;
        if (gid == null) return;
        gadgetMetricsListener(gid, 'metrics_event', {
            ...message,
            pageId: pageId
        });
    }, [
        gadgetMetricsListener
    ]);
    const timeoutMessageBusListenerAdaptor = (0, $5uXOq.useCallback)((type)=>{
        if (type !== (0, $JIPqS.GADGET_METRICS_TYPE).TIMEOUT) return;
        gadgetMetricsTimeout();
    }, [
        gadgetMetricsTimeout
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        // NOTE - This is temporary until we fix metrics for wallboard
        if (routeName === 'dashboard-wallboard') // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        registerMessageListener(gadgetMetricsMessageBusListenerAdaptor);
        registerMessageListener(timeoutMessageBusListenerAdaptor);
        return ()=>{
            unregisterMessageListener(gadgetMetricsMessageBusListenerAdaptor);
            unregisterMessageListener(timeoutMessageBusListenerAdaptor);
        };
    }, [
        gadgetMetricsMessageBusListenerAdaptor,
        gadgetMetricsListener,
        registerMessageListener,
        timeoutMessageBusListenerAdaptor,
        unregisterMessageListener,
        routeName
    ]);
    // NOTE - This is temporary until we fix metrics for wallboard
    if (routeName === 'dashboard-wallboard') return;
    if (dashboardMetricsContext.current == null || dashboardMetricsContext.current.overallMetricsSent === true) return;
    // Send overall event immediately for empty dashboard
    if (dashboardMetricsContext.current?.gadgetIdsInOverallAnalytics.length === 0) {
        onAboveTheFoldGadgetsHandled();
        onAllGadgetHandled();
    } else if (dashboardMetricsContext.current?.gadgetIdsInTti.length === 0 && dashboardMetricsContext.current?.atfMetricsSent === false) onAboveTheFoldGadgetsHandled();
    if (dashboardMetricsContext.current != null && !dashboardMetricsContext.current.implicitlyIgnoredGadgetLogged) {
        dashboardMetricsContext.current.implicitlyIgnoredGadgetLogged = true;
        $d46d9a3e27973a8e$export$b2ee8eefeb9c97ce(gadgets).forEach((item)=>{
            (0, $2YZCu.default).safeWarnWithoutCustomerData('spa-apps.dashboard.gadget.metrics', `metrics for gadget [${item.amdModule ?? 'unknown'}] is ignored implicitly.`);
        });
    }
};

});
parcelRegister("8UPoO", function(module, exports) {

$parcel$export(module.exports, "getAboveTheFoldGadgets", () => $149138b232138cbc$export$e12eddecf5e86fe5);
$parcel$export(module.exports, "useRenderAboveTheFold", () => $149138b232138cbc$export$16f58cfd4c8ccf70);
$parcel$export(module.exports, "RenderAboveTheFoldContainer", () => $149138b232138cbc$export$9710049f7f21917b);
$parcel$export(module.exports, "useOnGadgetRender", () => $149138b232138cbc$export$c127791d148e941c);
$parcel$export(module.exports, "useOnGadgetRenderEffect", () => $149138b232138cbc$export$1f28971b410f9e3);
$parcel$export(module.exports, "useShouldRenderGadget", () => $149138b232138cbc$export$428a5d740650db3e);
$parcel$export(module.exports, "useLocalStorageGadgetHeight", () => $149138b232138cbc$export$94d0a966fb813ab7);
/* eslint-disable @typescript-eslint/no-unnecessary-type-constraint */ 
var $5uXOq = parcelRequire("5uXOq");

var $JIPqS = parcelRequire("JIPqS");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $19nfo = parcelRequire("19nfo");
const $149138b232138cbc$var$TOP_NAVIGATION_HEIGHT = 56;
const $149138b232138cbc$var$DASHBOARD_HEADER_HEIGHT = 80;
const $149138b232138cbc$var$GADGET_HEADER_AND_FOOTER_HEIGHT = 84;
const $149138b232138cbc$var$PRIORITISED_RENDERING_TIMEOUT = 7000;
const $149138b232138cbc$export$e12eddecf5e86fe5 = (columns, dashboardId)=>{
    const aboveTheFoldGadgets = new Set();
    const availableViewportHeight = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.innerHeight - $149138b232138cbc$var$TOP_NAVIGATION_HEIGHT - $149138b232138cbc$var$DASHBOARD_HEADER_HEIGHT;
    columns.forEach((column)=>{
        let occupiedViewportHeight = 0;
        column.some((gadget)=>{
            if (occupiedViewportHeight < availableViewportHeight) {
                const gadgetHeight = (0, $19nfo.getLocalStorageHeight)(dashboardId, gadget.id) + $149138b232138cbc$var$GADGET_HEADER_AND_FOOTER_HEIGHT;
                aboveTheFoldGadgets.add(gadget.id);
                occupiedViewportHeight += gadgetHeight;
                return false;
            }
            // if we have enough height, we terminate the loop
            return true;
        });
    });
    return aboveTheFoldGadgets;
};
const $149138b232138cbc$export$e324594224ef24da = {
    onGadgetRender: (gadgetId, height)=>({ setState: setState, getState: getState })=>{
            const { dashboardId: dashboardId, loadingAboveTheFold: hasAboveTheFold, timeoutId: timeoutLast } = getState();
            // Always return default for wallboard, where dashboardId is null
            if (dashboardId === null) return;
            // we want this to always happen whenever onGadgetRender is called
            if (height != null) {
                (0, $19nfo.updateLocalStorageHeight)(dashboardId, gadgetId, height);
                setState({
                    localStorageGadgetHeights: {
                        // we can't use this from the state as it might be stale due to other gadgets
                        // possibly updating their heights directly in localStorage
                        ...(0, $19nfo.getAllLocalStorageHeights)(dashboardId),
                        [gadgetId]: {
                            height: height
                        }
                    }
                });
            }
            if (!hasAboveTheFold) return;
            const remainingAboveTheFoldGadgets = new Set(getState().remainingAboveTheFoldGadgets);
            remainingAboveTheFoldGadgets.delete(gadgetId);
            const loadingAboveTheFold = Boolean(remainingAboveTheFoldGadgets.size);
            const timeoutId = loadingAboveTheFold ? timeoutLast : null;
            if (timeoutLast && !timeoutId) clearTimeout(timeoutLast);
            setState({
                remainingAboveTheFoldGadgets: remainingAboveTheFoldGadgets,
                loadingAboveTheFold: loadingAboveTheFold,
                timeoutId: timeoutId
            });
        }
};
const $149138b232138cbc$var$Store = (0, $iXqE5.createStore)({
    name: 'RenderAboveTheFold',
    initialState: {
        dashboardId: null,
        loadingAboveTheFold: true,
        aboveTheFoldGadgets: new Set(),
        remainingAboveTheFoldGadgets: new Set(),
        timeoutId: null,
        timeout: false,
        localStorageGadgetHeights: {}
    },
    actions: $149138b232138cbc$export$e324594224ef24da
});
const $149138b232138cbc$export$16f58cfd4c8ccf70 = (0, $3sQ5x.createHook)($149138b232138cbc$var$Store);
const $149138b232138cbc$export$f0ff1fd44503e803 = (0, $3sQ5x.createHook)($149138b232138cbc$var$Store, {
    selector: null
});
const $149138b232138cbc$export$9710049f7f21917b = (0, $gg7kZ.createContainer)($149138b232138cbc$var$Store, {
    onInit: ()=>({ setState: setState, getState: getState }, { columns: columns, dashboardId: dashboardId, maximizedGadgetId: maximizedGadgetId })=>{
            if (getState().dashboardId !== dashboardId && dashboardId != null) {
                const loadingAboveTheFoldTimeout = ()=>{
                    setState({
                        remainingAboveTheFoldGadgets: new Set(),
                        loadingAboveTheFold: false,
                        timeout: true
                    });
                };
                const aboveTheFoldGadgets = maximizedGadgetId ? new Set([
                    maximizedGadgetId
                ]) : $149138b232138cbc$export$e12eddecf5e86fe5(columns, dashboardId);
                // calculate gadgets
                setState({
                    dashboardId: dashboardId,
                    aboveTheFoldGadgets: aboveTheFoldGadgets,
                    remainingAboveTheFoldGadgets: new Set(aboveTheFoldGadgets),
                    loadingAboveTheFold: Boolean(aboveTheFoldGadgets.size),
                    timeoutId: setTimeout(loadingAboveTheFoldTimeout, $149138b232138cbc$var$PRIORITISED_RENDERING_TIMEOUT),
                    timeout: false,
                    localStorageGadgetHeights: (0, $19nfo.getAllLocalStorageHeights)(dashboardId)
                });
            }
        }
});
const $149138b232138cbc$export$c127791d148e941c = (id)=>{
    const [, { onGadgetRender: onGadgetRender }] = $149138b232138cbc$export$f0ff1fd44503e803();
    return (0, $5uXOq.useCallback)((height)=>onGadgetRender(id, height), [
        id,
        onGadgetRender
    ]);
};
const $149138b232138cbc$export$1f28971b410f9e3 = (id, gadgetRef)=>{
    const onGadgetRender = $149138b232138cbc$export$c127791d148e941c(id);
    (0, $5uXOq.useEffect)(()=>{
        onGadgetRender(gadgetRef?.getBoundingClientRect().height);
    }, [
        onGadgetRender,
        gadgetRef
    ]);
};
const $149138b232138cbc$export$b8a31aa234db5dc9 = (// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
hook)=>(args)=>{
        // eslint-disable-next-line @atlassian/eng-health/code-evolution/ts-migration-4.9-5.4
        // @ts-expect-error([Part of upgrade 4.9-5.4]) - Argument of type '[PR]' is not assignable to parameter of type 'void'.
        const [value] = hook(args);
        return value;
    };
const $149138b232138cbc$export$428a5d740650db3e = $149138b232138cbc$export$b8a31aa234db5dc9((0, $3sQ5x.createHook)($149138b232138cbc$var$Store, {
    selector: ({ loadingAboveTheFold: loadingAboveTheFold, aboveTheFoldGadgets: aboveTheFoldGadgets, dashboardId: dashboardId }, gadgetId)=>{
        // Always return true for wallboard, where the dashboardId isn't defined as it uses query parameters instead
        if (dashboardId === null) return true;
        return !loadingAboveTheFold || aboveTheFoldGadgets.has(gadgetId);
    }
}));
const $149138b232138cbc$export$94d0a966fb813ab7 = $149138b232138cbc$export$b8a31aa234db5dc9((0, $3sQ5x.createHook)($149138b232138cbc$var$Store, {
    selector: ({ localStorageGadgetHeights: localStorageGadgetHeights }, gadgetId)=>localStorageGadgetHeights[gadgetId]?.height ?? (0, $JIPqS.GADGET_DEFAULT_HEIGHT)
}));

});

parcelRegister("i0rkS", function(module, exports) {

$parcel$export(module.exports, "useMessageBus", () => $f812b795237bfc34$export$69241ffa7d4e8d8d);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $f812b795237bfc34$var$actions = {
    registerListener: (listener)=>({ setState: setState, getState: getState })=>{
            const { listeners: listeners } = getState();
            setState({
                listeners: [
                    ...listeners,
                    listener
                ]
            });
        },
    unregisterListener: (listener)=>({ setState: setState, getState: getState })=>{
            const { listeners: listeners } = getState();
            setState({
                listeners: listeners.filter((cb)=>cb !== listener)
            });
        },
    broadcastMessage: (type, message, context)=>({ getState: getState })=>{
            getState().listeners.forEach((listener)=>listener(type, message, context));
        }
};
const $f812b795237bfc34$var$Store = (0, $iXqE5.createStore)({
    name: 'dashboard-message-bus',
    initialState: {
        listeners: []
    },
    actions: $f812b795237bfc34$var$actions
});
const $f812b795237bfc34$export$69241ffa7d4e8d8d = (0, $3sQ5x.createHook)($f812b795237bfc34$var$Store);

});

parcelRegister("5TsWX", function(module, exports) {

$parcel$export(module.exports, "UNKNOWN_GADGET_TYPE", () => $3975f005d3e53b97$export$4db4c2521224b627);
$parcel$export(module.exports, "CONNECT_MODULE_PATTERN", () => $3975f005d3e53b97$export$c1ee01d79441a123);
$parcel$export(module.exports, "FORGE_MODULE_PATTERN", () => $3975f005d3e53b97$export$216b1f7517647987);
$parcel$export(module.exports, "WRM_GADGET_METRICS", () => $3975f005d3e53b97$export$747c046b02db553e);
$parcel$export(module.exports, "FORGE_GADGET_METRICS", () => $3975f005d3e53b97$export$fd11359c208e3b3d);
$parcel$export(module.exports, "REACT_GADGET_METRICS", () => $3975f005d3e53b97$export$e6e5910bcc3a541f);
$parcel$export(module.exports, "FALLBACK_GADGET_SOURCE", () => $3975f005d3e53b97$export$b17b847ae2e73914);
$parcel$export(module.exports, "IDLE_GADGET_SOURCE", () => $3975f005d3e53b97$export$8e7a356fc2e45e1);
$parcel$export(module.exports, "GADGET_MARK_EVENT_PREFIX", () => $3975f005d3e53b97$export$deb23548f6bb4aa6);
$parcel$export(module.exports, "GADGET_MARK_EVENT_PATTERN", () => $3975f005d3e53b97$export$dc82d3f06c18522e);
$parcel$export(module.exports, "GADGET_RENDER_CONTAINER_EVENT", () => $3975f005d3e53b97$export$479474c5d2f30a0a);
$parcel$export(module.exports, "GADGET_START_EVENT", () => $3975f005d3e53b97$export$76b0ea781056f8d3);
$parcel$export(module.exports, "GADGET_RENDERING_FINISHED_EVENT", () => $3975f005d3e53b97$export$b9c9f3ffa9290059);
$parcel$export(module.exports, "DEFAULT_WRM_GADGET_EVENTS", () => $3975f005d3e53b97$export$f34d5b0533833e95);
const $3975f005d3e53b97$export$4db4c2521224b627 = 'unknown';
const $3975f005d3e53b97$export$c1ee01d79441a123 = /^atlassian-connect\/.*/;
const $3975f005d3e53b97$export$216b1f7517647987 = /^ari:cloud:ecosystem::extension\/.*/;
const $3975f005d3e53b97$export$747c046b02db553e = 'wrm_gadget_metrics';
const $3975f005d3e53b97$export$fd11359c208e3b3d = 'forge_gadget_metrics';
const $3975f005d3e53b97$export$e6e5910bcc3a541f = 'react_gadget_metrics';
const $3975f005d3e53b97$export$b17b847ae2e73914 = 'fallback_gadget';
const $3975f005d3e53b97$export$8e7a356fc2e45e1 = 'idle_gadget';
const $3975f005d3e53b97$export$deb23548f6bb4aa6 = 'gadget-mark';
const $3975f005d3e53b97$export$dc82d3f06c18522e = new RegExp(`^${$3975f005d3e53b97$export$deb23548f6bb4aa6}-(.+)-(start|end)$`);
const $3975f005d3e53b97$export$479474c5d2f30a0a = 'gadget-render-container';
const $3975f005d3e53b97$export$76b0ea781056f8d3 = 'gadget-start';
const $3975f005d3e53b97$export$b9c9f3ffa9290059 = 'gadget-rendering-finished';
const $3975f005d3e53b97$export$f34d5b0533833e95 = [
    $3975f005d3e53b97$export$479474c5d2f30a0a,
    $3975f005d3e53b97$export$76b0ea781056f8d3,
    $3975f005d3e53b97$export$b9c9f3ffa9290059
];

});

parcelRegister("7FHsN", function(module, exports) {

$parcel$export(module.exports, "getAllEventHandlers", () => $f42b084586d299a2$export$835bb833cb903f59);
$parcel$export(module.exports, "getNavStart", () => $f42b084586d299a2$export$f409d0aa399347ac);
$parcel$export(module.exports, "useGadgetMetricsAnalytics", () => $f42b084586d299a2$export$ea517a7cfce02895);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $eyWK5 = parcelRequire("eyWK5");

var $lAOer = parcelRequire("lAOer");

var $2YZCu = parcelRequire("2YZCu");

var $JIPqS = parcelRequire("JIPqS");

var $b3IiT = parcelRequire("b3IiT");

var $j8DrX = parcelRequire("j8DrX");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $iAWa3 = parcelRequire("iAWa3");

var $3B7oW = parcelRequire("3B7oW");

var $gh1hi = parcelRequire("gh1hi");

var $bVDE5 = parcelRequire("bVDE5");

var $doZTA = parcelRequire("doZTA");

var $7cLxq = parcelRequire("7cLxq");

var $8UDz8 = parcelRequire("8UDz8");

var $trHKK = parcelRequire("trHKK");

var $hmyfM = parcelRequire("hmyfM");

var $8UPoO = parcelRequire("8UPoO");

var $5TsWX = parcelRequire("5TsWX");
// At time of writing BM3 doesn't support ssrFeatureFlags unless your page performs initial-paint
// in ssr (not just skeleton content), which Dashboard does not.
// We are forced to recreate here based on "@atlassian/jira-browser-metrics".
// We cannot reference code from BM directly since it gets removed in storybook, causing errors.
const $f42b084586d299a2$var$getSSRFeatureFlags = (0, $8QpSo.default)(()=>{
    try {
        const metaTagValue = (0, $j8DrX.default)('spa-service-flags');
        return metaTagValue != null && JSON.parse(metaTagValue) || {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return null;
    }
});
// All expected metrics events from a WRM gadget in Config mode
const $f42b084586d299a2$var$DEFAULT_WRM_GADGET_CONFIG_EVENTS = [
    (0, $5TsWX.GADGET_RENDER_CONTAINER_EVENT)
];
// Expected metrics events from immediately finished gadgets e.g. fallbacks
const $f42b084586d299a2$var$IMMEDIATE_FINISH_GADGET_EVENTS = [
    (0, $5TsWX.GADGET_RENDER_CONTAINER_EVENT)
];
// Events send by the gadget container, which should not be counted to determine idle gadget
const $f42b084586d299a2$var$GADGET_CONTAINER_EVENTS = new Set([
    (0, $5TsWX.GADGET_RENDER_CONTAINER_EVENT)
]);
const $f42b084586d299a2$export$835bb833cb903f59 = (eventSource, contentType = 'View')=>{
    if (eventSource === (0, $5TsWX.WRM_GADGET_METRICS) || eventSource === (0, $5TsWX.FORGE_GADGET_METRICS) || eventSource === (0, $5TsWX.REACT_GADGET_METRICS)) return contentType === 'Config' ? $f42b084586d299a2$var$DEFAULT_WRM_GADGET_CONFIG_EVENTS : (0, $5TsWX.DEFAULT_WRM_GADGET_EVENTS);
    return $f42b084586d299a2$var$IMMEDIATE_FINISH_GADGET_EVENTS;
};
const $f42b084586d299a2$var$isIdle = (gadgetEventRecord)=>{
    if (gadgetEventRecord == null) return false;
    if (gadgetEventRecord.source === (0, $5TsWX.IDLE_GADGET_SOURCE)) return true;
    const eventEntries = Array.from(gadgetEventRecord.events.entries());
    return eventEntries.length === $f42b084586d299a2$var$GADGET_CONTAINER_EVENTS.size && eventEntries.every((entry)=>$f42b084586d299a2$var$GADGET_CONTAINER_EVENTS.has(entry[0]));
};
const $f42b084586d299a2$export$b1f29dd0b70f467b = (events)=>{
    const customMarksMap = {};
    const customMarksList = [];
    events.forEach((event, eventKey)=>{
        const parts = (0, $5TsWX.GADGET_MARK_EVENT_PATTERN).exec(eventKey);
        if (parts == null) return;
        const key = parts[1];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const stage = parts[2];
        const customMark = customMarksMap[key];
        if (customMark == null) {
            const newCustomMark = {
                name: `gadgetMark_${key}`,
                [stage]: event.spaTime
            };
            customMarksMap[key] = newCustomMark;
            customMarksList.push(newCustomMark);
        } else customMark[stage] = event.spaTime;
    });
    return customMarksList;
};
const $f42b084586d299a2$var$getInitialMarks = (context)=>({
        TTI: Date.now() - Number(context.navStart),
        isInitialRender: context.isInitialRender,
        isWritable: context.isWritable,
        isRouteReplaced: context.isRouteReplaced,
        currentPageId: context.currentPageId,
        // TODO should be removed in favour of BM3 pageVisible property
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        pageVisible: !window?.document?.hidden,
        ssrFeatureFlags: $f42b084586d299a2$var$getSSRFeatureFlags(),
        featureFlags: (0, $7cLxq.getDashboardFeatureFlags)(),
        featureGates: (0, $8UDz8.getDashboardFeatureGates)(),
        centralised: true
    });
const $f42b084586d299a2$export$f409d0aa399347ac = (isInitialRender, lastTransitionStartTime, navigationStart)=>{
    const sessionStart = navigationStart != null ? new Date(navigationStart).getTime() : 0;
    return !isInitialRender && lastTransitionStartTime != null ? lastTransitionStartTime : sessionStart;
};
const $f42b084586d299a2$var$isInvalidContextState = (metricsContextTimeStamp, currentNavStart, currentPageId)=>{
    if (metricsContextTimeStamp.currentPageId !== currentPageId) return true;
    if (metricsContextTimeStamp.created < metricsContextTimeStamp.navStart) return true;
    const now = Date.now();
    if (now < metricsContextTimeStamp.navStart) return true;
    if (now < Number(currentNavStart)) return true;
    return false;
};
const $f42b084586d299a2$export$ea517a7cfce02895 = (dashboardId)=>{
    const [{ isInitialRender: isInitialRender, lastTransitionStartTime: lastTransitionStartTime, navigationStart: navigationStart, currentPageId: currentPageId = 'unknown' }] = (0, $bVDE5.useSpaStateTransition)();
    const [{ aboveTheFoldGadgets: aboveTheFoldGadgets }] = (0, $8UPoO.useRenderAboveTheFold)();
    const [routerState] = (0, $doZTA.useRouter)();
    const navStart = $f42b084586d299a2$export$f409d0aa399347ac(isInitialRender, lastTransitionStartTime, navigationStart);
    const dashboardData = (0, $gh1hi.useDashboardResource)().data;
    const { scrollStartTimestamp: scrollStartTimestamp, resetScrollStartTime: resetScrollStartTime } = (0, $hmyfM.useDashboardScrollAnalytics)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const newContext = {
        dashboardId: dashboardId,
        isInitialRender: isInitialRender,
        isRouteReplaced: routerState.action === 'REPLACE',
        lastTransitionStartTime: lastTransitionStartTime,
        navigationStart: navigationStart,
        currentPageId: currentPageId,
        navStart: navStart,
        gadgets: dashboardData?.gadgets,
        isWritable: dashboardData?.writable ?? false,
        scrollStartTimestamp: scrollStartTimestamp,
        aboveTheFoldGadgets: aboveTheFoldGadgets,
        resetScrollStartTime: resetScrollStartTime
    };
    const context = (0, $5uXOq.useRef)(newContext);
    context.current = newContext;
    const sendGadgetMetrics = (0, $5uXOq.useCallback)((gadgetId, gadgetEventRecord)=>{
        if (context.current.navigationStart == null) return;
        const gadgetModel = context.current.gadgets?.find((item)=>item.id === gadgetId) || null;
        // Setup common marks first
        const customMarks = {
            ...$f42b084586d299a2$var$getInitialMarks(context.current),
            timeout: gadgetEventRecord.timedOut === true,
            gadgetContentType: gadgetEventRecord.contentType,
            isAboveTheFold: context.current.aboveTheFoldGadgets.has(gadgetId)
        };
        // Timeout Marks
        if (gadgetEventRecord.timedOut === true) {
            if ($f42b084586d299a2$var$isIdle(gadgetEventRecord)) customMarks.timeout_idle = true;
            else $f42b084586d299a2$export$835bb833cb903f59(gadgetEventRecord.source, gadgetEventRecord.contentType).filter((event)=>!$f42b084586d299a2$var$GADGET_CONTAINER_EVENTS.has(event)).filter((event)=>!gadgetEventRecord.events.has(event)).forEach((event)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                customMarks[`timeout_${event}`] = true;
            });
        }
        if (gadgetEventRecord.source === (0, $5TsWX.WRM_GADGET_METRICS) || gadgetEventRecord.source === (0, $5TsWX.FORGE_GADGET_METRICS) || gadgetEventRecord.source === (0, $5TsWX.REACT_GADGET_METRICS)) {
            customMarks.gadgetType = gadgetModel?.amdModule || gadgetModel?.forge?.key || gadgetModel?.reactKey || (0, $5TsWX.UNKNOWN_GADGET_TYPE);
            const renderContainer = gadgetEventRecord.events.get((0, $5TsWX.GADGET_RENDER_CONTAINER_EVENT));
            const start = gadgetEventRecord.events.get((0, $5TsWX.GADGET_START_EVENT));
            if (renderContainer != null) customMarks.gadgetRenderContainer = renderContainer.spaTime - Number(context.current.navStart);
            if (start != null) {
                customMarks.gadgetStartTime = start.spaTime - Number(context.current.navStart);
                customMarks.gadgetDuration = Date.now() - start.spaTime;
            }
        } else if (gadgetEventRecord.source === (0, $5TsWX.IDLE_GADGET_SOURCE) || gadgetEventRecord.source === (0, $5TsWX.FALLBACK_GADGET_SOURCE)) // The gadget doesn't send any event till timed out
        customMarks.gadgetType = gadgetModel?.amdModule || gadgetModel?.forge?.key || (0, $5TsWX.UNKNOWN_GADGET_TYPE);
        $f42b084586d299a2$export$b1f29dd0b70f467b(gadgetEventRecord.events).forEach((gadgetMark)=>{
            if (gadgetMark.start != null) customMarks[`${gadgetMark.name}-start`] = gadgetMark.start - Number(context.current.navStart);
            if (gadgetMark.start != null && gadgetMark.end != null) customMarks[`${gadgetMark.name}-duration`] = gadgetMark.end - gadgetMark.start;
        });
        const gadgetLoadIdentifier = `gadget-${context.current.dashboardId ?? 'no-dashboard-id'}-${gadgetId}`;
        (0, $trHKK.gadgetLoad)(gadgetLoadIdentifier).start({
            startTime: context.current.navStart
        });
        (0, $trHKK.gadgetLoad)(gadgetLoadIdentifier).stop({
            customData: customMarks,
            stopTime: Date.now()
        });
    }, []);
    const sendOverallGadgetMetrics = (0, $5uXOq.useCallback)((gadgetIds, gadgetMetricsEvents, timeout)=>{
        const metricToReport = {
            timeout: timeout,
            fullDashboardTTI: Date.now() - Number(context.current.navStart),
            dashboardScrollStartTime: context.current.scrollStartTimestamp.current != null ? context.current.scrollStartTimestamp.current - Number(context.current.navStart) : 'unknown',
            belowTheFoldTTI: Date.now() - (context.current.scrollStartTimestamp.current != null && (context.current.gadgets?.length || 0) - context.current.aboveTheFoldGadgets.size > 0 ? context.current.scrollStartTimestamp.current : Date.now())
        };
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'fullDashboard loaded', metricToReport);
    }, [
        createAnalyticsEvent
    ]);
    const onAboveTheFoldGadgetsRender = (0, $5uXOq.useCallback)((gadgetIds, gadgetMetricsEvents, gadgetRenderStartTime, contextTimeStamps, timeout)=>{
        const totalGadgetsCount = context.current.gadgets?.length || 0;
        // count connect gadgets
        const connectGadgetCount = context.current.gadgets?.filter((item)=>(0, $5TsWX.CONNECT_MODULE_PATTERN).test(item.amdModule || '')).length || 0;
        // count forge gadgets
        const forgeGadgetCount = context.current.gadgets?.filter((item)=>(0, $5TsWX.FORGE_MODULE_PATTERN).test(item.forge?.key || '')).length || 0;
        // count internal gadgets
        const internalGadgetCount = totalGadgetsCount - connectGadgetCount - forgeGadgetCount;
        // count untracked gadgets (including connect)
        const untrackedGadgetCount = context.current.gadgets?.filter((item)=>gadgetIds.every((id)=>id !== item.id)).length || 0;
        // count the deprecated gadgets
        const deprecatedGadgetsCount = context.current.gadgets ? context.current.gadgets.filter((gadget)=>(0, $b3IiT.checkGadgetType)((0, $JIPqS.DEPRECATED_GADGETS_MAP), gadget.amdModule)).length : 0;
        const initialMarks = $f42b084586d299a2$var$getInitialMarks(context.current);
        const gadgetRenderStart = gadgetRenderStartTime - Number(context.current.navStart);
        // Validate metrics context
        const invalidContextState = $f42b084586d299a2$var$isInvalidContextState(contextTimeStamps, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        context.current.navStart, context.current.currentPageId) || initialMarks.TTI < 0 || gadgetRenderStart < 0;
        if (invalidContextState) // Report abnormal status
        (0, $2YZCu.default).safeWarnWithoutCustomerData('spa-apps.dashboard.gadget.metrics', `metrics context state is invalid for dashboard [${context.current.currentPageId ?? 'null'}]: { contextTimestamps: ${JSON?.stringify(contextTimeStamps)}, now:${Date.now()}, pnow:${performance?.now()}, navStart:${context.current.navStart} }`);
        const customData = {
            ...initialMarks,
            gadgetRenderStart: gadgetRenderStart,
            // counts
            gadgetCount_Total: totalGadgetsCount,
            gadgetCount_Internal: internalGadgetCount,
            gadgetCount_Connect: connectGadgetCount,
            gadgetCount_Forge: forgeGadgetCount,
            gadgetCount_Unknown: untrackedGadgetCount - connectGadgetCount,
            timeout: timeout,
            gadgetCount_AboveTheFold: context.current.aboveTheFoldGadgets.size,
            gadgetCount_BelowTheFold: totalGadgetsCount - context.current.aboveTheFoldGadgets.size,
            gadgetCount_Deprecated: deprecatedGadgetsCount,
            isStaled: invalidContextState
        };
        (0, $eyWK5.addUFOCustomData)(customData);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $3B7oW.trackBM3FeatureFlagsAccessed)((0, $trHKK.dashboardLoad));
        (0, $lAOer.addApdexToAll)({
            key: (0, $trHKK.dashboardLoad).key,
            stopTime: performance.now()
        });
        (0, $iAWa3.afterPaintEmit)((stopTime)=>{
            (0, $trHKK.dashboardLoad).stop({
                stopTime: stopTime,
                customData: // @ts-expect-error - feature flags may technically be null which BM3 doesn't like
                customData
            });
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $trHKK.dashboardLoad));
    }, []);
    const resetScrollStartMetrics = (0, $5uXOq.useCallback)(()=>{
        context.current.resetScrollStartTime();
    }, []);
    const sendDebuggingAnalytics = (0, $5uXOq.useCallback)((contextTimeStamps)=>{
        const attributes = {
            isStale: $f42b084586d299a2$var$isInvalidContextState(contextTimeStamps, context.current.navStart, context.current.currentPageId),
            tti: Date.now() - Number(context.current.navStart),
            currentPageId: context.current.currentPageId
        };
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'tti sent', attributes);
    }, [
        createAnalyticsEvent
    ]);
    return {
        sendGadgetMetrics: sendGadgetMetrics,
        sendOverallGadgetMetrics: sendOverallGadgetMetrics,
        onAboveTheFoldGadgetsRender: onAboveTheFoldGadgetsRender,
        resetScrollStartMetrics: resetScrollStartMetrics,
        sendDebuggingAnalytics: sendDebuggingAnalytics
    };
};

});
parcelRegister("iAWa3", function(module, exports) {

$parcel$export(module.exports, "afterPaintEmit", () => $8ad29d98765af503$export$dc4c3408669b8f4e);

var $x9xyg = parcelRequire("x9xyg");

const $8ad29d98765af503$export$dc4c3408669b8f4e = (emitMetrics, metric)=>{
    const stopTime = performance.now();
    setTimeout(()=>{
        metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
        (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
        setTimeout(()=>{
            emitMetrics(stopTime);
        }, 500);
    });
};

});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $32M8E = parcelRequire("32M8E");

var $y7eb2 = parcelRequire("y7eb2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $32M8E.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});

parcelRegister("7cLxq", function(module, exports) {

$parcel$export(module.exports, "getDashboardFeatureFlags", () => $9b049cc4dacaaa3a$export$5f260d38da0c0462);
/**
 * Feature flags convention: go/frontend-feature-flags
 */ 
var $8QpSo = parcelRequire("8QpSo");

var $y7eb2 = parcelRequire("y7eb2");
// IMPORTANT - endeavour dashboard flags should match schema, this is primarily for other teams FFs
const $9b049cc4dacaaa3a$var$DASHBOARD_ADDITIONAL_FLAGS = [];
const $9b049cc4dacaaa3a$var$DASHBOARD_FEATURE_FLAG_SCHEMA = /^endeavour\.(spa|dashboard|gadget)\.[\w-]+$/;
const $9b049cc4dacaaa3a$export$5f260d38da0c0462 = (0, $8QpSo.default)(()=>{
    // at time of writing getFeatureFlags() will throw for badly formed feature flag JSON
    try {
        const allFFs = (0, $y7eb2.default)() || {};
        return Object.fromEntries(Object.keys(allFFs).filter((key)=>$9b049cc4dacaaa3a$var$DASHBOARD_FEATURE_FLAG_SCHEMA.test(key) || $9b049cc4dacaaa3a$var$DASHBOARD_ADDITIONAL_FLAGS.includes(key)).sort((a, b)=>a.localeCompare(b, undefined, {
                ignorePunctuation: true
            })).map((key)=>[
                key,
                allFFs[key].value
            ]));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return null;
    }
});

});

parcelRegister("8UDz8", function(module, exports) {

$parcel$export(module.exports, "getDashboardFeatureGates", () => $0c1208fe9722c23a$export$7cf9f66e85966b7);

var $8QpSo = parcelRequire("8QpSo");

var $4R6GH = parcelRequire("4R6GH");
const $0c1208fe9722c23a$export$7cf9f66e85966b7 = (0, $8QpSo.default)(()=>({
        endeavour_nin_assigned_to_me_gadget: (0, $4R6GH.fg)('endeavour_nin_assigned_to_me_gadget'),
        endeavour_nin_issues_in_progress_gadget: (0, $4R6GH.fg)('endeavour_nin_issues_in_progress_gadget'),
        endeavour_nin_filter_results_gadget: (0, $4R6GH.fg)('endeavour_nin_filter_results_gadget'),
        endeavour_nin_watched_issues_gadget: (0, $4R6GH.fg)('endeavour_nin_watched_issues_gadget'),
        endeavour_nin_voted_issues_gadget: (0, $4R6GH.fg)('endeavour_nin_voted_issues_gadget'),
        endeavour_gadget_deprecation_banner_v1: (0, $4R6GH.fg)('endeavour_gadget_deprecation_banner_v1'),
        endeavour_gadget_deprecation_remove_functionality: (0, $4R6GH.fg)('endeavour_gadget_deprecation_remove_functionality')
    }));

});

parcelRegister("trHKK", function(module, exports) {

$parcel$export(module.exports, "gadgetLoad", () => $b46e477904ae8756$export$4de73f6aec94634c);
$parcel$export(module.exports, "dashboardLoad", () => $b46e477904ae8756$export$2b2c4cbb9844d8cb);

var $2nKjG = parcelRequire("2nKjG");
const $b46e477904ae8756$export$4de73f6aec94634c = (0, $2nKjG.metrics).concurrent.custom({
    key: 'dashboard.gadget',
    featureFlags: []
});
const $b46e477904ae8756$export$2b2c4cbb9844d8cb = (0, $2nKjG.metrics).pageLoad({
    key: 'dashboard',
    featureFlags: []
});

});

parcelRegister("hmyfM", function(module, exports) {

$parcel$export(module.exports, "useDashboardScrollAnalytics", () => $03a594e6b9b8c3c6$export$83af525d5e7538fa);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $eNjJm = parcelRequire("eNjJm");

var $bVDE5 = parcelRequire("bVDE5");
const $03a594e6b9b8c3c6$export$83af525d5e7538fa = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const currentPage = (0, $eNjJm.useCurrentPage)();
    const [{ isInitialRender: isInitialRender, currentPageId: currentPageId }] = (0, $bVDE5.useSpaStateTransition)();
    const { startTime: startTime } = currentPage;
    const scrollStartTimestamp = (0, $5uXOq.useRef)(null);
    const debounceSendAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((_scrollStartTimestamp)=>{
        if (scrollStartTimestamp.current != null) return;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const percentageOfPageScrolled = window.scrollY / window.innerHeight;
        if (percentageOfPageScrolled < 0.2) return;
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'scrolled',
            actionSubject: 'page'
        }), 'dashboardScroll', {
            isInitialRender: isInitialRender,
            scrollStartTimeFromPageLoad: _scrollStartTimestamp - startTime,
            percentageOfPageScrolled: percentageOfPageScrolled,
            currentPageId: currentPageId
        });
        scrollStartTimestamp.current = _scrollStartTimestamp;
    }, 500);
    (0, $5uXOq.useEffect)(()=>{
        const fireScrollAnalytics = ()=>{
            debounceSendAnalytics(Date.now());
        };
        const resetScrollPosition = ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.scrollTo(0, 0);
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('scroll', fireScrollAnalytics);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('unload', resetScrollPosition);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('scroll', fireScrollAnalytics);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('unload', resetScrollPosition);
        };
    }, [
        debounceSendAnalytics
    ]);
    const resetScrollStartTime = (0, $5uXOq.useCallback)(()=>{
        scrollStartTimestamp.current = null;
    }, []);
    return {
        scrollStartTimestamp: scrollStartTimestamp,
        resetScrollStartTime: resetScrollStartTime
    };
};

});
parcelRegister("eNjJm", function(module, exports) {

$parcel$export(module.exports, "useCurrentPage", () => $a69ad6f74a66de9c$export$6faff8ed5e305ed3);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");

var $7w9eZ = parcelRequire("7w9eZ");
const $a69ad6f74a66de9c$var$useSweetStateCurrentPage = (0, $3sQ5x.createHook)((0, $7w9eZ.default), {
    selector: (state)=>state.currentPage
});
const $a69ad6f74a66de9c$export$6faff8ed5e305ed3 = ()=>{
    const [currentPage] = $a69ad6f74a66de9c$var$useSweetStateCurrentPage();
    return currentPage;
};

});



parcelRegister("gW6vr", function(module, exports) {

$parcel$export(module.exports, "GADGETS_TO_REPORT", () => $a70b755fbe2a81b5$export$2c28b0760818db72);
$parcel$export(module.exports, "GADGETS_IGNORED", () => $a70b755fbe2a81b5$export$c1d730ac3dcf5785);
// A list of gadgets (gadgetType) should contribute to the overall dashboard TTI.
// Some gadgets not in this list may not send metrics event to the dashboard and potentially hold up the dashboard
// metrics until 60 second timeout.
const $a70b755fbe2a81b5$export$2c28b0760818db72 = new Set([
    // WRM gadgets
    'jira-dashboard-items/assigned-to-me',
    'jira-dashboard-items/bubble-chart-dashboard-item',
    'jira-dashboard-items/createdvsresolved',
    'jira-dashboard-items/favourite-filters',
    'jira-dashboard-items/filter-results',
    'jira-dashboard-items/in-progress',
    'jira-dashboard-items/labels',
    'jira-dashboard-items/piechart',
    'jira-dashboard-items/stats',
    'jira-dashboard-items/two-dimensional-stats',
    'jira-dashboard-items/voted',
    'jira-dashboard-items/watched',
    'jira-dashboard-items/issuescalendar',
    'jira-dashboard-items/projects',
    'jira-dashboard-items/activitystream',
    'jira-dashboard-items/recently-created',
    'jira-dashboard-items/workload-pie-chart',
    'jira-dashboard-items/roadmap',
    'jira-dashboard-items/average-age-chart',
    'jira-dashboard-items/average-time-in-status-chart',
    'jira-dashboard-items/average-number-of-times-in-status-chart',
    'jira-dashboard-items/heat-map',
    'jira-dashboard-items/time-to-first-response',
    'jira-dashboard-items/sprint-burndown',
    'jira-dashboard-items/resolution-time',
    'jira-dashboard-items/timesince',
    'jira-dashboard-items/spacer',
    'jira-dashboard-items/rapid-view',
    'jira-dashboard-items/version-report',
    // simple iframe gadgets
    'rest/gadgets/1.0/g/com.atlassian.bonfire.plugin:bonfire-test-sessions-gadget/gadget/bonfire-sessions-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.ext.calendar:issuescalendar-gadget/templates/plugins/jira/portlets/calendar/gadget/calendar-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.ext.charting:firstresponse-gadget/com/atlassian/jira/ext/charting/gadget/firstresponse-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.ext.charting:numberoftimesinstatus-gadget/com/atlassian/jira/ext/charting/gadget/numberoftimesinstatus-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.ext.charting:timeinstatus-gadget/com/atlassian/jira/ext/charting/gadget/timeinstatus-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.ext.charting:workloadpie-gadget/com/atlassian/jira/ext/charting/gadget/workloadpie-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:average-age-chart-gadget/gadgets/average-age-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:heat-map-gadget/gadgets/heatmap-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:project-gadget/gadgets/project-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:recently-created-chart-gadget/gadgets/recently-created-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:resolution-time-gadget/gadgets/resolution-time-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:road-map-gadget/gadgets/roadmap-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:time-since-chart-gadget/gadgets/timesince-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jirafisheyeplugin:crucible-charting-gadget/gadgets/crucible-charting-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jirafisheyeplugin:fisheye-charting-gadget/gadgets/fisheye-charting-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jirafisheyeplugin:fisheye-recent-commits-gadget/gadgets/fisheye-recent-commits-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jirawallboard.atlassian-wallboard-plugin:spacer-gadget/gadgets/spacerGadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.streams.streams-jira-plugin:activitystream-gadget/gadgets/activitystream-gadget.xml',
    'rest/gadgets/1.0/g/com.pyxis.greenhopper.jira:greenhopper-gadget-rapid-view/gadgets/greenhopper-rapid-view.xml',
    'rest/gadgets/1.0/g/com.pyxis.greenhopper.jira:greenhopper-gadget-sprint-burndown/gadgets/greenhopper-sprint-burndown.xml',
    'rest/gadgets/1.0/g/com.pyxis.greenhopper.jira:greenhopper-gadget-version-report/gadgets/greenhopper-version-report.xml'
]);
const $a70b755fbe2a81b5$export$c1d730ac3dcf5785 = new Set([
    'jira-dashboard-items/sprint-days-remaining',
    'jira-dashboard-items/sprint-health',
    'servicedesk/internal/reports/feature/custom-report-dashboard-item/custom-report-dashboard-item',
    'servicedesk/internal/dashboard-items/filter/filter-dashboard-item'
]);

});


parcelRegister("h5Jym", function(module, exports) {

$parcel$export(module.exports, "useSpaStatePageReady", () => $80ca19e1fa573e80$export$ea2491906b753456);

var $5uXOq = parcelRequire("5uXOq");

var $x9xyg = parcelRequire("x9xyg");

var $JIPqS = parcelRequire("JIPqS");

var $gh1hi = parcelRequire("gh1hi");

var $4oDnX = parcelRequire("4oDnX");

var $i0rkS = parcelRequire("i0rkS");
const $80ca19e1fa573e80$var$isAmdGadget = (gadget)=>gadget.amdModule != null && gadget.amdModule !== (0, $JIPqS.CONNECT_ITEM_AMD_MODULE);
const $80ca19e1fa573e80$var$isWaitableGadget = (gadget)=>$80ca19e1fa573e80$var$isAmdGadget(gadget);
const $80ca19e1fa573e80$var$getWaitableGadgetSet = (gadgets)=>new Set(gadgets.filter($80ca19e1fa573e80$var$isWaitableGadget).map(({ id: id })=>id));
const $80ca19e1fa573e80$export$ea2491906b753456 = ()=>{
    const { data: data, loading: loading } = (0, $gh1hi.useDashboardResource)();
    const [, { registerListener: registerListener, unregisterListener: unregisterListener }] = (0, $i0rkS.useMessageBus)();
    const lastDashboardId = (0, $5uXOq.useRef)();
    const pendingGadgetSet = (0, $5uXOq.useRef)(new Set());
    const [, { setAppReady: setAppReady }] = (0, $4oDnX.useSpaStateActions)();
    const callback = (0, $5uXOq.useCallback)((type, _, { gadgetId: gadgetId })=>{
        if (type !== (0, $JIPqS.GADGET_METRICS_TYPE).REPORT) return;
        if (!pendingGadgetSet.current.has(gadgetId)) return;
        pendingGadgetSet.current.delete(gadgetId);
        if (pendingGadgetSet.current.size > 0) return;
        unregisterListener(callback);
        (0, $x9xyg.setMark)((0, $JIPqS.PAGE_READY_METRIC_KEY));
        setAppReady();
    }, [
        setAppReady,
        unregisterListener
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (loading || data == null || data.id === lastDashboardId.current) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        lastDashboardId.current = data.id;
        pendingGadgetSet.current = $80ca19e1fa573e80$var$getWaitableGadgetSet(data.gadgets);
        if (pendingGadgetSet.current.size === 0) {
            (0, $x9xyg.setMark)((0, $JIPqS.PAGE_READY_METRIC_KEY));
            setAppReady();
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        registerListener(callback);
        return ()=>{
            unregisterListener(callback);
        };
    }, [
        callback,
        data,
        loading,
        registerListener,
        setAppReady,
        unregisterListener
    ]);
};

});

parcelRegister("5jJ3W", function(module, exports) {

$parcel$export(module.exports, "addDashboardToRecents", () => $f6e4dfdb0385e67e$export$9f034829a82f8a11);
const $f6e4dfdb0385e67e$export$9f034829a82f8a11 = (dashboardId)=>fetch(`/rest/internal/latest/dashboards/history/${dashboardId}`, {
        method: 'POST'
    });

});

parcelRegister("8CCTB", function(module, exports) {

$parcel$export(module.exports, "getErrorCode", () => $f10972789d3e7859$export$ab5c47d1a2f2c859);
const $f10972789d3e7859$export$ab5c47d1a2f2c859 = (error)=>{
    if (error && typeof error.message === 'string') return Number(error?.message?.substring(error.message.length - 3));
    return null;
};

});

parcelRegister("1Bx5m", function(module, exports) {

$parcel$export(module.exports, "AboveTheFoldContainer", () => $c6a764536e1ff0c0$export$60c1d52f3e30a1cd);

var $5uXOq = parcelRequire("5uXOq");

var $8UPoO = parcelRequire("8UPoO");

var $1oaeD = parcelRequire("1oaeD");

var $6fab6 = parcelRequire("6fab6");
const $c6a764536e1ff0c0$export$60c1d52f3e30a1cd = ({ gadgets: gadgets, dashboardId: dashboardId, layout: layout, children: children })=>{
    const { getMaximisedGadgetId: getMaximisedGadgetId } = (0, $1oaeD.useMaximizedGadget)(gadgets);
    const columns = (0, $5uXOq.useMemo)(()=>(0, $6fab6.toColumns)(gadgets, layout), [
        gadgets,
        layout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8UPoO.RenderAboveTheFoldContainer), {
        columns: columns,
        dashboardId: dashboardId,
        scope: dashboardId,
        maximizedGadgetId: getMaximisedGadgetId
    }, children);
};

});

parcelRegister("7v0Ei", function(module, exports) {

$parcel$export(module.exports, "AmdGadgetMonolithOverrideStyles", () => $c5037e48649c048f$export$17921465e6f60e58);

var $5uXOq = parcelRequire("5uXOq");
const $c5037e48649c048f$var$styles = `.piechart-gadget .piechart-fill {
    opacity: 1
}

.piechart-gadget .legend-icon {
    float: left;
    margin-top: 2px;
    margin-right: 10px
}


.piechart-gadget a {
    color: #0052cc;
    text-decoration: none;
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-size: 14px;
    font-weight: ${"var(--ds-font-weight-regular, 400)"};
    line-height: 20px
}

.piechart-gadget a:focus,.piechart-gadget a:hover {
    color: #0065ff;
    text-decoration: underline
}

.piechart-gadget a:active {
    color: #0049b0;
    text-decoration: underline
}

.piechart-gadget .legend-wrapper {
    padding: 0 7px 7px 7px;
    max-width: 450px
}

.piechart-gadget .legend-wrapper a {
    text-decoration: none;
    color: ${"var(--ds-text, #172B4D)"};
}

.piechart-gadget .legend-wrapper a:focus,.piechart-gadget .legend-wrapper a:hover {
    color: ${"var(--ds-link, #0C66E4)"};
    text-decoration: underline
}

.piechart-gadget .legend-wrapper a:active {
    color: ${"var(--ds-text, #172B4D)"};
    text-decoration: underline
}

.piechart-gadget .legend-wrapper .legend-item {
    border-top-width: 0;
    border-bottom-width: 0
}

.piechart-gadget .legend-wrapper .legend-item:first-child {
    border-top: 2px solid ${"var(--ds-border-accent-gray, #758195)"};
}

.piechart-gadget .legend-wrapper .legend-item:last-child {
    border-bottom: 2px solid ${"var(--ds-border-accent-gray, #758195)"};
}

.piechart-gadget .legend-wrapper .legend-item .legend-content {
    padding: 8px 7px 8px 7px
}

.piechart-gadget .legend-wrapper .legend-item .legend-content .legend-item-value {
    padding-right: 7px
}

.two-d-container .extra-container {
    padding: 0
}

.two-d-container .extra-container tbody tr:last-child>td,.two-d-container .extra-container tbody tr:last-child>th,.two-d-container .extra-container tbody tr:last-child>tr,.two-d-container .extra-container tbody tr>td:last-child {
    padding: 7px;
    background: ${"var(--ds-background-neutral, #091E420F)"};
}

.two-d-container .data-footer {
    padding: 5px
}

.two-d-container .data-footer p {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: ${"var(--ds-text-subtle, #44546F)"};
    font-size: 14px;
    font-weight: ${"var(--ds-font-weight-regular, 400)"};
    line-height: 20px
}

table.aui thead tr th {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #5e6c84;
    font-size: 12px;
    font-weight: ${"var(--ds-font-weight-semibold, 600)"};
    line-height: 16px;
    padding-top: 4px;
    padding-bottom: 4px
}

table.aui thead .aui-iconfont-up {
    visibility: hidden
}

table.aui thead .aui-iconfont-up:after {
    top: 11px;
    margin-left: -16px;
    content: "";
    display: inline-block;
    width: 4px;
    height: 4px;
    border: none;
    border-right: 2px solid;
    border-top: 2px solid;
    transform: rotate(-45deg);
    visibility: visible;
    float: right;
    position: relative;
    top: 8px
}

table.aui thead .aui-iconfont-down {
    visibility: hidden
}

table.aui thead .aui-iconfont-down:after {
    top: 11px;
    margin-left: -16px;
    content: "";
    display: inline-block;
    width: 4px;
    height: 4px;
    border: none;
    border-right: 2px solid;
    border-top: 2px solid;
    transform: rotate(135deg);
    visibility: visible;
    float: right;
    position: relative;
    top: 6px
}

table.aui tbody:before {
    height: 0
}

table.aui tbody a {
    text-decoration: none;
    color: ${"var(--ds-link, #0C66E4)"};
}

table.aui tbody a:focus,table.aui tbody a:hover {
    color: ${"var(--ds-link, #0C66E4)"};
    text-decoration: underline
}

table.aui tbody a:active {
    color: ${"var(--ds-link, #0C66E4)"};
    text-decoration: underline
}

table.aui tbody>tr:hover {
    background: #ebecf0
}

table.aui tbody>tr>td:last-child {
    border-left-width: 0
}

table.aui tbody>tr>th {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-size: 14px;
    font-weight: ${"var(--ds-font-weight-regular, 400)"};
    line-height: 20px
}

table.aui tbody>tr:first-child>th {
    border-top-width: 0
}

.stats-gadget {
    padding: 0
}

.stats-gadget tbody a {
    color: #0052cc;
    text-decoration: none;
    color: #5e6c84
}

.stats-gadget tbody a:focus,.stats-gadget tbody a:hover {
    color: #0065ff;
    text-decoration: underline
}

.stats-gadget tbody a:active {
    color: #0049b0;
    text-decoration: underline
}

.stats-gadget tbody tr>td .aui-progress-indicator-value {
    background: #0065ff
}

.stats-gadget tbody tr.stats-gadget-final-row>* {
    font-weight: ${"var(--ds-font-weight-regular, 400)"};
    background: #ebecf0
}

.stats-gadget tbody td {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-size: 14px;
    font-weight: ${"var(--ds-font-weight-regular, 400)"};
    line-height: 20px
}

.stats-gadget tbody:last-child>td,.stats-gadget tbody:last-child>th {
    padding: 7px
}

.favourite-filters-item {
    padding: 0
}

.favourite-filters-item .favourite-filters-view {
    border-top: 2px solid #dfe1e6
}

.favourite-filters-item tbody>tr:first-child td {
    border-top-width: 1px
}

.favourite-filters-item .config-options,.favourite-filters-item .empty-container {
    padding: 6px 0 0 7px
}

.favourite-filters-item .config-options .operations-list .aui-button:first-child,.favourite-filters-item .config-options .operations-list li:first-child,.favourite-filters-item .config-options>div .aui-button:first-child,.favourite-filters-item .config-options>div li:first-child,.favourite-filters-item .empty-container .operations-list .aui-button:first-child,.favourite-filters-item .empty-container .operations-list li:first-child,.favourite-filters-item .empty-container>div .aui-button:first-child,.favourite-filters-item .empty-container>div li:first-child {
    display: none
}

.favourite-filters-item .config-options .operations-list .aui-button:nth-child(2),.favourite-filters-item .config-options>div .aui-button:nth-child(2),.favourite-filters-item .empty-container .operations-list .aui-button:nth-child(2),.favourite-filters-item .empty-container>div .aui-button:nth-child(2) {
    margin-left: 0;
    padding-left: 0
}

.favourite-filters-item .config-options .operations-list a,.favourite-filters-item .config-options>div a,.favourite-filters-item .empty-container .operations-list a,.favourite-filters-item .empty-container>div a {
    color: #0052cc;
    text-decoration: none;
    color: #5e6c84
}

.favourite-filters-item .config-options .operations-list a:focus,.favourite-filters-item .config-options .operations-list a:hover,.favourite-filters-item .config-options>div a:focus,.favourite-filters-item .config-options>div a:hover,.favourite-filters-item .empty-container .operations-list a:focus,.favourite-filters-item .empty-container .operations-list a:hover,.favourite-filters-item .empty-container>div a:focus,.favourite-filters-item .empty-container>div a:hover {
    color: #0065ff;
    text-decoration: underline
}

.favourite-filters-item .config-options .operations-list a:active,.favourite-filters-item .config-options>div a:active,.favourite-filters-item .empty-container .operations-list a:active,.favourite-filters-item .empty-container>div a:active {
    color: #0049b0;
    text-decoration: underline
}

.createdvsresolved-gadget {
    padding: 0
}

.createdvsresolved-gadget a {
    color: #0052cc;
    text-decoration: none;
    color: #5e6c84
}

.createdvsresolved-gadget a:focus,.createdvsresolved-gadget a:hover {
    color: #0065ff;
    text-decoration: underline
}

.createdvsresolved-gadget a:active {
    color: #0049b0;
    text-decoration: underline
}

.createdvsresolved-gadget .createdvsresolved-chart text {
    fill: #091e42
}

.createdvsresolved-gadget .createdvsresolved-chart .grid line,.createdvsresolved-gadget .createdvsresolved-chart .versions line {
    stroke: #dfe1e6
}

.createdvsresolved-gadget .createdvsresolved-chart .created path,.createdvsresolved-gadget .createdvsresolved-chart .created-points circle {
    stroke: #ff5630
}

.createdvsresolved-gadget .createdvsresolved-chart .resolved path,.createdvsresolved-gadget .createdvsresolved-chart .resolved-points circle {
    stroke: #36b37e
}

.createdvsresolved-gadget .createdvsresolved-chart-info {
    padding-left: 7px
}

.createdvsresolved-gadget .createdvsresolved-chart-details-link {
    display: block;
    margin-left: 0
}

.createdvsresolved-gadget .createdvsresolved-chart-details-grouping {
    margin-left: 0
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .created-totals svg {
    padding-bottom: 2px
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .created-totals svg circle {
    stroke: #ff5630
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .resolved-totals svg {
    padding-bottom: 2px
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .resolved-totals svg circle {
    stroke: #36b37e
}`;
const $c5037e48649c048f$export$17921465e6f60e58 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", null, $c5037e48649c048f$var$styles);

});

parcelRegister("fxC6K", function(module, exports) {

$parcel$export(module.exports, "DASHBOARD_PERMISSION_ERROR_CODE_LIST", () => $525e26e500bd2620$export$f33202be19a062b9);
// NOTE: Avoid modifying code `401` as this is used by wallboard and permission error pages (search DASHBOARD_PERMISSION_ERROR_CODE_LIST for usages).
// Wallboard does not reference this list directly because there are import issues, so it uses `401` as a string.
const $525e26e500bd2620$export$f33202be19a062b9 = [
    401,
    403,
    404,
    429
];

});

parcelRegister("kUwqK", function(module, exports) {

$parcel$export(module.exports, "usePageStatusLogger", () => $994ab79b91cbaa2e$export$8b3b053e4f10e669);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");


var $bVDE5 = parcelRequire("bVDE5");

var $bOnpg = parcelRequire("bOnpg");

var $7cLxq = parcelRequire("7cLxq");
const $994ab79b91cbaa2e$var$TEN_MIN = 600000;
// We need to replace '.' in FF keys with '_' to match BM3 and avoid confusion in Splunk
const $994ab79b91cbaa2e$var$sanitiseKeys = (featureFlags)=>Object.fromEntries(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(featureFlags || {}).map(([key, value])=>[
            key.replace(/\./g, '_'),
            value
        ]));
const $994ab79b91cbaa2e$export$8b3b053e4f10e669 = (interval)=>{
    const fireAnalytics = (0, $bOnpg.useDashboardAnalytics)();
    const [{ isInitialRender: isInitialRender, currentPageId: currentPageId, lastTransition: lastTransition }] = (0, $bVDE5.useSpaStateTransition)();
    (0, $5uXOq.useEffect)(()=>{
        const logFeatureFlags = ()=>{
            const featureFlags = JSON.stringify($994ab79b91cbaa2e$var$sanitiseKeys((0, $7cLxq.getDashboardFeatureFlags)()));
            const attributes = {
                isInitialRender: isInitialRender,
                lastTransition: lastTransition,
                currentPageId: currentPageId,
                featureFlags: featureFlags
            };
            (0, $2YZCu.default).safeInfoWithoutCustomerData('spa-apps.dashboard.page-status', Object.entries(attributes) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map(([k, v])=>`${k} [${String(v ?? null)}]`).join(' '));
            fireAnalytics({
                eventType: (0, $4d5e0871c06cee03$export$12346a674644c156),
                actionSubject: 'dashboard.page-status',
                actionSubjectId: 'featureFlags',
                action: 'logged',
                attributes: attributes
            });
        };
        logFeatureFlags();
        const logInterval = setInterval(logFeatureFlags, Math.max($994ab79b91cbaa2e$var$TEN_MIN, interval) || $994ab79b91cbaa2e$var$TEN_MIN);
        return ()=>clearInterval(logInterval);
    }, [
        interval,
        fireAnalytics,
        isInitialRender,
        currentPageId,
        lastTransition
    ]);
};

});

parcelRegister("hwuTz", function(module, exports) {

$parcel$export(module.exports, "RouteResourceValidator", () => $79eff52e66ba4eb8$export$1d8835c03b47dfbd);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");

var $gh1hi = parcelRequire("gh1hi");

var $bVDE5 = parcelRequire("bVDE5");
const $79eff52e66ba4eb8$export$1d8835c03b47dfbd = ()=>{
    const [{ isInitialRender: isInitialRender }] = (0, $bVDE5.useSpaStateTransition)();
    const { promise: promise, loading: loading, data: data, error: error } = (0, $gh1hi.useDashboardAMDModulesResource)();
    const [hasRendered, setHasRendered] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (!loading) setHasRendered(true);
    }, [
        loading
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (false) return;
        const prefix = `Resource validation [${isInitialRender ? 'initial' : 'transition'}][${hasRendered ? 'rerender' : 'original'}]`;
        if (!promise) (0, $2YZCu.default).safeErrorWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} failed, AMD resource may be missing`);
        else if (loading) (0, $2YZCu.default).safeInfoWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} loading`);
        else if (data) {
            const { amdModules: amdModules, sharedValue: sharedValue } = data;
            if (sharedValue == null || sharedValue instanceof Error) (0, $2YZCu.default).safeErrorWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} failed, AMD resource shared value [${String(sharedValue)}]`);
            else if (!sharedValue?.isPreloaded && isInitialRender && !hasRendered) (0, $2YZCu.default).safeErrorWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} failed, config+wrm resource did not run in SSR`);
            else if (amdModules === null) (0, $2YZCu.default).safeErrorWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} failed, WRM resources failed to load`);
            else {
                const [failedCount, totalCount] = Object.values(amdModules).reduce(([f], v, i, arr)=>[
                        f + (v == null ? 1 : 0),
                        arr.length
                    ], [
                    0,
                    0
                ]);
                if (failedCount > 0) {
                    const failedNames = Object.entries(amdModules).filter(([, v])=>v == null).map(([k])=>k).join(',');
                    (0, $2YZCu.default).safeErrorWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} failed, AMD evaluation failed [${failedCount}] of [${totalCount}], failed modules [${failedNames}]`);
                } else (0, $2YZCu.default).safeInfoWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} success`);
            }
        } else if (error) (0, $2YZCu.default).safeErrorWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} failed with AMD resource error [${error instanceof Error ? error.message : String(error)}]`, error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        promise,
        loading,
        data,
        error
    ]);
    return null;
};

});


parcelRegister("h7J1E", function(module, exports) {

$parcel$export(module.exports, "useGadgetTitle", () => $9f983f20098b68ef$export$dba832fc7432cba1);
$parcel$export(module.exports, "useConnectGadgetTitles", () => $9f983f20098b68ef$export$66e677fcbdac9c95);

var $5uXOq = parcelRequire("5uXOq");
function $9f983f20098b68ef$export$dba832fc7432cba1({ defaultTitle: initialDefaultTitle, title: title, onSave: onSave }) {
    const [defaultTitle, setDefaultTitle] = (0, $5uXOq.useState)(initialDefaultTitle);
    const [userTitle, setUserTitle] = (0, $5uXOq.useState)(title);
    const setTitle = (0, $5uXOq.useCallback)(async (newTitle)=>{
        const previousTitle = userTitle;
        setUserTitle(newTitle);
        onSave?.(newTitle).catch(()=>{
            setUserTitle(previousTitle);
        });
    }, [
        userTitle,
        onSave
    ]);
    const setDefaultTitleWithInitialTitle = (0, $5uXOq.useCallback)((defaultTitleUpdaterOrValue)=>{
        setDefaultTitle(typeof defaultTitleUpdaterOrValue === 'function' ? defaultTitleUpdaterOrValue(initialDefaultTitle) : defaultTitleUpdaterOrValue);
    }, [
        initialDefaultTitle
    ]);
    return {
        title: userTitle || defaultTitle,
        setDefaultTitle: setDefaultTitleWithInitialTitle,
        setTitle: setTitle
    };
}
const $9f983f20098b68ef$export$66e677fcbdac9c95 = ()=>{
    const [connectGadgets, setConnectGadgets] = (0, $5uXOq.useState)({});
    const registerConnectGadget = (0, $5uXOq.useCallback)((id, setTitle)=>{
        setConnectGadgets((gadgets)=>({
                ...gadgets,
                [id]: setTitle
            }));
    }, []);
    const unregisterConnectGadget = (0, $5uXOq.useCallback)((id)=>{
        setConnectGadgets((gadgets)=>{
            const { [id]: _, ...rest } = gadgets;
            return rest;
        });
    }, []);
    const setCustomTitle = (0, $5uXOq.useCallback)((id, title)=>{
        const setTitle = connectGadgets[id];
        if (!setTitle) throw new Error(`Unable to set custom title on Connect gadget. No gadget with id ${id} found. Available ids: ${Object.keys(connectGadgets).join(', ')}`);
        return setTitle(title);
    }, [
        connectGadgets
    ]);
    return {
        registerConnectGadget: registerConnectGadget,
        setCustomTitle: setCustomTitle,
        unregisterConnectGadget: unregisterConnectGadget
    };
};

});

parcelRegister("dWAHS", function(module, exports) {

$parcel$export(module.exports, "RightPanelLayoutContainer", () => $dd693cdfa657686b$export$b0b99b1b479c37c2);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2GZKW = parcelRequire("2GZKW");
var $2s57o = parcelRequire("2s57o");


var $gwIPs = parcelRequire("gwIPs");

var $GQeXq = parcelRequire("GQeXq");
const $dd693cdfa657686b$var$RIGHT_PANEL_WIDTH = (0, $gwIPs.gridSize) * 46;
const $dd693cdfa657686b$export$b0b99b1b479c37c2 = ({ isOpenByDefault: isOpenByDefault = false, defaultPanelId: defaultPanelId, rightContent: rightContent, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $GQeXq.RightPanelContainer), {
        isOpenByDefault: isOpenByDefault,
        defaultPanelId: defaultPanelId,
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dd693cdfa657686b$var$Panels, {
        rightContent: rightContent
    }, children));
// `useRightPanelState` needs to be called from inside `RightPanelContainer` to ensure the value of isOpen is
// set correctly on initial render (otherwise it defaults to false), so we need a separate component here.
const $dd693cdfa657686b$var$Panels = ({ rightContent: rightContent, children: children })=>{
    const { isOpen: isRightPanelOpen } = (0, $GQeXq.useRightPanelState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2GZKW.default), {
        templateColumns: isRightPanelOpen ? `1fr ${$dd693cdfa657686b$var$RIGHT_PANEL_WIDTH}px` : '1fr 0',
        gap: isRightPanelOpen ? 'space.500' : 'space.0',
        xcss: $dd693cdfa657686b$var$gridStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $dd693cdfa657686b$var$leftPanelStyles
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        as: "aside",
        xcss: $dd693cdfa657686b$var$rightPanelStyles
    }, rightContent));
};
const $dd693cdfa657686b$var$rightPanelStyles = (0, $2s57o.xcss)({
    position: 'sticky',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: `calc(${(0, $81918a2ef6db1f93$export$d60454526e2281af)})`,
    alignSelf: 'start',
    marginRight: 'space.negative.400'
});
const $dd693cdfa657686b$var$leftPanelStyles = (0, $2s57o.xcss)({
    minWidth: '0'
});
const $dd693cdfa657686b$var$gridStyles = (0, $2s57o.xcss)({
    transition: 'grid-template-columns 300ms cubic-bezier(0.2, 0, 0, 1) 0s'
});

});
// We need to move away from using these variables directly as it results in a brittle hard to evolve system.
// This doesn't use @atlassian/jira-navigation-system as it results in a hard-to-debug cycle.
// These variables are inlined to reduce TS Complexity - Please reach out to #help-jfp-squads if you need more information.
const $81918a2ef6db1f93$var$UNSAFE_DO_NOT_USE_BANNER_HEIGHT = 'var(--bannerHeight, 0px)';
const $81918a2ef6db1f93$var$UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT = 'var(--topNavigationHeight, 0px)';
const $81918a2ef6db1f93$export$638757b621fbf475 = `${$81918a2ef6db1f93$var$UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT} + ${$81918a2ef6db1f93$var$UNSAFE_DO_NOT_USE_BANNER_HEIGHT}`;
const $81918a2ef6db1f93$export$d60454526e2281af = `(${$81918a2ef6db1f93$export$638757b621fbf475})`;

parcelRegister("GQeXq", function(module, exports) {

$parcel$export(module.exports, "useRightPanelToggle", () => $3a63146a91b26595$export$898b0b9e6647aa1a);
$parcel$export(module.exports, "useRightPanelState", () => $3a63146a91b26595$export$44f374c6fe8a17ef);
$parcel$export(module.exports, "RightPanelContainer", () => $3a63146a91b26595$export$e37cfb5282d612c2);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $3a63146a91b26595$var$initialState = {
    isOpen: false,
    focusKey: 0,
    panelId: null,
    isTriggerFocused: false
};
const $3a63146a91b26595$var$openPanel = (panelId)=>({ setState: setState, getState: getState })=>{
        if (getState().isOpen === false) setState({
            isOpen: true,
            focusKey: getState().focusKey + 1,
            panelId: panelId,
            isTriggerFocused: false
        });
        else setState({
            // if the panel is already open, we only want to focus it
            // this scenario occurs when the panel is open by default
            // and the user clicks on the add gadget button
            // update key to trigger re-focusing of the side panel
            focusKey: getState().focusKey + 1
        });
    };
const $3a63146a91b26595$var$closePanel = ()=>({ setState: setState, getState: getState })=>{
        if (getState().isOpen === true) setState({
            ...$3a63146a91b26595$var$initialState,
            isTriggerFocused: true
        });
    };
const $3a63146a91b26595$var$focusTrigger = (focusTriggerCallback)=>({ setState: setState, getState: getState })=>{
        if (getState().isTriggerFocused) focusTriggerCallback();
        setState({
            isTriggerFocused: false
        });
    };
const $3a63146a91b26595$var$focusPanel = (focusPanelCallback)=>({ getState: getState })=>{
        if (getState().focusKey > 0) focusPanelCallback();
    };
const $3a63146a91b26595$var$Store = (0, $iXqE5.createStore)({
    initialState: $3a63146a91b26595$var$initialState,
    actions: {
        openPanel: $3a63146a91b26595$var$openPanel,
        closePanel: $3a63146a91b26595$var$closePanel,
        focusTrigger: $3a63146a91b26595$var$focusTrigger,
        focusPanel: $3a63146a91b26595$var$focusPanel
    },
    name: 'right-side-panel'
});
const $3a63146a91b26595$var$useRightPanel = (0, $3sQ5x.createHook)($3a63146a91b26595$var$Store);
const $3a63146a91b26595$var$useRightPanelActions = (0, $3sQ5x.createHook)($3a63146a91b26595$var$Store, {
    selector: null
});
const $3a63146a91b26595$export$898b0b9e6647aa1a = ()=>{
    const [, actions] = $3a63146a91b26595$var$useRightPanelActions();
    return {
        onCloseRightPanel: actions.closePanel,
        onOpenRightPanel: actions.openPanel,
        onFocusTrigger: actions.focusTrigger,
        onFocusPanel: actions.focusPanel
    };
};
const $3a63146a91b26595$export$44f374c6fe8a17ef = ()=>$3a63146a91b26595$var$useRightPanel()[0];
const $3a63146a91b26595$export$e37cfb5282d612c2 = (0, $gg7kZ.createContainer)($3a63146a91b26595$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpenByDefault: isOpenByDefault, defaultPanelId: defaultPanelId })=>{
            if (isOpenByDefault === true && defaultPanelId != null) setState({
                isOpen: true,
                panelId: defaultPanelId
            });
        }
});

});


parcelRegister("fkN9I", function(module, exports) {

$parcel$export(module.exports, "useLayoutChange", () => $809cf51522b3607b$export$13f16b0ff83cf772);

var $5uXOq = parcelRequire("5uXOq");

var $hh0bW = parcelRequire("hh0bW");

var $JIPqS = parcelRequire("JIPqS");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $gh1hi = parcelRequire("gh1hi");
const $809cf51522b3607b$var$expAttributes = {
    analyticsSource: 'dashboard',
    experience: (0, $JIPqS.CHANGE_LAYOUT_EXPERIENCE),
    application: null,
    edition: null,
    additionalAttributes: {}
};
const $809cf51522b3607b$export$755ca66aa40344da = (gadgets)=>[
        gadgets.filter((gadget)=>gadget.column === 0),
        gadgets.filter((gadget)=>gadget.column === 1),
        gadgets.filter((gadget)=>gadget.column === 2)
    ];
const $809cf51522b3607b$export$3ef0a75b350ea007 = (currentColumns, currentLayout, newLayout)=>{
    // if adding a column or no change in column count
    if (currentLayout.length <= newLayout.length) return currentColumns;
    if (currentLayout.length > newLayout.length) {
        const newColumns = currentColumns.slice(0, newLayout.length);
        const leftOver = currentColumns.slice(newLayout.length).flat().map((gadget)=>({
                ...gadget,
                column: newColumns.length - 1
            }));
        // append the leftover to last column
        newColumns[newColumns.length - 1] = newColumns[newColumns.length - 1].concat(leftOver);
        return newColumns;
    }
    return currentColumns;
};
const $809cf51522b3607b$export$13f16b0ff83cf772 = ()=>{
    const { data: data, update: update } = (0, $gh1hi.useDashboardResource)();
    return (0, $5uXOq.useCallback)(async (layout, explicitColumns)=>{
        if (!data) return;
        const columns = explicitColumns ?? $809cf51522b3607b$export$3ef0a75b350ea007($809cf51522b3607b$export$755ca66aa40344da(data.gadgets), data.layout, layout);
        const payload = columns.map((column)=>column.map((gadget)=>gadget.id));
        const url = `${data.resourceUrl}/layout`;
        try {
            await (0, $eusud.performPutRequest)(url, {
                body: JSON.stringify({
                    '0': payload[0],
                    '1': payload[1],
                    '2': payload[2],
                    layout: layout
                })
            });
            update((currentData)=>currentData && {
                    ...currentData,
                    gadgets: columns.flat(),
                    layout: layout
                });
            (0, $hh0bW.default)({
                ...$809cf51522b3607b$var$expAttributes,
                wasExperienceSuccesful: true
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $hh0bW.default)({
                ...$809cf51522b3607b$var$expAttributes,
                wasExperienceSuccesful: false
            });
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: (0, $JIPqS.CHANGE_LAYOUT_EXPERIENCE),
                    packageName: 'jiraDashboardEdit'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }, [
        data,
        update
    ]);
};

});

parcelRegister("1WOL5", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b8cddaae8b1bfa7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9b8cddaae8b1bfa7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    pageTitleFallback: {
        "id": "dashboard-edit.page-title-fallback",
        "defaultMessage": "Edit dashboard"
    },
    pageTitle: {
        "id": "dashboard-edit.page-title",
        "defaultMessage": "Edit - {dashboardName}"
    },
    editingInfo: {
        "id": "dashboard-edit.editing-info",
        "defaultMessage": "You are currently editing your dashboard. Changes will be saved automatically."
    }
});

});

parcelRegister("57x9W", function(module, exports) {

$parcel$export(module.exports, "GadgetEditable", () => $6ea73e60c5d315b8$export$9ea8e07be9334eb3);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $eWkgo = parcelRequire("eWkgo");
var $2s57o = parcelRequire("2s57o");

var $JIPqS = parcelRequire("JIPqS");

var $eXVsp = parcelRequire("eXVsp");

var $b3IiT = parcelRequire("b3IiT");

var $c1XZn = parcelRequire("c1XZn");

var $8h45R = parcelRequire("8h45R");

var $8FVKN = parcelRequire("8FVKN");

var $2XTsA = parcelRequire("2XTsA");

var $9TUxn = parcelRequire("9TUxn");

var $83NgX = parcelRequire("83NgX");

var $chUx7 = parcelRequire("chUx7");

var $lwPtc = parcelRequire("lwPtc");

var $4ozF0 = parcelRequire("4ozF0");

var $j3C3s = parcelRequire("j3C3s");

var $gFWXX = parcelRequire("gFWXX");

var $1yhBH = parcelRequire("1yhBH");

var $iIi7d = parcelRequire("iIi7d");

var $cmgca = parcelRequire("cmgca");

var $jATTU = parcelRequire("jATTU");

var $fJpBG = parcelRequire("fJpBG");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $gh1hi = parcelRequire("gh1hi");

var $hzLxu = parcelRequire("hzLxu");

var $lB5Qw = parcelRequire("lB5Qw");

var $8VGwU = parcelRequire("8VGwU");

var $clqf8 = parcelRequire("clqf8");

var $hWMwQ = parcelRequire("hWMwQ");

var $4zy27 = parcelRequire("4zy27");

var $g5A8z = parcelRequire("g5A8z");

var $jbkj1 = parcelRequire("jbkj1");

var $49IUu = parcelRequire("49IUu");
const $6ea73e60c5d315b8$export$c52d8ff08351976f = ({ data: { id: id, userPrefs: userPrefs, reactKey: reactKey, configurable: configurable, refreshable: isRefreshableByJira, connect: connect, forge: forge, ...data }, display: display, isConnectDisabled: isConnectDisabled, dashboardRefreshId: dashboardRefreshId, children: children })=>{
    const isRenamable = (0, $8h45R.useIsRenamable)(id);
    const saveTitleById = (0, $clqf8.useSaveCustomGadgetTitleById)(id);
    const showSaveTitleFlag = (0, $49IUu.useGadgetTitleChangeErrorFlag)();
    const localStorageService = (0, $83NgX.useLocalStorageService)(id);
    const { update: update } = (0, $gh1hi.useDashboardResource)();
    const userPreferencesService = (0, $chUx7.useUserPreferencesService)(id, update);
    const { reinitialise: onGadgetKeyChange, isEditable: isReactEditable, isLoading: isReactLoading } = (0, $9TUxn.useReactGadget)(id, reactKey);
    const automaticRefreshMs = (0, $5uXOq.useMemo)(()=>{
        const { refresh: refresh } = (0, $fJpBG.decodeUserPreferences)(userPrefs?.fields);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return parseInt(refresh, 10) * 60000 || null;
    }, [
        userPrefs?.fields
    ]);
    const saveTitle = (0, $5uXOq.useCallback)((...args)=>saveTitleById(...args).catch((error)=>{
            showSaveTitleFlag();
            throw error;
        }), [
        saveTitleById,
        showSaveTitleFlag
    ]);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
    const { isInEditMode: isInEditMode, ...editable } = (0, $hzLxu.useGadgetEditableController)({
        id: id,
        userPrefs: userPrefs,
        configurable: isReactEditable ?? configurable,
        reactKey: reactKey,
        isRenamable: isRenamable,
        isConnectDisabled: isConnectDisabled,
        saveTitle: saveTitle,
        userPreferencesAction: userPrefs?.action,
        userPreferencesService: userPreferencesService,
        ...data
    });
    // Ecosystem gadgets are not supposed to re-render if they are opting out refreshing
    const ignoreGlobalDashboardRefresh = !isRefreshableByJira;
    const { onRefresh: onRefresh, ...common } = (0, $2XTsA.useGadgetCommonController)({
        id: id,
        display: display,
        automaticRefreshMs: isInEditMode ? null : automaticRefreshMs,
        localStorageService: // disable auto refresh in edit mode
        localStorageService,
        dashboardRefreshId: ignoreGlobalDashboardRefresh ? null : dashboardRefreshId,
        onGadgetKeyChange: onGadgetKeyChange
    });
    const ecosystemRefresh = (0, $jATTU.useEcosystemRefresh)({
        id: id,
        connect: connect,
        forge: forge
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8FVKN.GadgetControllerContextProvider), {
        value: {
            ...common,
            ...editable,
            isLoading: isReactLoading ?? isLoading,
            setIsLoading: reactKey ? ()=>undefined : setIsLoading,
            isInEditMode: isInEditMode,
            isRenamable: isRenamable,
            onRefresh: isRefreshableByJira ? onRefresh : ecosystemRefresh.onRefresh ?? onRefresh
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: ecosystemRefresh.wrapperRef
    }, children));
};
const $6ea73e60c5d315b8$export$9ea8e07be9334eb3 = ({ dashboardId: dashboardId, data: data, display: display, isDraggable: isDraggable = false, isDragging: isDragging = false, isConnectDisabled: isConnectDisabled = false, dragHandleProps: dragHandleProps, refreshId: refreshId, onMaximizeOrRestore: onMaximizeOrRestore, onMount: onMount, onRegisterConnectGadget: onRegisterConnectGadget, onUnregisterConnectGadget: onUnregisterConnectGadget })=>{
    const { id: id, isMaximizable: isMaximizable, color: color, forge: forge, customisedTitle: customisedTitle, title: defaultTitle } = data;
    const saveColor = (0, $hWMwQ.useSaveGadgetColor)(id);
    const deleteGadget = (0, $lB5Qw.useDeleteGadget)(id, customisedTitle || defaultTitle);
    const duplicateGadget = (0, $8VGwU.useDuplicateGadget)(id);
    const gadgetHeaderRef = (0, $5uXOq.useRef)(null);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isFirstPartyGadget = !(0, $cmgca.isConnectGadget)(data) && !forge;
    const isDeprecated = (0, $b3IiT.checkGadgetType)((0, $JIPqS.DEPRECATED_GADGETS_MAP), data.amdModule);
    // this onMount function is idempotent so we don't need to ensure that it is
    // called at most one time use an additional ref. The controller will already
    // handle duplicate calls to ensure that the focus callback is only called once.
    (0, $5uXOq.useEffect)(()=>onMount?.(id, ()=>gadgetHeaderRef.current?.focus()), [
        onMount,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ea73e60c5d315b8$export$c52d8ff08351976f, {
        data: data,
        display: display,
        isConnectDisabled: isConnectDisabled,
        dashboardRefreshId: refreshId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8FVKN.GadgetControllerContextConsumer), null, ({ isDisplayed: isDisplayed, isMaximized: isMaximized, isMinimized: isMinimized, onMinimizeOrRestore: onMinimizeOrRestore, shouldUseCache: shouldUseCache, isLoading: isLoading, setIsLoading: setIsLoading, lastRefreshed: lastRefreshed, isUnconfigured: isUnconfigured, isEditModeEnabled: isEditModeEnabled, isEditButtonDisabled: isEditButtonDisabled, isInEditMode: isInEditMode, onEditModeTrigger: onEditModeTrigger, onEditModeCancel: onEditModeCancel, title: title, isRenamable: isRenamable, isRenaming: isRenaming, setDefaultTitle: setDefaultTitle, onRenameTrigger: onRenameTrigger, onRenameSave: onRenameSave, onRenameCancel: onRenameCancel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4ozF0.GadgetLayoutWithAnalytics), {
            gadgetData: data,
            isDisplayed: isDisplayed,
            isContentHidden: isMinimized,
            customWrapperStyles: [
                isDraggable && isDragging && $6ea73e60c5d315b8$var$gadgetDraggingStyles
            ],
            customPlaceholder: isDragging && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1XZn.SkeletonGadgetContent), {
                customHeight: `${(0, $JIPqS.GADGET_DEFAULT_HEIGHT)}px`,
                isPulsing: false
            }),
            header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", dragHandleProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
                alignItems: "center",
                xcss: [
                    isDraggable && $6ea73e60c5d315b8$var$draggableHeaderStyles
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j3C3s.GadgetTitleWrapper), {
                isRenaming: isRenaming,
                id: `gadget-title-${id}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jbkj1.TitleEditor), {
                isRenamable: isRenamable,
                isRenaming: isRenaming,
                title: title,
                onEdit: onRenameTrigger,
                editButtonLabel: formatMessage((0, $g5A8z.default).rename, {
                    gadgetName: title
                }),
                onConfirmEdit: onRenameSave,
                onCancelEdit: onRenameCancel
            }, isDeprecated && (0, $4R6GH.fg)('endeavour_gadget_deprecation_banner_v1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                xcss: $6ea73e60c5d315b8$var$titleStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gFWXX.TitleReadOnly), {
                title: title,
                // We don't want to render a link in edit mode
                titleUrl: undefined,
                forgeEnvironment: forge?.environment,
                forgeEnvironmentKey: forge?.environmentKey
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                xcss: $6ea73e60c5d315b8$var$tooltipStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eXVsp.DeprecationTooltip), null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gFWXX.TitleReadOnly), {
                title: title,
                // We don't want to render a link in edit mode
                titleUrl: undefined,
                forgeEnvironment: forge?.environment,
                forgeEnvironmentKey: forge?.environmentKey
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1yhBH.GadgetToolbar), {
                gadgetId: id,
                title: title,
                onMinimizeOrRestore: onMinimizeOrRestore,
                isMinimized: isMinimized,
                isMaximizable: isMaximizable,
                onMaximizeOrRestore: onMaximizeOrRestore,
                isMaximized: isMaximized,
                additionalToolbarItems: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4zy27.ConfigDropdown), {
                    isEditable: isEditModeEnabled && !(isDeprecated && (0, $4R6GH.fg)('endeavour_gadget_deprecation_remove_functionality')),
                    isEditDisabled: isLoading || isEditButtonDisabled,
                    isDeprecatedGadget: isDeprecated,
                    gadgetId: id,
                    gadgetTitle: title,
                    gadgetColor: color,
                    onSaveColor: saveColor,
                    onEditModeClick: onEditModeTrigger,
                    onDeleteGadget: deleteGadget,
                    onDuplicateGadget: duplicateGadget
                })
            }))),
            footer: isFirstPartyGadget && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iIi7d.LastRefreshed), {
                lastRefreshed: lastRefreshed,
                updateInterval: (0, $JIPqS.REFRESH_LABEL_UPDATE_INTERVAL)
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "dashboard-edit.ui.gadget-editable.gadget-editable"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lwPtc.GadgetInner), {
            dashboardId: dashboardId,
            data: data,
            isUnconfigured: isUnconfigured,
            isEditModeEnabled: isEditModeEnabled,
            isLoading: isLoading,
            isInEditMode: isInEditMode,
            shouldUseCache: shouldUseCache,
            setIsLoading: setIsLoading,
            setDefaultTitle: setDefaultTitle,
            setTitle: onRenameSave,
            onEditModeCancel: onEditModeCancel,
            isMaximized: isMaximized,
            onRegisterConnectGadget: onRegisterConnectGadget,
            onUnregisterConnectGadget: onUnregisterConnectGadget
        })))));
};
const $6ea73e60c5d315b8$var$draggableHeaderStyles = (0, $2s57o.xcss)({
    cursor: 'grab'
});
const $6ea73e60c5d315b8$var$gadgetDraggingStyles = (0, $2s57o.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${(0, $JIPqS.GADGET_DRAG_CONTAINER_HEIGHT)}px !important`
});
const $6ea73e60c5d315b8$var$titleStyles = (0, $2s57o.xcss)({
    display: 'flex',
    flexDirection: 'row'
});
const $6ea73e60c5d315b8$var$tooltipStyles = (0, $2s57o.xcss)({
    marginTop: 'space.025'
});

});
parcelRegister("eXVsp", function(module, exports) {

$parcel$export(module.exports, "DeprecationTooltip", () => $a9bfc6bd944fc87c$export$3afd8bd60d8bcdb8);

var $5uXOq = parcelRequire("5uXOq");

var $aUcIH = parcelRequire("aUcIH");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $koVbs = parcelRequire("koVbs");

var $hjSul = parcelRequire("hjSul");

var $cM8Sm = parcelRequire("cM8Sm");
const $a9bfc6bd944fc87c$export$3afd8bd60d8bcdb8 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $a9bfc6bd944fc87c$var$tooltipStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aUcIH.default), {
        appearance: "warning"
    }, formatMessage((0, $cM8Sm.default).gadgetDeprecationTooltip, {
        Link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
                href: "https://community.atlassian.com/t5/Jira-articles/Update-We-re-ending-support-for-five-dashboard-gadgets-in-May/ba-p/2844556"
            }, chunks),
        br: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null))
    })));
};
const $a9bfc6bd944fc87c$var$tooltipStyles = (0, $2s57o.xcss)({
    marginLeft: 'space.050'
});

});
parcelRegister("aUcIH", function(module, exports) {

$parcel$export(module.exports, "default", () => $11d1058d97996ffb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cNW3X = parcelRequire("cNW3X");

var $55tuP = parcelRequire("55tuP");

var $5sLH0 = parcelRequire("5sLH0");
var $k9nuy = parcelRequire("k9nuy");

var $4QxdL = parcelRequire("4QxdL");
const $11d1058d97996ffb$var$rootStyles = null;
const $11d1058d97996ffb$var$iconColor = {
    connectivity: "_x5v91r2e",
    confirmation: "_x5v91fgg",
    info: "_x5v913wx",
    warning: "_x5v9f6ss",
    error: "_x5v9k8x7"
};
/**
 * __Inline message__
 *
 * An inline message lets users know when important information is available or when an action is required.
 *
 * - [Examples](https://atlassian.design/components/inline-message/examples)
 * - [Code](https://atlassian.design/components/inline-message/code)
 * - [Usage](https://atlassian.design/components/inline-message/usage)
 *
 * @example
 *
 * ```jsx
 * const Component = () => (
 *   <InlineMessage
 *    title="Inline Message Title Example"
 *    secondaryText="Secondary Text"
 *   >
 *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
 *   </InlineMessage>
 * );
 * ```
 */ const $11d1058d97996ffb$var$InlineMessage = ({ placement: placement = 'bottom-start', secondaryText: secondaryText = '', title: title = '', type: type = 'connectivity', appearance: appearance, children: children, testId: testId, iconLabel: iconLabel })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const toggleDialog = (0, $5uXOq.useCallback)(()=>{
        setIsOpen((oldState)=>!oldState);
    }, [
        setIsOpen
    ]);
    const onCloseDialog = (0, $5uXOq.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    if (!appearance) appearance = type;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _p12f1osq _nt751r31 _49pcnqa1 _1hvwt94y _kvh018uv _38q98stv _1o0knqa1 _1yyu1kum",
            $11d1058d97996ffb$var$iconColor[appearance]
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $55tuP.default), {
            onClose: onCloseDialog,
            content: children,
            isOpen: isOpen,
            placement: placement,
            testId: testId && `${testId}--inline-dialog`,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
                "data-ds--inline-message--button": true,
                appearance: "subtle-link",
                onClick: toggleDialog,
                spacing: "none",
                testId: testId && `${testId}--button`,
                "aria-expanded": isOpen,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                    space: "space.050",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4QxdL.default), {
                            isOpen: isOpen,
                            appearance: appearance,
                            label: iconLabel
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                            space: "space.100",
                            children: [
                                title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                                    weight: "medium",
                                    testId: testId && `${testId}--title`,
                                    children: title
                                }),
                                secondaryText && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                                    weight: "medium",
                                    color: "color.text.subtlest",
                                    maxLines: 1,
                                    testId: testId && `${testId}--text`,
                                    children: secondaryText
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var $11d1058d97996ffb$export$2e2bcd8739ae039 = $11d1058d97996ffb$var$InlineMessage;

});
parcelRegister("4QxdL", function(module, exports) {

$parcel$export(module.exports, "default", () => $12eee54571ecf193$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3nZ0X = parcelRequire("3nZ0X");
const $12eee54571ecf193$var$iconColor = {
    connectivity: "_1b3i1c86",
    confirmation: "_1b3icdx1",
    info: "_1b3ige5s",
    warning: "_1b3i1n6p",
    error: "_1b3i1378"
};
const $12eee54571ecf193$var$iconWrapperStyles = null;
const $12eee54571ecf193$var$iconColorStyles = null;
/**
 * __Selected icon__
 *
 * The selected icon is used as the primary interactive element for the dialog.
 * Can be used with or without supporting text.
 */ const $12eee54571ecf193$var$SelectedIcon = ({ appearance: appearance, isOpen: isOpen, label: label })=>{
    const { [appearance]: { icon: Icon, defaultLabel: defaultLabel } } = (0, $3nZ0X.typesMapping);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-ds--inline-message--icon": true,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _4cvr1h6o _syazkr0v",
            isOpen && "_syaz1kum",
            $12eee54571ecf193$var$iconColor[appearance]
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
            testId: "inline-message-icon",
            label: label || defaultLabel,
            color: "currentColor",
            LEGACY_size: "medium",
            spacing: "spacious"
        })
    });
};
var $12eee54571ecf193$export$2e2bcd8739ae039 = $12eee54571ecf193$var$SelectedIcon;

});
parcelRegister("3nZ0X", function(module, exports) {

$parcel$export(module.exports, "typesMapping", () => $f033e99722d4c1b8$export$4d111645c0b39d5d);

var $5E93O = parcelRequire("5E93O");

var $k01Ou = parcelRequire("k01Ou");

var $bMdrA = parcelRequire("bMdrA");

var $85eFT = parcelRequire("85eFT");
const $f033e99722d4c1b8$export$4d111645c0b39d5d = {
    connectivity: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($85eFT))),
        defaultLabel: 'connectivity inline message'
    },
    confirmation: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bMdrA))),
        defaultLabel: 'confirmation inline message'
    },
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($k01Ou))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($85eFT))),
        defaultLabel: 'warning inline message'
    },
    error: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5E93O))),
        defaultLabel: 'error inline message'
    }
};

});



parcelRegister("cM8Sm", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c54fb5c971a7e8c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5c54fb5c971a7e8c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    gadgetDeprecationTooltip: {
        "id": "dashboard-internal-common.common.gadget.deprecation-tooltip.gadget-deprecation-tooltip.non-final",
        "defaultMessage": "Starting May 2025, we're no longer supporting this gadget. Delete it before then to reference its data in the available alternatives.<br></br><Link>More about the gadgets and the extended timeline</Link>"
    }
});

});


parcelRegister("c1XZn", function(module, exports) {

$parcel$export(module.exports, "SkeletonGadgetContent", () => $5d9b139cc9647a02$export$8609a145e570faa1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $ht34f = parcelRequire("ht34f");

var $8iquX = parcelRequire("8iquX");

var $koVbs = parcelRequire("koVbs");

var $19nfo = parcelRequire("19nfo");

var $kZxfg = parcelRequire("kZxfg");
const $5d9b139cc9647a02$export$8609a145e570faa1 = ({ dashboardId: dashboardId, gadgetId: gadgetId, customHeight: customHeight, isPulsing: isPulsing = true, isLimitedToScreenHeight: isLimitedToScreenHeight = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const gadgetLocalHeight = customHeight ?? `${(0, $19nfo.getLocalStorageHeight)(dashboardId, gadgetId)}px`;
    const heightIsZero = gadgetLocalHeight.match(/^0[^.0-9]*$/);
    // will match 0px,0%,etc but not 0.1px
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8iquX.default), {
        name: "skeleton-gadget-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5d9b139cc9647a02$var$SkeletonContent, {
        height: gadgetLocalHeight,
        isLimitedToScreenHeight: isLimitedToScreenHeight,
        isPulsing: isPulsing,
        "data-testid": "dashboard-internal-common.common.gadget.gadget-skeleton.skeleton-content",
        role: "status",
        "aria-label": "Loading"
    }, !heightIsZero && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ht34f))), {
        LEGACY_size: "large",
        label: formatMessage((0, $kZxfg.default).genericPlaceholderIcon),
        color: "currentColor"
    })));
};
const $5d9b139cc9647a02$var$PulseAnimation = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5d9b139cc9647a02$var$SkeletonContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLimitedToScreenHeight: isLimitedToScreenHeight, isPulsing: isPulsing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1kmmpls": (0, $lD23V.default)(__cmplp.height ?? '100%')
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _4t3i101j _bfhkm7j4 _1e0c1txw _4cvr1h6o _1bah1h6o _1nj1m7j4 _v4q31yy8 _nhwa12c5 _1qzzvp3v _8em7p3kn",
            __cmplp.isLimitedToScreenHeight && "_c71l1rea",
            __cmplp.isPulsing ? "_h82i9cwz" : "_h82iidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ht34f", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::856a9abd2f2917165082d78a9be3e71c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb77863e3255cd9c$var$_react = $cb77863e3255cd9c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $cb77863e3255cd9c$var$_chartBar = $cb77863e3255cd9c$var$_interopRequireDefault((parcelRequire("dNhsC")));

var $cb77863e3255cd9c$var$_presentation = $cb77863e3255cd9c$var$_interopRequireDefault((parcelRequire("dYMbG")));
function $cb77863e3255cd9c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChartBarIcon.
 * This component is ChartBarIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesPresentationIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Reports in JSM, Space Analytics in Confluence, and other graph charts.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cb77863e3255cd9c$var$ChartBarIcon = (props)=>/*#__PURE__*/ $cb77863e3255cd9c$var$_react.default.createElement($cb77863e3255cd9c$var$_chartBar.default, Object.assign({
        LEGACY_fallbackIcon: $cb77863e3255cd9c$var$_presentation.default
    }, props));
$cb77863e3255cd9c$var$ChartBarIcon.Name = 'ChartBarIconMigration';
var $cb77863e3255cd9c$var$_default = module.exports.default = $cb77863e3255cd9c$var$ChartBarIcon;

});
parcelRegister("dNhsC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::938052aeb81071adc088ccde54cc9808>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a0ad654b113130c7$var$_react = $a0ad654b113130c7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a0ad654b113130c7$var$_baseNew = $a0ad654b113130c7$var$_interopRequireDefault((parcelRequire("enEmH")));
function $a0ad654b113130c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Reports in JSM, Space Analytics in Confluence, and other graph charts.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a0ad654b113130c7$var$ChartBarIcon = (props)=>/*#__PURE__*/ $a0ad654b113130c7$var$_react.default.createElement($a0ad654b113130c7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.333 1.75a.75.75 0 0 1 .75-.75h4.167a.75.75 0 0 1 .75.75V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9.75A.75.75 0 0 1 1.75 9h3.417V5.75a.75.75 0 0 1 .75-.75h3.416zm0 4.75H6.667v7h2.666zm1.5 7H13a.5.5 0 0 0 .5-.5V2.5h-2.667zm-5.666 0v-3H2.5V13a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$a0ad654b113130c7$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $a0ad654b113130c7$var$_default = module.exports.default = $a0ad654b113130c7$var$ChartBarIcon;

});

parcelRegister("dYMbG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2d642006227ff61$var$_react = $a2d642006227ff61$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $a2d642006227ff61$var$_chartBar = $a2d642006227ff61$var$_interopRequireDefault((parcelRequire("dNhsC")));
function $a2d642006227ff61$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a2d642006227ff61$var$MediaServicesPresentationIcon = (props)=>/*#__PURE__*/ $a2d642006227ff61$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="16" height="16" x="4" y="4" fill="currentcolor" rx="2"/><rect width="2" height="3" x="8" y="12" fill="inherit" rx="1"/><rect width="2" height="5" x="11" y="10" fill="inherit" rx="1"/><rect width="2" height="7" x="14" y="8" fill="inherit" rx="1"/></g></svg>`
    }, props, {
        newIcon: $a2d642006227ff61$var$_chartBar.default
    }));
$a2d642006227ff61$var$MediaServicesPresentationIcon.displayName = 'MediaServicesPresentationIcon';
var $a2d642006227ff61$var$_default = module.exports.default = $a2d642006227ff61$var$MediaServicesPresentationIcon;

});


parcelRegister("kZxfg", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cfdcaba3d94c905$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4cfdcaba3d94c905$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    genericPlaceholderIcon: {
        "id": "dashboard-internal-common.common.gadget.gadget-skeleton.generic-placeholder-icon",
        "defaultMessage": "Placeholder icon"
    }
});

});


parcelRegister("8FVKN", function(module, exports) {

$parcel$export(module.exports, "GadgetControllerContextProvider", () => $34f96cfa0524cd59$export$4de1bad6b03d7763);
$parcel$export(module.exports, "GadgetControllerContextConsumer", () => $34f96cfa0524cd59$export$4d4eb85e0f24da5c);
$parcel$export(module.exports, "useGadgetRefresh", () => $34f96cfa0524cd59$export$9e5c8ef16417c38e);
$parcel$export(module.exports, "useGadgetRenderKey", () => $34f96cfa0524cd59$export$b4c09774e3d2cd2d);
$parcel$export(module.exports, "useIsConnectDisabled", () => $34f96cfa0524cd59$export$2afbda65cda4cd52);
$parcel$export(module.exports, "useGadgetSetPreferences", () => $34f96cfa0524cd59$export$263d54a76be27f46);

var $jnkfq = parcelRequire("jnkfq");
const { createUseContextField: $34f96cfa0524cd59$export$56fb4dd71461f98e, Provider: $34f96cfa0524cd59$export$4de1bad6b03d7763, Consumer: $34f96cfa0524cd59$export$4d4eb85e0f24da5c } = (0, $jnkfq.createRendererContext)();
const $34f96cfa0524cd59$export$9e5c8ef16417c38e = $34f96cfa0524cd59$export$56fb4dd71461f98e('onRefresh');
const $34f96cfa0524cd59$export$b4c09774e3d2cd2d = $34f96cfa0524cd59$export$56fb4dd71461f98e('renderKey');
const $34f96cfa0524cd59$export$2afbda65cda4cd52 = $34f96cfa0524cd59$export$56fb4dd71461f98e('isConnectDisabled');
const $34f96cfa0524cd59$export$263d54a76be27f46 = $34f96cfa0524cd59$export$56fb4dd71461f98e('setPreferences');

});

parcelRegister("2XTsA", function(module, exports) {

$parcel$export(module.exports, "useGadgetCommonController", () => $369e7d9cc957d88d$export$3db154a5767b2bd0);

var $5uXOq = parcelRequire("5uXOq");

var $JIPqS = parcelRequire("JIPqS");
const $369e7d9cc957d88d$export$3db154a5767b2bd0 = ({ id: id, display: display, automaticRefreshMs: automaticRefreshMs, localStorageService: { get: localStorageServiceGet, put: localStorageServicePut, del: localStorageServiceDel }, dashboardRefreshId: dashboardRefreshId, onGadgetKeyChange: onGadgetKeyChange })=>{
    const isDisplayed = display !== (0, $JIPqS.GADGET_DISPLAY).HIDDEN;
    const isMaximized = display === (0, $JIPqS.GADGET_DISPLAY).MAXIMIZED;
    const [isMinimized, setIsMinimized] = (0, $5uXOq.useState)(()=>localStorageServiceGet('minimized') === 'true');
    const onMinimizeOrRestore = (0, $5uXOq.useCallback)((doMinimize)=>{
        if (doMinimize !== isMinimized) {
            if (doMinimize) localStorageServicePut('minimized', 'true');
            else localStorageServiceDel('minimized');
            setIsMinimized(doMinimize);
        }
    }, [
        isMinimized,
        setIsMinimized,
        localStorageServicePut,
        localStorageServiceDel
    ]);
    const [shouldUseCache, setShouldUseCache] = (0, $5uXOq.useState)(true);
    const [refreshId, setRefreshId] = (0, $5uXOq.useState)(Date.now());
    const renderKey = `${id}-${refreshId}-${dashboardRefreshId}-${isMaximized ? 'canvas' : 'default'}`;
    const prevRenderKey = (0, $5uXOq.useRef)(renderKey);
    const onRefresh = (0, $5uXOq.useCallback)(()=>{
        setShouldUseCache(false);
        setRefreshId(Date.now());
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (automaticRefreshMs == null || automaticRefreshMs <= 0) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        // The interval is stored in a signed 32-bit int so any number above 2**31-1 would
        // become negative which will cause the callback to infinitely loop without any delay.
        // https://stackoverflow.com/a/12633556/1104483
        const refreshIntervalMs = Math.min(automaticRefreshMs, Math.pow(2, 31) - 1);
        const interval = setInterval(onRefresh, refreshIntervalMs);
        return ()=>{
            clearInterval(interval);
        };
    }, [
        automaticRefreshMs,
        onRefresh
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (prevRenderKey.current !== renderKey) {
            prevRenderKey.current = renderKey;
            onGadgetKeyChange();
        }
    }, [
        renderKey,
        onGadgetKeyChange
    ]);
    // id is a timestamp
    const lastRefreshed = Math.max(Number(dashboardRefreshId), refreshId);
    return {
        isDisplayed: isDisplayed,
        isMaximized: isMaximized,
        isMinimized: isMinimized,
        onMinimizeOrRestore: onMinimizeOrRestore,
        renderKey: renderKey,
        shouldUseCache: shouldUseCache,
        onRefresh: onRefresh,
        lastRefreshed: lastRefreshed
    };
};

});

parcelRegister("9TUxn", function(module, exports) {

$parcel$export(module.exports, "useReactGadget", () => $f21126f6c18da11d$export$a821269bdacf74ba);

var $5uXOq = parcelRequire("5uXOq");

var $kspzT = parcelRequire("kspzT");

var $gh1hi = parcelRequire("gh1hi");

var $iXzvf = parcelRequire("iXzvf");
const $f21126f6c18da11d$export$a821269bdacf74ba = (gadgetId, reactKey)=>{
    const { update: update, refresh: refresh, loading: loading } = (0, $gh1hi.useDashboardReactGadgetsResource)();
    const [resetId, setResetId] = (0, $5uXOq.useState)(null);
    const [namedState, setNamedState] = (0, $5uXOq.useState)('idle');
    const isReactGadget = (0, $kspzT.isReactKey)(reactKey);
    const reinitialise = (0, $5uXOq.useCallback)(()=>{
        if (namedState === 'idle') {
            // IMPORTANT - Mutations to resource while loading will be lost
            if (loading) {
                setResetId(gadgetId);
                setNamedState('update');
            } else {
                // IMPORTANT - Set null in the resource and then refresh to remove the nulls
                update((0, $iXzvf.lensReactGadget)(gadgetId, null));
                setNamedState('refresh');
            }
        }
    }, [
        gadgetId,
        loading,
        update,
        namedState
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!loading && resetId != null && namedState === 'update') {
            setResetId(null);
            // IMPORTANT - Set null in the resource and then refresh to remove the nulls
            update((0, $iXzvf.lensReactGadget)(resetId, null));
            setNamedState('refresh');
        }
    }, [
        loading,
        update,
        resetId,
        namedState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // IMPORTANT - We need to arrive here asynchronously in case multiple gadgets are reset at once
        if (namedState === 'refresh') {
            setNamedState('loading');
            refresh();
        }
    }, [
        refresh,
        namedState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!loading && namedState === 'loading') setNamedState('idle');
    }, [
        loading,
        namedState
    ]);
    if (!isReactGadget) return {
        reinitialise: ()=>undefined,
        isEditable: null,
        isLoading: null
    };
    const { componentEdit: componentEdit } = (0, $kspzT.default)[reactKey];
    return {
        reinitialise: reinitialise,
        isEditable: Boolean(componentEdit),
        isLoading: namedState === 'loading' || loading && namedState === 'idle'
    };
};

});
parcelRegister("iXzvf", function(module, exports) {

$parcel$export(module.exports, "lensReactGadget", () => $18ff57dda50a1c7b$export$703ae6d6d75e47f1);
const $18ff57dda50a1c7b$export$bada82ca295a26d5 = (updateGadgets)=>(resource)=>resource && {
            ...resource,
            reactGadgetsState: updateGadgets(resource.reactGadgetsState)
        };
const $18ff57dda50a1c7b$export$703ae6d6d75e47f1 = (id, setterOrValue)=>{
    const setter = typeof setterOrValue === 'function' ? setterOrValue : ()=>setterOrValue;
    return $18ff57dda50a1c7b$export$bada82ca295a26d5((reactGadgetsState)=>{
        if (!reactGadgetsState || !(id in reactGadgetsState)) return reactGadgetsState;
        const prevStateOrError = reactGadgetsState[id];
        const newState = setter(prevStateOrError);
        const prevState = prevStateOrError === null || prevStateOrError instanceof Error ? {} : prevStateOrError;
        return {
            ...reactGadgetsState,
            [id]: newState === null ? null : {
                ...prevState,
                ...newState
            }
        };
    });
};

});


parcelRegister("83NgX", function(module, exports) {

$parcel$export(module.exports, "useLocalStorageService", () => $d6a2211d9def985e$export$aae02958650bede0);

var $5uXOq = parcelRequire("5uXOq");

var $19nfo = parcelRequire("19nfo");
const $d6a2211d9def985e$export$d4655e9fae202a89 = (id)=>(0, $5uXOq.useCallback)((...args)=>(0, $19nfo.getGadgetDataFromLocalStorage)(id, ...args), [
        id
    ]);
const $d6a2211d9def985e$export$3bf5aef0d5c5f925 = (id)=>(0, $5uXOq.useCallback)((...args)=>(0, $19nfo.putGadgetDataFromLocalStorage)(id, ...args), [
        id
    ]);
const $d6a2211d9def985e$export$84a14851141ef231 = (id)=>(0, $5uXOq.useCallback)((...args)=>(0, $19nfo.deleteGadgetDataFromLocalStorage)(id, ...args), [
        id
    ]);
const $d6a2211d9def985e$export$aae02958650bede0 = (id)=>{
    const get = $d6a2211d9def985e$export$d4655e9fae202a89(id);
    const put = $d6a2211d9def985e$export$3bf5aef0d5c5f925(id);
    const del = $d6a2211d9def985e$export$84a14851141ef231(id);
    return {
        get: get,
        put: put,
        del: del
    };
};

});

parcelRegister("chUx7", function(module, exports) {

$parcel$export(module.exports, "useUserPreferencesService", () => $e28e888e5ec2023e$export$f1180a44ef60f9a2);

var $5uXOq = parcelRequire("5uXOq");

var $fJpBG = parcelRequire("fJpBG");

var $04NWZ = parcelRequire("04NWZ");

var $8dUCk = parcelRequire("8dUCk");

var $cmJHP = parcelRequire("cmJHP");
const $e28e888e5ec2023e$export$f1180a44ef60f9a2 = (id, update)=>{
    const refresh = (0, $5uXOq.useCallback)((action, onUpdate)=>(0, $fJpBG.getUserPreferences)(action).then((userPrefs)=>new Promise((resolve)=>{
                // IMPORTANT
                //  some consumers need batch react state updates with route resource updates
                //  to avoid render race-conditions
                (0, $8dUCk.batch)(()=>{
                    update((0, $cmJHP.lensGadget)(id, {
                        userPrefs: userPrefs
                    }));
                    onUpdate && onUpdate();
                    resolve(userPrefs);
                });
            })), [
        id,
        update
    ]);
    return {
        get: (0, $fJpBG.getUserPreferences),
        put: (0, $04NWZ.putUserPreferences),
        refresh: refresh
    };
};

});
parcelRegister("04NWZ", function(module, exports) {

$parcel$export(module.exports, "putUserPreferences", () => $4633a504d8696aa1$export$4af73e9957d3b620);

var $eusud = parcelRequire("eusud");
const $4633a504d8696aa1$export$46db0cded8c5f9ba = (preferences)=>{
    const userPreferences = {
        up_isConfigured: true
    };
    if (preferences) Object.keys(preferences).forEach((key)=>{
        userPreferences[`up_${key}`] = preferences[key];
    });
    return userPreferences;
};
const $4633a504d8696aa1$export$4af73e9957d3b620 = (action, preferences)=>{
    if (Object.entries(preferences).length === 0) return null;
    const body = JSON.stringify($4633a504d8696aa1$export$46db0cded8c5f9ba(preferences));
    return (0, $eusud.performPutRequest)(action, {
        body: body
    });
};

});

parcelRegister("cmJHP", function(module, exports) {

$parcel$export(module.exports, "lensGadgetsList", () => $3155a2d52607ee02$export$20e5dac1cf24abd6);
$parcel$export(module.exports, "lensGadget", () => $3155a2d52607ee02$export$fd99d53e8db9addf);
const $3155a2d52607ee02$export$20e5dac1cf24abd6 = (updateGadgets)=>(config)=>config && {
            ...config,
            gadgets: updateGadgets(config.gadgets)
        };
const $3155a2d52607ee02$export$fd99d53e8db9addf = (id, setterOrValue)=>{
    const setter = typeof setterOrValue === 'function' ? setterOrValue : ()=>setterOrValue;
    return $3155a2d52607ee02$export$20e5dac1cf24abd6((gadgets)=>gadgets.map((item)=>item.id === id ? {
                ...item,
                ...setter(item)
            } : item));
};

});


parcelRegister("lwPtc", function(module, exports) {

$parcel$export(module.exports, "GadgetInner", () => $1be6d64e8f66591c$export$9bb8ef6d23720658);

var $5uXOq = parcelRequire("5uXOq");

var $kspzT = parcelRequire("kspzT");

var $l8ruj = parcelRequire("l8ruj");

var $8UPoO = parcelRequire("8UPoO");

var $gc2JH = parcelRequire("gc2JH");

var $cmgca = parcelRequire("cmgca");

var $eW8ji = parcelRequire("eW8ji");

var $1NzHy = parcelRequire("1NzHy");

var $9sF5P = parcelRequire("9sF5P");

var $k3y1k = parcelRequire("k3y1k");

var $ce1BZ = parcelRequire("ce1BZ");
const $1be6d64e8f66591c$export$9bb8ef6d23720658 = ({ dashboardId: dashboardId, data: data, isUnconfigured: isUnconfigured, isEditModeEnabled: isEditModeEnabled, isLoading: isLoading, isInEditMode: isInEditMode, setIsLoading: setIsLoading, setDefaultTitle: setDefaultTitle, setTitle: setTitle, shouldUseCache: shouldUseCache, isMaximized: isMaximized, onEditModeCancel: onEditModeCancel, unconfiguredFallback: unconfiguredFallback, onRegisterConnectGadget: onRegisterConnectGadget, onUnregisterConnectGadget: onUnregisterConnectGadget })=>{
    const enhancedContext = (0, $gc2JH.useGadgetDataContextEnhancer)(data.context);
    const onGadgetRender = (0, $8UPoO.useOnGadgetRender)(data.id);
    const unconfiguredModernGadgetInViewMode = !isInEditMode && isUnconfigured && !(0, $cmgca.isConnectGadget)(data);
    const localStorageHeight = (0, $8UPoO.useLocalStorageGadgetHeight)(data.id);
    if (unconfiguredFallback != null && unconfiguredModernGadgetInViewMode) return unconfiguredFallback;
    if ((0, $cmgca.isConnectGadget)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "gadget-inner-connect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1NzHy.Connect), {
        dashboardId: dashboardId,
        gadgetId: data.id,
        inlineHtml: data.inlineHtml,
        isLoading: isLoading,
        isInEditMode: isInEditMode,
        setIsLoading: setIsLoading,
        onEditModeCancel: onEditModeCancel,
        onRegister: onRegisterConnectGadget,
        onUnregister: onUnregisterConnectGadget,
        setTitle: setTitle
    }));
    if (data.amdModule != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "gadget-inner-amd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eW8ji.Amd), {
        dashboardId: dashboardId,
        gadgetId: data.id,
        amdModule: data.amdModule,
        context: enhancedContext,
        defaultTitle: data.title,
        userPrefs: data.userPrefs,
        inlineHtml: data.inlineHtml,
        isEditable: isEditModeEnabled,
        isLoading: isLoading,
        isInEditMode: isInEditMode,
        setIsLoading: setIsLoading,
        setDefaultTitle: setDefaultTitle,
        shouldUseCache: shouldUseCache,
        isMaximized: isMaximized,
        onEditModeCancel: onEditModeCancel
    }));
    if (data.inlineHtml != null && data.renderedGadgetUrl == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "gadget-inner-inline-html"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k3y1k.InlineHtml), {
        id: data.id,
        inlineHtml: data.inlineHtml,
        isLoading: isLoading,
        setIsLoading: setIsLoading
    }));
    if (data.forge != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "gadget-inner-forge"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9sF5P.Forge), {
        forgeKey: data.forge.key,
        gadgetData: data,
        isInEditMode: isInEditMode,
        onEditModeCancel: onEditModeCancel,
        setIsLoading: setIsLoading
    }));
    if ((0, $kspzT.isReactKey)(data.reactKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "gadget-inner-react"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ce1BZ.ReactGadget), {
        id: data.id,
        reactKey: data.reactKey,
        onEditModeCancel: onEditModeCancel,
        isInEditMode: isInEditMode,
        userPrefs: data.userPrefs,
        onRenderComplete: onGadgetRender,
        setDefaultTitle: setDefaultTitle,
        customSkeletonHeightInPx: localStorageHeight
    }));
    throw new Error(`Unrecognised gadget type [${data.title}, ${data?.gadgetSpecUrl}]`);
};

});
parcelRegister("gc2JH", function(module, exports) {

$parcel$export(module.exports, "useGadgetDataContextEnhancer", () => $ef0abc66ae6c989f$export$c9b763726c221f0f);

var $5uXOq = parcelRequire("5uXOq");

var $90yGq = parcelRequire("90yGq");

var $8wYJI = parcelRequire("8wYJI");
const $ef0abc66ae6c989f$export$191677f0ab656833 = ({ user: user, ...context }, enhancedUser)=>({
        ...context,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        user: {
            ...user,
            ...enhancedUser
        }
    });
const $ef0abc66ae6c989f$export$c9b763726c221f0f = (data)=>{
    const accountId = (0, $90yGq.useAccountId)();
    const languageTag = (0, $8wYJI.useLanguageTag)();
    return (0, $5uXOq.useMemo)(()=>$ef0abc66ae6c989f$export$191677f0ab656833(data, {
            accountId: accountId,
            languageTag: languageTag
        }), [
        accountId,
        data,
        languageTag
    ]);
};

});
parcelRegister("8wYJI", function(module, exports) {

$parcel$export(module.exports, "useLanguageTag", () => $98f5b4da7049a1e2$export$dbb9c2c3f6b09f02);

var $9OXo1 = parcelRequire("9OXo1");
const $98f5b4da7049a1e2$export$271af7ea6b55125e = 'en-US';
const $98f5b4da7049a1e2$export$dbb9c2c3f6b09f02 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.languageTag || $98f5b4da7049a1e2$export$271af7ea6b55125e;
};

});


parcelRegister("cmgca", function(module, exports) {

$parcel$export(module.exports, "isConnectGadget", () => $d6e9d4b1bec846d6$export$d4464474d72c938d);

var $JIPqS = parcelRequire("JIPqS");
const $d6e9d4b1bec846d6$export$d4464474d72c938d = ({ amdModule: amdModule })=>amdModule === (0, $JIPqS.CONNECT_ITEM_AMD_MODULE);

});

parcelRegister("eW8ji", function(module, exports) {

$parcel$export(module.exports, "Amd", () => $f71dbcea44b19d9c$export$f7e1ea694836dc0c);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $hh0bW = parcelRequire("hh0bW");

var $2YZCu = parcelRequire("2YZCu");

var $JIPqS = parcelRequire("JIPqS");

var $fJpBG = parcelRequire("fJpBG");

var $jcw0u = parcelRequire("jcw0u");

var $gh1hi = parcelRequire("gh1hi");

var $bVDE5 = parcelRequire("bVDE5");

var $9kbEN = parcelRequire("9kbEN");

var $4uQB7 = parcelRequire("4uQB7");

var $c1XZn = parcelRequire("c1XZn");

var $jszBL = parcelRequire("jszBL");

var $8FVKN = parcelRequire("8FVKN");

var $ih7Bj = parcelRequire("ih7Bj");

var $7vg9b = parcelRequire("7vg9b");

var $i0rkS = parcelRequire("i0rkS");

var $5TsWX = parcelRequire("5TsWX");

var $ikoXd = parcelRequire("ikoXd");

var $WIEWs = parcelRequire("WIEWs");
const $f71dbcea44b19d9c$var$expAttributes = {
    analyticsSource: 'dashboard',
    experience: (0, $JIPqS.VIEW_WRM_GADGET_EXPERIENCE),
    application: null,
    edition: null,
    additionalAttributes: {}
};
const $f71dbcea44b19d9c$var$reportError = (gadgetId, reportGadgetMetrics, error)=>{
    reportGadgetMetrics(gadgetId, (0, $5TsWX.GADGET_START_EVENT), 'ErrorMessage');
    reportGadgetMetrics(gadgetId, (0, $5TsWX.GADGET_RENDERING_FINISHED_EVENT), 'ErrorMessage');
    (0, $hh0bW.default)({
        ...$f71dbcea44b19d9c$var$expAttributes,
        wasExperienceSuccesful: false
    });
    (0, $jcw0u.default)({
        error: error,
        meta: {
            id: (0, $JIPqS.VIEW_WRM_GADGET_EXPERIENCE),
            packageName: 'jiraDashboardInternalCommon'
        }
    });
};
const $f71dbcea44b19d9c$export$f7e1ea694836dc0c = ({ dashboardId: dashboardId, gadgetId: gadgetId, amdModule: amdModule, context: context, defaultTitle: defaultTitle, userPrefs: userPrefs, inlineHtml: inlineHtml, isEditable: isEditable, isLoading: isLoading, isInEditMode: isInEditMode, setIsLoading: setIsLoading, setDefaultTitle: setDefaultTitle, shouldUseCache: shouldUseCache, isMaximized: isMaximized, onEditModeCancel: onEditModeCancel })=>{
    const [{ currentPageId: currentPageId }] = (0, $bVDE5.useSpaStateTransition)();
    const { loading: loadingB, data: data } = (0, $gh1hi.useDashboardAMDModulesResource)();
    const { amdModules: amdModules = null } = data ?? {};
    const setPreferences = (0, $8FVKN.useGadgetSetPreferences)();
    const preference = (0, $5uXOq.useMemo)(()=>(0, $fJpBG.decodeUserPreferences)(userPrefs?.fields), [
        userPrefs?.fields
    ]);
    const module = (0, $5uXOq.useRef)(null);
    const divRef = (0, $5uXOq.useRef)(null);
    const { addEventHandler: addEventHandler, triggerEvent: triggerEvent, removeEventHandlers: removeEventHandlers } = (0, $jszBL.useEventPublisher)();
    const isSkeleton = isLoading && !isInEditMode;
    const [, { broadcastMessage: broadcastMessageBusListener }] = (0, $i0rkS.useMessageBus)();
    const [gadgetError, setGadgetError] = (0, $5uXOq.useState)(null);
    const fullWidthStyles = null;
    (0, $7vg9b.useLinkInterceptor)(divRef.current, isLoading);
    const reportGadgetMetrics = (0, $5uXOq.useCallback)((gid, eventType, contentType, markName, markStage)=>{
        broadcastMessageBusListener((0, $JIPqS.GADGET_METRICS_TYPE).REPORT, {
            eventType: eventType,
            contentType: contentType,
            markName: markName,
            markStage: markStage,
            source: (0, $5TsWX.WRM_GADGET_METRICS)
        }, {
            gadgetId: gid,
            pageId: currentPageId
        });
    }, [
        broadcastMessageBusListener,
        currentPageId
    ]);
    const isGlobalsReady = (0, $ih7Bj.useIsGlobalsReady)(()=>$f71dbcea44b19d9c$var$reportError(gadgetId, reportGadgetMetrics, new Error(`Failed to instantiate AMD module [${amdModule}] due to timeout waiting for globals`)));
    const isRenderable = isGlobalsReady && !loadingB && amdModules?.[amdModule ?? ''] != null || module.current != null;
    const gadgetApi = (0, $5uXOq.useMemo)(()=>(0, $ikoXd.getInlineGadgetApi)({
            gadgetId: gadgetId,
            amdModule: amdModule ?? '',
            context: // This will never happen, we're just want Flow to shut up
            context,
            defaultTitle: defaultTitle,
            isEditable: isEditable,
            closeEdit: onEditModeCancel,
            setIsLoading: setIsLoading,
            ref: divRef,
            setDefaultTitle: setDefaultTitle,
            reportGadgetMetrics: reportGadgetMetrics,
            dashboardId: dashboardId,
            addEventHandler: addEventHandler,
            removeEventHandlers: removeEventHandlers,
            triggerEvent: triggerEvent,
            setPreferences: setPreferences,
            shouldUseCache: shouldUseCache,
            view: isMaximized ? 'canvas' : 'default',
            setError: setGadgetError
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // IMPORTANT - this effect must come before AMD initialisation effect
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (inlineHtml == null || divRef.current == null) return;
        divRef.current.innerHTML = '';
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        divRef.current.appendChild(document.createRange().createContextualFragment(inlineHtml));
    }, [
        inlineHtml
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        (async ()=>{
            // TODO - amdModule missing should be a hard error not a type refinement
            if (!isRenderable || amdModule == null) return;
            // first time initialisation
            if (module.current == null) {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const Module = amdModules[amdModule];
                try {
                    module.current = new Module(gadgetApi);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    $f71dbcea44b19d9c$var$reportError(gadgetId, reportGadgetMetrics, error);
                    setGadgetError((0, $JIPqS.GADGET_ERROR_TYPE).VIEW_ERROR);
                    (0, $2YZCu.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.amd', `Failed to instantiate AMD module [${amdModule}]`, error);
                }
            }
            // re-render on edit-mode config/view change
            if (module.current != null) {
                (0, $2YZCu.default).safeInfoWithoutCustomerData('spa-apps.dashboard.gadget.amd', `Render AMD module [${amdModule}] in ${isInEditMode ? 'Edit' : 'View'} mode`);
                reportGadgetMetrics(gadgetId, (0, $5TsWX.GADGET_RENDER_CONTAINER_EVENT), isInEditMode ? 'Config' : 'View', undefined, undefined);
                const render = isInEditMode && module.current?.renderEdit || preference.isConfigured && module.current?.render || null;
                if (render == null) {
                    $f71dbcea44b19d9c$var$reportError(gadgetId, reportGadgetMetrics, new Error('gadget render is null'));
                    setGadgetError((0, $JIPqS.GADGET_ERROR_TYPE).VIEW_ERROR);
                    // NOTE - this is not a plausible case but log it anyway, ideally we'd want type guarantees
                    (0, $2YZCu.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.amd', `Render AMD module [${amdModule}] failure in ${isInEditMode ? 'Edit' : 'View'} mode, render method missing`);
                } else {
                    try {
                        render.call(module.current, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                        window.jQuery(divRef.current), preference);
                        setGadgetError(null);
                        // The view-wrm-gadget success count is being sampled at 10%.
                        // The Tome SLO (https://tome.prod.atl-paas.net/slo/5c05ad48-7535-4566-a4ef-a6e1d94de332)
                        // success count has a multiplier of 10 to account for this sampling.
                        if ((0, $9kbEN.isInSample)(10)) (0, $hh0bW.default)({
                            ...$f71dbcea44b19d9c$var$expAttributes,
                            wasExperienceSuccesful: true
                        });
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (error) {
                        $f71dbcea44b19d9c$var$reportError(gadgetId, reportGadgetMetrics, error);
                        setGadgetError((0, $JIPqS.GADGET_ERROR_TYPE).VIEW_ERROR);
                        (0, $2YZCu.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.amd', `Render AMD module [${amdModule}] failure in ${isInEditMode ? 'Edit' : 'View'} mode, render method throws error`, error);
                    }
                    triggerEvent('afterRender');
                }
            }
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isInEditMode,
        preference,
        isRenderable
    ]);
    (0, $5uXOq.useEffect)(// clean up, in separate hook because we only want it called once on unmount
    ()=>()=>{
            if (module.current) module.current = null;
        }, []);
    return gadgetError != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uQB7.GadgetErrorFallback), {
        errorType: gadgetError,
        id: gadgetId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WIEWs.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WIEWs.GadgetContainer), {
        id: `gadget-${gadgetId}`,
        ref: divRef,
        isHidden: isSkeleton,
        className: (0, $bwpsq.default)([
            (0, $4R6GH.fg)('jfp-magma-fix-dashboard-infinite-render') && "_1bsb1osq"
        ])
    }), isSkeleton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WIEWs.SkeletonWrapper), {
        "data-testid": "dashboard-internal-common.ui.gadget.gadget-inner.amd.loading-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1XZn.SkeletonGadgetContent), {
        dashboardId: dashboardId,
        gadgetId: gadgetId
    })));
};

});
parcelRegister("4uQB7", function(module, exports) {

$parcel$export(module.exports, "GadgetErrorFallbackBase", () => $73c4c8c0862da954$export$f9edce43cd0e391a);
$parcel$export(module.exports, "GadgetErrorFallback", () => $73c4c8c0862da954$export$6de1d4202af2589f);

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $85eFT = parcelRequire("85eFT");

var $koVbs = parcelRequire("koVbs");

var $8FVKN = parcelRequire("8FVKN");

var $ii3gE = parcelRequire("ii3gE");

var $2n7g7 = parcelRequire("2n7g7");

var $e0K9l = parcelRequire("e0K9l");
const $73c4c8c0862da954$export$f9edce43cd0e391a = ({ id: id, message: message, isRefresh: isRefresh = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onRefreshClick = (0, $8FVKN.useGadgetRefresh)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ii3gE.GadgetFallback), {
        id: id,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($85eFT))), {
            spacing: "spacious",
            label: formatMessage((0, $2n7g7.default).errorTitle),
            color: "var(--ds-text-warning, #A54800)"
        }),
        action: isRefresh && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
            appearance: "default",
            spacing: "default",
            onClick: onRefreshClick
        }, formatMessage((0, $2n7g7.default).refreshButtonText))
    }, message);
};
const $73c4c8c0862da954$export$6de1d4202af2589f = ({ id: id, errorType: errorType })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73c4c8c0862da954$export$f9edce43cd0e391a, {
        message: formatMessage((0, $e0K9l.MESSAGES_BY_ERROR)[errorType]),
        isRefresh: (0, $e0K9l.IS_REFRESH_BY_ERROR)[errorType],
        id: id
    });
};

});
parcelRegister("ii3gE", function(module, exports) {

$parcel$export(module.exports, "GadgetFallback", () => $b7e4ec4cca3d9de1$export$5c6c3d588eda4d74);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $8UPoO = parcelRequire("8UPoO");
const $b7e4ec4cca3d9de1$export$5c6c3d588eda4d74 = ({ icon: icon, action: action, id: id, children: children })=>{
    const ref = (0, $5uXOq.useRef)(null);
    const onGadgetRender = (0, $8UPoO.useOnGadgetRender)(id);
    (0, $5uXOq.useEffect)(()=>{
        const measuredHeight = ref.current?.getBoundingClientRect().height;
        onGadgetRender(measuredHeight === 0 ? undefined : measuredHeight);
    }, [
        onGadgetRender
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b7e4ec4cca3d9de1$var$GadgetFallbackWrapper, {
        ref: ref
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $b7e4ec4cca3d9de1$var$contentStyles
    }, children), action);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $b7e4ec4cca3d9de1$var$GadgetFallbackWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoiti9 _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _bfhk11bn _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _syaz1dyx _vchhusvi _y3gn1h6o _4t3i1kw7",
            __cmplp.className
        ])
    });
});
const $b7e4ec4cca3d9de1$var$contentStyles = (0, $2s57o.xcss)({
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    margin: 'space.100'
});

});

parcelRegister("2n7g7", function(module, exports) {

$parcel$export(module.exports, "default", () => $8791e45dc80d54b0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8791e45dc80d54b0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorMessage: {
        "id": "dashboard-internal-common.common.gadget.gadget-error-fallback.error-message",
        "defaultMessage": "We're having some trouble displaying this gadget. It's probably a temporary problem. Try refreshing the gadget."
    },
    errorTitle: {
        "id": "dashboard-internal-common.common.gadget.gadget-error-fallback.error-title",
        "defaultMessage": "Warning"
    },
    configErrorMessage: {
        "id": "dashboard-internal-common.common.gadget.gadget-error-fallback.config-error-message",
        "defaultMessage": "Something went wrong. We could not save your gadget configuration. Refresh this gadget to update its configuration and try again."
    },
    refreshButtonText: {
        "id": "dashboard-internal-common.common.gadget.gadget-error-fallback.refresh-button-text",
        "defaultMessage": "Refresh"
    },
    notSupportedErrorMessage: {
        "id": "dashboard-internal-common.common.gadget.gadget-error-fallback.not-supported-error-message",
        "defaultMessage": "This gadget is no longer supported by Jira."
    }
});

});

parcelRegister("e0K9l", function(module, exports) {

$parcel$export(module.exports, "MESSAGES_BY_ERROR", () => $96b21687e2fe8cc8$export$8c49a4613a61ecc1);
$parcel$export(module.exports, "IS_REFRESH_BY_ERROR", () => $96b21687e2fe8cc8$export$1b18ce488a22b856);

var $JIPqS = parcelRequire("JIPqS");

var $2n7g7 = parcelRequire("2n7g7");
const $96b21687e2fe8cc8$export$8c49a4613a61ecc1 = {
    [(0, $JIPqS.GADGET_ERROR_TYPE).CONFIG_ERROR]: (0, $2n7g7.default).configErrorMessage,
    [(0, $JIPqS.GADGET_ERROR_TYPE).VIEW_ERROR]: (0, $2n7g7.default).errorMessage,
    [(0, $JIPqS.GADGET_ERROR_TYPE).EDIT_ERROR]: (0, $2n7g7.default).errorMessage,
    [(0, $JIPqS.GADGET_ERROR_TYPE).NOT_SUPPORTED_ERROR]: (0, $2n7g7.default).notSupportedErrorMessage
};
const $96b21687e2fe8cc8$export$1b18ce488a22b856 = {
    [(0, $JIPqS.GADGET_ERROR_TYPE).CONFIG_ERROR]: true,
    [(0, $JIPqS.GADGET_ERROR_TYPE).VIEW_ERROR]: true,
    [(0, $JIPqS.GADGET_ERROR_TYPE).EDIT_ERROR]: true,
    [(0, $JIPqS.GADGET_ERROR_TYPE).NOT_SUPPORTED_ERROR]: false
};

});


parcelRegister("jszBL", function(module, exports) {

$parcel$export(module.exports, "useEventPublisher", () => $4e63d8ae41297db4$export$15f587a36eadd076);

var $5uXOq = parcelRequire("5uXOq");
const $4e63d8ae41297db4$export$15f587a36eadd076 = ()=>{
    // Do not reassign current, as this change will not be seen by useCallback dependency list.  Mutate object instead.
    const eventHandlers = (0, $5uXOq.useRef)(new Map()).current;
    const singleUseEventHandlers = (0, $5uXOq.useRef)(new Map()).current;
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const addEventHandler = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (eventName, handler, isSingleUse = false)=>{
        const handlers = isSingleUse ? singleUseEventHandlers : eventHandlers;
        handlers.has(eventName) ? handlers.get(eventName)?.add(handler) : handlers.set(eventName, new Set([
            handler
        ]));
    }, [
        eventHandlers,
        singleUseEventHandlers
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const removeEventHandlers = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (eventName, handler)=>{
        if (eventName == null) {
            eventHandlers.clear();
            singleUseEventHandlers.clear();
            return;
        }
        if (!handler) {
            eventHandlers.delete(eventName);
            singleUseEventHandlers.delete(eventName);
            return;
        }
        eventHandlers.get(eventName)?.delete(handler);
        singleUseEventHandlers.get(eventName)?.delete(handler);
    }, [
        eventHandlers,
        singleUseEventHandlers
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const triggerEvent = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (eventName)=>{
        eventHandlers.get(eventName)?.forEach((handler)=>{
            handler();
        });
        singleUseEventHandlers.get(eventName)?.forEach((handler)=>{
            handler();
        });
        singleUseEventHandlers.delete(eventName);
    }, [
        eventHandlers,
        singleUseEventHandlers
    ]);
    return {
        addEventHandler: addEventHandler,
        removeEventHandlers: removeEventHandlers,
        triggerEvent: triggerEvent
    };
};

});

parcelRegister("ih7Bj", function(module, exports) {

$parcel$export(module.exports, "useIsGlobalsReady", () => $6d5b1af24dce0aaf$export$676419e1d49cf911);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");

var $4R6GH = parcelRequire("4R6GH");

var $jU6q7 = parcelRequire("jU6q7");

var $4P2OM = parcelRequire("4P2OM");
let $6d5b1af24dce0aaf$var$pollingSingleton = null;
const $6d5b1af24dce0aaf$export$ef596e2a3bce12f6 = ()=>{
    $6d5b1af24dce0aaf$var$pollingSingleton = null;
};
class $6d5b1af24dce0aaf$var$PollingTimedOutError extends Error {
    constructor(){
        super('Timed out polling for globals');
        this.skipSentry = true;
    }
}
const $6d5b1af24dce0aaf$export$676419e1d49cf911 = (onTimeOutCallback)=>{
    try {
        $6d5b1af24dce0aaf$var$pollingSingleton = $6d5b1af24dce0aaf$var$pollingSingleton ?? new (0, $jU6q7.default)(100, (0, $4P2OM.POLLING_TIMEOUT_MS), (0, $2YZCu.default));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeWarnWithoutCustomerData('spa-apps.dashboard.common', 'error creating globals polling singleton', error);
    }
    // IMPORTANT - must evaluate readiness synchronously on the first call to avoid async delay
    const [isGlobalsReady, setIsGlobalsReady] = (0, $5uXOq.useState)(()=>$6d5b1af24dce0aaf$var$pollingSingleton?.isReady ?? false);
    const [isTimedOut, setIsTimedOut] = (0, $5uXOq.useState)(()=>$6d5b1af24dce0aaf$var$pollingSingleton?.isTimedOut ?? false);
    (0, $5uXOq.useEffect)(()=>{
        const setGlobalsReady = ()=>{
            setIsGlobalsReady(true);
        };
        const setTimedOut = ()=>{
            setIsTimedOut(true);
        };
        $6d5b1af24dce0aaf$var$pollingSingleton?.addEventListener('onReady', setGlobalsReady);
        $6d5b1af24dce0aaf$var$pollingSingleton?.addEventListener('onTimeout', setTimedOut);
        return ()=>{
            $6d5b1af24dce0aaf$var$pollingSingleton?.removeEventListener('onReady', setGlobalsReady);
            $6d5b1af24dce0aaf$var$pollingSingleton?.removeEventListener('onTimeout', setTimedOut);
        };
    }, []);
    // NOTE - additional state and effect is needed for error to trigger react ErrorBoundary
    (0, $5uXOq.useEffect)(()=>{
        if (isTimedOut) {
            if ((0, $4R6GH.fg)('endeavour_send_failure_on_globals_timeout')) onTimeOutCallback?.();
            throw new $6d5b1af24dce0aaf$var$PollingTimedOutError();
        }
    }, [
        isTimedOut,
        onTimeOutCallback
    ]);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return $6d5b1af24dce0aaf$var$pollingSingleton !== null ? isGlobalsReady : (0, $4P2OM.DEPENDENCIES).every((dep)=>window[dep]);
};

});
parcelRegister("jU6q7", function(module, exports) {

$parcel$export(module.exports, "default", () => $6560cd8e50818359$export$2e2bcd8739ae039);

var $4P2OM = parcelRequire("4P2OM");

var $euXBp = parcelRequire("euXBp");
const $6560cd8e50818359$var$formatGlobals = (deps)=>deps.map((dep)=>`window.${dep}`).join(', ');
// IMPORTANT - EventTarget does not exist in SSR so a degenerate version is required so that it doesn't fail SSR.
// This class should not be run on SSR as it will fall back to the degenerate version.
const $6560cd8e50818359$var$EventTargetUniversal = typeof EventTarget === 'undefined' ? (0, $euXBp.default) : EventTarget;
class $6560cd8e50818359$export$2e2bcd8739ae039 extends $6560cd8e50818359$var$EventTargetUniversal {
    #intervalID;
    #timeoutID;
    #startTime;
    constructor(pollingMs, timeoutMs, logger){
        super(), this.isReady = false, this.isTimedOut = false, this.missingDeps = [], this.#intervalID = null, this.#timeoutID = null, this.#startTime = Date.now(), this.#constructPolling = (pollingMs, timeoutMs, logger)=>{
            this.#intervalID = setInterval(()=>{
                const newReadyDeps = (0, $4P2OM.DEPENDENCIES).filter(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                (dep)=>window[dep] && this.missingDeps.includes(dep));
                if (newReadyDeps.length !== 0) {
                    this.missingDeps = this.missingDeps.filter((dep)=>!newReadyDeps.includes(dep));
                    logger.safeInfoWithoutCustomerData('spa-apps.dashboard.common', `globals [${$6560cd8e50818359$var$formatGlobals(newReadyDeps)}] ready after ${(Date.now() - this.#startTime) / 1000}s, missing globals [${$6560cd8e50818359$var$formatGlobals(this.missingDeps)}]`);
                }
                if (this.missingDeps.length === 0) {
                    this.isReady = true;
                    this.destroy();
                    this.dispatchEvent(new CustomEvent('onReady'));
                    logger.safeInfoWithoutCustomerData('spa-apps.dashboard.common', `all globals [${$6560cd8e50818359$var$formatGlobals((0, $4P2OM.DEPENDENCIES))}] ready after ${(Date.now() - this.#startTime) / 1000}s`);
                }
            }, pollingMs);
            this.#timeoutID = setTimeout(()=>{
                this.destroy();
                if (!this.isReady) {
                    this.isTimedOut = true;
                    this.dispatchEvent(new CustomEvent('onTimeout'));
                    logger.safeErrorWithoutCustomerData('spa-apps.dashboard.common', `timed out polling globals, missing globals [${$6560cd8e50818359$var$formatGlobals(this.missingDeps)}]`);
                }
            }, timeoutMs);
        }, this.destroy = ()=>{
            if (this.#intervalID != null) {
                clearInterval(this.#intervalID);
                this.#intervalID = null;
            }
            if (this.#timeoutID != null) {
                clearTimeout(this.#timeoutID);
                this.#timeoutID = null;
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        this.missingDeps = (0, $4P2OM.DEPENDENCIES).filter((dep)=>!window[dep]);
        if (this.missingDeps.length === 0) {
            logger.safeInfoWithoutCustomerData('spa-apps.dashboard.common', `all globals [${$6560cd8e50818359$var$formatGlobals((0, $4P2OM.DEPENDENCIES))}] ready on initialisation`);
            this.isReady = true;
        } else {
            logger.safeWarnWithoutCustomerData('spa-apps.dashboard.common', `missing globals [${$6560cd8e50818359$var$formatGlobals(this.missingDeps)}]`);
            this.#constructPolling(pollingMs, timeoutMs, logger);
        }
    }
    #constructPolling;
}

});
parcelRegister("4P2OM", function(module, exports) {

$parcel$export(module.exports, "DEPENDENCIES", () => $f910f3784745e897$export$db362e2d293fe52e);
$parcel$export(module.exports, "POLLING_TIMEOUT_MS", () => $f910f3784745e897$export$560b5415aba6175);
const $f910f3784745e897$export$db362e2d293fe52e = [
    'require',
    'jQuery'
];
const $f910f3784745e897$export$560b5415aba6175 = 60000;

});

parcelRegister("euXBp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ae767f7162d54de$export$2e2bcd8739ae039);
class $9ae767f7162d54de$export$2e2bcd8739ae039 {
    constructor(){
        throw new Error('EventTarget is not defined');
    }
}

});



parcelRegister("7vg9b", function(module, exports) {

$parcel$export(module.exports, "useLinkInterceptor", () => $403995a50b1fa001$export$d6b75f959ce086c3);

var $5uXOq = parcelRequire("5uXOq");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $lVJAU = parcelRequire("lVJAU");

var $cdUgf = parcelRequire("cdUgf");

var $2SLmH = parcelRequire("2SLmH");
const $403995a50b1fa001$export$ad8ccaa587ef5e2e = 3984;
// Issue Table meatball menu links
// These have been explicitly ignored as they will generally open modals or perform actions
const $403995a50b1fa001$var$EXCLUDED_ISSUE_TABLE_PATHS = [
    // Assign. The anchor tag it belongs to opens a modal in the monolith.
    /^\/secure\/AssignIssue!default\.jspa/,
    // Assign to me. The anchor tag it belongs to reassigns then reloads page.
    /^\/secure\/AssignIssue\.jspa/,
    // Vote and watch. The anchor tag it belongs to votes/watches on the issue then reloads page.
    /^\/secure\/VoteOrWatchIssue\.jspa/,
    // Rank top. The anchor tag it belongs to ranks the issue to the top then reloads page.
    /^\/secure\/RankTop\.jspa/,
    // Rank bottom. The anchor tag it belongs to ranks the issue to the bottom then reloads page.
    /^\/secure\/RankBottom\.jspa/,
    // Create sub task. The anchor tag it belongs opens a modal in SPA (not monolith)
    /^\/secure\/CreateSubTaskIssue!default\.jspa/,
    // Permission helper. The anchor tag it belongs to opens a modal in monolith.
    /^\/notimportant/,
    // Workflow page. This is when a user transitions an issue, it can open a modal or refresh the modal.
    /^\/secure\/WorkflowUIDispatcher\.jspa/
];
const $403995a50b1fa001$var$EXCLUDED_PATHS = [
    /^\/rest\/(?:gadget|api)\/1\.0\//,
    /^\/plugins\/servlet\/gadgets\/ifr/,
    ...$403995a50b1fa001$var$EXCLUDED_ISSUE_TABLE_PATHS
];
const $403995a50b1fa001$var$isExcludedPath = (path)=>{
    return $403995a50b1fa001$var$EXCLUDED_PATHS.some((regex)=>regex.test(path));
};
const $403995a50b1fa001$export$d6b75f959ce086c3 = (element, isLoading)=>{
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    (0, $5uXOq.useEffect)(()=>{
        if (isLoading) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const linkClickHandler = (event)=>{
            const anchor = event.target instanceof HTMLAnchorElement ? event.target : event.target.closest?.('a');
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (anchor == null || window.location.hostname !== anchor.hostname) // skip if it is not an anchor or to external link
            return;
            if (anchor.href && anchor.href.length > $403995a50b1fa001$export$ad8ccaa587ef5e2e) {
                event.preventDefault();
                const flagConfig = {
                    key: (0, $7HGHK.toFlagId)('urlTooLongWarning'),
                    type: 'error',
                    title: (0, $2SLmH.default).linkInterceptorUrlTooLongTitle,
                    description: (0, $2SLmH.default).linkInterceptorUrlTooLongDescription,
                    messageId: 'dashboard-internal-common.controllers.flag-config.error',
                    messageType: 'transactional'
                };
                showFlag(flagConfig);
            } else if (anchor.pathname && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            !(0, $cdUgf.clickedWithShortcutKeys)(event) && // some links from the monolith code are invalid and calls
            // event.preventDefault (e.g. popups), so we filter those out
            !event.defaultPrevented && !$403995a50b1fa001$var$isExcludedPath(anchor.pathname)) {
                event.preventDefault();
                push(anchor.href);
            }
        };
        element?.addEventListener('click', linkClickHandler);
        return ()=>{
            element?.removeEventListener('click', linkClickHandler);
        };
    }, [
        element,
        isLoading,
        push,
        showFlag
    ]);
};

});
parcelRegister("cdUgf", function(module, exports) {

$parcel$export(module.exports, "clickedWithShortcutKeys", () => $330ad2eb7d232df1$export$141f1be6ae7df96b);
const $330ad2eb7d232df1$export$141f1be6ae7df96b = (e)=>{
    if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey || e.button === 1) return true;
    return false;
};

});

parcelRegister("2SLmH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e234c15db6f6ac4a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e234c15db6f6ac4a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    linkInterceptorUrlTooLongTitle: {
        "id": "dashboard-internal-common.controllers.link-interceptor-url-too-long-title",
        "defaultMessage": "Requested URL too large"
    },
    linkInterceptorUrlTooLongDescription: {
        "id": "dashboard-internal-common.controllers.link-interceptor-url-too-long-description",
        "defaultMessage": "Try shortening the JQL of your saved filter."
    }
});

});


parcelRegister("ikoXd", function(module, exports) {

$parcel$export(module.exports, "getInlineGadgetApi", () => $f1aaef72e172dd4d$export$a7c3539038fb2c0);

var $8Rkzz = parcelRequire("8Rkzz");

var $hh0bW = parcelRequire("hh0bW");

var $2YZCu = parcelRequire("2YZCu");

var $JIPqS = parcelRequire("JIPqS");

var $jcw0u = parcelRequire("jcw0u");

var $19nfo = parcelRequire("19nfo");
const $f1aaef72e172dd4d$export$a7c3539038fb2c0 = ({ gadgetId: gadgetId, amdModule: amdModule, context: context, defaultTitle: defaultTitle, isEditable: isEditable, closeEdit: closeEdit, ref: ref, setIsLoading: setIsLoading, setDefaultTitle: setDefaultTitle, reportGadgetMetrics: reportGadgetMetrics = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), dashboardId: dashboardId, setPreferences: setPreferences, addEventHandler: addEventHandler, removeEventHandlers: removeEventHandlers, triggerEvent: triggerEvent, shouldUseCache: shouldUseCache, view: view, setError: setError })=>{
    const resize = ()=>{
        if (!dashboardId || !gadgetId) return;
        // Store current height of gadget in local storage
        const height = ref.current?.getBoundingClientRect().height;
        (0, $19nfo.updateLocalStorageHeight)(dashboardId, gadgetId, height);
    };
    const moduleAPI = {
        on: (id, handler)=>addEventHandler(id, handler),
        once: (id, handler)=>addEventHandler(id, handler, true),
        off: (id, handler)=>removeEventHandlers(id, handler),
        trigger: (id)=>triggerEvent(id)
    };
    const expAttributes = {
        analyticsSource: 'dashboard',
        experience: (0, $JIPqS.SAVE_AMD_GADGET_CONFIG_PREFERENCES),
        application: null,
        edition: null,
        additionalAttributes: {}
    };
    return {
        gadget: {
            amdModule: amdModule,
            context: context,
            moduleAPI: moduleAPI
        },
        showLoadingBar: ()=>{
            setIsLoading(true);
        },
        resize: resize,
        isEditable: ()=>isEditable,
        savePreferences: async (preferences)=>{
            // IMPORTANT
            //  per JDAG-413 we need to batch react state updates with route resource update
            const maybePromise = setPreferences(preferences, ()=>{
                setError(null);
                closeEdit();
            });
            if (!maybePromise) return;
            try {
                await maybePromise;
                (0, $hh0bW.default)({
                    ...expAttributes,
                    wasExperienceSuccesful: true
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                (0, $2YZCu.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.amd.api', `${e.message} [${defaultTitle}]`);
                setError((0, $JIPqS.GADGET_ERROR_TYPE).CONFIG_ERROR);
                (0, $hh0bW.default)({
                    ...expAttributes,
                    wasExperienceSuccesful: false
                });
                (0, $jcw0u.default)({
                    error: e,
                    meta: {
                        id: (0, $JIPqS.SAVE_AMD_GADGET_CONFIG_PREFERENCES),
                        packageName: 'jiraDashboardInternalCommon'
                    }
                });
            }
        },
        setTitle: setDefaultTitle,
        hideLoadingBar: ()=>setIsLoading(false),
        initRefresh: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        getRefreshFieldValue: (fieldName)=>{
            const input = ref.current?.querySelector(`input[name=${fieldName || 'refresh'}]`);
            if (input == null || !(input instanceof HTMLInputElement) || !input.checked) return 'false';
            return input.value;
        },
        getGadgetId: ()=>gadgetId,
        closeEdit: closeEdit,
        // deprecated
        forceLayoutRefresh: ()=>{
            (0, $2YZCu.default).safeWarnWithoutCustomerData('endeavour.spa.dashboard.gadget.amd.api', 'deprecated forceLayoutRefresh() is called');
            resize();
        },
        publicInstace: ()=>(0, $2YZCu.default).safeWarnWithoutCustomerData('endeavour.spa.dashboard.gadget.amd.api', 'Unexpected public instance called'),
        _preparePreferencesToBeSaved: (preference)=>{
            let preferenceStr = '';
            try {
                preferenceStr = JSON.stringify(preference);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                preferenceStr = 'non-stringifiable type';
            }
            (0, $2YZCu.default).safeWarnWithoutCustomerData('endeavour.spa.dashboard.gadget.amd.api', `Unexpected prepare preferences called with ${preferenceStr} for ${defaultTitle}`);
        },
        getContext: ()=>context,
        // deprecated, replaced by react life cycle
        ...moduleAPI,
        listenTo: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        stopListening: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        listenToOnce: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        reportGadgetMetrics: reportGadgetMetrics,
        shouldUseCache: shouldUseCache,
        view: view
    };
};

});

parcelRegister("WIEWs", function(module, exports) {

$parcel$export(module.exports, "styleOverrideFromMonolith", () => $ab2b4dcf374b66f3$export$a135452a315aaac8);
$parcel$export(module.exports, "editModeStyleOverrideFromMonolith", () => $ab2b4dcf374b66f3$export$5dd19c8cd0b42775);
$parcel$export(module.exports, "Container", () => $ab2b4dcf374b66f3$export$42a852a2b6b56249);
$parcel$export(module.exports, "SkeletonWrapper", () => $ab2b4dcf374b66f3$export$6069cbe61f690103);
$parcel$export(module.exports, "GadgetContainer", () => $ab2b4dcf374b66f3$export$3f9afbcf9557b0b4);
$parcel$export(module.exports, "ConfigureButton", () => $ab2b4dcf374b66f3$export$b95d78b6ea7efb0b);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cNW3X = parcelRequire("cNW3X");
const $ab2b4dcf374b66f3$export$a135452a315aaac8 = `
.piechart-gadget .piechart-fill {
    opacity: 1
}

.piechart-gadget .legend-icon {
    float: left;
    margin-top: 2px;
    margin-right: 10px
}


.piechart-gadget a {
    color: #0052cc;
    text-decoration: none;
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-size: 14px;
    font-weight: ${"var(--ds-font-weight-regular, 400)"};
    line-height: 20px
}

.piechart-gadget a:focus,.piechart-gadget a:hover {
    color: #0065ff;
    text-decoration: underline
}

.piechart-gadget a:active {
    color: #0049b0;
    text-decoration: underline
}

.piechart-gadget .legend-wrapper {
    padding: 0 7px 7px 7px;
    max-width: 450px
}

.piechart-gadget .legend-wrapper a {
    text-decoration: none;
    color: ${"var(--ds-text, #172B4D)"};
}

.piechart-gadget .legend-wrapper a:focus,.piechart-gadget .legend-wrapper a:hover {
    color: ${"var(--ds-link, #0C66E4)"};
    text-decoration: underline
}

.piechart-gadget .legend-wrapper a:active {
    color: ${"var(--ds-text, #172B4D)"};
    text-decoration: underline
}

.piechart-gadget .legend-wrapper .legend-item {
    border-top-width: 0;
    border-bottom-width: 0
}

.piechart-gadget .legend-wrapper .legend-item:first-child {
    border-top: 2px solid ${"var(--ds-border-accent-gray, #758195)"};
}

.piechart-gadget .legend-wrapper .legend-item:last-child {
    border-bottom: 2px solid ${"var(--ds-border-accent-gray, #758195)"};
}

.piechart-gadget .legend-wrapper .legend-item .legend-content {
    padding: 8px 7px 8px 7px
}

.piechart-gadget .legend-wrapper .legend-item .legend-content .legend-item-value {
    padding-right: 7px
}

.two-d-container .extra-container {
    padding: 0
}

.two-d-container .extra-container tbody tr:last-child>td,.two-d-container .extra-container tbody tr:last-child>th,.two-d-container .extra-container tbody tr:last-child>tr,.two-d-container .extra-container tbody tr>td:last-child {
    padding: 7px;
    background: ${"var(--ds-background-neutral, #091E420F)"};
}

.two-d-container .data-footer {
    padding: 5px
}

.two-d-container .data-footer p {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: ${"var(--ds-text-subtle, #44546F)"};
    font-size: 14px;
    font-weight: ${"var(--ds-font-weight-regular, 400)"};
    line-height: 20px
}

table.aui thead tr th {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #5e6c84;
    font-size: 12px;
    font-weight: ${"var(--ds-font-weight-semibold, 600)"};
    line-height: 16px;
    padding-top: 4px;
    padding-bottom: 4px
}

table.aui thead .aui-iconfont-up {
    visibility: hidden
}

table.aui thead .aui-iconfont-up:after {
    top: 11px;
    margin-left: -16px;
    content: "";
    display: inline-block;
    width: 4px;
    height: 4px;
    border: none;
    border-right: 2px solid;
    border-top: 2px solid;
    transform: rotate(-45deg);
    visibility: visible;
    float: right;
    position: relative;
    top: 8px
}

table.aui thead .aui-iconfont-down {
    visibility: hidden
}

table.aui thead .aui-iconfont-down:after {
    top: 11px;
    margin-left: -16px;
    content: "";
    display: inline-block;
    width: 4px;
    height: 4px;
    border: none;
    border-right: 2px solid;
    border-top: 2px solid;
    transform: rotate(135deg);
    visibility: visible;
    float: right;
    position: relative;
    top: 6px
}

table.aui tbody:before {
    height: 0
}

table.aui tbody a {
    text-decoration: none;
    color: ${"var(--ds-link, #0C66E4)"};
}

table.aui tbody a:focus,table.aui tbody a:hover {
    color: ${"var(--ds-link, #0C66E4)"};
    text-decoration: underline
}

table.aui tbody a:active {
    color: ${"var(--ds-link, #0C66E4)"};
    text-decoration: underline
}

table.aui tbody>tr:hover {
    background: #ebecf0
}

table.aui tbody>tr>td:last-child {
    border-left-width: 0
}

table.aui tbody>tr>th {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-size: 14px;
    font-weight: ${"var(--ds-font-weight-regular, 400)"};
    line-height: 20px
}

table.aui tbody>tr:first-child>th {
    border-top-width: 0
}

.stats-gadget {
    padding: 0
}

.stats-gadget tbody a {
    color: #0052cc;
    text-decoration: none;
    color: #5e6c84
}

.stats-gadget tbody a:focus,.stats-gadget tbody a:hover {
    color: #0065ff;
    text-decoration: underline
}

.stats-gadget tbody a:active {
    color: #0049b0;
    text-decoration: underline
}

.stats-gadget tbody tr>td .aui-progress-indicator-value {
    background: #0065ff
}

.stats-gadget tbody tr.stats-gadget-final-row>* {
    font-weight: ${"var(--ds-font-weight-regular, 400)"};
    background: #ebecf0
}

.stats-gadget tbody td {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-size: 14px;
    font-weight: ${"var(--ds-font-weight-regular, 400)"};
    line-height: 20px
}

.stats-gadget tbody:last-child>td,.stats-gadget tbody:last-child>th {
    padding: 7px
}

.favourite-filters-item {
    padding: 0
}

.favourite-filters-item .favourite-filters-view {
    border-top: 2px solid #dfe1e6
}

.favourite-filters-item tbody>tr:first-child td {
    border-top-width: 1px
}

.favourite-filters-item .config-options,.favourite-filters-item .empty-container {
    padding: 6px 0 0 7px
}

.favourite-filters-item .config-options .operations-list .aui-button:first-child,.favourite-filters-item .config-options .operations-list li:first-child,.favourite-filters-item .config-options>div .aui-button:first-child,.favourite-filters-item .config-options>div li:first-child,.favourite-filters-item .empty-container .operations-list .aui-button:first-child,.favourite-filters-item .empty-container .operations-list li:first-child,.favourite-filters-item .empty-container>div .aui-button:first-child,.favourite-filters-item .empty-container>div li:first-child {
    display: none
}

.favourite-filters-item .config-options .operations-list .aui-button:nth-child(2),.favourite-filters-item .config-options>div .aui-button:nth-child(2),.favourite-filters-item .empty-container .operations-list .aui-button:nth-child(2),.favourite-filters-item .empty-container>div .aui-button:nth-child(2) {
    margin-left: 0;
    padding-left: 0
}

.favourite-filters-item .config-options .operations-list a,.favourite-filters-item .config-options>div a,.favourite-filters-item .empty-container .operations-list a,.favourite-filters-item .empty-container>div a {
    color: #0052cc;
    text-decoration: none;
    color: #5e6c84
}

.favourite-filters-item .config-options .operations-list a:focus,.favourite-filters-item .config-options .operations-list a:hover,.favourite-filters-item .config-options>div a:focus,.favourite-filters-item .config-options>div a:hover,.favourite-filters-item .empty-container .operations-list a:focus,.favourite-filters-item .empty-container .operations-list a:hover,.favourite-filters-item .empty-container>div a:focus,.favourite-filters-item .empty-container>div a:hover {
    color: #0065ff;
    text-decoration: underline
}

.favourite-filters-item .config-options .operations-list a:active,.favourite-filters-item .config-options>div a:active,.favourite-filters-item .empty-container .operations-list a:active,.favourite-filters-item .empty-container>div a:active {
    color: #0049b0;
    text-decoration: underline
}

.createdvsresolved-gadget {
    padding: 0
}

.createdvsresolved-gadget a {
    color: #0052cc;
    text-decoration: none;
    color: #5e6c84
}

.createdvsresolved-gadget a:focus,.createdvsresolved-gadget a:hover {
    color: #0065ff;
    text-decoration: underline
}

.createdvsresolved-gadget a:active {
    color: #0049b0;
    text-decoration: underline
}

.createdvsresolved-gadget .createdvsresolved-chart text {
    fill: #091e42
}

.createdvsresolved-gadget .createdvsresolved-chart .grid line,.createdvsresolved-gadget .createdvsresolved-chart .versions line {
    stroke: #dfe1e6
}

.createdvsresolved-gadget .createdvsresolved-chart .created path,.createdvsresolved-gadget .createdvsresolved-chart .created-points circle {
    stroke: #ff5630
}

.createdvsresolved-gadget .createdvsresolved-chart .resolved path,.createdvsresolved-gadget .createdvsresolved-chart .resolved-points circle {
    stroke: #36b37e
}

.createdvsresolved-gadget .createdvsresolved-chart-info {
    padding-left: 7px
}

.createdvsresolved-gadget .createdvsresolved-chart-details-link {
    display: block;
    margin-left: 0
}

.createdvsresolved-gadget .createdvsresolved-chart-details-grouping {
    margin-left: 0
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .created-totals svg {
    padding-bottom: 2px
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .created-totals svg circle {
    stroke: #ff5630
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .resolved-totals svg {
    padding-bottom: 2px
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .resolved-totals svg circle {
    stroke: #36b37e
}`;
const $ab2b4dcf374b66f3$export$5dd19c8cd0b42775 = `
form.aui .buttons-container .buttons, form.aui .submit-cancel-controls {
    text-align: end;
}
.piechart-gadget .dashboard-item-preferences-config {
    margin: -20px
}
`;
const $ab2b4dcf374b66f3$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $ab2b4dcf374b66f3$export$6069cbe61f690103 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _bfhkvuon",
            __cmplp.className
        ])
    });
});
const $ab2b4dcf374b66f3$export$3f9afbcf9557b0b4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isHidden: isHidden, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isHidden && "_3um015vq _kqsw7079",
            __cmplp.className
        ])
    });
});
const $ab2b4dcf374b66f3$export$b95d78b6ea7efb0b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $cNW3X.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01wug",
            __cmplp.className
        ])
    });
});

});


parcelRegister("1NzHy", function(module, exports) {

$parcel$export(module.exports, "Connect", () => $e94ecec6e18bdb3d$export$59e6910693f047c2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");

var $dJZWD = parcelRequire("dJZWD");

var $c1XZn = parcelRequire("c1XZn");

var $8UPoO = parcelRequire("8UPoO");

var $8h45R = parcelRequire("8h45R");

var $8FVKN = parcelRequire("8FVKN");

var $ih7Bj = parcelRequire("ih7Bj");

var $19nfo = parcelRequire("19nfo");
const $e94ecec6e18bdb3d$var$GadgetContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>// for monolith to identify gadget
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e94ecec6e18bdb3d$var$GadgetContainerComponent, {
        className: "connect-gadget",
        ...props,
        ref: ref
    }));
const $e94ecec6e18bdb3d$export$59e6910693f047c2 = ({ dashboardId: dashboardId, gadgetId: gadgetId, inlineHtml: inlineHtml, isLoading: isLoading, isInEditMode: isInEditMode, setIsLoading: setIsLoading, onEditModeCancel: onEditModeCancel, onRegister: onRegister, onUnregister: onUnregister, setTitle: setTitle })=>{
    const divRef = (0, $5uXOq.useRef)(null);
    const isGlobalsReady = (0, $ih7Bj.useIsGlobalsReady)();
    const isDisabled = (0, $8FVKN.useIsConnectDisabled)();
    const forcedHeightFromState = (0, $8h45R.useForcedHeight)(gadgetId);
    const forcedHeight = (0, $5uXOq.useMemo)(()=>forcedHeightFromState ?? (0, $19nfo.getLocalStorageHeight)(dashboardId, gadgetId), [
        forcedHeightFromState,
        dashboardId,
        gadgetId
    ]);
    const onGadgetRender = (0, $8UPoO.useOnGadgetRender)(gadgetId);
    const onRefresh = (0, $8FVKN.useGadgetRefresh)();
    const showSkeleton = isLoading && !isInEditMode;
    (0, $5uXOq.useEffect)(()=>{
        // TODO - inlineHtml missing should be a hard error not a type refinement
        if (!isGlobalsReady || inlineHtml == null) return;
        (0, $dJZWD.setupConnectJs)().then(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const slotHtml = document.createRange().createContextualFragment(inlineHtml);
            if (divRef.current) {
                divRef.current.innerHTML = '';
                divRef.current.appendChild(slotHtml);
                setIsLoading(false);
                onGadgetRender();
            }
        }).catch((error)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.connect', 'Failed to render Connect gadget', error);
        // TODO - where is setError here, where is reportError here?? (compare with amd gadget)
        });
    }, [
        isGlobalsReady,
        inlineHtml,
        onGadgetRender,
        setIsLoading
    ]);
    (0, $5uXOq.useEffect)(()=>{
        onRegister(gadgetId, setTitle);
        return ()=>{
            onUnregister(gadgetId);
        };
    }, [
        gadgetId,
        setTitle,
        onRegister,
        onUnregister
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const target = divRef.current?.getElementsByTagName('iframe')[0];
        if (!target || !isInEditMode || isLoading) return;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.connectHost?.broadcastEvent('jira_dashboard_item_edit', {
            id: target.getAttribute('id')
        });
    }, [
        isInEditMode,
        isLoading
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const connectEventHandler = (event)=>{
            const eventData = event.data;
            const target = divRef.current?.getElementsByTagName('iframe')[0];
            if (target == null || eventData == null || eventData.eid !== target.getAttribute('id')) return;
            if (eventData.type === 'unload') onRefresh();
            else onEditModeCancel();
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('message', connectEventHandler, false);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('message', connectEventHandler);
        };
    }, [
        dashboardId,
        gadgetId,
        inlineHtml,
        isGlobalsReady,
        onRefresh,
        onEditModeCancel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e94ecec6e18bdb3d$var$Container, {
        minHeight: forcedHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e94ecec6e18bdb3d$var$GadgetContainer, {
        id: `gadget-${gadgetId}`,
        "data-gadget-id": gadgetId,
        "data-testid": "dashboard-internal-common.ui.gadget.gadget-inner.connect.connect",
        ref: divRef,
        isHidden: showSkeleton,
        isDisabled: isDisabled
    }), showSkeleton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e94ecec6e18bdb3d$var$SkeletonWrapper, {
        "data-testid": "dashboard-internal-common.ui.gadget.gadget-inner.connect.loading-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1XZn.SkeletonGadgetContent), {
        dashboardId: dashboardId,
        gadgetId: gadgetId
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $e94ecec6e18bdb3d$var$SkeletonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhku67f _kqswstnw _1ltvidpf _154iidpf _1bsb1osq _4t3i1osq _1pby1sen",
            __cmplp.className
        ])
    });
});
const $e94ecec6e18bdb3d$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { minHeight: minHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1l1bpbj": (0, $lD23V.default)(`${__cmplp.minHeight}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1tkemu0a",
            __cmplp.className
        ])
    });
});
const $e94ecec6e18bdb3d$var$GadgetContainerComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isHidden: isHidden, isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isHidden ? "_1e0cglyw" : "_1e0c1kw7",
            __cmplp.isDisabled ? "_lcxvglyw" : "_lcxv1kw7",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9sF5P", function(module, exports) {

$parcel$export(module.exports, "Forge", () => $ce96d098a49d18cb$export$4b9c9e62f20bbcd0);

var $5uXOq = parcelRequire("5uXOq");

var $WjHsO = parcelRequire("WjHsO");

var $JIPqS = parcelRequire("JIPqS");

var $1bM8W = parcelRequire("1bM8W");

var $4qMi4 = parcelRequire("4qMi4");

var $e0AC8 = parcelRequire("e0AC8");

var $lfTZh = parcelRequire("lfTZh");

var $gh1hi = parcelRequire("gh1hi");

var $bVDE5 = parcelRequire("bVDE5");

var $4uQB7 = parcelRequire("4uQB7");

var $c1XZn = parcelRequire("c1XZn");

var $8FVKN = parcelRequire("8FVKN");

var $i0rkS = parcelRequire("i0rkS");

var $5TsWX = parcelRequire("5TsWX");

var $dg9na = parcelRequire("dg9na");
const $ce96d098a49d18cb$export$4b36646b2dadb9ee = ({ gadgetData: gadgetData, forgeKey: forgeKey, isInEditMode: isInEditMode, onEditModeCancel: onEditModeCancel, setIsLoading: setIsLoading })=>{
    const [{ currentPageId: currentPageId }] = (0, $bVDE5.useSpaStateTransition)();
    const { data: dashboardData } = (0, $gh1hi.useDashboardResource)();
    const { data: forgeResourceData, loading: isDashboardForgeResourceLoading, error: resourceError } = (0, $gh1hi.useDashboardForgeResource)();
    const setPreferences = (0, $8FVKN.useGadgetSetPreferences)();
    const [, { broadcastMessage: broadcastMessageBusListener }] = (0, $i0rkS.useMessageBus)();
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [isUpdatePending, setIsUpdatePending] = (0, $5uXOq.useState)(false);
    const reportGadgetMetrics = (0, $5uXOq.useCallback)((eventType, contentType, markName, markStage)=>{
        broadcastMessageBusListener((0, $JIPqS.GADGET_METRICS_TYPE).REPORT, {
            eventType: eventType,
            contentType: contentType,
            markName: markName,
            markStage: markStage,
            source: (0, $5TsWX.FORGE_GADGET_METRICS)
        }, {
            gadgetId: gadgetData.id,
            pageId: currentPageId
        });
    }, [
        gadgetData.id,
        broadcastMessageBusListener,
        currentPageId
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        // gadget container mounted event
        reportGadgetMetrics((0, $5TsWX.GADGET_RENDER_CONTAINER_EVENT), 'View');
    }, [
        reportGadgetMetrics
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isDashboardForgeResourceLoading) setIsLoading(false);
    }, [
        isDashboardForgeResourceLoading,
        setIsLoading
    ]);
    const onConfigurationSave = (0, $5uXOq.useCallback)((dataToSave)=>{
        (0, $1bM8W.fireUiTriggerClickEvent)('dashboardGadgetEdit');
        setIsUpdatePending(true);
        return (0, $dg9na.savePreferences)(gadgetData, dataToSave, setPreferences, setError, ()=>{
            setIsUpdatePending(false);
        });
    }, [
        gadgetData,
        setPreferences,
        setError,
        setIsUpdatePending
    ]);
    const dashboardId = dashboardData?.id || '';
    const extensionData = (0, $5uXOq.useMemo)(()=>({
            gadgetConfiguration: (0, $dg9na.transformUserPrefsForForgeAppConsumption)(gadgetData.userPrefs?.fields),
            dashboard: {
                id: dashboardId
            },
            gadget: {
                id: gadgetData.id
            }
        }), [
        gadgetData.userPrefs?.fields,
        dashboardId,
        gadgetData.id
    ]);
    if (isDashboardForgeResourceLoading || isUpdatePending) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1XZn.SkeletonGadgetContent), null);
    const forgeGadget = forgeResourceData?.gadgets.find((gadget)=>gadget.id === forgeKey);
    if (resourceError || error || !forgeGadget || !dashboardId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uQB7.GadgetErrorFallback), {
        errorType: error ?? (0, $JIPqS.GADGET_ERROR_TYPE).VIEW_ERROR,
        id: gadgetData.id
    });
    return(// have to use Suspense here because AsyncDashboardGadget is lazy loaded using React.lazy()
    // which requires a Suspense further up the tree to work
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-dashboard-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1XZn.SkeletonGadgetContent), null)
    }, isInEditMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WjHsO.AsyncDashboardGadgetEdit), {
        extension: forgeGadget,
        extensionData: extensionData,
        onReportGadgetMetrics: reportGadgetMetrics,
        loadingComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1XZn.SkeletonGadgetContent), null),
        onEditModeCancel: onEditModeCancel,
        onConfigurationSave: onConfigurationSave
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WjHsO.AsyncDashboardGadgetView), {
        extension: forgeGadget,
        extensionData: extensionData,
        onReportGadgetMetrics: reportGadgetMetrics,
        loadingComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1XZn.SkeletonGadgetContent), null)
    })));
};
const $ce96d098a49d18cb$export$4b9c9e62f20bbcd0 = (props)=>{
    const { gadgetData: { id: id }, isInEditMode: isInEditMode } = props;
    const envType = props.gadgetData.forge?.environment;
    const forgeKey = props.gadgetData.forge?.key;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4qMi4.AnalyticsWrapper), {
        attributes: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {
            envType: envType,
            ...forgeKey ? (0, $e0AC8.parseExtensionId)(forgeKey) : {}
        },
        key: `${id}__${isInEditMode}`,
        isInEditMode: isInEditMode,
        errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uQB7.GadgetErrorFallback), {
                errorType: (0, $JIPqS.GADGET_ERROR_TYPE).VIEW_ERROR,
                id: id
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce96d098a49d18cb$export$4b36646b2dadb9ee, props));
};

});
parcelRegister("WjHsO", function(module, exports) {

$parcel$export(module.exports, "AsyncDashboardGadgetView", () => $797cf06bbdcad765$export$8f8b884c8f9b7f99);
$parcel$export(module.exports, "AsyncDashboardGadgetEdit", () => $797cf06bbdcad765$export$11802f9302dce8a3);
// eslint-disable-next-line jira/restricted/react-lazy

var $5uXOq = parcelRequire("5uXOq");

var $1rTGO = parcelRequire("1rTGO");

var $k2DRb = parcelRequire("k2DRb");

var $3mOWa = parcelRequire("3mOWa");

var $4R6GH = parcelRequire("4R6GH");
const $797cf06bbdcad765$var$GADGET_START_EVENT = 'gadget-start';
const $797cf06bbdcad765$var$GADGET_FINISH_EVENT = 'gadget-rendering-finished';

// We are using React.lazy() instead of react-loosley-lazy here because DashboardGadget
// renders RendererNext from the forge-ui package which uses Suspense
// and you can't mix React.Suspense with RLL
const $797cf06bbdcad765$var$getUiKitModule = ()=>(parcelRequire("hqvG9"));
const $797cf06bbdcad765$export$d53932a75c2ba294 = (0, $1rTGO.withMetrics)(/*#__PURE__*/ (0, $5uXOq.lazy)(()=>$797cf06bbdcad765$var$getUiKitModule().then((module)=>({
            default: module.DashboardGadgetView
        }))));
const $797cf06bbdcad765$export$e388a2aaf41cd524 = (0, $1rTGO.withMetrics)(/*#__PURE__*/ (0, $5uXOq.lazy)(()=>$797cf06bbdcad765$var$getUiKitModule().then((module)=>({
            default: module.DashboardGadgetEdit
        }))));

const $797cf06bbdcad765$var$getForgeExtensionModule = ()=>(parcelRequire("eKnA9"));
const $797cf06bbdcad765$export$90dc543486d6f150 = (0, $1rTGO.withMetrics)(/*#__PURE__*/ (0, $5uXOq.lazy)(()=>$797cf06bbdcad765$var$getForgeExtensionModule().then((module)=>({
            default: module.DashboardGadgetViewExtension
        }))));
const $797cf06bbdcad765$export$8a87cc350601aff5 = (0, $1rTGO.withMetrics)(/*#__PURE__*/ (0, $5uXOq.lazy)(()=>$797cf06bbdcad765$var$getForgeExtensionModule().then((module)=>({
            default: module.DashboardGadgetEditExtension
        }))));
const $797cf06bbdcad765$var$useDashboardGadget = (onReportGadgetMetrics, extensionData, entryPoint)=>{
    const onInitialRender = (0, $5uXOq.useCallback)((payload)=>{
        if (payload !== undefined && payload.error == null) onReportGadgetMetrics($797cf06bbdcad765$var$GADGET_FINISH_EVENT, 'View');
        else onReportGadgetMetrics($797cf06bbdcad765$var$GADGET_FINISH_EVENT, 'ErrorMessage');
    }, [
        onReportGadgetMetrics
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        onReportGadgetMetrics($797cf06bbdcad765$var$GADGET_START_EVENT, 'View');
    }, [
        onReportGadgetMetrics
    ]);
    return (0, $5uXOq.useMemo)(()=>{
        const extraPropsUiCommon = {
            module: (0, $k2DRb.DASHBOARD_GADGET_MODULE),
            entryPoint: entryPoint,
            extensionData: {
                ...extensionData,
                entryPoint: entryPoint,
                type: (0, $k2DRb.DASHBOARD_GADGET_MODULE)
            },
            ...(0, $4R6GH.fg)('add-fct-to-forge-jira-modules') && {
                contextToken: (0, $k2DRb.CONTEXT_TOKEN_TYPE_JIRA)
            }
        };
        return {
            onInitialRender: onInitialRender,
            extraPropsUiCommon: extraPropsUiCommon
        };
    }, [
        entryPoint,
        extensionData,
        onInitialRender
    ]);
};
const $797cf06bbdcad765$export$8f8b884c8f9b7f99 = (props)=>{
    const { extensionData: extensionData, onReportGadgetMetrics: onReportGadgetMetrics, ...restProps } = props;
    const { onInitialRender: onInitialRender, extraPropsUiCommon: extraPropsUiCommon } = $797cf06bbdcad765$var$useDashboardGadget(onReportGadgetMetrics, extensionData);
    const extraPropsUiKit = {
        ...extraPropsUiCommon,
        onInitialRender: onInitialRender
    };
    const extraPropsCustomUi = {
        ...extraPropsUiCommon,
        onLoad: onInitialRender
    };
    if ((0, $3mOWa.isNativeUiExtension)(props.extension) || (0, $3mOWa.isCustomUIExtension)(props.extension)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($797cf06bbdcad765$export$90dc543486d6f150, {
        ...restProps,
        ...extraPropsCustomUi
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($797cf06bbdcad765$export$d53932a75c2ba294, {
        ...restProps,
        ...extraPropsUiKit
    });
};
const $797cf06bbdcad765$export$11802f9302dce8a3 = (props)=>{
    const { extensionData: extensionData, onReportGadgetMetrics: onReportGadgetMetrics, ...restProps } = props;
    const { onInitialRender: onInitialRender, extraPropsUiCommon: extraPropsUiCommon } = $797cf06bbdcad765$var$useDashboardGadget(onReportGadgetMetrics, extensionData, (0, $k2DRb.ENTRY_POINT_EDIT));
    const extraPropsUiKitEdit = {
        ...extraPropsUiCommon,
        onInitialRender: onInitialRender
    };
    const extraPropsCustomUiEdit = {
        ...extraPropsUiCommon,
        onLoad: onInitialRender
    };
    if ((0, $3mOWa.isNativeUiExtension)(props.extension, (0, $k2DRb.ENTRY_POINT_EDIT)) || (0, $3mOWa.isCustomUIExtension)(props.extension, (0, $k2DRb.ENTRY_POINT_EDIT))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($797cf06bbdcad765$export$8a87cc350601aff5, {
        ...restProps,
        ...extraPropsCustomUiEdit
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($797cf06bbdcad765$export$e388a2aaf41cd524, {
        ...restProps,
        ...extraPropsUiKitEdit
    });
};

});
parcelRegister("hqvG9", function(module, exports) {

let $cafd7027c444f8e7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cafd7027c444f8e7$var$load("i0S0H").then(()=>parcelRequire('3JVox'));

});

parcelRegister("eKnA9", function(module, exports) {

let $abc7a777a0b4770a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $abc7a777a0b4770a$var$load("kWrFZ"),
    $abc7a777a0b4770a$var$load("cM9em"),
    $abc7a777a0b4770a$var$load("fr9NE"),
    $abc7a777a0b4770a$var$load("hPzOn"),
    $abc7a777a0b4770a$var$load("h2MrD"),
    $abc7a777a0b4770a$var$load("bYT2S"),
    $abc7a777a0b4770a$var$load("jZDL6")
]).then(()=>parcelRequire('1CNt0'));

});


parcelRegister("1bM8W", function(module, exports) {

$parcel$export(module.exports, "fireTrackEditedEvent", () => $32b5ad7fb71ba34b$export$1798d320c6527c08);
$parcel$export(module.exports, "fireOperationalEditFailedEvent", () => $32b5ad7fb71ba34b$export$762dee9e981de3e1);
$parcel$export(module.exports, "fireUiTriggerClickEvent", () => $32b5ad7fb71ba34b$export$cfefb608fbbf02c9);

var $k2DRb = parcelRequire("k2DRb");

var $8uOa6 = parcelRequire("8uOa6");

var $9BrHy = parcelRequire("9BrHy");

var $hBuqR = parcelRequire("hBuqR");

var $4R6GH = parcelRequire("4R6GH");
const $32b5ad7fb71ba34b$var$moduleEventId = (0, $9BrHy.getEventIdOld)({
    module: (0, $k2DRb.DASHBOARD_GADGET_MODULE),
    moduleType: (0, $hBuqR.MODULE_TYPE_EXTENSION),
    entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT)
});
const $32b5ad7fb71ba34b$var$triggerEventId = (0, $9BrHy.getEventIdOld)({
    module: (0, $k2DRb.DASHBOARD_GADGET_MODULE),
    moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER),
    entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT)
});
const $32b5ad7fb71ba34b$export$1798d320c6527c08 = (source, attributes)=>(0, $8uOa6.fireTrackEvent)((0, $hBuqR.TRACK_ACTIONS).EDITED, {
        id: (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: (0, $k2DRb.DASHBOARD_GADGET_MODULE),
            moduleType: (0, $hBuqR.MODULE_TYPE_EXTENSION),
            entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT)
        }) : $32b5ad7fb71ba34b$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $32b5ad7fb71ba34b$export$762dee9e981de3e1 = (source, attributes)=>(0, $8uOa6.fireOperationalEvent)((0, $hBuqR.OPERATIONAL_ACTIONS).EDIT_FAILED, {
        id: (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: (0, $k2DRb.DASHBOARD_GADGET_MODULE),
            moduleType: (0, $hBuqR.MODULE_TYPE_EXTENSION),
            entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT)
        }) : $32b5ad7fb71ba34b$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $32b5ad7fb71ba34b$export$cfefb608fbbf02c9 = (source, attributes)=>(0, $8uOa6.fireUiEvent)((0, $hBuqR.UI_ACTIONS).CLICKED, {
        id: (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: (0, $k2DRb.DASHBOARD_GADGET_MODULE),
            moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER),
            entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT)
        }) : $32b5ad7fb71ba34b$var$triggerEventId,
        source: source,
        attributes: attributes
    });

});

parcelRegister("4qMi4", function(module, exports) {

$parcel$export(module.exports, "AnalyticsWrapper", () => $03ae219febd68629$export$63b55d605f8a2340);

var $5uXOq = parcelRequire("5uXOq");

var $k2DRb = parcelRequire("k2DRb");

var $1rTGO = parcelRequire("1rTGO");
const $03ae219febd68629$export$63b55d605f8a2340 = (props)=>{
    const { isInEditMode: isInEditMode, ...restProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        ...restProps,
        module: (0, $k2DRb.DASHBOARD_GADGET_MODULE),
        entryPoint: isInEditMode ? (0, $k2DRb.ENTRY_POINT_EDIT) : undefined,
        shouldFireInitializedEvent: true
    });
};

});

parcelRegister("dg9na", function(module, exports) {

$parcel$export(module.exports, "savePreferences", () => $7fcdc9b72606be07$export$f1786e2fa4419c16);
$parcel$export(module.exports, "transformUserPrefsForForgeAppConsumption", () => $7fcdc9b72606be07$export$b5d9bfce42b49862);

var $hh0bW = parcelRequire("hh0bW");

var $2YZCu = parcelRequire("2YZCu");

var $JIPqS = parcelRequire("JIPqS");

var $jcw0u = parcelRequire("jcw0u");

var $1bM8W = parcelRequire("1bM8W");
const $7fcdc9b72606be07$var$expAttributes = {
    analyticsSource: 'dashboard',
    experience: (0, $JIPqS.SAVE_FORGE_GADGET_CONFIG_PREFERENCES),
    application: null,
    edition: null,
    additionalAttributes: {}
};
const $7fcdc9b72606be07$export$f1786e2fa4419c16 = async (data, preferences, setPreferences, setError, onComplete)=>{
    const { title: defaultTitle } = data;
    // the backend checks that each user pref value is valid json
    // so we need to stringify string values eg ""value""
    // this is done inside the gadget for other gadget types but
    // we need to do it here for forge
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const newUserPrefs = {};
    Object.entries(preferences).forEach(([key, value])=>{
        newUserPrefs[key] = typeof value === 'string' ? JSON.stringify(value) : value;
    });
    const maybePromise = setPreferences(newUserPrefs, onComplete);
    if (!maybePromise) return;
    try {
        await maybePromise;
        setError(null);
        (0, $hh0bW.default)({
            ...$7fcdc9b72606be07$var$expAttributes,
            wasExperienceSuccesful: true
        });
        (0, $1bM8W.fireTrackEditedEvent)('dashboardGadgetEdit');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.forge', `${e.message} [${defaultTitle}]`);
        setError((0, $JIPqS.GADGET_ERROR_TYPE).CONFIG_ERROR);
        (0, $hh0bW.default)({
            ...$7fcdc9b72606be07$var$expAttributes,
            wasExperienceSuccesful: false
        });
        (0, $jcw0u.default)({
            error: e,
            meta: {
                id: (0, $JIPqS.SAVE_FORGE_GADGET_CONFIG_PREFERENCES),
                packageName: 'jiraDashboardInternalCommon'
            }
        });
        (0, $1bM8W.fireOperationalEditFailedEvent)('dashboardGadgetEdit', {
            error: e
        });
    }
};
// user prefs with a string value are encoded like "&quot;value&quot;" so we need to
// decode them for forge gadgets
const $7fcdc9b72606be07$var$decodeQuotes = (value)=>value.replace(/(?:&quot;)/gm, '"');
const $7fcdc9b72606be07$export$b5d9bfce42b49862 = (userPrefsFields)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const transformedUserPrefs = {};
    if (userPrefsFields !== undefined) userPrefsFields.forEach((field)=>{
        if (field.name !== 'isConfigured') // the backend stringifies all configuration values,
        // we need to parse them here for forge gadgets
        transformedUserPrefs[field.name] = JSON.parse($7fcdc9b72606be07$var$decodeQuotes(field.value));
    });
    return transformedUserPrefs;
};

});


parcelRegister("k3y1k", function(module, exports) {

$parcel$export(module.exports, "InlineHtml", () => $4f214ca561897841$export$109427fbef437c1e);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $8iquX = parcelRequire("8iquX");

var $344pu = parcelRequire("344pu");

var $8UPoO = parcelRequire("8UPoO");

var $7vg9b = parcelRequire("7vg9b");
const $4f214ca561897841$export$109427fbef437c1e = ({ id: id, inlineHtml: inlineHtml, isLoading: isLoading, setIsLoading: setIsLoading })=>{
    const inlineHtmlRef = (0, $5uXOq.useRef)(null);
    const [hasIntroLogo, setHasIntroLogo] = (0, $5uXOq.useState)(false);
    (0, $7vg9b.useLinkInterceptor)(inlineHtmlRef.current, isLoading);
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const slotHtml = document.createRange().createContextualFragment(inlineHtml);
        if (inlineHtmlRef.current) {
            inlineHtmlRef.current.innerHTML = '';
            inlineHtmlRef.current.appendChild(slotHtml);
            const introLogoElement = inlineHtmlRef.current.querySelector('.intro-logo');
            if (introLogoElement) setHasIntroLogo(true);
        }
        setIsLoading(false);
    }, [
        inlineHtml,
        setIsLoading
    ]);
    (0, $8UPoO.useOnGadgetRenderEffect)(id, inlineHtmlRef.current);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8iquX.default), {
        name: "inline-html-gadget",
        hold: isLoading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: hasIntroLogo && $4f214ca561897841$var$introStyles
    }, hasIntroLogo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $344pu.default), {
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        id: `gadget-${id}`,
        ref: inlineHtmlRef
    })));
};
const $4f214ca561897841$var$introStyles = (0, $2s57o.xcss)({
    overflow: 'auto',
    height: '160px',
    display: 'flex',
    justifyContent: 'space-around',
    padding: 'space.200',
    gap: 'space.200'
});

});
parcelRegister("344pu", function(module, exports) {

$parcel$export(module.exports, "default", () => $031bf061693e3531$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $dCLgq = parcelRequire("dCLgq");

var $6EOSB = parcelRequire("6EOSB");
const $031bf061693e3531$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($6EOSB)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($6EOSB))
});
var $031bf061693e3531$export$2e2bcd8739ae039 = $031bf061693e3531$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $031bf061693e3531$export$a179c88182cb9d56 = [
    0,
    0,
    431,
    406
];

});
parcelRegister("6EOSB", function(module, exports) {
module.exports = new URL("graph-go-up-with-people.4705ad58.svg", import.meta.url).toString();

});



parcelRegister("ce1BZ", function(module, exports) {

$parcel$export(module.exports, "ReactGadget", () => $e6dfd10c598d91ed$export$561f0f8350aca3ee);

var $5uXOq = parcelRequire("5uXOq");

var $hh0bW = parcelRequire("hh0bW");

var $JIPqS = parcelRequire("JIPqS");

var $7CMCs = parcelRequire("7CMCs");

var $bVDE5 = parcelRequire("bVDE5");

var $4uQB7 = parcelRequire("4uQB7");

var $8FVKN = parcelRequire("8FVKN");

var $i0rkS = parcelRequire("i0rkS");

var $5TsWX = parcelRequire("5TsWX");

var $kMe81 = parcelRequire("kMe81");
const $e6dfd10c598d91ed$var$expAttributes = {
    analyticsSource: 'dashboard',
    application: null,
    edition: null,
    additionalAttributes: {}
};
const $e6dfd10c598d91ed$export$561f0f8350aca3ee = ({ id: id, userPrefs: userPrefs, isInEditMode: isInEditMode, reactKey: reactKey, onEditModeCancel: onEditModeCancel, onRenderComplete: onRenderComplete, setDefaultTitle: setDefaultTitle, customSkeletonHeightInPx: customSkeletonHeightInPx })=>{
    const [{ currentPageId: currentPageId }] = (0, $bVDE5.useSpaStateTransition)();
    const [, { broadcastMessage: broadcastMessageBusListener }] = (0, $i0rkS.useMessageBus)();
    const setPreferences = (0, $8FVKN.useGadgetSetPreferences)();
    const ref = (0, $5uXOq.useRef)(null);
    const isExperienceCompletedRef = (0, $5uXOq.useRef)(false);
    const { state: state, componentView: ComponentView, componentEdit: ComponentEdit, setState: setState } = (0, $kMe81.useReactGadgetState)(id, reactKey);
    const experienceKey = `${(0, $JIPqS.VIEW_REACT_GADGET_EXPERIENCE)}-${reactKey.split('/')[1]}`; // e.g. view-react-gadget-filter-results
    const reportGadgetMetrics = (0, $5uXOq.useCallback)((eventType)=>{
        broadcastMessageBusListener((0, $JIPqS.GADGET_METRICS_TYPE).REPORT, {
            eventType: eventType,
            contentType: isInEditMode ? 'Config' : 'View',
            source: (0, $5TsWX.REACT_GADGET_METRICS)
        }, {
            gadgetId: id,
            pageId: currentPageId
        });
    }, [
        broadcastMessageBusListener,
        isInEditMode,
        id,
        currentPageId
    ]);
    const reportGadgetStart = (0, $5uXOq.useCallback)(()=>{
        reportGadgetMetrics((0, $5TsWX.GADGET_START_EVENT));
    }, [
        reportGadgetMetrics
    ]);
    const onGadgetFinish = (0, $5uXOq.useCallback)(// this API is not ideal, but a temporary solution to allow gadget to not save height to localStorage
    (shouldPersistHeight = true)=>{
        if (shouldPersistHeight) {
            const height = ref.current?.getBoundingClientRect().height;
            onRenderComplete(height);
        }
        reportGadgetMetrics((0, $5TsWX.GADGET_RENDERING_FINISHED_EVENT));
        if (!isExperienceCompletedRef.current) {
            (0, $hh0bW.default)({
                ...$e6dfd10c598d91ed$var$expAttributes,
                experience: experienceKey,
                wasExperienceSuccesful: true
            });
            isExperienceCompletedRef.current = true;
        }
    }, [
        reportGadgetMetrics,
        onRenderComplete,
        experienceKey
    ]);
    const errorFallback = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uQB7.GadgetErrorFallback), {
            id: id,
            errorType: (0, $JIPqS.GADGET_ERROR_TYPE).VIEW_ERROR
        }), [
        id
    ]);
    const sendFailExperience = (0, $5uXOq.useCallback)(()=>{
        if (!isExperienceCompletedRef.current) {
            (0, $hh0bW.default)({
                ...$e6dfd10c598d91ed$var$expAttributes,
                experience: experienceKey,
                wasExperienceSuccesful: false
            });
            isExperienceCompletedRef.current = true;
        }
    }, [
        experienceKey
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        // gadget container mounted event
        reportGadgetMetrics((0, $5TsWX.GADGET_RENDER_CONTAINER_EVENT));
    }, [
        reportGadgetMetrics
    ]);
    const setGadgetContentTitle = (0, $5uXOq.useCallback)((contentTitle)=>{
        setDefaultTitle((initialDefaultTitle)=>contentTitle ? `${initialDefaultTitle}: ${contentTitle}` : initialDefaultTitle);
    }, [
        setDefaultTitle
    ]);
    const Component = isInEditMode ? ComponentEdit : ComponentView;
    if (state instanceof Error) {
        sendFailExperience();
        throw state;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: errorFallback,
        packageName: "jiraDashboardInternalCommon",
        id: reactKey,
        teamName: "endeavour",
        onError: sendFailExperience,
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: ref
    }, Component && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
        setPreferences: setPreferences,
        state: state,
        onGadgetStart: reportGadgetStart,
        onGadgetFinish: onGadgetFinish,
        userPrefs: userPrefs,
        onEditModeCancel: onEditModeCancel,
        setState: setState,
        setGadgetContentTitle: setGadgetContentTitle,
        customSkeletonHeightInPx: customSkeletonHeightInPx
    })));
};

});
parcelRegister("kMe81", function(module, exports) {

$parcel$export(module.exports, "useReactGadgetState", () => $6bed3136adbdd754$export$8e5d1b52830d94a5);

var $5uXOq = parcelRequire("5uXOq");

var $kspzT = parcelRequire("kspzT");

var $gh1hi = parcelRequire("gh1hi");

var $iXzvf = parcelRequire("iXzvf");
const $6bed3136adbdd754$export$8e5d1b52830d94a5 = (id, reactKey)=>{
    const { data: data, update: update, loading: loading, error: error } = (0, $gh1hi.useDashboardReactGadgetsResource)();
    const reactGadgetsState = data?.reactGadgetsState ?? null;
    const state = (()=>{
        if (reactGadgetsState != null && id in reactGadgetsState) return reactGadgetsState[id];
        if (loading) return null;
        if (reactGadgetsState == null) return error ?? new Error('Gadget resource not initialised');
        return new Error(`Gadget state not found in initialised resource for gadget with reactKey: "${reactKey}" and ID: "${id}"`);
    })();
    const { componentView: componentView, componentEdit: componentEdit } = (0, $kspzT.default)[reactKey];
    const setState = (0, $5uXOq.useCallback)((setterOrValue)=>{
        if (reactGadgetsState && id in reactGadgetsState) update((0, $iXzvf.lensReactGadget)(id, setterOrValue));
    }, [
        update,
        reactGadgetsState,
        id
    ]);
    return {
        state: state,
        componentView: componentView,
        componentEdit: componentEdit,
        setState: setState
    };
};

});



parcelRegister("4ozF0", function(module, exports) {

$parcel$export(module.exports, "GadgetLayoutWithAnalytics", () => $a21461a35586ce8b$export$fbd1c75042cfdd67);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $JIPqS = parcelRequire("JIPqS");

var $7CMCs = parcelRequire("7CMCs");

var $iXVV6 = parcelRequire("iXVV6");

var $4uQB7 = parcelRequire("4uQB7");

var $lE1Ya = parcelRequire("lE1Ya");

var $grY2f = parcelRequire("grY2f");
function $a21461a35586ce8b$export$fbd1c75042cfdd67({ gadgetData: gadgetData, isDisplayed: isDisplayed, header: header, isContentHidden: isContentHidden, customWrapperStyles: customWrapperStyles, children: children, footer: footer, customPlaceholder: customPlaceholder }) {
    const { id: id, color: color, title: title, errorMessage: errorMessage } = gadgetData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        objectType: "gadget",
        objectId: gadgetData.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "gadget",
        packageName: "jiraDashboardInternalCommon",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: [
            isDisplayed ? $a21461a35586ce8b$var$wrapperStyles : $a21461a35586ce8b$var$gadgetNotDisplayedStyles,
            ...Array.isArray(customWrapperStyles) ? customWrapperStyles : [
                customWrapperStyles
            ],
            color && $a21461a35586ce8b$var$colorsMap[color]
        ],
        id: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        id: `gadget-title-${id}`
    }, header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        "aria-labelledby": `gadget-title-${id}`,
        id: `gadget-content-${id}`,
        role: "region"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $grY2f.GadgetBoundary), {
        data: gadgetData,
        isError: !title,
        errorFallback: errorMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uQB7.GadgetErrorFallbackBase), {
            id: id,
            message: errorMessage
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uQB7.GadgetErrorFallback), {
            id: id,
            errorType: !title ? (0, $JIPqS.GADGET_ERROR_TYPE).NOT_SUPPORTED_ERROR : (0, $JIPqS.GADGET_ERROR_TYPE).VIEW_ERROR
        }),
        customPlaceholder: customPlaceholder
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: [
            isContentHidden ? $a21461a35586ce8b$var$contentHiddenStyles : $a21461a35586ce8b$var$contentStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lE1Ya.GadgetAnalyticsContainer), {
        data: gadgetData
    }, children), footer))))));
}
const $a21461a35586ce8b$var$wrapperStyles = (0, $2s57o.xcss)({
    boxShadow: 'elevation.shadow.raised',
    borderTopWidth: '4px',
    borderTopStyle: 'solid',
    borderRadius: 'border.radius.100',
    marginBottom: 'space.200',
    background: "var(--ds-surface-raised, #FFFFFF)",
    paddingInline: 'space.200',
    paddingBottom: 'space.200',
    position: 'relative',
    borderColor: 'color.border.brand'
});
const $a21461a35586ce8b$var$gadgetNotDisplayedStyles = (0, $2s57o.xcss)({
    display: 'none'
});
const $a21461a35586ce8b$var$colorsMap = Object.fromEntries(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore-next-line The borderColor value isn't a valid token
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
Object.entries((0, $JIPqS.COLOR_MAP)).map(([key, value])=>[
        key,
        (0, $2s57o.xcss)({
            borderColor: value
        })
    ]));
const $a21461a35586ce8b$var$contentStyles = (0, $2s57o.xcss)({
    overflowWrap: 'anywhere'
});
const $a21461a35586ce8b$var$contentHiddenStyles = (0, $2s57o.xcss)({
    display: 'none'
});

});
parcelRegister("lE1Ya", function(module, exports) {

$parcel$export(module.exports, "GadgetAnalyticsContainer", () => $8dd46ecf3ec4fed0$export$33d5cbc3e6507749);

var $5uXOq = parcelRequire("5uXOq");

var $bOnpg = parcelRequire("bOnpg");

var $3Wusa = parcelRequire("3Wusa");
const $8dd46ecf3ec4fed0$export$33250e472f9e12c2 = 4840;
const $8dd46ecf3ec4fed0$export$33d5cbc3e6507749 = ({ data: data, children: children })=>{
    const fireAnalytics = (0, $bOnpg.useDashboardAnalytics)();
    const eventSent = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (data !== null && eventSent.current === false) {
            fireAnalytics({
                ...(0, $3Wusa.getGadgetAnalyticsProps)(data),
                action: 'viewed'
            });
            eventSent.current = true;
        }
    }, [
        data,
        fireAnalytics
    ]);
    if (!data) return null;
    if (data.renderedGadgetUrl != null && data.renderedGadgetUrl.length > $8dd46ecf3ec4fed0$export$33250e472f9e12c2) {
        if (eventSent.current === false) {
            fireAnalytics({
                ...(0, $3Wusa.getGadgetAnalyticsProps)(data),
                action: 'viewedFailed'
            });
            eventSent.current = true;
        }
        throw new Error('Request header is too large');
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};

});
parcelRegister("3Wusa", function(module, exports) {

$parcel$export(module.exports, "getGadgetAnalyticsProps", () => $ad3242df71f39677$export$42d88d3ece4aff0);


var $kspzT = parcelRequire("kspzT");
const $ad3242df71f39677$export$42d88d3ece4aff0 = (data)=>{
    let gadgetType = 'UNKNOWN_GADGET';
    if (data.amdModule != null) gadgetType = data.amdModule;
    else if (data.forge != null) gadgetType = data.forge.key;
    else if ((0, $kspzT.isReactKey)(data.reactKey)) gadgetType = data.reactKey;
    return {
        eventType: (0, $4d5e0871c06cee03$export$947dac6c72b26f81),
        actionSubjectId: 'gadget',
        actionSubject: 'gadget',
        attributes: {
            gadgetTitle: data.title,
            gadgetType: gadgetType
        }
    };
};

});


parcelRegister("grY2f", function(module, exports) {

$parcel$export(module.exports, "GadgetBoundary", () => $4828aa186ac8828a$export$9327e9e817f0323d);

var $5uXOq = parcelRequire("5uXOq");

var $JIPqS = parcelRequire("JIPqS");

var $7CMCs = parcelRequire("7CMCs");

var $c1XZn = parcelRequire("c1XZn");

var $8UPoO = parcelRequire("8UPoO");

var $8FVKN = parcelRequire("8FVKN");
const $4828aa186ac8828a$export$9327e9e817f0323d = ({ data: data, errorFallback: errorFallback, customPlaceholder: customPlaceholder, isError: isError, children: children })=>{
    const { id: id } = data;
    const renderKey = (0, $8FVKN.useGadgetRenderKey)();
    const shouldRender = (0, $8UPoO.useShouldRenderGadget)(id);
    const renderFallback = (0, $5uXOq.useCallback)(()=>errorFallback, [
        errorFallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "gadget-content",
        packageName: "jiraDashboardInternalCommon",
        fallback: renderFallback
    }, (()=>{
        if (isError) return errorFallback;
        if (customPlaceholder) return customPlaceholder;
        if (!shouldRender) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1XZn.SkeletonGadgetContent), {
            customHeight: `${(0, $JIPqS.GADGET_DEFAULT_HEIGHT)}px`,
            isPulsing: true
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: renderKey
        }, children);
    })());
};

});


parcelRegister("j3C3s", function(module, exports) {

$parcel$export(module.exports, "GadgetTitleWrapper", () => $41769e611e2b6e1f$export$88d654f5e42c4cf);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");
function $41769e611e2b6e1f$export$88d654f5e42c4cf({ isRenaming: isRenaming, children: children, id: id }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: [
            $41769e611e2b6e1f$var$titleStyles,
            isRenaming && $41769e611e2b6e1f$var$titleRenamingStyles
        ],
        id: id
    }, children);
}
const $41769e611e2b6e1f$var$titleStyles = (0, $2s57o.xcss)({
    minHeight: "var(--ds-space-250, 20px)",
    flexGrow: 1,
    minWidth: '0',
    paddingBlock: 'space.200',
    paddingRight: 'space.100',
    wordBreak: 'break-word',
    marginRight: 'space.200'
});
const $41769e611e2b6e1f$var$titleRenamingStyles = (0, $2s57o.xcss)({
    cursor: 'text'
});

});

parcelRegister("gFWXX", function(module, exports) {

$parcel$export(module.exports, "TitleReadOnly", () => $dc1e643a17c4a39f$export$10ece9f949c62d6e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $bWfiu = parcelRequire("bWfiu");

var $5KCCi = parcelRequire("5KCCi");

var $h0JHu = parcelRequire("h0JHu");

var $hjSul = parcelRequire("hjSul");

var $6hp8I = parcelRequire("6hp8I");
const $dc1e643a17c4a39f$var$TitleInner = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ title: title, titleUrl: titleUrl, forgeEnvironment: forgeEnvironment, forgeEnvironmentKey: forgeEnvironmentKey }, ref)=>{
    const displayTitle = forgeEnvironment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h0JHu.ExtensionTitle), {
        extensionEnvType: forgeEnvironment,
        extensionEnvKey: forgeEnvironmentKey,
        extensionName: title
    }) : title;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWfiu.default), {
        size: "small",
        as: "h2",
        testId: "dashboard-internal-common.ui.gadget.title-readonly.title-inner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dc1e643a17c4a39f$var$HeaderTextWrapper, {
        ref: ref
    }, titleUrl !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
        href: titleUrl
    }, displayTitle) : displayTitle));
});
const $dc1e643a17c4a39f$export$10ece9f949c62d6e = ({ title: title, titleUrl: titleUrl, forgeEnvironment: forgeEnvironment, forgeEnvironmentKey: forgeEnvironmentKey })=>{
    const dimensions = (0, $6hp8I.useDimensions)();
    const ref = (0, $5uXOq.useRef)(null);
    const [showTooltip, setShowTooltip] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (ref.current == null) return;
        const { offsetWidth: offsetWidth, scrollWidth: scrollWidth } = ref.current;
        const shouldShowTooltip = offsetWidth < scrollWidth;
        if (showTooltip !== shouldShowTooltip) setShowTooltip(shouldShowTooltip);
    }, [
        dimensions,
        showTooltip
    ]);
    const tooltipContent = (0, $5uXOq.useMemo)(()=>{
        if (showTooltip) return forgeEnvironment ? `${title} (${forgeEnvironment})` : title;
        return null;
    }, [
        showTooltip,
        forgeEnvironment,
        title
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dc1e643a17c4a39f$var$TooltipWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        content: tooltipContent,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dc1e643a17c4a39f$var$TitleInner, {
        title: title,
        ref: ref,
        titleUrl: titleUrl,
        forgeEnvironment: forgeEnvironment,
        forgeEnvironmentKey: forgeEnvironmentKey
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dc1e643a17c4a39f$var$TooltipWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul9idpf",
            __cmplp.className
        ])
    });
});
const $dc1e643a17c4a39f$var$HeaderTextWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _19pkidpf _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1yhBH", function(module, exports) {

$parcel$export(module.exports, "GadgetToolbar", () => $5fcf8ae904c6c9b8$export$bef5bd636ffcc29c);

var $5uXOq = parcelRequire("5uXOq");

var $1Seuh = parcelRequire("1Seuh");

var $crNzP = parcelRequire("crNzP");

var $km0w9 = parcelRequire("km0w9");

var $7NkuU = parcelRequire("7NkuU");

var $5wFdR = parcelRequire("5wFdR");

var $kegpy = parcelRequire("kegpy");

var $eWkgo = parcelRequire("eWkgo");

var $5KCCi = parcelRequire("5KCCi");

var $koVbs = parcelRequire("koVbs");


var $bOnpg = parcelRequire("bOnpg");

var $8FVKN = parcelRequire("8FVKN");

var $7K2Ba = parcelRequire("7K2Ba");
function $5fcf8ae904c6c9b8$export$bef5bd636ffcc29c({ gadgetId: gadgetId, title: title, onMinimizeOrRestore: onMinimizeOrRestore, isMinimized: isMinimized, isMaximizable: isMaximizable, onMaximizeOrRestore: onMaximizeOrRestore, isMaximized: isMaximized, additionalToolbarItems: additionalToolbarItems }) {
    const onRefresh = (0, $8FVKN.useGadgetRefresh)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5fcf8ae904c6c9b8$export$266a769812832828, {
        onClick: ()=>onMinimizeOrRestore(!isMinimized),
        action: "minimize-restore-button",
        tooltipMessageKey: (0, $7K2Ba.default)[isMinimized ? 'expand' : 'minimize'],
        ariaLabelMessageKey: (0, $7K2Ba.default)[isMinimized ? 'expandAriaLabel' : 'minimizeAriaLabel'],
        gadgetName: title,
        gadgetId: gadgetId,
        icon: isMinimized ? (0, (/*@__PURE__*/$parcel$interopDefault($7NkuU))) : (0, (/*@__PURE__*/$parcel$interopDefault($kegpy)))
    }), isMaximizable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5fcf8ae904c6c9b8$export$266a769812832828, {
        onClick: ()=>onMaximizeOrRestore(!isMaximized),
        action: "maximize-restore-button",
        tooltipMessageKey: (0, $7K2Ba.default)[isMaximized ? 'singleColumn' : 'maximize'],
        ariaLabelMessageKey: (0, $7K2Ba.default)[isMaximized ? 'singleColumn' : 'maximizeAriaLabel'],
        gadgetId: gadgetId,
        gadgetName: title,
        icon: isMaximized ? (0, (/*@__PURE__*/$parcel$interopDefault($km0w9))) : (0, (/*@__PURE__*/$parcel$interopDefault($crNzP)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5fcf8ae904c6c9b8$export$266a769812832828, {
        gadgetId: gadgetId,
        onClick: onRefresh,
        action: "refresh-button",
        tooltipMessageKey: (0, $7K2Ba.default).refresh,
        ariaLabelMessageKey: (0, $7K2Ba.default).refreshAriaLabel,
        gadgetName: title,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5wFdR)))
    }), additionalToolbarItems);
}
const $5fcf8ae904c6c9b8$export$266a769812832828 = ({ gadgetId: gadgetId, onClick: onClick, action: action, tooltipMessageKey: tooltipMessageKey, ariaLabelMessageKey: ariaLabelMessageKey, gadgetName: gadgetName, icon: icon })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const fireAnalytics = (0, $bOnpg.useDashboardAnalytics)();
    const onClickHandler = ()=>{
        fireAnalytics({
            eventType: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e),
            actionSubject: `gadget.${action}`,
            action: 'clicked',
            actionSubjectId: 'gadget'
        });
        onClick();
    };
    const tooltipContent = formatMessage(tooltipMessageKey);
    const ariaLabel = formatMessage(ariaLabelMessageKey, {
        gadgetName: gadgetName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        content: tooltipContent,
        hideTooltipOnClick: true,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
        appearance: "subtle",
        spacing: "default",
        label: ariaLabel,
        onClick: onClickHandler,
        icon: icon,
        testId: `dashboard-internal-common.ui.gadget.toolbar.${action}`,
        "aria-controls": `gadget-content-${gadgetId}`
    }));
};

});
parcelRegister("crNzP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b4962bfdd1d57664baf15c6aae063ace>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0256af551c5369d9$var$_react = $0256af551c5369d9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0256af551c5369d9$var$_fullscreenEnter = $0256af551c5369d9$var$_interopRequireDefault((parcelRequire("4J7Pm")));

var $0256af551c5369d9$var$_vidFullScreenOn = $0256af551c5369d9$var$_interopRequireDefault((parcelRequire("iDfTp")));
function $0256af551c5369d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FullscreenEnterIcon.
 * This component is FullscreenEnterIcon, with `UNSAFE_fallbackIcon` set to "VidFullScreenOnIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for full screen videos or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0256af551c5369d9$var$FullscreenEnterIcon = (props)=>/*#__PURE__*/ $0256af551c5369d9$var$_react.default.createElement($0256af551c5369d9$var$_fullscreenEnter.default, Object.assign({
        LEGACY_fallbackIcon: $0256af551c5369d9$var$_vidFullScreenOn.default
    }, props));
$0256af551c5369d9$var$FullscreenEnterIcon.Name = 'FullscreenEnterIconMigration';
var $0256af551c5369d9$var$_default = module.exports.default = $0256af551c5369d9$var$FullscreenEnterIcon;

});
parcelRegister("4J7Pm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0300804bdadb8133f36dfd3426232a41>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $37116fc045231229$var$_react = $37116fc045231229$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $37116fc045231229$var$_baseNew = $37116fc045231229$var$_interopRequireDefault((parcelRequire("enEmH")));
function $37116fc045231229$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FullscreenEnter".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for full screen videos or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $37116fc045231229$var$FullscreenEnterIcon = (props)=>/*#__PURE__*/ $37116fc045231229$var$_react.default.createElement($37116fc045231229$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 2.5h-3V1h3a2 2 0 0 1 2 2v3h-1.5V3a.5.5 0 0 0-.5-.5m-10 0a.5.5 0 0 0-.5.5v3H1V3a2 2 0 0 1 2-2h3v1.5zM2.5 10v3a.5.5 0 0 0 .5.5h3V15H3a2 2 0 0 1-2-2v-3zm11 3v-3H15v3a2 2 0 0 1-2 2h-3v-1.5h3a.5.5 0 0 0 .5-.5" clip-rule="evenodd"/>`
    }, props));
$37116fc045231229$var$FullscreenEnterIcon.displayName = 'FullscreenEnterIcon';
var $37116fc045231229$var$_default = module.exports.default = $37116fc045231229$var$FullscreenEnterIcon;

});

parcelRegister("iDfTp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d9083275d8bf749b$var$_react = $d9083275d8bf749b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $d9083275d8bf749b$var$_fullscreenEnter = $d9083275d8bf749b$var$_interopRequireDefault((parcelRequire("4J7Pm")));
function $d9083275d8bf749b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d9083275d8bf749b$var$VidFullScreenOnIcon = (props)=>/*#__PURE__*/ $d9083275d8bf749b$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 18h3a1 1 0 0 1 0 2H6a2 2 0 0 1-2-2v-3a1 1 0 0 1 2 0zm12 2h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0v3a2 2 0 0 1-2 2M6 4h3a1 1 0 1 1 0 2H6v3a1 1 0 1 1-2 0V6a2 2 0 0 1 2-2m12 2h-3a1 1 0 0 1 0-2h3a2 2 0 0 1 2 2v3a1 1 0 0 1-2 0z"/></svg>`
    }, props, {
        newIcon: $d9083275d8bf749b$var$_fullscreenEnter.default
    }));
$d9083275d8bf749b$var$VidFullScreenOnIcon.displayName = 'VidFullScreenOnIcon';
var $d9083275d8bf749b$var$_default = module.exports.default = $d9083275d8bf749b$var$VidFullScreenOnIcon;

});


parcelRegister("km0w9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7aed1f5d591b795b5f69329c869bddf6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ed16437b50748dd9$var$_react = $ed16437b50748dd9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ed16437b50748dd9$var$_fullscreenExit = $ed16437b50748dd9$var$_interopRequireDefault((parcelRequire("lh1mD")));

var $ed16437b50748dd9$var$_fullScreen = $ed16437b50748dd9$var$_interopRequireDefault((parcelRequire("dnJ2a")));
function $ed16437b50748dd9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FullscreenExitIcon.
 * This component is FullscreenExitIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesFullScreenIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for return screen videos or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ed16437b50748dd9$var$FullscreenExitIcon = (props)=>/*#__PURE__*/ $ed16437b50748dd9$var$_react.default.createElement($ed16437b50748dd9$var$_fullscreenExit.default, Object.assign({
        LEGACY_fallbackIcon: $ed16437b50748dd9$var$_fullScreen.default
    }, props));
$ed16437b50748dd9$var$FullscreenExitIcon.Name = 'FullscreenExitIconMigration';
var $ed16437b50748dd9$var$_default = module.exports.default = $ed16437b50748dd9$var$FullscreenExitIcon;

});
parcelRegister("lh1mD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::04f340248c4142a991ad78e080057fbe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7cc3e604eda18b6$var$_react = $f7cc3e604eda18b6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f7cc3e604eda18b6$var$_baseNew = $f7cc3e604eda18b6$var$_interopRequireDefault((parcelRequire("enEmH")));
function $f7cc3e604eda18b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FullscreenExit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for return screen videos or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7cc3e604eda18b6$var$FullscreenExitIcon = (props)=>/*#__PURE__*/ $f7cc3e604eda18b6$var$_react.default.createElement($f7cc3e604eda18b6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.5 12v3H10v-3a2 2 0 0 1 2-2h3v1.5h-3a.5.5 0 0 0-.5.5m-7 3v-3a.5.5 0 0 0-.5-.5H1V10h3a2 2 0 0 1 2 2v3zM12 4.5h3V6h-3a2 2 0 0 1-2-2V1h1.5v3a.5.5 0 0 0 .5.5m-8 0a.5.5 0 0 0 .5-.5V1H6v3a2 2 0 0 1-2 2H1V4.5z" clip-rule="evenodd"/>`
    }, props));
$f7cc3e604eda18b6$var$FullscreenExitIcon.displayName = 'FullscreenExitIcon';
var $f7cc3e604eda18b6$var$_default = module.exports.default = $f7cc3e604eda18b6$var$FullscreenExitIcon;

});

parcelRegister("dnJ2a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9be05b27446a0d7e$var$_react = $9be05b27446a0d7e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $9be05b27446a0d7e$var$_fullscreenExit = $9be05b27446a0d7e$var$_interopRequireDefault((parcelRequire("lh1mD")));
function $9be05b27446a0d7e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9be05b27446a0d7e$var$MediaServicesFullScreenIcon = (props)=>/*#__PURE__*/ $9be05b27446a0d7e$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16 8h3a1 1 0 0 1 0 2h-3a2 2 0 0 1-2-2V5a1 1 0 0 1 2 0zm-8 2H5a1 1 0 1 1 0-2h3V5a1 1 0 1 1 2 0v3a2 2 0 0 1-2 2m8 4h3a1 1 0 0 1 0 2h-3v3a1 1 0 0 1-2 0v-3a2 2 0 0 1 2-2m-8 2H5a1 1 0 0 1 0-2h3a2 2 0 0 1 2 2v3a1 1 0 0 1-2 0z"/></svg>`
    }, props, {
        newIcon: $9be05b27446a0d7e$var$_fullscreenExit.default
    }));
$9be05b27446a0d7e$var$MediaServicesFullScreenIcon.displayName = 'MediaServicesFullScreenIcon';
var $9be05b27446a0d7e$var$_default = module.exports.default = $9be05b27446a0d7e$var$MediaServicesFullScreenIcon;

});


parcelRegister("7NkuU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::95f2961def649e58284c9134f09a8716>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5acd0264cf7f9b6d$var$_react = $5acd0264cf7f9b6d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5acd0264cf7f9b6d$var$_growDiagonal = $5acd0264cf7f9b6d$var$_interopRequireDefault((parcelRequire("34MjD")));

var $5acd0264cf7f9b6d$var$_actualSize = $5acd0264cf7f9b6d$var$_interopRequireDefault((parcelRequire("ejYdG")));
function $5acd0264cf7f9b6d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for GrowDiagonalIcon.
 * This component is GrowDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesActualSizeIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5acd0264cf7f9b6d$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $5acd0264cf7f9b6d$var$_react.default.createElement($5acd0264cf7f9b6d$var$_growDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $5acd0264cf7f9b6d$var$_actualSize.default
    }, props));
$5acd0264cf7f9b6d$var$GrowDiagonalIcon.Name = 'GrowDiagonalIconMigration';
var $5acd0264cf7f9b6d$var$_default = module.exports.default = $5acd0264cf7f9b6d$var$GrowDiagonalIcon;

});

parcelRegister("5wFdR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97b7deedaffb04632472c93b0c8f5452>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $405fead422c4948a$var$_react = $405fead422c4948a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $405fead422c4948a$var$_refresh = $405fead422c4948a$var$_interopRequireDefault((parcelRequire("6SDzC")));

var $405fead422c4948a$var$_refresh2 = $405fead422c4948a$var$_interopRequireDefault((parcelRequire("UPm1a")));
function $405fead422c4948a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for RefreshIcon.
 * This component is RefreshIcon, with `UNSAFE_fallbackIcon` set to "RefreshIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $405fead422c4948a$var$RefreshIcon = (props)=>/*#__PURE__*/ $405fead422c4948a$var$_react.default.createElement($405fead422c4948a$var$_refresh.default, Object.assign({
        LEGACY_fallbackIcon: $405fead422c4948a$var$_refresh2.default
    }, props));
$405fead422c4948a$var$RefreshIcon.Name = 'RefreshIconMigration';
var $405fead422c4948a$var$_default = module.exports.default = $405fead422c4948a$var$RefreshIcon;

});
parcelRegister("6SDzC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::688997f0a16a41562042ca280fe15628>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $50267bae9676a074$var$_react = $50267bae9676a074$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $50267bae9676a074$var$_baseNew = $50267bae9676a074$var$_interopRequireDefault((parcelRequire("enEmH")));
function $50267bae9676a074$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $50267bae9676a074$var$RefreshIcon = (props)=>/*#__PURE__*/ $50267bae9676a074$var$_react.default.createElement($50267bae9676a074$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 .5h4.25a.75.75 0 0 1 .75.75V5.5H5.5V2.941a9 9 0 0 0-1.094.916C3.42 4.83 2.5 6.214 2.5 8c0 1.813.817 3.18 1.871 4.11 1.079.95 2.346 1.39 3.129 1.39V15c-1.217 0-2.825-.623-4.121-1.765C2.058 12.07 1 10.312 1 8c0-2.339 1.21-4.084 2.354-5.211.308-.304.615-.567.9-.789H2zm10.621 2.266C13.942 3.93 15 5.688 15 8c0 2.338-1.204 4.079-2.344 5.201-.304.3-.607.56-.889.78H14v1.5H9.75a.75.75 0 0 1-.75-.75v-4.25h1.5v2.573a9 9 0 0 0 1.104-.921C12.584 11.166 13.5 9.787 13.5 8c0-1.813-.817-3.18-1.871-4.11C10.551 2.94 9.283 2.5 8.5 2.5V1c1.217 0 2.825.623 4.121 1.766" clip-rule="evenodd"/>`
    }, props));
$50267bae9676a074$var$RefreshIcon.displayName = 'RefreshIcon';
var $50267bae9676a074$var$_default = module.exports.default = $50267bae9676a074$var$RefreshIcon;

});

parcelRegister("UPm1a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0aad10f002a9a12a$var$_react = $0aad10f002a9a12a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $0aad10f002a9a12a$var$_refresh = $0aad10f002a9a12a$var$_interopRequireDefault((parcelRequire("6SDzC")));
function $0aad10f002a9a12a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0aad10f002a9a12a$var$RefreshIcon = (props)=>/*#__PURE__*/ $0aad10f002a9a12a$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.98.98 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.96.96 0 0 0 15.002 4a1 1 0 0 0-.905.596"/></g></svg>`
    }, props, {
        newIcon: $0aad10f002a9a12a$var$_refresh.default
    }));
$0aad10f002a9a12a$var$RefreshIcon.displayName = 'RefreshIcon';
var $0aad10f002a9a12a$var$_default = module.exports.default = $0aad10f002a9a12a$var$RefreshIcon;

});


parcelRegister("kegpy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1977529ed36a56b31b9b9f03121ff6d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eba1d85e1dd9b598$var$_react = $eba1d85e1dd9b598$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eba1d85e1dd9b598$var$_shrinkDiagonal = $eba1d85e1dd9b598$var$_interopRequireDefault((parcelRequire("jmSR7")));

var $eba1d85e1dd9b598$var$_fitToPage = $eba1d85e1dd9b598$var$_interopRequireDefault((parcelRequire("jJCZj")));
function $eba1d85e1dd9b598$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShrinkDiagonalIcon.
 * This component is ShrinkDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesFitToPageIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eba1d85e1dd9b598$var$ShrinkDiagonalIcon = (props)=>/*#__PURE__*/ $eba1d85e1dd9b598$var$_react.default.createElement($eba1d85e1dd9b598$var$_shrinkDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $eba1d85e1dd9b598$var$_fitToPage.default
    }, props));
$eba1d85e1dd9b598$var$ShrinkDiagonalIcon.Name = 'ShrinkDiagonalIconMigration';
var $eba1d85e1dd9b598$var$_default = module.exports.default = $eba1d85e1dd9b598$var$ShrinkDiagonalIcon;

});

parcelRegister("7K2Ba", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d16755660d37c6c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9d16755660d37c6c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    minimize: {
        "id": "dashboard-internal-common.gadget.toolbar.minimize",
        "defaultMessage": "Minimize"
    },
    minimizeAriaLabel: {
        "id": "dashboard-internal-common.gadget.toolbar.minimize-aria-label",
        "defaultMessage": "Minimize {gadgetName}"
    },
    expand: {
        "id": "dashboard-internal-common.gadget.toolbar.expand",
        "defaultMessage": "Expand"
    },
    expandAriaLabel: {
        "id": "dashboard-internal-common.gadget.toolbar.expand-aria-label",
        "defaultMessage": "Expand {gadgetName}"
    },
    maximize: {
        "id": "dashboard-internal-common.gadget.toolbar.maximize",
        "defaultMessage": "Maximize"
    },
    maximizeAriaLabel: {
        "id": "dashboard-internal-common.gadget.toolbar.maximize-aria-label",
        "defaultMessage": "Maximize {gadgetName}"
    },
    refresh: {
        "id": "dashboard-internal-common.gadget.toolbar.refresh",
        "defaultMessage": "Refresh"
    },
    refreshAriaLabel: {
        "id": "dashboard-internal-common.gadget.toolbar.refresh-aria-label",
        "defaultMessage": "Refresh {gadgetName}"
    },
    singleColumn: {
        "id": "dashboard-internal-common.gadget.toolbar.single-column",
        "defaultMessage": "Single column"
    }
});

});


parcelRegister("iIi7d", function(module, exports) {

$parcel$export(module.exports, "LastRefreshed", () => $64481a9700f86c7d$export$66aab1cf9cd737cc);

var $5uXOq = parcelRequire("5uXOq");

var $5wFdR = parcelRequire("5wFdR");

var $eWkgo = parcelRequire("eWkgo");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");

var $koVbs = parcelRequire("koVbs");

var $1p96B = parcelRequire("1p96B");

var $9OXo1 = parcelRequire("9OXo1");

var $8hIHC = parcelRequire("8hIHC");
const $64481a9700f86c7d$export$66aab1cf9cd737cc = ({ lastRefreshed: lastRefreshed, updateInterval: updateInterval })=>{
    const [lastRefreshedTimeAgo, setLastRefreshedTimeAgo] = (0, $5uXOq.useState)('');
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { locale: locale } = (0, $9OXo1.useTenantContext)();
    (0, $5uXOq.useEffect)(()=>{
        setLastRefreshedTimeAgo(formatMessage((0, $8hIHC.default).justNow));
        const refreshInterval = setInterval(()=>lastRefreshed != null && setLastRefreshedTimeAgo(formatMessage((0, $8hIHC.default).timeAgo, {
                timeAgo: (0, $1p96B.formatDistanceStrictWithLocale)(lastRefreshed, new Date(), locale)
            })), updateInterval);
        return ()=>clearInterval(refreshInterval);
    }, [
        formatMessage,
        lastRefreshed,
        locale,
        updateInterval
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        direction: "row",
        alignItems: "center",
        xcss: $64481a9700f86c7d$var$lastRefreshedWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5wFdR))), {
        LEGACY_size: "small",
        label: formatMessage((0, $8hIHC.default).lastRefreshedIcon)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        size: "UNSAFE_small",
        color: "color.text.subtle"
    }, lastRefreshedTimeAgo));
};
const $64481a9700f86c7d$var$lastRefreshedWrapperStyles = (0, $2s57o.xcss)({
    paddingTop: 'space.200',
    color: 'color.text.subtle',
    gap: 'space.050'
});

});
parcelRegister("8hIHC", function(module, exports) {

$parcel$export(module.exports, "default", () => $3afac6d64be9e0b6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3afac6d64be9e0b6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    justNow: {
        "id": "dashboard-internal-common.last-refreshed.just-now",
        "defaultMessage": "Just now"
    },
    timeAgo: {
        "id": "dashboard-internal-common.last-refreshed.time-ago",
        "defaultMessage": "{timeAgo} ago"
    },
    lastRefreshedIcon: {
        "id": "dashboard-internal-common.last-refreshed.last-refreshed-icon",
        "defaultMessage": "Last refreshed"
    }
});

});


parcelRegister("jATTU", function(module, exports) {

$parcel$export(module.exports, "useEcosystemRefresh", () => $dc36a798f3ea6a32$export$a96edb2d9dc3e9bf);

var $5uXOq = parcelRequire("5uXOq");

var $kwTKp = parcelRequire("kwTKp");

var $JIPqS = parcelRequire("JIPqS");
const $dc36a798f3ea6a32$export$1da99641cec7fdf3 = (payload, id)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.connectHost?.broadcastEvent((0, $JIPqS.CONNECT_GADGET_REFRESH_REQUEST_EVENT), {
        id: id
    }, payload);
const $dc36a798f3ea6a32$export$a96edb2d9dc3e9bf = ({ id: id, connect: connect, forge: forge })=>{
    const isConnect = Boolean(connect?.addonKey);
    const isForge = Boolean(forge?.key);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    const ecosystemOnRefresh = (0, $5uXOq.useCallback)(()=>{
        const payload = {
            origin: 'gadget',
            gadgetId: id
        };
        if (isConnect) $dc36a798f3ea6a32$export$1da99641cec7fdf3(payload, wrapperRef.current?.querySelector('iframe')?.id);
        else if (isForge) (0, $kwTKp.emit)((0, $JIPqS.FORGE_JIRA_DASHBOARD_GADGET_REFRESH_EVENT), payload);
    }, [
        id,
        isConnect,
        isForge
    ]);
    return {
        wrapperRef: wrapperRef,
        onRefresh: isConnect || isForge ? ecosystemOnRefresh : undefined
    };
};

});

parcelRegister("hzLxu", function(module, exports) {

$parcel$export(module.exports, "useGadgetEditableController", () => $11aa1fd44911c0cf$export$bcc758b734cee1d1);

var $5uXOq = parcelRequire("5uXOq");

var $l7m8v = parcelRequire("l7m8v");

var $cmgca = parcelRequire("cmgca");

var $iXzvf = parcelRequire("iXzvf");

var $h7J1E = parcelRequire("h7J1E");

var $gh1hi = parcelRequire("gh1hi");
const $11aa1fd44911c0cf$export$bcc758b734cee1d1 = ({ id: id, title: defaultTitle, customisedTitle: customisedTitle, configurable: configurable, hasNonHiddenUserPrefs: hasNonHiddenUserPrefs, renderedGadgetUrl: renderedGadgetUrl, userPrefs: userPrefs, amdModule: amdModule, reactKey: reactKey, isRenamable: isRenamable, isConnectDisabled: isConnectDisabled, saveTitle: saveTitle, userPreferencesAction: userPreferencesAction, userPreferencesService: userPreferencesService, instrumentation: instrumentation })=>{
    const { put: userPreferencesServicePut, refresh: userPreferencesServiceRefresh } = userPreferencesService;
    const { isConfigurable: isEditModeEnabled, isUnconfigured: isUnconfigured } = (0, $l7m8v.useConfigurationStatus)({
        configurable: configurable,
        hasNonHiddenUserPrefs: hasNonHiddenUserPrefs,
        renderedGadgetUrl: renderedGadgetUrl,
        userPrefs: userPrefs
    });
    const [isInEditMode, setIsInEditMode] = (0, $5uXOq.useState)(isEditModeEnabled && isUnconfigured);
    const isEditButtonDisabled = isInEditMode && !(0, $cmgca.isConnectGadget)({
        amdModule: amdModule
    });
    const onEditModeTrigger = (0, $5uXOq.useCallback)(()=>{
        instrumentation?.onEditModeEnter?.();
        setIsInEditMode(true);
    }, [
        setIsInEditMode,
        instrumentation
    ]);
    const onEditModeCancel = (0, $5uXOq.useCallback)(()=>setIsInEditMode(false), [
        setIsInEditMode
    ]);
    const [isRenaming, setIsRenaming] = (0, $5uXOq.useState)(false);
    const onRenameSave = (0, $5uXOq.useCallback)(async (newTitle)=>{
        if (isRenamable) await saveTitle(newTitle);
        setIsRenaming(false);
    }, [
        isRenamable,
        saveTitle
    ]);
    const { title: title, setDefaultTitle: setDefaultTitle, setTitle: setTitle } = (0, $h7J1E.useGadgetTitle)({
        defaultTitle: defaultTitle,
        title: customisedTitle,
        onSave: onRenameSave
    });
    const onRenameTrigger = (0, $5uXOq.useCallback)(()=>{
        setIsRenaming(true);
    }, [
        setIsRenaming
    ]);
    const onRenameCancel = (0, $5uXOq.useCallback)(()=>{
        setIsRenaming(false);
    }, [
        setIsRenaming
    ]);
    const { update: update } = (0, $gh1hi.useDashboardReactGadgetsResource)();
    const setPreferences = (0, $5uXOq.useCallback)((preferences, onUpdate)=>{
        if (userPreferencesAction == null) throw new Error('gadget attempted to save preference without existing preferences');
        const maybePromise = userPreferencesServicePut(userPreferencesAction, preferences);
        if (!maybePromise) return null;
        return (async ()=>{
            try {
                await maybePromise;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                throw new Error(`failed to put gadget preference: ${e.message}`);
            }
            if (reactKey) // refresh react gadget
            update((0, $iXzvf.lensReactGadget)(id, null));
            const userPrefsFromService = await userPreferencesServiceRefresh(userPreferencesAction, onUpdate);
            if (userPrefsFromService == null) throw new Error('failed to get preferences after put preferences');
        })();
    }, [
        userPreferencesAction,
        userPreferencesServicePut,
        userPreferencesServiceRefresh,
        update,
        id,
        reactKey
    ]);
    return {
        isUnconfigured: isUnconfigured,
        isEditModeEnabled: isEditModeEnabled,
        isEditButtonDisabled: isEditButtonDisabled,
        isInEditMode: isInEditMode,
        isConnectDisabled: isConnectDisabled,
        onEditModeTrigger: onEditModeTrigger,
        onEditModeCancel: onEditModeCancel,
        title: title,
        isRenaming: isRenaming,
        setDefaultTitle: setDefaultTitle,
        onRenameTrigger: onRenameTrigger,
        onRenameSave: setTitle,
        onRenameCancel: onRenameCancel,
        setPreferences: setPreferences
    };
};

});
parcelRegister("l7m8v", function(module, exports) {

$parcel$export(module.exports, "useConfigurationStatus", () => $93e0d1b0527a2ad8$export$416bc2c29f65a3f8);

var $5uXOq = parcelRequire("5uXOq");

var $5IKQ6 = parcelRequire("5IKQ6");
const $93e0d1b0527a2ad8$export$416bc2c29f65a3f8 = ({ configurable: configurable, hasNonHiddenUserPrefs: hasNonHiddenUserPrefs, renderedGadgetUrl: renderedGadgetUrl, userPrefs: userPrefs })=>{
    const isConfigurable = Boolean(configurable || hasNonHiddenUserPrefs || renderedGadgetUrl);
    const isUnconfigured = (0, $5uXOq.useMemo)(()=>isConfigurable && !(0, $5IKQ6.isGadgetConfigured)(userPrefs), [
        isConfigurable,
        userPrefs
    ]);
    return {
        isConfigurable: isConfigurable,
        isUnconfigured: isUnconfigured
    };
};

});


parcelRegister("lB5Qw", function(module, exports) {

$parcel$export(module.exports, "useDeleteGadget", () => $476984e53bb15767$export$fddaf21479a00190);

var $5uXOq = parcelRequire("5uXOq");

var $8h45R = parcelRequire("8h45R");

var $cmJHP = parcelRequire("cmJHP");

var $eusud = parcelRequire("eusud");

var $pa9q9 = parcelRequire("pa9q9");

var $gh1hi = parcelRequire("gh1hi");

var $fNTzJ = parcelRequire("fNTzJ");
const $476984e53bb15767$var$deleteSuccessFlag = (name)=>({
        type: 'success',
        title: (0, $fNTzJ.messages).successTitle,
        description: [
            (0, $fNTzJ.messages).successDescription,
            {
                name: name
            }
        ],
        isAutoDismiss: false,
        delayAnnouncement: 1500,
        messageId: 'dashboard-edit.services.flag.success.delete-success-flag',
        messageType: 'transactional'
    });
const $476984e53bb15767$var$deleteFailureFlag = {
    type: 'error',
    title: (0, $fNTzJ.messages).failureTitle,
    description: (0, $fNTzJ.messages).failureDescription,
    isAutoDismiss: false,
    delayAnnouncement: 1500,
    messageId: 'dashboard-edit.services.delete-failure-flag.error',
    messageType: 'transactional'
};
const $476984e53bb15767$export$fddaf21479a00190 = (id, name)=>{
    const { data: data, update: update } = (0, $gh1hi.useDashboardResource)();
    const [, { remove: remove }] = (0, $8h45R.useGadgetAdditionalStateActions)();
    const flagService = (0, $pa9q9.useFlagService)();
    return (0, $5uXOq.useCallback)(async ()=>{
        if (!data) return;
        const gadgetUrl = `/rest/dashboards/1.0/${data.id}/gadget/${id}`;
        try {
            await (0, $eusud.performDeleteRequest)(gadgetUrl);
            update((0, $cmJHP.lensGadgetsList)((gadgets)=>gadgets.filter((element)=>element.id !== id)));
            remove(id);
            flagService.showFlag($476984e53bb15767$var$deleteSuccessFlag(name));
        } catch (_) {
            flagService.showFlag($476984e53bb15767$var$deleteFailureFlag);
        }
    }, [
        data,
        id,
        update,
        remove,
        flagService,
        name
    ]);
};

});
parcelRegister("fNTzJ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2261dff7bcf05f7b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $2261dff7bcf05f7b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    successTitle: {
        "id": "dashboard-edit.services.success-title",
        "defaultMessage": "Gadget has been removed"
    },
    successDescription: {
        "id": "dashboard-edit.services.success-description",
        "defaultMessage": "You've successfully removed the \"{name}\" gadget."
    },
    failureTitle: {
        "id": "dashboard-edit.services.failure-title",
        "defaultMessage": "We couldn't delete the gadget"
    },
    failureDescription: {
        "id": "dashboard-edit.services.failure-description",
        "defaultMessage": "Give it a couple of minutes, then try again."
    }
});

});


parcelRegister("8VGwU", function(module, exports) {

$parcel$export(module.exports, "useDuplicateGadget", () => $69dddfa95f9940b3$export$f1865177002d12dd);

var $5uXOq = parcelRequire("5uXOq");

var $hh0bW = parcelRequire("hh0bW");

var $JIPqS = parcelRequire("JIPqS");

var $7RGnr = parcelRequire("7RGnr");

var $iyrll = parcelRequire("iyrll");

var $cmJHP = parcelRequire("cmJHP");

var $iLC4C = parcelRequire("iLC4C");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $pa9q9 = parcelRequire("pa9q9");

var $7HGHK = parcelRequire("7HGHK");

var $gh1hi = parcelRequire("gh1hi");

var $wlDl0 = parcelRequire("wlDl0");

var $eeAmR = parcelRequire("eeAmR");

var $fkIcM = parcelRequire("fkIcM");
const $69dddfa95f9940b3$export$6fb6758aa812bdfb = {
    analyticsSource: 'dashboard',
    experience: (0, $JIPqS.DUPLICATE_GADGET_EXPERIENCE),
    application: null,
    edition: null,
    additionalAttributes: {}
};
const $69dddfa95f9940b3$var$errorFlagAttributes = {
    key: (0, $7HGHK.toFlagId)('gadgetDuplicateError'),
    type: 'error',
    title: (0, $fkIcM.default).errorFlagTitle,
    description: (0, $fkIcM.default).errorFlagDescription,
    messageId: 'dashboard-edit.services.duplicate-gadget.error-flag-attributes.error',
    messageType: 'transactional',
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    actions: [
        {
            content: (0, $fkIcM.default).errorFlagAction,
            onClick: ()=>window.location.reload()
        }
    ]
};
const $69dddfa95f9940b3$var$successFlagAttributes = (name)=>({
        key: (0, $7HGHK.toFlagId)('gadgetDuplicateSuccess'),
        type: 'success',
        title: (0, $fkIcM.default).successFlagTitle,
        description: [
            (0, $fkIcM.default).successFlagDescription,
            {
                name: name
            }
        ],
        messageId: 'dashboard-edit.services.duplicate-gadget.flag.success.success-flag-attributes',
        messageType: 'transactional'
    });
const $69dddfa95f9940b3$export$f1865177002d12dd = (id)=>{
    const { data: data, update: update } = (0, $gh1hi.useDashboardResource)();
    const { canAddGadgetWithinLimit: canAddGadgetWithinLimit, showGadgetLimitFlag: showGadgetLimitFlag } = (0, $eeAmR.useAddGadgetWithinLimit)((0, $wlDl0.MAX_GADGETS_COUNT_INCLUDE_IGNORED_GADGETS), (0, $wlDl0.MAX_ALLOWED_GADGETS_COUNT));
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const onBeforeGadgetAdded = (0, $iyrll.useOnAddedGadget)();
    return (0, $5uXOq.useCallback)(async ()=>{
        if (!data) return;
        const originalGadget = data.gadgets.find((gadget)=>gadget.id === id);
        if (!originalGadget) {
            showFlag($69dddfa95f9940b3$var$errorFlagAttributes);
            return;
        }
        const isGadgetIgnored = !!originalGadget?.amdModule && Object.values((0, $wlDl0.IGNORED_GADGETS_FROM_COUNT_MAP)).includes(originalGadget.amdModule);
        if (!canAddGadgetWithinLimit(data.gadgets, isGadgetIgnored)) {
            showGadgetLimitFlag();
            return;
        }
        const duplicateGadgetUrl = `/rest/dashboards/1.0/${data.id}/gadget/${id}/duplicate`;
        (0, $eusud.performPostRequest)(duplicateGadgetUrl).then((gadgetData)=>{
            onBeforeGadgetAdded(gadgetData.id);
            update((0, $cmJHP.lensGadgetsList)((gadgets)=>[
                    ...(0, $7RGnr.mapToReactGadgets)([
                        gadgetData
                    ]),
                    ...gadgets
                ]));
            showFlag($69dddfa95f9940b3$var$successFlagAttributes(originalGadget.title));
            (0, $hh0bW.default)({
                ...$69dddfa95f9940b3$export$6fb6758aa812bdfb,
                wasExperienceSuccesful: true
            });
        }).catch((error)=>{
            showFlag($69dddfa95f9940b3$var$errorFlagAttributes);
            (0, $iLC4C.handleFetchErrorAsExperience)({
                error: error,
                sendSuccessExperience: ()=>{
                    (0, $hh0bW.default)({
                        ...$69dddfa95f9940b3$export$6fb6758aa812bdfb,
                        wasExperienceSuccesful: true
                    });
                },
                sendFailedExperience: ()=>{
                    (0, $hh0bW.default)({
                        ...$69dddfa95f9940b3$export$6fb6758aa812bdfb,
                        wasExperienceSuccesful: false
                    });
                },
                logErrorEvent: (reason)=>{
                    (0, $jcw0u.default)({
                        error: error,
                        meta: {
                            id: (0, $JIPqS.DUPLICATE_GADGET_EXPERIENCE),
                            packageName: (0, $wlDl0.PACKAGE_NAME)
                        },
                        attributes: {
                            reason: reason,
                            endpoint: 'duplicateGadget'
                        }
                    });
                }
            });
        });
    }, [
        data,
        canAddGadgetWithinLimit,
        id,
        showFlag,
        showGadgetLimitFlag,
        onBeforeGadgetAdded,
        update
    ]);
};

});
parcelRegister("iLC4C", function(module, exports) {

$parcel$export(module.exports, "handleFetchErrorAsExperience", () => $10506a1bb5cb99af$export$8b2399c5090eddc3);

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");
const $10506a1bb5cb99af$export$65e55894e6e38a89 = 'client network error';
const $10506a1bb5cb99af$export$796b9e0e5da90309 = 'unauthenticated (401)';
const $10506a1bb5cb99af$export$8b2399c5090eddc3 = ({ error: error, sendSuccessExperience: sendSuccessExperience, sendFailedExperience: sendFailedExperience, logErrorEvent: logErrorEvent })=>{
    if ((0, $fZneA.isClientFetchError)(error)) {
        sendSuccessExperience();
        logErrorEvent($10506a1bb5cb99af$export$65e55894e6e38a89);
    } else if (error instanceof (0, $jJZqs.default) && error.constructor === (0, $jJZqs.default)) {
        const errorCode = Number(error.message.substring(error.message.length - 3));
        if (errorCode === 304) // 304 response cached
        sendSuccessExperience();
        else if (errorCode === 401) // 401 user unauthenticated, neither success nor fail
        logErrorEvent($10506a1bb5cb99af$export$796b9e0e5da90309);
        else {
            sendFailedExperience();
            logErrorEvent(`${errorCode} status code response`);
        }
    } else {
        // in the case of Error, SyntaxError and ValidationError(400);
        sendFailedExperience();
        logErrorEvent();
    }
};

});

parcelRegister("wlDl0", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $b636aeae1a431342$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "MAX_ALLOWED_GADGETS_COUNT", () => $b636aeae1a431342$export$e11360046219e002);
$parcel$export(module.exports, "MAX_GADGETS_COUNT_INCLUDE_IGNORED_GADGETS", () => $b636aeae1a431342$export$2ea683536c2351db);
$parcel$export(module.exports, "IGNORED_GADGETS_FROM_COUNT_MAP", () => $b636aeae1a431342$export$7f4c0fee173151d3);
const $b636aeae1a431342$export$b8b9d90f9e5bd72b = 'jiraDashboardEdit';
const $b636aeae1a431342$export$93b482f0f653203d = [
    {
        pattern: /React does not recognize/,
        ignoredBecause: 'Warning from `createAnalyticsEvent` prop being forwarded to Atlaskit DropdownMenu.',
        jiraIssueId: 'DAG-688'
    },
    {
        pattern: /The above error occurred in the (.+?) component/,
        ignoredBecause: 'this is a stub `avatarUrl` for asset "/secure/viewavatar?size=medium&avatarId=10315&avatarType=issuetype"',
        jiraIssueId: 'DAG-688'
    },
    {
        pattern: /jira.frontend.common.error-boundary/,
        ignoredBecause: 'Unhandled error caught by error boundary',
        jiraIssueId: 'DAG-688'
    },
    {
        pattern: /jira.frontend.experience-tracker.missing-provider/,
        ignoredBecause: 'Unhandled error caught by error boundary',
        jiraIssueId: 'DAG-688'
    },
    {
        pattern: /Failed to load resource: the server responded with a status of 404/,
        ignoredBecause: 'this is a stub `avatarUrl` for asset "/secure/viewavatar?size=medium&avatarId=10315&avatarType=issuetype"',
        jiraIssueId: 'DAG-688'
    },
    {
        pattern: /rest\/internal\/2\/log\/safe\/error/,
        ignoredBecause: 'this is a stub `avatarUrl` for asset "/secure/viewavatar?size=medium&avatarId=10315&avatarType=issuetype"',
        jiraIssueId: 'DAG-688'
    },
    {
        pattern: /Encountered two children with the same key/,
        ignoredBecause: 'this is a stub `avatarUrl` for asset "/secure/viewavatar?size=medium&avatarId=10315&avatarType=issuetype"',
        jiraIssueId: 'DAG-688'
    },
    {
        pattern: /Unrecognised gadget type/,
        ignoredBecause: 'exception thrown: Unrecognised gadget type',
        jiraIssueId: 'DAG-688'
    },
    {
        pattern: /FetchError: Error server response/,
        ignoredBecause: 'exception thrown: Error server response',
        jiraIssueId: 'DAG-688'
    }
];
const $b636aeae1a431342$export$e11360046219e002 = 20;
const $b636aeae1a431342$export$2ea683536c2351db = 50;
const $b636aeae1a431342$export$7f4c0fee173151d3 = {
    'rest/gadgets/1.0/g/com.atlassian.jira.atlassian-wallboard-plugin:spacer-gadget/gadgets/spacerGadget.xml': 'jira-dashboard-items/spacer'
};

});

parcelRegister("eeAmR", function(module, exports) {

$parcel$export(module.exports, "useAddGadgetWithinLimit", () => $e0a1534f8271bebf$export$c536a8bb380238f8);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $7HGHK = parcelRequire("7HGHK");

var $wlDl0 = parcelRequire("wlDl0");

var $astCn = parcelRequire("astCn");
const $e0a1534f8271bebf$export$b9cafb79af2372cd = {
    key: (0, $7HGHK.toFlagId)('gadgetAddWithinLimitError'),
    type: 'error',
    title: (0, $astCn.default).gadgetLimitFlagTitle,
    description: (0, $astCn.default).gadgetLimitFlagDescription,
    messageId: 'dashboard-edit.utils.add-gadget-within-limit.gadget-limit-flag-attributes.error',
    messageType: 'transactional'
};
const $e0a1534f8271bebf$export$c536a8bb380238f8 = (limitIncludeIgnoredGadgets, limitExcludeIgnoredGadgets)=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const canAddGadgetWithinLimit = (0, $5uXOq.useCallback)((gadgets, isGadgetIgnored)=>isGadgetIgnored ? gadgets.length < limitIncludeIgnoredGadgets : gadgets.length < limitIncludeIgnoredGadgets && gadgets.filter((e)=>typeof e.amdModule !== 'undefined' ? !Object.values((0, $wlDl0.IGNORED_GADGETS_FROM_COUNT_MAP)).includes(e.amdModule) : true).length < limitExcludeIgnoredGadgets, [
        limitIncludeIgnoredGadgets,
        limitExcludeIgnoredGadgets
    ]);
    const showGadgetLimitFlag = (0, $5uXOq.useCallback)(()=>{
        showFlag($e0a1534f8271bebf$export$b9cafb79af2372cd);
    }, [
        showFlag
    ]);
    return {
        canAddGadgetWithinLimit: canAddGadgetWithinLimit,
        showGadgetLimitFlag: showGadgetLimitFlag
    };
};

});
parcelRegister("astCn", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dc750b26471aa12$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3dc750b26471aa12$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    gadgetLimitFlagTitle: {
        "id": "dashboard-edit.utils.add-gadget-within-limit.gadget-limit-flag-title",
        "defaultMessage": "Error."
    },
    gadgetLimitFlagDescription: {
        "id": "dashboard-edit.utils.add-gadget-within-limit.gadget-limit-flag-description",
        "defaultMessage": "Sorry, you have exceeded the maximum number of gadgets supported by your dashboard.  You must remove some gadgets before proceeding."
    }
});

});


parcelRegister("fkIcM", function(module, exports) {

$parcel$export(module.exports, "default", () => $30fd23e5ade8cf85$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $30fd23e5ade8cf85$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorFlagTitle: {
        "id": "dashboard-edit.services.duplicate-gadget.error-flag-title",
        "defaultMessage": "Error"
    },
    errorFlagDescription: {
        "id": "dashboard-edit.services.duplicate-gadget.error-flag-description",
        "defaultMessage": "We cannot duplicate that gadget at the moment"
    },
    errorFlagAction: {
        "id": "dashboard-edit.services.duplicate-gadget.error-flag-action",
        "defaultMessage": "Refresh"
    },
    successFlagTitle: {
        "id": "dashboard-edit.services.duplicate-gadget.success-flag-title",
        "defaultMessage": "Gadget has been duplicated"
    },
    successFlagDescription: {
        "id": "dashboard-edit.services.duplicate-gadget.success-flag-description",
        "defaultMessage": "You've successfully duplicated the \"{name}\" gadget."
    }
});

});


parcelRegister("clqf8", function(module, exports) {

$parcel$export(module.exports, "useSaveCustomGadgetTitleById", () => $4c7986e2f2b82ecd$export$4156ac3cf466d45d);

var $5uXOq = parcelRequire("5uXOq");

var $hh0bW = parcelRequire("hh0bW");

var $2YZCu = parcelRequire("2YZCu");

var $JIPqS = parcelRequire("JIPqS");

var $cmJHP = parcelRequire("cmJHP");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $gh1hi = parcelRequire("gh1hi");
const $4c7986e2f2b82ecd$var$expAttributes = {
    analyticsSource: 'dashboard',
    experience: (0, $JIPqS.SAVE_CUSTOM_GADGET_TITLE_PREFERENCES),
    application: null,
    edition: null,
    additionalAttributes: {}
};
const $4c7986e2f2b82ecd$export$5b8abdff51d766d5 = ()=>{
    const { data: data, update: update } = (0, $gh1hi.useDashboardResource)();
    return (0, $5uXOq.useCallback)(async (id, title)=>{
        const gadget = data?.gadgets.find((g)=>g.id === id);
        if (!gadget || title === gadget.customisedTitle || !data) return;
        const changeTitleUrl = `/rest/dashboards/1.0/${data.id}/gadget/${id}/title`;
        try {
            await (0, $eusud.performPutRequest)(changeTitleUrl, {
                body: JSON.stringify({
                    title: title
                })
            });
            update((0, $cmJHP.lensGadget)(id, {
                customisedTitle: title
            }));
            (0, $hh0bW.default)({
                ...$4c7986e2f2b82ecd$var$expAttributes,
                wasExperienceSuccesful: true
            });
            (0, $2YZCu.default).safeInfoWithoutCustomerData('spa-apps.dashboard', 'Set gadget title');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $hh0bW.default)({
                ...$4c7986e2f2b82ecd$var$expAttributes,
                wasExperienceSuccesful: false
            });
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: (0, $JIPqS.SAVE_CUSTOM_GADGET_TITLE_PREFERENCES),
                    packageName: 'jiraDashboardEdit'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }, // update should be in this list, but it changes every render and breaks everything
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        data
    ]);
};
const $4c7986e2f2b82ecd$export$4156ac3cf466d45d = (id)=>{
    const saveCustomTitle = $4c7986e2f2b82ecd$export$5b8abdff51d766d5();
    return (0, $5uXOq.useCallback)((title)=>saveCustomTitle(id, title), [
        id,
        saveCustomTitle
    ]);
};

});

parcelRegister("hWMwQ", function(module, exports) {

$parcel$export(module.exports, "useSaveGadgetColor", () => $781e1687ba03beb2$export$13794d1743e6e544);

var $5uXOq = parcelRequire("5uXOq");

var $cmJHP = parcelRequire("cmJHP");

var $eusud = parcelRequire("eusud");

var $gh1hi = parcelRequire("gh1hi");
const $781e1687ba03beb2$export$13794d1743e6e544 = (id)=>{
    const { data: data, update: update } = (0, $gh1hi.useDashboardResource)();
    return (0, $5uXOq.useCallback)(async (newColorId)=>{
        if (!data) return;
        const colorUrl = `/rest/dashboards/1.0/${data.id}/gadget/${id}/color`;
        await (0, $eusud.performPutRequest)(colorUrl, {
            body: JSON.stringify({
                color: newColorId
            })
        });
        update((0, $cmJHP.lensGadget)(id, {
            color: newColorId
        }));
    }, [
        data,
        id,
        update
    ]);
};

});

parcelRegister("4zy27", function(module, exports) {

$parcel$export(module.exports, "ConfigDropdown", () => $77b3dd02970e5f8c$export$47c9dde399e23070);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cNW3X = parcelRequire("cNW3X");

var $doIqw = parcelRequire("doIqw");
var $aXOG6 = parcelRequire("aXOG6");

var $j7m8K = parcelRequire("j7m8K");
var $1eETS = parcelRequire("1eETS");
var $3jAdT = parcelRequire("3jAdT");

var $bfuFk = parcelRequire("bfuFk");

var $JIPqS = parcelRequire("JIPqS");

var $koVbs = parcelRequire("koVbs");

var $e9QkH = parcelRequire("e9QkH");

var $4R6GH = parcelRequire("4R6GH");

var $lQvIi = parcelRequire("lQvIi");

var $44DPy = parcelRequire("44DPy");
const $77b3dd02970e5f8c$export$47c9dde399e23070 = ({ isEditable: isEditable, isEditDisabled: isEditDisabled, isDeprecatedGadget: isDeprecatedGadget, gadgetColor: gadgetColor, gadgetId: gadgetId, gadgetTitle: gadgetTitle, onSaveColor: onSaveColor, onEditModeClick: onEditModeClick, onDeleteGadget: onDeleteGadget, onDuplicateGadget: onDuplicateGadget })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $5uXOq.useState)(false);
    const [shouldFocusModalTrigger, setShouldFocusModalTrigger] = (0, $5uXOq.useState)(false);
    const [, { on: gadgetDeleteOpen }] = (0, $e9QkH.useSwitchModals)(gadgetId);
    const modalTriggerRef = (0, $5uXOq.useRef)(null);
    const isMounted = (0, $5uXOq.useRef)(true);
    const colorPalette = (0, $5uXOq.useMemo)(()=>Object.values((0, $JIPqS.COLOR_MAP)).map((code)=>{
            const colorName = (0, $JIPqS.COLOR_NAME_MAP)[code];
            return {
                label: colorName ? formatMessage(colorName) : code,
                value: code
            };
        }), [
        formatMessage
    ]);
    const handleDropdownOpenChange = (0, $5uXOq.useCallback)(({ isOpen: isOpen })=>setIsDropdownOpen(isOpen), []);
    const handleModalClose = (0, $5uXOq.useCallback)(()=>{
        setTimeout(()=>{
            // prevent unwanted state update if component is unmounted
            if (isMounted.current) {
                // Added 1ms delay to allow for the modal onClose event to finish
                // This is because closing the modal via the `ESC` key will trigger
                // the dropdown menu to close simultaneously, so we must dispatch this
                // after the keypress event has finished
                setIsDropdownOpen(true);
                setShouldFocusModalTrigger(true);
            }
        }, 1);
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldFocusModalTrigger && isDropdownOpen) {
            // DropdownMenu component uses useFocusManager hook to focus the first
            // dropdown menu item when the menu is opened, so we need to wait roughly
            // 50ms for the menu to open and focus the first item before then focusing
            // the modal trigger.
            setTimeout(()=>{
                modalTriggerRef.current?.focus();
            }, 50);
            setShouldFocusModalTrigger(false);
        }
    }, [
        isDropdownOpen,
        shouldFocusModalTrigger
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            isMounted.current = false;
        }, []);
    const onColourChange = (0, $5uXOq.useCallback)((_, newColor)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const colorId = Object.keys((0, $JIPqS.COLOR_MAP)).find((key)=>(0, $JIPqS.COLOR_MAP)[key] === newColor);
        if (colorId) onSaveColor(colorId);
    }, [
        onSaveColor
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($77b3dd02970e5f8c$var$DropdownWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j7m8K.default), {
        isOpen: isDropdownOpen,
        onOpenChange: handleDropdownOpenChange,
        isLoading: false,
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "default",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bfuFk))), {
                    label: formatMessage((0, $44DPy.default).moreActions, {
                        gadgetTitle: gadgetTitle
                    }),
                    LEGACY_size: "medium",
                    spacing: "spacious"
                }),
                testId: "dashboard-edit.ui.gadget-editable.config-dropdown.dropdown-button",
                ref: triggerRef
            }),
        shouldFlip: true,
        placement: "bottom-end",
        appearance: "tall",
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3jAdT.default), {
        title: formatMessage((0, $44DPy.default).colorHeading)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($77b3dd02970e5f8c$var$ColorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $doIqw.default), {
        label: formatMessage((0, $44DPy.default).colorHeading),
        palette: colorPalette,
        selectedColor: (0, $JIPqS.COLOR_MAP)[gadgetColor],
        checkMarkColor: (0, $JIPqS.COLOR_CHECKMARK_MAP)[gadgetColor],
        mode: (0, $aXOG6.Compact),
        cols: Object.keys((0, $JIPqS.COLOR_MAP)).length,
        onChange: onColourChange
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3jAdT.default), null, isEditable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
        "data-testid": "dashboard-edit.ui.gadget-editable.config-dropdown.edit",
        isDisabled: isEditDisabled,
        onClick: onEditModeClick
    }, formatMessage((0, $44DPy.default).configure)), !(isDeprecatedGadget && (0, $4R6GH.fg)('endeavour_gadget_deprecation_remove_functionality')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
        "data-testid": "dashboard-edit.ui.gadget-editable.config-dropdown.duplicate",
        onClick: onDuplicateGadget
    }, formatMessage((0, $44DPy.default).duplicate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
        "data-testid": "dashboard-edit.ui.gadget-editable.config-dropdown.delete",
        ref: modalTriggerRef,
        onClick: gadgetDeleteOpen
    }, formatMessage((0, $44DPy.default).delete))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lQvIi.DeleteGadgetModal), {
        id: gadgetId,
        onDeleteGadget: onDeleteGadget,
        gadgetName: gadgetTitle,
        onClose: handleModalClose
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $77b3dd02970e5f8c$var$DropdownWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $77b3dd02970e5f8c$var$ColorWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n7zl1pvm _ca0qidpf _u5f312x7 _n3td1b66 _19bvpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("doIqw", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f3c14f2fe41978d$export$2e2bcd8739ae039);
/* ColorPaletteMenu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $c9URB = parcelRequire("c9URB");

var $9Iej8 = parcelRequire("9Iej8");
var $asiGE = parcelRequire("asiGE");
var $3TR0I = parcelRequire("3TR0I");

var $4Knwz = parcelRequire("4Knwz");

var $5Pi5x = parcelRequire("5Pi5x");

const $0f3c14f2fe41978d$export$4bbfe93c6a14e8e6 = ({ autoFocus: autoFocus = true, isFocusLockEnabled: isFocusLockEnabled = true, isInsideMenu: isInsideMenu = true, createAnalyticsEvent: createAnalyticsEvent, onChange: onChange, palette: palette, selectedColor: selectedColor, checkMarkColor: checkMarkColor, label: label = 'Color picker', cols: cols = 6, mode: mode = (0, $c9URB.Mode).Standard, initialFocusRef: initialFocusRef, variant: variant = 'fill' })=>{
    const { options: options, value: selectedValue } = (0, $5Pi5x.getOptions)(palette, selectedColor);
    const fullLabel = `${label}, ${selectedValue.label} selected`;
    const selectedColorIndex = selectedValue.value ? options.findIndex(({ value: value })=>value === selectedValue.value) : 0;
    const [focusedIndex, setFocusedIndex] = (0, $5uXOq.useState)(selectedColorIndex);
    const createAndFireEventOnAtlaskit = (0, $9Iej8.default)('atlaskit');
    const changeAnalyticsCaller = ()=>{
        if (createAnalyticsEvent) return createAndFireEventOnAtlaskit({
            action: 'clicked',
            actionSubject: 'color-palette-menu',
            attributes: {
                componentName: 'color-picker',
                packageName: "platform-pkg",
                packageVersion: "0.0.0-use.local"
            }
        })(createAnalyticsEvent);
        return undefined;
    };
    const colorCardRefs = (0, $5uXOq.useMemo)(()=>[], []);
    const handleChange = (event, value)=>{
        onChange(event, value, changeAnalyticsCaller());
    };
    (0, $5uXOq.useEffect)(()=>{
        colorCardRefs[focusedIndex]?.focus();
    }, [
        focusedIndex,
        colorCardRefs
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        const numItems = options.length;
        switch(event.key){
            case 0, $c61654819d9c7ca7$export$1734a06b2397c2a8:
            case 0, $c61654819d9c7ca7$export$695331c89a36efd6:
                setFocusedIndex((prevIndex)=>(prevIndex + 1) % numItems);
                break;
            case 0, $c61654819d9c7ca7$export$b34c7ae3fd8138d2:
            case 0, $c61654819d9c7ca7$export$842fd6cf65a6b80c:
                setFocusedIndex((prevIndex)=>(prevIndex - 1 + numItems) % numItems);
                break;
            case 0, $c61654819d9c7ca7$export$10f6869ed0a7d75b:
                if (isFocusLockEnabled) {
                    event.preventDefault();
                    event.stopPropagation();
                    setFocusedIndex(selectedColorIndex);
                }
                break;
            default:
                break;
        }
    }, [
        isFocusLockEnabled,
        selectedColorIndex,
        setFocusedIndex,
        options
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "aria-label": fullLabel,
        role: isInsideMenu ? 'menu' : 'radiogroup',
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: `${(0, $5Pi5x.getWidth)(cols, mode)}px`
        },
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswh2mm _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _bfhk1bhr",
            mode === (0, $c9URB.Mode).Standard && "_2rkosqtm _16qs1akw"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                "_1e0c1txw _1n261g80 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
                mode === (0, $c9URB.Mode).Compact && "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t"
            ]),
            children: options.map(({ label: label, value: value }, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _4t3izwfg"
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4Knwz.default), {
                        type: (0, $c61654819d9c7ca7$export$2643a2cdce1d3963),
                        label: label,
                        value: value,
                        checkMarkColor: checkMarkColor,
                        isOption: true,
                        selected: value === selectedValue.value,
                        onClick: handleChange,
                        ref: (ref)=>{
                            colorCardRefs[index] = ref;
                        },
                        autoFocus: autoFocus,
                        initialFocusRef: value === selectedValue.value ? initialFocusRef : undefined,
                        isInsideMenu: isInsideMenu,
                        onKeyDown: handleKeyDown,
                        variant: variant
                    })
                }, value))
        })
    });
};
var $0f3c14f2fe41978d$export$2e2bcd8739ae039 = (0, $asiGE.default)({
    componentName: 'color-picker',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
})((0, $3TR0I.default)()($0f3c14f2fe41978d$export$4bbfe93c6a14e8e6));
const $0f3c14f2fe41978d$var$colorCardWrapperStyles = null;
const $0f3c14f2fe41978d$var$colorPaletteContainerStyles = null;
const $0f3c14f2fe41978d$var$colorPaletteContainerCompactStyles = null;
const $0f3c14f2fe41978d$var$colorPaletteMenuStyles = null;
const $0f3c14f2fe41978d$var$colorPaletteMenuStandardStyles = null;

});
parcelRegister("c9URB", function(module, exports) {

$parcel$export(module.exports, "Mode", () => $1d773cca214d8394$export$9484bbecc3c49a2e);
var $1d773cca214d8394$export$9484bbecc3c49a2e = /*#__PURE__*/ function(Mode) {
    Mode[Mode["Compact"] = 0] = "Compact";
    Mode[Mode["Standard"] = 1] = "Standard";
    return Mode;
}({});

});

parcelRegister("4Knwz", function(module, exports) {

$parcel$export(module.exports, "default", () => $79999f9905bd28af$export$2e2bcd8739ae039);
/* ColorCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $k0SFP = parcelRequire("k0SFP");

var $5KCCi = parcelRequire("5KCCi");



var $bWn3s = parcelRequire("bWn3s");
const $79999f9905bd28af$var$ColorCard = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, componentRef)=>{
    const { type: type, autoFocus: autoFocus = true, initialFocusRef: initialFocusRef, isInsideMenu: isInsideMenu = true, value: value, label: label, selected: selected, focused: focused, checkMarkColor: checkMarkColor = (0, $a7f8c6b391092279$export$29a4f05edc054374), isTabbing: isTabbing, onClick: onClick, onKeyDown: onKeyDown, variant: variant = 'fill' } = props;
    const ref = (0, $5uXOq.useRef)(null);
    const isInitialFocus = (0, $5uXOq.useRef)(true);
    const isColorPaletteMenu = type === (0, $c61654819d9c7ca7$export$2643a2cdce1d3963);
    const handleMouseDown = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            onClick(event, value);
        }
    }, [
        onClick,
        value
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if ((isColorPaletteMenu || isTabbing === undefined || isTabbing) && onClick && (event.key === (0, $c61654819d9c7ca7$export$8152f929a25a0ff4) || event.key === (0, $c61654819d9c7ca7$export$e51a3576c045c8d5))) {
            event.preventDefault();
            if (isTabbing) event.stopPropagation();
            onClick(event, value);
        }
        if (isColorPaletteMenu) onKeyDown?.(event);
        else if (event.key === (0, $c61654819d9c7ca7$export$10f6869ed0a7d75b)) {
            event.preventDefault();
            event.stopPropagation();
        }
    }, [
        isColorPaletteMenu,
        isTabbing,
        value,
        onClick,
        onKeyDown
    ]);
    (0, $5uXOq.useImperativeHandle)(componentRef, ()=>({
            focus: ()=>{
                if (isColorPaletteMenu) {
                    if (isInitialFocus.current) {
                        autoFocus && !initialFocusRef && ref.current?.focus();
                        isInitialFocus.current = false;
                    } else ref.current?.focus();
                }
            }
        }), [
        autoFocus,
        isColorPaletteMenu,
        initialFocusRef
    ]);
    const isInsideMenuRole = isInsideMenu ? 'menuitemradio' : 'radio';
    const role = isColorPaletteMenu ? isInsideMenuRole : 'presentation';
    const ariaChecked = isColorPaletteMenu ? selected : undefined;
    const ariaLabel = isColorPaletteMenu ? label : undefined;
    const isOutlineVariant = variant === 'outline';
    const newCheckmarkColor = isOutlineVariant ? "var(--ds-icon, #44546F)" : checkMarkColor;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
        content: label,
        children: (tooltipProps)=>{
            delete tooltipProps['aria-describedby'];
            return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ...tooltipProps,
                ref: initialFocusRef ? (0, $bWn3s.mergeRefs)([
                    ref,
                    tooltipProps.ref,
                    initialFocusRef
                ]) : (0, $bWn3s.mergeRefs)([
                    ref,
                    tooltipProps.ref
                ]),
                role: role,
                tabIndex: selected ? 0 : -1,
                "aria-checked": ariaChecked,
                "aria-label": ariaLabel,
                onClick: handleClick,
                onMouseDown: handleMouseDown,
                onKeyDown: handleKeyDown,
                className: (0, $bwpsq.default)([
                    "_19it4jjs _2rko130s _v564ervx _12ji1r31 _1qu2glyw _12y31o36 _1e0c1o8l _kqswh2mm _1bsbzwfg _4t3izwfg _vchhusvi _bfhktxrc _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _80omtlke",
                    (isColorPaletteMenu || isTabbing === undefined || isTabbing) && "_858uvmul _4cvxvmul",
                    focused && (isColorPaletteMenu || !isTabbing) && "_1h6dvmul"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        "_1bsb1osq _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    , {
                        style: isOutlineVariant ? {
                            borderColor: value || 'grey'
                        } : {
                            backgroundColor: value || 'transparent'
                        },
                        className: (0, $bwpsq.default)([
                            "_2rkosqtm _1bsb1tcg _4t3i1tcg _16qs16qq",
                            isOutlineVariant && "_189e1bk5 _1dqonqa1 _16qsglyw"
                        ]),
                        children: selected && /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k0SFP))), {
                            color: newCheckmarkColor,
                            label: "",
                            spacing: "spacious",
                            LEGACY_margin: "1px"
                        })
                    })
                })
            });
        }
    });
});
var $79999f9905bd28af$export$2e2bcd8739ae039 = $79999f9905bd28af$var$ColorCard;
const $79999f9905bd28af$var$colorCardOptionTabbingStyles = null;
const $79999f9905bd28af$var$colorCardOptionFocusedStyles = null;
const $79999f9905bd28af$var$sharedColorContainerStyles = null;
const $79999f9905bd28af$var$colorCardWrapperStyles = null;
const $79999f9905bd28af$var$colorCardContentStyles = null;
const $79999f9905bd28af$var$colorCardContentStylesOutline = null;

});
parcelRegister("k0SFP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::666ec8073f4584891951ab85e48975eb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e91e37cbf9192b44$var$_react = $e91e37cbf9192b44$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e91e37cbf9192b44$var$_checkMark = $e91e37cbf9192b44$var$_interopRequireDefault((parcelRequire("dVU8x")));

var $e91e37cbf9192b44$var$_done = $e91e37cbf9192b44$var$_interopRequireDefault((parcelRequire("4UpSr")));
function $e91e37cbf9192b44$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e91e37cbf9192b44$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $e91e37cbf9192b44$var$_react.default.createElement($e91e37cbf9192b44$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $e91e37cbf9192b44$var$_done.default
    }, props));
$e91e37cbf9192b44$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $e91e37cbf9192b44$var$_default = module.exports.default = $e91e37cbf9192b44$var$CheckMarkIcon;

});
parcelRegister("dVU8x", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e71f4112aeb66b16fbd284cc49bbc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a24c24cfbaad63c1$var$_react = $a24c24cfbaad63c1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a24c24cfbaad63c1$var$_baseNew = $a24c24cfbaad63c1$var$_interopRequireDefault((parcelRequire("enEmH")));
function $a24c24cfbaad63c1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a24c24cfbaad63c1$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $a24c24cfbaad63c1$var$_react.default.createElement($a24c24cfbaad63c1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m15.076 3.23-8.75 10.5a.75.75 0 0 1-1.159-.008l-4.25-5.25 1.166-.944 3.675 4.54 8.166-9.798z" clip-rule="evenodd"/>`
    }, props));
$a24c24cfbaad63c1$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $a24c24cfbaad63c1$var$_default = module.exports.default = $a24c24cfbaad63c1$var$CheckMarkIcon;

});

parcelRegister("4UpSr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3930770d7c775047$var$_react = $3930770d7c775047$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $3930770d7c775047$var$_checkMark = $3930770d7c775047$var$_interopRequireDefault((parcelRequire("dVU8x")));
function $3930770d7c775047$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3930770d7c775047$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $3930770d7c775047$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $3930770d7c775047$var$_checkMark.default
    }));
$3930770d7c775047$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $3930770d7c775047$var$_default = module.exports.default = $3930770d7c775047$var$EditorDoneIcon;

});


const $c61654819d9c7ca7$export$9fea11a016bc5bcf = 'COLOR_PICKER';
const $c61654819d9c7ca7$export$2643a2cdce1d3963 = 'COLOR_PALETTE_MENU';
const $c61654819d9c7ca7$export$64c9b8c6e6a2c6ac = 32;
const $c61654819d9c7ca7$export$e51a3576c045c8d5 = ' ';
const $c61654819d9c7ca7$export$8152f929a25a0ff4 = 'Enter';
const $c61654819d9c7ca7$export$b34c7ae3fd8138d2 = 'ArrowUp';
const $c61654819d9c7ca7$export$1734a06b2397c2a8 = 'ArrowDown';
const $c61654819d9c7ca7$export$842fd6cf65a6b80c = 'ArrowLeft';
const $c61654819d9c7ca7$export$695331c89a36efd6 = 'ArrowRight';
const $c61654819d9c7ca7$export$10f6869ed0a7d75b = 'Tab';
const $c61654819d9c7ca7$export$929c2026f4dd54a2 = 'Escape';

var $a7f8c6b391092279$exports = {};

$parcel$export($a7f8c6b391092279$exports, "R50", () => $a7f8c6b391092279$export$4b84fd0e2c617bd);
$parcel$export($a7f8c6b391092279$exports, "R75", () => $a7f8c6b391092279$export$b34b069eff244586);
$parcel$export($a7f8c6b391092279$exports, "R100", () => $a7f8c6b391092279$export$be802dd0d8b57f35);
$parcel$export($a7f8c6b391092279$exports, "R200", () => $a7f8c6b391092279$export$60847d42f9da92a6);
$parcel$export($a7f8c6b391092279$exports, "R300", () => $a7f8c6b391092279$export$4a7404f376229999);
$parcel$export($a7f8c6b391092279$exports, "R400", () => $a7f8c6b391092279$export$2010d0fb4295b346);
$parcel$export($a7f8c6b391092279$exports, "R500", () => $a7f8c6b391092279$export$2837b5a1a71d5c02);
$parcel$export($a7f8c6b391092279$exports, "Y50", () => $a7f8c6b391092279$export$8d9596b529bbb9cf);
$parcel$export($a7f8c6b391092279$exports, "Y75", () => $a7f8c6b391092279$export$41060a744ab0b7ae);
$parcel$export($a7f8c6b391092279$exports, "Y100", () => $a7f8c6b391092279$export$1cc05bbbf340e559);
$parcel$export($a7f8c6b391092279$exports, "Y200", () => $a7f8c6b391092279$export$5aae31392d72caaa);
$parcel$export($a7f8c6b391092279$exports, "Y300", () => $a7f8c6b391092279$export$c6930421db9fa514);
$parcel$export($a7f8c6b391092279$exports, "Y400", () => $a7f8c6b391092279$export$59619663aa6500fb);
$parcel$export($a7f8c6b391092279$exports, "Y500", () => $a7f8c6b391092279$export$874739ea9e379ab6);
$parcel$export($a7f8c6b391092279$exports, "G50", () => $a7f8c6b391092279$export$8a6341c32b6a3ee6);
$parcel$export($a7f8c6b391092279$exports, "G75", () => $a7f8c6b391092279$export$69a3bf21b9686c2b);
$parcel$export($a7f8c6b391092279$exports, "G100", () => $a7f8c6b391092279$export$afbce1382ec95f73);
$parcel$export($a7f8c6b391092279$exports, "G200", () => $a7f8c6b391092279$export$747d86715d4175de);
$parcel$export($a7f8c6b391092279$exports, "G300", () => $a7f8c6b391092279$export$940e1f69e873f202);
$parcel$export($a7f8c6b391092279$exports, "G400", () => $a7f8c6b391092279$export$a49394138f7b8e85);
$parcel$export($a7f8c6b391092279$exports, "G500", () => $a7f8c6b391092279$export$6fa04827ac68a4fb);
$parcel$export($a7f8c6b391092279$exports, "B50", () => $a7f8c6b391092279$export$226de0355ed012f8);
$parcel$export($a7f8c6b391092279$exports, "B75", () => $a7f8c6b391092279$export$8c13c2ee36917869);
$parcel$export($a7f8c6b391092279$exports, "B100", () => $a7f8c6b391092279$export$ecfc1dff386a3e7a);
$parcel$export($a7f8c6b391092279$exports, "B200", () => $a7f8c6b391092279$export$215b7063051591f1);
$parcel$export($a7f8c6b391092279$exports, "B300", () => $a7f8c6b391092279$export$e62e8919cca44969);
$parcel$export($a7f8c6b391092279$exports, "B400", () => $a7f8c6b391092279$export$b3de0ae08da2ce64);
$parcel$export($a7f8c6b391092279$exports, "B500", () => $a7f8c6b391092279$export$a6ee3d71bc067634);
$parcel$export($a7f8c6b391092279$exports, "B600", () => $a7f8c6b391092279$export$67f15409e87642a1);
$parcel$export($a7f8c6b391092279$exports, "B700", () => $a7f8c6b391092279$export$f0539dbc42dbb067);
$parcel$export($a7f8c6b391092279$exports, "P50", () => $a7f8c6b391092279$export$363e4475840015bb);
$parcel$export($a7f8c6b391092279$exports, "P75", () => $a7f8c6b391092279$export$4b0a4417ed59760f);
$parcel$export($a7f8c6b391092279$exports, "P100", () => $a7f8c6b391092279$export$6011520a64d9a187);
$parcel$export($a7f8c6b391092279$exports, "P200", () => $a7f8c6b391092279$export$a7175d4e9206bc80);
$parcel$export($a7f8c6b391092279$exports, "P300", () => $a7f8c6b391092279$export$b48405b95304b5a1);
$parcel$export($a7f8c6b391092279$exports, "P400", () => $a7f8c6b391092279$export$c71e4279dd54a18d);
$parcel$export($a7f8c6b391092279$exports, "P500", () => $a7f8c6b391092279$export$147899de772240ec);
$parcel$export($a7f8c6b391092279$exports, "T50", () => $a7f8c6b391092279$export$2cf711fe14c66f06);
$parcel$export($a7f8c6b391092279$exports, "T75", () => $a7f8c6b391092279$export$7a8f4d33f6f9772c);
$parcel$export($a7f8c6b391092279$exports, "T100", () => $a7f8c6b391092279$export$776c9c497ef08533);
$parcel$export($a7f8c6b391092279$exports, "T200", () => $a7f8c6b391092279$export$69cb3ca10c1e330e);
$parcel$export($a7f8c6b391092279$exports, "T300", () => $a7f8c6b391092279$export$9dc1ef0f3f48059b);
$parcel$export($a7f8c6b391092279$exports, "T400", () => $a7f8c6b391092279$export$7c835c78b6fcdef8);
$parcel$export($a7f8c6b391092279$exports, "T500", () => $a7f8c6b391092279$export$6036577f95c3877e);
$parcel$export($a7f8c6b391092279$exports, "N0", () => $a7f8c6b391092279$export$29a4f05edc054374);
$parcel$export($a7f8c6b391092279$exports, "N10", () => $a7f8c6b391092279$export$e655ef011c4aa1a2);
$parcel$export($a7f8c6b391092279$exports, "N20", () => $a7f8c6b391092279$export$9fdfb749e33cdf97);
$parcel$export($a7f8c6b391092279$exports, "N30", () => $a7f8c6b391092279$export$3e51e8f1440314ba);
$parcel$export($a7f8c6b391092279$exports, "N40", () => $a7f8c6b391092279$export$1ce2d1575d444ceb);
$parcel$export($a7f8c6b391092279$exports, "N50", () => $a7f8c6b391092279$export$8754fc7e6d8b3000);
$parcel$export($a7f8c6b391092279$exports, "N60", () => $a7f8c6b391092279$export$c2e91cbeada39b8b);
$parcel$export($a7f8c6b391092279$exports, "N70", () => $a7f8c6b391092279$export$5f71e19f3a7ad9de);
$parcel$export($a7f8c6b391092279$exports, "N80", () => $a7f8c6b391092279$export$eaa8c8a70ac22806);
$parcel$export($a7f8c6b391092279$exports, "N90", () => $a7f8c6b391092279$export$7c87d337fb91a97d);
$parcel$export($a7f8c6b391092279$exports, "N100", () => $a7f8c6b391092279$export$d6447c357493214f);
$parcel$export($a7f8c6b391092279$exports, "N200", () => $a7f8c6b391092279$export$f563ee71e9ee74cd);
$parcel$export($a7f8c6b391092279$exports, "N300", () => $a7f8c6b391092279$export$e2ef2124cf4024b1);
$parcel$export($a7f8c6b391092279$exports, "N400", () => $a7f8c6b391092279$export$eece5f492e429f08);
$parcel$export($a7f8c6b391092279$exports, "N500", () => $a7f8c6b391092279$export$c39c0fe0f26207ae);
$parcel$export($a7f8c6b391092279$exports, "N600", () => $a7f8c6b391092279$export$7090862dc3038a9f);
$parcel$export($a7f8c6b391092279$exports, "N700", () => $a7f8c6b391092279$export$ad0bacf983b7ddaa);
$parcel$export($a7f8c6b391092279$exports, "N800", () => $a7f8c6b391092279$export$7d61b15e0da132af);
$parcel$export($a7f8c6b391092279$exports, "N900", () => $a7f8c6b391092279$export$fbda843f0a27fe96);
$parcel$export($a7f8c6b391092279$exports, "N10A", () => $a7f8c6b391092279$export$791e57b27ca738ef);
$parcel$export($a7f8c6b391092279$exports, "N20A", () => $a7f8c6b391092279$export$8d43898f60b96a82);
$parcel$export($a7f8c6b391092279$exports, "N30A", () => $a7f8c6b391092279$export$920c0d5c49070351);
$parcel$export($a7f8c6b391092279$exports, "N40A", () => $a7f8c6b391092279$export$46987b49aab6d1a8);
$parcel$export($a7f8c6b391092279$exports, "N50A", () => $a7f8c6b391092279$export$7d3359664e8bb0e5);
$parcel$export($a7f8c6b391092279$exports, "N60A", () => $a7f8c6b391092279$export$d2d3bedfb276cac0);
$parcel$export($a7f8c6b391092279$exports, "N70A", () => $a7f8c6b391092279$export$6e5e7499ff054f6d);
$parcel$export($a7f8c6b391092279$exports, "N80A", () => $a7f8c6b391092279$export$59264b346c877fa7);
$parcel$export($a7f8c6b391092279$exports, "N90A", () => $a7f8c6b391092279$export$d092757d7c64925c);
$parcel$export($a7f8c6b391092279$exports, "N100A", () => $a7f8c6b391092279$export$486ab785e4bac3c6);
$parcel$export($a7f8c6b391092279$exports, "N200A", () => $a7f8c6b391092279$export$fba592bbc6419fea);
$parcel$export($a7f8c6b391092279$exports, "N300A", () => $a7f8c6b391092279$export$13609db0e6812ab8);
$parcel$export($a7f8c6b391092279$exports, "N400A", () => $a7f8c6b391092279$export$fbae4efaa892d883);
$parcel$export($a7f8c6b391092279$exports, "N500A", () => $a7f8c6b391092279$export$f13946d26f440ce6);
$parcel$export($a7f8c6b391092279$exports, "N600A", () => $a7f8c6b391092279$export$19f58225ac52a306);
$parcel$export($a7f8c6b391092279$exports, "N700A", () => $a7f8c6b391092279$export$6384f09da70e7b62);
$parcel$export($a7f8c6b391092279$exports, "N800A", () => $a7f8c6b391092279$export$d0dccc730683edc2);
$parcel$export($a7f8c6b391092279$exports, "DN900", () => $a7f8c6b391092279$export$2f6319cf7d736c2a);
$parcel$export($a7f8c6b391092279$exports, "DN800", () => $a7f8c6b391092279$export$95126bc8884d6634);
$parcel$export($a7f8c6b391092279$exports, "DN700", () => $a7f8c6b391092279$export$8338d8c35d44ff1);
$parcel$export($a7f8c6b391092279$exports, "DN600", () => $a7f8c6b391092279$export$5368d76ae4fbbda7);
$parcel$export($a7f8c6b391092279$exports, "DN500", () => $a7f8c6b391092279$export$9f0a771d16ec8d36);
$parcel$export($a7f8c6b391092279$exports, "DN400", () => $a7f8c6b391092279$export$abcf8c38338b4aa5);
$parcel$export($a7f8c6b391092279$exports, "DN300", () => $a7f8c6b391092279$export$97e81faa16a182c7);
$parcel$export($a7f8c6b391092279$exports, "DN200", () => $a7f8c6b391092279$export$bfe21c59123ecf33);
$parcel$export($a7f8c6b391092279$exports, "DN100", () => $a7f8c6b391092279$export$ee82aa2ea6a1558);
$parcel$export($a7f8c6b391092279$exports, "DN90", () => $a7f8c6b391092279$export$682927c6ed76be02);
$parcel$export($a7f8c6b391092279$exports, "DN80", () => $a7f8c6b391092279$export$91fd9994c5be9757);
$parcel$export($a7f8c6b391092279$exports, "DN70", () => $a7f8c6b391092279$export$d281fbfe3cff2df6);
$parcel$export($a7f8c6b391092279$exports, "DN60", () => $a7f8c6b391092279$export$3902c91d8b98a753);
$parcel$export($a7f8c6b391092279$exports, "DN50", () => $a7f8c6b391092279$export$8e8133c1ba5845b5);
$parcel$export($a7f8c6b391092279$exports, "DN40", () => $a7f8c6b391092279$export$33ff357f6620b39);
$parcel$export($a7f8c6b391092279$exports, "DN30", () => $a7f8c6b391092279$export$633847cf062b69e0);
$parcel$export($a7f8c6b391092279$exports, "DN20", () => $a7f8c6b391092279$export$9776a6e503bdbf76);
$parcel$export($a7f8c6b391092279$exports, "DN10", () => $a7f8c6b391092279$export$6c813d5160dff5db);
$parcel$export($a7f8c6b391092279$exports, "DN0", () => $a7f8c6b391092279$export$3d4f271a500072a);
$parcel$export($a7f8c6b391092279$exports, "DN800A", () => $a7f8c6b391092279$export$fe151285c22759ec);
$parcel$export($a7f8c6b391092279$exports, "DN700A", () => $a7f8c6b391092279$export$a101c6190d0da34);
$parcel$export($a7f8c6b391092279$exports, "DN600A", () => $a7f8c6b391092279$export$4b16f52932fda51);
$parcel$export($a7f8c6b391092279$exports, "DN500A", () => $a7f8c6b391092279$export$a74bcd7b9845b0d8);
$parcel$export($a7f8c6b391092279$exports, "DN400A", () => $a7f8c6b391092279$export$9209c179316d1751);
$parcel$export($a7f8c6b391092279$exports, "DN300A", () => $a7f8c6b391092279$export$88f55133f636c8dd);
$parcel$export($a7f8c6b391092279$exports, "DN200A", () => $a7f8c6b391092279$export$51126f85d1009512);
$parcel$export($a7f8c6b391092279$exports, "DN100A", () => $a7f8c6b391092279$export$a069b547bd23af78);
$parcel$export($a7f8c6b391092279$exports, "DN90A", () => $a7f8c6b391092279$export$40cce05af3b2600a);
$parcel$export($a7f8c6b391092279$exports, "DN80A", () => $a7f8c6b391092279$export$b78942185925a0d);
$parcel$export($a7f8c6b391092279$exports, "DN70A", () => $a7f8c6b391092279$export$e058fb44b8eaafca);
$parcel$export($a7f8c6b391092279$exports, "DN60A", () => $a7f8c6b391092279$export$92b0b8de26920c18);
$parcel$export($a7f8c6b391092279$exports, "DN50A", () => $a7f8c6b391092279$export$67564f7459d3fc9e);
$parcel$export($a7f8c6b391092279$exports, "DN40A", () => $a7f8c6b391092279$export$77868e1ca884ffa3);
$parcel$export($a7f8c6b391092279$exports, "DN30A", () => $a7f8c6b391092279$export$2afd71d7d3ea2cd5);
$parcel$export($a7f8c6b391092279$exports, "DN20A", () => $a7f8c6b391092279$export$f2a0acaab9972c70);
$parcel$export($a7f8c6b391092279$exports, "DN10A", () => $a7f8c6b391092279$export$9ab70e67d6475361);
$parcel$export($a7f8c6b391092279$exports, "T30", () => $a7f8c6b391092279$export$d2adc5dedf09fced);
$parcel$export($a7f8c6b391092279$exports, "L50", () => $a7f8c6b391092279$export$f51762073d2bb381);
$parcel$export($a7f8c6b391092279$exports, "L75", () => $a7f8c6b391092279$export$95e26d54def96891);
// Reds
const $a7f8c6b391092279$export$4b84fd0e2c617bd = '#FFEBE6';
const $a7f8c6b391092279$export$b34b069eff244586 = '#FFBDAD';
const $a7f8c6b391092279$export$be802dd0d8b57f35 = '#FF8F73';
const $a7f8c6b391092279$export$60847d42f9da92a6 = '#FF7452';
const $a7f8c6b391092279$export$4a7404f376229999 = '#FF5630';
const $a7f8c6b391092279$export$2010d0fb4295b346 = '#DE350B';
const $a7f8c6b391092279$export$2837b5a1a71d5c02 = '#BF2600';
const $a7f8c6b391092279$export$8d9596b529bbb9cf = '#FFFAE6';
const $a7f8c6b391092279$export$41060a744ab0b7ae = '#FFF0B3';
const $a7f8c6b391092279$export$1cc05bbbf340e559 = '#FFE380';
const $a7f8c6b391092279$export$5aae31392d72caaa = '#FFC400';
const $a7f8c6b391092279$export$c6930421db9fa514 = '#FFAB00';
const $a7f8c6b391092279$export$59619663aa6500fb = '#FF991F';
const $a7f8c6b391092279$export$874739ea9e379ab6 = '#FF8B00';
const $a7f8c6b391092279$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $a7f8c6b391092279$export$69a3bf21b9686c2b = '#ABF5D1';
const $a7f8c6b391092279$export$afbce1382ec95f73 = '#79F2C0';
const $a7f8c6b391092279$export$747d86715d4175de = '#57D9A3';
const $a7f8c6b391092279$export$940e1f69e873f202 = '#36B37E';
const $a7f8c6b391092279$export$a49394138f7b8e85 = '#00875A';
const $a7f8c6b391092279$export$6fa04827ac68a4fb = '#006644';
const $a7f8c6b391092279$export$226de0355ed012f8 = '#DEEBFF';
const $a7f8c6b391092279$export$8c13c2ee36917869 = '#B3D4FF';
const $a7f8c6b391092279$export$ecfc1dff386a3e7a = '#4C9AFF';
const $a7f8c6b391092279$export$215b7063051591f1 = '#2684FF';
const $a7f8c6b391092279$export$e62e8919cca44969 = '#0065FF';
const $a7f8c6b391092279$export$b3de0ae08da2ce64 = '#0052CC';
const $a7f8c6b391092279$export$a6ee3d71bc067634 = '#0747A6';
const $a7f8c6b391092279$export$67f15409e87642a1 = '#669DF1';
const $a7f8c6b391092279$export$f0539dbc42dbb067 = '#8FB8F6';
const $a7f8c6b391092279$export$363e4475840015bb = '#EAE6FF';
const $a7f8c6b391092279$export$4b0a4417ed59760f = '#C0B6F2';
const $a7f8c6b391092279$export$6011520a64d9a187 = '#998DD9';
const $a7f8c6b391092279$export$a7175d4e9206bc80 = '#8777D9';
const $a7f8c6b391092279$export$b48405b95304b5a1 = '#6554C0';
const $a7f8c6b391092279$export$c71e4279dd54a18d = '#5243AA';
const $a7f8c6b391092279$export$147899de772240ec = '#403294';
const $a7f8c6b391092279$export$2cf711fe14c66f06 = '#E6FCFF';
const $a7f8c6b391092279$export$7a8f4d33f6f9772c = '#B3F5FF';
const $a7f8c6b391092279$export$776c9c497ef08533 = '#79E2F2';
const $a7f8c6b391092279$export$69cb3ca10c1e330e = '#00C7E6';
const $a7f8c6b391092279$export$9dc1ef0f3f48059b = '#00B8D9';
const $a7f8c6b391092279$export$7c835c78b6fcdef8 = '#00A3BF';
const $a7f8c6b391092279$export$6036577f95c3877e = '#008DA6';
const $a7f8c6b391092279$export$29a4f05edc054374 = '#FFFFFF';
const $a7f8c6b391092279$export$e655ef011c4aa1a2 = '#FAFBFC';
const $a7f8c6b391092279$export$9fdfb749e33cdf97 = '#F4F5F7';
const $a7f8c6b391092279$export$3e51e8f1440314ba = '#EBECF0';
const $a7f8c6b391092279$export$1ce2d1575d444ceb = '#DFE1E6';
const $a7f8c6b391092279$export$8754fc7e6d8b3000 = '#C1C7D0';
const $a7f8c6b391092279$export$c2e91cbeada39b8b = '#B3BAC5';
const $a7f8c6b391092279$export$5f71e19f3a7ad9de = '#A5ADBA';
const $a7f8c6b391092279$export$eaa8c8a70ac22806 = '#97A0AF';
const $a7f8c6b391092279$export$7c87d337fb91a97d = '#8993A4';
const $a7f8c6b391092279$export$d6447c357493214f = '#7A869A';
const $a7f8c6b391092279$export$f563ee71e9ee74cd = '#6B778C';
const $a7f8c6b391092279$export$e2ef2124cf4024b1 = '#5E6C84';
const $a7f8c6b391092279$export$eece5f492e429f08 = '#505F79';
const $a7f8c6b391092279$export$c39c0fe0f26207ae = '#42526E';
const $a7f8c6b391092279$export$7090862dc3038a9f = '#344563';
const $a7f8c6b391092279$export$ad0bacf983b7ddaa = '#253858';
const $a7f8c6b391092279$export$7d61b15e0da132af = '#172B4D';
const $a7f8c6b391092279$export$fbda843f0a27fe96 = '#091E42';
const $a7f8c6b391092279$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $a7f8c6b391092279$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $a7f8c6b391092279$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $a7f8c6b391092279$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $a7f8c6b391092279$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $a7f8c6b391092279$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $a7f8c6b391092279$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $a7f8c6b391092279$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $a7f8c6b391092279$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $a7f8c6b391092279$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $a7f8c6b391092279$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $a7f8c6b391092279$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $a7f8c6b391092279$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $a7f8c6b391092279$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $a7f8c6b391092279$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $a7f8c6b391092279$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $a7f8c6b391092279$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $a7f8c6b391092279$export$2f6319cf7d736c2a = '#E6EDFA';
const $a7f8c6b391092279$export$95126bc8884d6634 = '#DCE5F5';
const $a7f8c6b391092279$export$8338d8c35d44ff1 = '#CED9EB';
const $a7f8c6b391092279$export$5368d76ae4fbbda7 = '#B8C7E0';
const $a7f8c6b391092279$export$9f0a771d16ec8d36 = '#ABBBD6';
const $a7f8c6b391092279$export$abcf8c38338b4aa5 = '#9FB0CC';
const $a7f8c6b391092279$export$97e81faa16a182c7 = '#8C9CB8';
const $a7f8c6b391092279$export$bfe21c59123ecf33 = '#7988A3';
const $a7f8c6b391092279$export$ee82aa2ea6a1558 = '#67758F';
const $a7f8c6b391092279$export$682927c6ed76be02 = '#56637A';
const $a7f8c6b391092279$export$91fd9994c5be9757 = '#455166';
const $a7f8c6b391092279$export$d281fbfe3cff2df6 = '#3B475C';
const $a7f8c6b391092279$export$3902c91d8b98a753 = '#313D52';
const $a7f8c6b391092279$export$8e8133c1ba5845b5 = '#283447';
const $a7f8c6b391092279$export$33ff357f6620b39 = '#202B3D';
const $a7f8c6b391092279$export$633847cf062b69e0 = '#1B2638';
const $a7f8c6b391092279$export$9776a6e503bdbf76 = '#121A29';
const $a7f8c6b391092279$export$6c813d5160dff5db = '#0E1624';
const $a7f8c6b391092279$export$3d4f271a500072a = '#0D1424';
const $a7f8c6b391092279$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $a7f8c6b391092279$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $a7f8c6b391092279$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $a7f8c6b391092279$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $a7f8c6b391092279$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $a7f8c6b391092279$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $a7f8c6b391092279$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $a7f8c6b391092279$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $a7f8c6b391092279$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $a7f8c6b391092279$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $a7f8c6b391092279$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $a7f8c6b391092279$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $a7f8c6b391092279$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $a7f8c6b391092279$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $a7f8c6b391092279$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $a7f8c6b391092279$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $a7f8c6b391092279$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $a7f8c6b391092279$export$d2adc5dedf09fced = '#292A2E';
const $a7f8c6b391092279$export$f51762073d2bb381 = '#94C748';
const $a7f8c6b391092279$export$95e26d54def96891 = '#B3DF72';


parcelRegister("5Pi5x", function(module, exports) {

$parcel$export(module.exports, "getWidth", () => $654029f6933ad60d$export$3c49c185de0c2bfc);
$parcel$export(module.exports, "getOptions", () => $654029f6933ad60d$export$d2312e68e1f5ad00);
// AFP-2532 TODO: Fix automatic suppressions below
// eslint-disable-next-line @atlassian/tangerine/import/entry-points

var $b4a3S = parcelRequire("b4a3S");


var $8QpSo = parcelRequire("8QpSo");

var $c9URB = parcelRequire("c9URB");
const $654029f6933ad60d$export$3c49c185de0c2bfc = (cols, mode)=>{
    const width = cols * ((0, $c61654819d9c7ca7$export$64c9b8c6e6a2c6ac) + (0, $b4a3S.gridSize)() / 2);
    return mode === (0, $c9URB.Mode).Standard ? width + (0, $b4a3S.gridSize)() : width;
};
const $654029f6933ad60d$export$d2312e68e1f5ad00 = (0, $8QpSo.default)((palette, selectedColor, showDefaultSwatchColor)=>{
    let focusedItemIndex = 0;
    let defaultSelectedColor = palette[0];
    if (!showDefaultSwatchColor) defaultSelectedColor = {
        label: '',
        value: ''
    };
    const value = palette.find((color, index)=>{
        if (color.value === selectedColor) {
            focusedItemIndex = index;
            return true;
        }
        return false;
    }) || defaultSelectedColor;
    return {
        options: palette,
        value: value,
        focusedItemIndex: focusedItemIndex
    };
});

});


parcelRegister("aXOG6", function(module, exports) {

$parcel$export(module.exports, "Compact", () => $c725046404cedda2$export$6479582a9c9e50ce);
$parcel$export(module.exports, "default", () => $c725046404cedda2$export$2e2bcd8739ae039);

var $imYbk = parcelRequire("imYbk");

var $c9URB = parcelRequire("c9URB");

var $doIqw = parcelRequire("doIqw");
const { Compact: $c725046404cedda2$export$6479582a9c9e50ce, Standard: $c725046404cedda2$export$d5a1f56087d42b19 } = (0, $c9URB.Mode);
var $c725046404cedda2$export$2e2bcd8739ae039 = (0, $imYbk.default);

});
parcelRegister("imYbk", function(module, exports) {

$parcel$export(module.exports, "default", () => $20aece5413e02e0d$export$2e2bcd8739ae039);
/* ColorPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $1JbQI = parcelRequire("1JbQI");

var $jJ4dP = parcelRequire("jJ4dP");

var $iTb7F = parcelRequire("iTb7F");


var $9Iej8 = parcelRequire("9Iej8");
var $asiGE = parcelRequire("asiGE");
var $3TR0I = parcelRequire("3TR0I");

var $5Pi5x = parcelRequire("5Pi5x");

var $8RXs9 = parcelRequire("8RXs9");

var $fHpHg = parcelRequire("fHpHg");

var $TIfiO = parcelRequire("TIfiO");
const $20aece5413e02e0d$var$defaultPopperProps = {
    strategy: 'fixed',
    modifiers: [
        {
            name: 'offset',
            options: {
                offset: [
                    0,
                    8
                ]
            }
        }
    ],
    placement: 'bottom-start'
};
const $20aece5413e02e0d$var$packageName = "platform-pkg";
const $20aece5413e02e0d$var$packageVersion = "0.0.0-use.local";
class $20aece5413e02e0d$var$ColorPickerWithoutAnalyticsBase extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { palette: palette, selectedColor: selectedColor, checkMarkColor: checkMarkColor, cols: cols, popperProps: popperProps = $20aece5413e02e0d$var$defaultPopperProps, label: label = 'Color picker', triggerId: triggerId, selectedColourSwatchSize: selectedColourSwatchSize, showDefaultSwatchColor: showDefaultSwatchColor = true, isDisabledSelectedSwatch: isDisabledSelectedSwatch, intl: intl, variant: variant = 'fill' } = this.props;
        const { options: options, value: value } = (0, $5Pi5x.getOptions)(palette, selectedColor, showDefaultSwatchColor);
        const fullLabel = this.getFullLabel(intl, value, label);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1JbQI.default), {
            target: ({ ref: ref, isOpen: isOpen })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    ref: ref,
                    className: (0, $bwpsq.default)([
                        "_1e0c1o8l"
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jJ4dP.default), {
                        ...value,
                        label: fullLabel,
                        expanded: isOpen,
                        swatchSize: selectedColourSwatchSize,
                        isDisabled: isDisabledSelectedSwatch,
                        id: triggerId,
                        variant: variant
                    })
                }),
            popperProps: popperProps,
            maxMenuWidth: "auto",
            minMenuWidth: "auto",
            options: options,
            label: fullLabel,
            value: value,
            components: $iTb7F,
            onChange: this.onChangeSelect,
            searchThreshold: Number.MAX_VALUE,
            //@ts-ignore react-select unsupported props
            cols: cols,
            checkMarkColor: checkMarkColor,
            variant: variant,
            onKeyDown: this.onKeyDown,
            isTabbing: this.state.isTabbing,
            onOptionKeyDown: this.onOptionKeyDown,
            ...(0, $fHpHg.fg)('one_event_rules_them_all_fg') && {
                onMenuOpen: this.props.onMenuOpen
            }
        });
    }
    constructor(...args){
        super(...args), this.createAndFireEventOnAtlaskit = (0, $9Iej8.default)('atlaskit'), this.state = {
            isTabbing: false
        }, this.changeAnalyticsCaller = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) return this.createAndFireEventOnAtlaskit({
                action: 'clicked',
                actionSubject: 'color-picker',
                attributes: {
                    componentName: 'color-picker',
                    packageName: $20aece5413e02e0d$var$packageName,
                    packageVersion: $20aece5413e02e0d$var$packageVersion
                }
            })(createAnalyticsEvent);
            return undefined;
        }, this.onChangeSelect = (option)=>{
            this.props.onChange(option.value, this.changeAnalyticsCaller());
        }, this.onOptionKeyDown = (value)=>{
            this.props.onChange(value, this.changeAnalyticsCaller());
        }, this.onKeyDown = (e)=>{
            const key = e.key;
            if (key === (0, $c61654819d9c7ca7$export$10f6869ed0a7d75b)) this.setState({
                isTabbing: true
            });
            else if (key === (0, $c61654819d9c7ca7$export$b34c7ae3fd8138d2) || key === (0, $c61654819d9c7ca7$export$1734a06b2397c2a8)) this.setState({
                isTabbing: false
            });
            else if (key === (0, $c61654819d9c7ca7$export$929c2026f4dd54a2)) e.stopPropagation();
        }, this.getFullLabel = (intl, value, label)=>{
            if (value && value.label) return intl.formatMessage((0, $TIfiO.default).colorPickerAriaLabel, {
                color: value.label,
                message: label
            });
            else return label;
        };
    }
}
const $20aece5413e02e0d$export$2fcf66ed38ff3cf5 = (0, $8RXs9.default)($20aece5413e02e0d$var$ColorPickerWithoutAnalyticsBase);
var $20aece5413e02e0d$export$2e2bcd8739ae039 = (0, $asiGE.default)({
    componentName: 'color-picker',
    packageName: $20aece5413e02e0d$var$packageName,
    packageVersion: $20aece5413e02e0d$var$packageVersion
})((0, $3TR0I.default)()($20aece5413e02e0d$export$2fcf66ed38ff3cf5));
const $20aece5413e02e0d$var$colorCardWrapperStyles = null;

});
parcelRegister("jJ4dP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee07b21e56d2f93a$export$2e2bcd8739ae039);
/* Trigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5KCCi = parcelRequire("5KCCi");

var $fHpHg = parcelRequire("fHpHg");
const $ee07b21e56d2f93a$var$ColorCard = ({ value: value, label: label, expanded: expanded, onClick: onClick, swatchSize: swatchSize = 'default', isDisabled: isDisabled, id: id, variant: variant = 'fill' })=>{
    const handleMouseDown = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        /**
     * The 'platform_dst_layer_observer_select' feature flag updates `PopupSelect` to close itself when
     * the internal Select's `onMenuClose` prop is called.
     *
     * By moving focus to the trigger element after the select menu is open, it causes the select
     * menu to think it is being closed, and call its `onMenuClose` prop.
     *
     * This results in the PopupSelect instantly closing when the user clicks to open it.
     */ if (!(0, $fHpHg.fg)('platform_dst_layer_observer_select')) event.currentTarget.focus();
        if (onClick) {
            event.preventDefault();
            onClick();
        }
    }, [
        onClick
    ]);
    const isOutlineVariant = variant === 'outline';
    const colorCardStyles = isOutlineVariant ? {
        borderColor: value || 'grey'
    } : {
        backgroundColor: value || 'transparent'
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
        content: label,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
            disabled: isDisabled,
            onClick: handleClick,
            onMouseDown: handleMouseDown,
            "aria-label": label,
            "aria-expanded": expanded,
            "aria-haspopup": true,
            type: "button",
            id: id,
            className: (0, $bwpsq.default)([
                "_19it4jjs _2rko130s _v564ervx _12ji1r31 _1qu2glyw _12y31o36 _1e0c1o8l _kqswh2mm _vchhusvi _bfhktxrc _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _80omtlke",
                swatchSize === 'small' ? "_1bsb1tcg _4t3i1tcg _154i1i6y" : "_1bsbzwfg _4t3izwfg",
                "_nt751r31 _gk8x1r31 _49pcglyw _24ueglyw _1hvw1o36 _b4yv1o36 _858u1l4g _rslm1l4g _4cvxtxrc",
                expanded && !(0, $fHpHg.fg)('platform-design-system-dsp-20821-color-pickr-focus') && "_12ji1r31 _1qu2glyw _12y31o36 _1h6d1l4g"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    "_1bsb1osq _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    style: colorCardStyles,
                    className: (0, $bwpsq.default)([
                        isOutlineVariant ? "_2rkosqtm _189e1bk5 _1dqonqa1" : "_2rkosqtm _16qs16qq",
                        swatchSize === 'small' ? "_1bsb7vkz _4t3i7vkz" : "_1bsb1tcg _4t3i1tcg"
                    ])
                })
            })
        })
    });
};
var $ee07b21e56d2f93a$export$2e2bcd8739ae039 = $ee07b21e56d2f93a$var$ColorCard;
const $ee07b21e56d2f93a$var$sharedColorContainerStyles = null;
const $ee07b21e56d2f93a$var$smallColorContainerSize = null;
const $ee07b21e56d2f93a$var$defaultColorContainerSize = null;
const $ee07b21e56d2f93a$var$colorCardButtonStyles = null;
const $ee07b21e56d2f93a$var$colorCardButtonFocusedStyles = null;
const $ee07b21e56d2f93a$var$colorCardWrapperStyles = null;
const $ee07b21e56d2f93a$var$colorCardContentStyles = null;
const $ee07b21e56d2f93a$var$colorCardContentStylesOutline = null;
const $ee07b21e56d2f93a$var$smallColorCardContentSize = null;
const $ee07b21e56d2f93a$var$defaultColorCardContentSize = null;

});

parcelRegister("iTb7F", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $1a36ce4997b19817$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "Option", () => $1a36ce4997b19817$export$36d18380658d5d20);
$parcel$export(module.exports, "DropdownIndicator", () => $1a36ce4997b19817$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "Placeholder", () => $1a36ce4997b19817$export$84712d0562a614b8);
/* components.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4Knwz = parcelRequire("4Knwz");

var $5Pi5x = parcelRequire("5Pi5x");


var $koVbs = parcelRequire("koVbs");

var $TIfiO = parcelRequire("TIfiO");
const $1a36ce4997b19817$export$d4c4e98c5044dc8 = (props)=>{
    const { //@ts-ignore react-select unsupported props
    selectProps: { cols: cols }, innerRef: innerRef, children: children } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "group",
        "aria-label": formatMessage((0, $TIfiO.default).menuListAriaLabel),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            maxWidth: cols ? (0, $5Pi5x.getWidth)(cols) : undefined
        },
        //@ts-ignore react-select unsupported props
        ref: innerRef,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1n261g80 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
        ]),
        children: children
    });
};
const $1a36ce4997b19817$export$36d18380658d5d20 = (props)=>{
    const { data: { value: value, label: label }, //@ts-ignore react-select unsupported props
    selectProps: { checkMarkColor: checkMarkColor, onOptionKeyDown: onOptionKeyDown, isTabbing: isTabbing, variant: variant }, isFocused: isFocused, isSelected: isSelected, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...innerProps,
        role: "radio",
        "aria-checked": isSelected,
        "aria-selected": undefined,
        "aria-label": label,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _4t3izwfg"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4Knwz.default), {
            type: (0, $c61654819d9c7ca7$export$9fea11a016bc5bcf),
            label: label,
            value: value,
            checkMarkColor: checkMarkColor,
            isOption: true,
            focused: isFocused,
            selected: isSelected,
            onKeyDown: (value)=>onOptionKeyDown(value),
            isTabbing: isTabbing,
            variant: variant
        })
    });
};
const $1a36ce4997b19817$export$ec98719d3db7f2e4 = ()=>null;
const $1a36ce4997b19817$export$84712d0562a614b8 = ()=>null;
const $1a36ce4997b19817$var$colorCardWrapperStyles = null;
const $1a36ce4997b19817$var$colorPaletteContainerStyles = null;

});
parcelRegister("TIfiO", function(module, exports) {

$parcel$export(module.exports, "default", () => $593ecb30144105a3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $593ecb30144105a3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    colorPickerAriaLabel: {
        id: 'jira.color-picker.src.color-picker-aria-label',
        defaultMessage: '{color} selected, {message}',
        description: 'This text is used as aria-label text in color picker component'
    },
    menuListAriaLabel: {
        id: 'jira.color-picker.src.menu-list-aria-label',
        defaultMessage: 'Color picker list',
        description: 'This text is used as aria-label text for the listbox element in color picker component'
    }
});

});




parcelRegister("bfuFk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aad5194e08f67bfe24a1828a13f5785c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8308e1fbf0fe7f0d$var$_react = $8308e1fbf0fe7f0d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8308e1fbf0fe7f0d$var$_showMoreHorizontal = $8308e1fbf0fe7f0d$var$_interopRequireDefault((parcelRequire("c8rIN")));

var $8308e1fbf0fe7f0d$var$_more = $8308e1fbf0fe7f0d$var$_interopRequireDefault((parcelRequire("66eDK")));
function $8308e1fbf0fe7f0d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShowMoreHorizontalIcon.
 * This component is ShowMoreHorizontalIcon, with `UNSAFE_fallbackIcon` set to "EditorMoreIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8308e1fbf0fe7f0d$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $8308e1fbf0fe7f0d$var$_react.default.createElement($8308e1fbf0fe7f0d$var$_showMoreHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $8308e1fbf0fe7f0d$var$_more.default
    }, props));
$8308e1fbf0fe7f0d$var$ShowMoreHorizontalIcon.Name = 'ShowMoreHorizontalIconMigration';
var $8308e1fbf0fe7f0d$var$_default = module.exports.default = $8308e1fbf0fe7f0d$var$ShowMoreHorizontalIcon;

});
parcelRegister("66eDK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $470ea8d678816326$var$_react = $470ea8d678816326$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $470ea8d678816326$var$_showMoreHorizontal = $470ea8d678816326$var$_interopRequireDefault((parcelRequire("c8rIN")));
function $470ea8d678816326$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $470ea8d678816326$var$EditorMoreIcon = (props)=>/*#__PURE__*/ $470ea8d678816326$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 14a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m-4.5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m9 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"/></svg>`
    }, props, {
        newIcon: $470ea8d678816326$var$_showMoreHorizontal.default
    }));
$470ea8d678816326$var$EditorMoreIcon.displayName = 'EditorMoreIcon';
var $470ea8d678816326$var$_default = module.exports.default = $470ea8d678816326$var$EditorMoreIcon;

});


parcelRegister("lQvIi", function(module, exports) {

$parcel$export(module.exports, "DeleteGadgetModal", () => $8aabe587794829c1$export$80937f1cc474f594);

var $5uXOq = parcelRequire("5uXOq");

var $1wnUy = parcelRequire("1wnUy");

var $lfTZh = parcelRequire("lfTZh");

var $e9QkH = parcelRequire("e9QkH");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $8aabe587794829c1$var$AsyncDeleteGadgetModal = (0, $b7Svb.lazy)(()=>(parcelRequire("bcGYM")), {
    moduleId: "./src/packages/global-pages/dashboard/edit/src/ui/gadget-editable/config-dropdown/delete-gadget-modal/main.tsx"
});
const $8aabe587794829c1$export$80937f1cc474f594 = ({ id: id, onDeleteGadget: onDeleteGadget, gadgetName: gadgetName, onClose: onClose })=>{
    const [isOpen, { off: close }] = (0, $e9QkH.useSwitchModals)(id);
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "delete-gadget-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wnUy.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aabe587794829c1$var$AsyncDeleteGadgetModal, {
        gadgetName: gadgetName,
        onClose: ()=>{
            close();
            onClose?.();
        },
        onDeleteGadget: onDeleteGadget
    })) : null;
};

});
parcelRegister("bcGYM", function(module, exports) {

let $021adf9ad025adbf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $021adf9ad025adbf$var$load("8Pcm9").then(()=>parcelRequire('3uEJK'));

});


parcelRegister("44DPy", function(module, exports) {

$parcel$export(module.exports, "default", () => $84fb4298c31695e7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $84fb4298c31695e7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    moreActions: {
        "id": "dashboard-edit.gadget-editable.config-dropdown.more-actions",
        "defaultMessage": "More actions for {gadgetTitle} gadget"
    },
    expand: {
        "id": "dashboard-edit.gadget-editable.config-dropdown.expand",
        "defaultMessage": "Expand"
    },
    maximize: {
        "id": "dashboard-edit.gadget-editable.config-dropdown.maximize",
        "defaultMessage": "Maximize"
    },
    restore: {
        "id": "dashboard-edit.gadget-editable.config-dropdown.restore",
        "defaultMessage": "Restore"
    },
    delete: {
        "id": "dashboard-edit.gadget-editable.config-dropdown.delete",
        "defaultMessage": "Delete"
    },
    configure: {
        "id": "dashboard-edit.gadget-editable.config-dropdown.configure",
        "defaultMessage": "Configure"
    },
    rename: {
        "id": "dashboard-edit.gadget-editable.config-dropdown.rename",
        "defaultMessage": "Rename"
    },
    duplicate: {
        "id": "dashboard-edit.gadget-editable.config-dropdown.duplicate",
        "defaultMessage": "Duplicate"
    },
    colorHeading: {
        "id": "dashboard-edit.gadget-editable.config-dropdown.color-heading",
        "defaultMessage": "Highlight color"
    }
});

});


parcelRegister("g5A8z", function(module, exports) {

$parcel$export(module.exports, "default", () => $351b39883f35264f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $351b39883f35264f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    rename: {
        "id": "dashboard-edit.gadget-editable.rename",
        "defaultMessage": "Rename {gadgetName}"
    }
});

});

parcelRegister("jbkj1", function(module, exports) {

$parcel$export(module.exports, "TitleEditor", () => $efd577c3c79b10d7$export$b7ae68644199241a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hhogF = parcelRequire("hhogF");

var $ec0Lk = parcelRequire("ec0Lk");

var $eWkgo = parcelRequire("eWkgo");
var $2s57o = parcelRequire("2s57o");

var $9r7BT = parcelRequire("9r7BT");

var $koVbs = parcelRequire("koVbs");

var $9AZKr = parcelRequire("9AZKr");
const $efd577c3c79b10d7$export$b7ae68644199241a = ({ isRenamable: isRenamable, isRenaming: isRenaming, title: title, onConfirmEdit: onConfirmEdit, onCancelEdit: onCancelEdit, onEdit: onEdit, editButtonLabel: editButtonLabel, children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return !isRenamable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), null, !isRenaming && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($efd577c3c79b10d7$var$DragHandlerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hhogF))), {
        spacing: "spacious",
        label: formatMessage((0, $9AZKr.default).dragLabel),
        color: "var(--ds-text, #172B4D)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($efd577c3c79b10d7$var$InlineEditWrapper, {
        "data-testid": "dashboard-edit.ui.gadget-editable.title-editor.inline-edit-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ec0Lk.default), {
        label: "",
        defaultValue: title,
        isEditing: isRenaming,
        editView: ({ errorMessage: errorMessage, ...fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9r7BT.default), {
                ...fieldProps,
                "aria-label": "Edit gadget title text input",
                testId: "dashboard-edit.ui.gadget-editable.title-editor.text-input"
            }),
        readView: ()=>children,
        onConfirm: onConfirmEdit,
        onCancel: onCancelEdit,
        readViewFitContainerWidth: true,
        onEdit: onEdit,
        editButtonLabel: editButtonLabel
    })));
};
const $efd577c3c79b10d7$var$DragHandlerWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        xcss: $efd577c3c79b10d7$var$dragHandlerWrapperStyles
    }, children);
const $efd577c3c79b10d7$var$dragHandlerWrapperStyles = (0, $2s57o.xcss)({
    flexShrink: 0
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $efd577c3c79b10d7$var$InlineEditWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _80om1kdv _6u9n1osq _wb9k78py",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hhogF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8e199447618ebf9961e7eca7a27c952>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c946d94ee24f80d1$var$_react = $c946d94ee24f80d1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c946d94ee24f80d1$var$_dragHandleVertical = $c946d94ee24f80d1$var$_interopRequireDefault((parcelRequire("9sKQw")));

var $c946d94ee24f80d1$var$_dragHandler = $c946d94ee24f80d1$var$_interopRequireDefault((parcelRequire("cAaml")));
function $c946d94ee24f80d1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DragHandleVerticalIcon.
 * This component is DragHandleVerticalIcon, with `UNSAFE_fallbackIcon` set to "DragHandlerIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dragging elements along a vertical axis.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c946d94ee24f80d1$var$DragHandleVerticalIcon = (props)=>/*#__PURE__*/ $c946d94ee24f80d1$var$_react.default.createElement($c946d94ee24f80d1$var$_dragHandleVertical.default, Object.assign({
        LEGACY_fallbackIcon: $c946d94ee24f80d1$var$_dragHandler.default
    }, props));
$c946d94ee24f80d1$var$DragHandleVerticalIcon.Name = 'DragHandleVerticalIconMigration';
var $c946d94ee24f80d1$var$_default = module.exports.default = $c946d94ee24f80d1$var$DragHandleVerticalIcon;

});
parcelRegister("9sKQw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37637907bc962c27c98c216148025653>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6e3b1145cb65094d$var$_react = $6e3b1145cb65094d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6e3b1145cb65094d$var$_baseNew = $6e3b1145cb65094d$var$_interopRequireDefault((parcelRequire("enEmH")));
function $6e3b1145cb65094d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DragHandleVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dragging elements along a vertical axis.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6e3b1145cb65094d$var$DragHandleVerticalIcon = (props)=>/*#__PURE__*/ $6e3b1145cb65094d$var$_react.default.createElement($6e3b1145cb65094d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M7 8a1.75 1.75 0 1 1-3.5 0A1.75 1.75 0 0 1 7 8m5.5 0A1.75 1.75 0 1 1 9 8a1.75 1.75 0 0 1 3.5 0M7 13.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"/>`
    }, props));
$6e3b1145cb65094d$var$DragHandleVerticalIcon.displayName = 'DragHandleVerticalIcon';
var $6e3b1145cb65094d$var$_default = module.exports.default = $6e3b1145cb65094d$var$DragHandleVerticalIcon;

});

parcelRegister("cAaml", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9290e2012148d12f$var$_react = $9290e2012148d12f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $9290e2012148d12f$var$_dragHandleVertical = $9290e2012148d12f$var$_interopRequireDefault((parcelRequire("9sKQw")));
function $9290e2012148d12f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9290e2012148d12f$var$DragHandlerIcon = (props)=>/*#__PURE__*/ $9290e2012148d12f$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="10" cy="8" r="1"/><circle cx="14" cy="8" r="1"/><circle cx="10" cy="16" r="1"/><circle cx="14" cy="16" r="1"/><circle cx="10" cy="12" r="1"/><circle cx="14" cy="12" r="1"/></g></svg>`
    }, props, {
        newIcon: $9290e2012148d12f$var$_dragHandleVertical.default
    }));
$9290e2012148d12f$var$DragHandlerIcon.displayName = 'DragHandlerIcon';
var $9290e2012148d12f$var$_default = module.exports.default = $9290e2012148d12f$var$DragHandlerIcon;

});


parcelRegister("ec0Lk", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c84accef102bc9e$export$2e2bcd8739ae039);
/* inline-edit.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $eNCZ4 = parcelRequire("eNCZ4");

var $4EHpO = parcelRequire("4EHpO");

var $7folp = parcelRequire("7folp");

var $fHpHg = parcelRequire("fHpHg");

var $7rJgC = parcelRequire("7rJgC");

var $cBCgC = parcelRequire("cBCgC");

var $5uae8 = parcelRequire("5uae8");

var $1eXlh = parcelRequire("1eXlh");

var $4P8zB = parcelRequire("4P8zB");
const $3c84accef102bc9e$var$fieldStyles = null;
const $3c84accef102bc9e$var$analyticsAttributes = {
    componentName: 'inlineEdit',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $3c84accef102bc9e$var$InnerInlineEdit = (props)=>{
    const { startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', editLabel: editLabel = 'edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel, onEdit: providedOnEdit, testId: testId } = props;
    const wasFocusReceivedSinceLastBlurRef = (0, $5uXOq.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const [isEditingState, setEditingState] = (0, $5uXOq.useState)(startWithEditViewOpen);
    const timerRef = (0, $5uXOq.useRef)();
    const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, $1eXlh.default)(isEditing, isEditingState);
    const onCancel = (0, $5uXOq.useCallback)(()=>{
        if (isControlled) setEditingState(false);
        providedOnCancel?.();
    }, [
        isControlled,
        providedOnCancel
    ]);
    const onEditRequested = (0, $5uXOq.useCallback)(()=>{
        if (isControlled) setEditingState(true);
        providedOnEdit?.();
        if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
    }, [
        isControlled,
        shouldBeEditing,
        editViewRef,
        providedOnEdit
    ]);
    const onConfirm = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            if (isControlled) setEditingState(false);
            providedOnConfirm(value, analyticsEvent);
        },
        action: 'confirmed',
        analyticsData: analyticsContext,
        ...$3c84accef102bc9e$var$analyticsAttributes
    });
    const onCancelClick = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        onCancel();
    }, [
        onCancel
    ]);
    const tryAutoSubmitWhenBlur = (0, $5uXOq.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
            doNotFocusOnEditButton();
            if (formRef.current.checkValidity()) onSubmit();
        }
    }, [
        doNotFocusOnEditButton
    ]); /**
                                 * If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
                                 *  confirms the value, if the focus is not transferred to the action buttons.
                                 *
                                 *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
                                 *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
                                 *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
                                 *  `autoSubmitWhenBlur`.
                                 *
                                 *  There are two paths here the function can be triggered:
                                 *
                                 *  - focus on input first, and then use keyboard to `submit`
                                 *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save).
                                 */ 
    const onEditViewWrapperBlur = (0, $5uXOq.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid, onSubmit, formRef), 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        tryAutoSubmitWhenBlur
    ]); /**
                                                        * Gets called when focus is transferred to the editView, or action buttons.
                                                        *
                                                        * There are three paths here the function can be called:
                                                        *
                                                        * - when a user click the `editView`
                                                        * - when a user use keyboard to tab into `editView`
                                                        * - when a user use keyboard to tab into `submit` when they were on input field.
                                                        */ 
    const onEditViewWrapperFocus = (0, $5uXOq.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const concatenatedEditButtonLabel = ()=>{
        if (label) return `${editButtonLabel}, ${label}, ${editLabel}`;
        return `${editButtonLabel}, ${editLabel}`;
    };
    const renderReadView = ()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4P8zB.default), {
            editButtonLabel: concatenatedEditButtonLabel(),
            onEditRequested: onEditRequested,
            postReadViewClick: doNotFocusOnEditButton,
            editButtonRef: editButtonRef,
            readViewFitContainerWidth: readViewFitContainerWidth,
            readView: readView,
            testId: testId
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7folp.default), {
        onSubmit: (data)=>onConfirm(data.inlineEdit),
        children: ({ formProps: { onKeyDown: onKeyDown, onSubmit: onSubmit, ref: formRef }, reset: reset })=>/*#__PURE__*/ (0, $2OMIu.jsx)("form", {
                /**
                 * It is not normally acceptable to add key handlers to non-interactive elements
                 * as this is an accessibility anti-pattern. However, because this instance is
                 * to add support for keyboard functionality instead of creating an inaccessible
                 * custom element, we can add role="presentation" so that there is no negative
                 * impacts to assistive technologies.
                 */ role: "presentation",
                onKeyDown: (e)=>{
                    onKeyDown(e);
                    if (e.key === 'Esc' || e.key === 'Escape') {
                        if ((0, $fHpHg.fg)('platform-design-system-inline-edit-reset-on-escape')) reset();
                        onCancel();
                    }
                },
                onSubmit: onSubmit,
                ref: formRef,
                children: shouldBeEditing ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4EHpO.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: defaultValue,
                    validate: validate,
                    isRequired: isRequired,
                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                            onBlur: (e)=>{
                                if (!e.currentTarget.contains(e.relatedTarget)) onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit, formRef);
                            },
                            onFocus: onEditViewWrapperFocus,
                            className: (0, $bwpsq.default)([
                                "_p12f1osq _kqswh2mm"
                            ]),
                            children: [
                                editView({
                                    ...fieldProps,
                                    errorMessage: error
                                }, editViewRef),
                                !hideActionButtons ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uae8.default), {
                                    testId: testId,
                                    cancelButtonLabel: cancelButtonLabel,
                                    confirmButtonLabel: confirmButtonLabel,
                                    onMouseDown: ()=>{
                                        /**
             * Prevents focus on edit button only if mouse is used to click button, but not when keyboard is used
             */ doNotFocusOnEditButton();
                                    },
                                    onCancelClick: (e)=>{
                                        reset();
                                        onCancelClick(e);
                                    }
                                }) : /**
           * This is to allow Ctrl + Enter to submit without action buttons
           */ /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7rJgC.default), {
                                    hidden: true,
                                    type: "submit",
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cBCgC.default), {
                                        children: "Submit"
                                    })
                                })
                            ]
                        })
                }, "edit-view" // used for reset to default value
                ) : /**
       * Field is used here only for the label and spacing
       */ /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4EHpO.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: "",
                    isRequired: isRequired,
                    children: renderReadView
                }, "read-view" // used for reset to default value
                )
            })
    });
};
const $3c84accef102bc9e$var$InlineEdit = (props)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $2OMIu.jsx)($3c84accef102bc9e$var$InnerInlineEdit, {
        ...props
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $3c84accef102bc9e$export$2e2bcd8739ae039 = $3c84accef102bc9e$var$InlineEdit;

});
parcelRegister("5uae8", function(module, exports) {

$parcel$export(module.exports, "default", () => $568f5c85371814cc$export$2e2bcd8739ae039);
/* buttons.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1Seuh = parcelRequire("1Seuh");

var $goMg1 = parcelRequire("goMg1");

var $gANiX = parcelRequire("gANiX");

var $dR8fb = parcelRequire("dR8fb");
const $568f5c85371814cc$var$buttonsContainerStyles = null;
const $568f5c85371814cc$var$buttonWrapperBaseStyles = null;
const $568f5c85371814cc$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswstnw _1o9zidpf _152t1osq _rjxpidpf _1pfh12x7"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                tabIndex: -1,
                className: (0, $bwpsq.default)([
                    "_2rko1sit _11c82smr _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1mxi _1mpy1b66 _1nlxe0lp _l2uv1d38 _7mfv1dzg _szlb1x4z"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Seuh.default), {
                    type: "submit",
                    icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dR8fb))), {
                            ...iconProps,
                            LEGACY_size: "small"
                        }),
                    onMouseDown: onMouseDown,
                    label: confirmButtonLabel,
                    testId: testId && `${testId}--confirm`
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                tabIndex: -1,
                className: (0, $bwpsq.default)([
                    "_2rko1sit _11c82smr _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1mxi _1mpy1b66 _1nlxe0lp _l2uv1d38 _7mfv1dzg _szlb1x4z"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Seuh.default), {
                    icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gANiX))), {
                            ...iconProps,
                            LEGACY_size: "small",
                            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($goMg1)))
                        }),
                    label: cancelButtonLabel,
                    onClick: onCancelClick,
                    onMouseDown: onMouseDown,
                    testId: testId && `${testId}--cancel`
                })
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$568f5c85371814cc$export$2e2bcd8739ae039 = $568f5c85371814cc$var$Buttons;

});
parcelRegister("dR8fb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9db35ecad695c835ed46bfa4bbde0dff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1669ea74f05704f$var$_react = $a1669ea74f05704f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a1669ea74f05704f$var$_checkMark = $a1669ea74f05704f$var$_interopRequireDefault((parcelRequire("aiSXl")));

var $a1669ea74f05704f$var$_check = $a1669ea74f05704f$var$_interopRequireDefault((parcelRequire("2n32C")));
function $a1669ea74f05704f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "CheckIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a1669ea74f05704f$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $a1669ea74f05704f$var$_react.default.createElement($a1669ea74f05704f$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $a1669ea74f05704f$var$_check.default
    }, props));
$a1669ea74f05704f$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $a1669ea74f05704f$var$_default = module.exports.default = $a1669ea74f05704f$var$CheckMarkIcon;

});
parcelRegister("aiSXl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f681ccdbe722d68d6bd374c0928f0bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $780636fcbb2cccd4$var$_react = $780636fcbb2cccd4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $780636fcbb2cccd4$var$_baseNew = $780636fcbb2cccd4$var$_interopRequireDefault((parcelRequire("enEmH")));
function $780636fcbb2cccd4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $780636fcbb2cccd4$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $780636fcbb2cccd4$var$_react.default.createElement($780636fcbb2cccd4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m11.06 3-6.25 7a.75.75 0 0 1-1.15-.037l-2.75-3.5 1.18-.926 2.197 2.796L9.94 2z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$780636fcbb2cccd4$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $780636fcbb2cccd4$var$_default = module.exports.default = $780636fcbb2cccd4$var$CheckMarkIcon;

});

parcelRegister("2n32C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1ba016b41382ba32$var$_react = $1ba016b41382ba32$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $1ba016b41382ba32$var$_checkMark = $1ba016b41382ba32$var$_interopRequireDefault((parcelRequire("dVU8x")));
function $1ba016b41382ba32$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1ba016b41382ba32$var$CheckIcon = (props)=>/*#__PURE__*/ $1ba016b41382ba32$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $1ba016b41382ba32$var$_checkMark.default
    }));
$1ba016b41382ba32$var$CheckIcon.displayName = 'CheckIcon';
var $1ba016b41382ba32$var$_default = module.exports.default = $1ba016b41382ba32$var$CheckIcon;

});



parcelRegister("1eXlh", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac0118167eb799ed$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $ac0118167eb799ed$var$usePrevious = (value)=>{
    const ref = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $ac0118167eb799ed$var$useButtonFocusHook = (isEditing, isEditingState)=>{
    const editButtonRef = (0, $5uXOq.useRef)(null);
    const editViewRef = (0, $5uXOq.useRef)();
    const preventFocusOnEditButtonRef = (0, $5uXOq.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const shouldBeEditing = isControlled ? isEditingState : isEditing;
    const prevIsEditing = $ac0118167eb799ed$var$usePrevious(shouldBeEditing);
    (0, $5uXOq.useEffect)(()=>{
        if (isEditingState && editViewRef.current) editViewRef.current.focus();
    }, [
        editViewRef,
        isEditingState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * This logic puts the focus on the edit button after confirming using
		 * the confirm button or using the keyboard to confirm, but not when
		 * it is confirmed by wrapper blur
		 */ if (prevIsEditing && !shouldBeEditing) {
            if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else if (editButtonRef && editButtonRef.current) // @ts-ignore
            editButtonRef.current.focus();
        }
    }, [
        prevIsEditing,
        shouldBeEditing
    ]);
    const doNotFocusOnEditButton = ()=>preventFocusOnEditButtonRef.current = true;
    return {
        editButtonRef: editButtonRef,
        editViewRef: editViewRef,
        shouldBeEditing: shouldBeEditing,
        doNotFocusOnEditButton: doNotFocusOnEditButton
    };
};
var $ac0118167eb799ed$export$2e2bcd8739ae039 = $ac0118167eb799ed$var$useButtonFocusHook;

});

parcelRegister("4P8zB", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3969b97f38c61a8$export$2e2bcd8739ae039);
/* read-view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $7rJgC = parcelRequire("7rJgC");
const $a3969b97f38c61a8$var$readViewContainerStyles = null;
const $a3969b97f38c61a8$var$editButtonStyles = {
    root: "_12ji1r31 _1qu2glyw _12y3idpf _189e1grb _1dqoglyw _1h6d3acm _1e0c1ule _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _r06hglyw _bfhk18uv _vwz4kb7n _1xp41p6i _14ly1bk5 _1j8znqa1 _mizu1r31 _ra3xglyw _128midpf"
};
const $a3969b97f38c61a8$var$readViewWrapperStyles = null;
const $a3969b97f38c61a8$var$readViewFitContainerWidthStyles = null;
const $a3969b97f38c61a8$var$DRAG_THRESHOLD = 5;
const $a3969b97f38c61a8$var$ReadView = ({ editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId })=>{
    const startX = (0, $5uXOq.useRef)(0);
    const startY = (0, $5uXOq.useRef)(0);
    const mouseHasMovedAfterMouseDown = (event)=>{
        return Math.abs(startX.current - event.clientX) >= $a3969b97f38c61a8$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $a3969b97f38c61a8$var$DRAG_THRESHOLD;
    };
    const onReadViewClick = (event)=>{
        const element = event.target;
        /**
     * If a link is clicked in the read view, default action should be taken
     */ if (element.tagName.toLowerCase() !== 'a' && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEditRequested();
            postReadViewClick();
        }
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        className: (0, $bwpsq.default)([
            "_vwz4kb7n"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7rJgC.default), {
                xcss: $a3969b97f38c61a8$var$editButtonStyles.root,
                onClick: onEditRequested,
                ref: editButtonRef,
                testId: testId && `${testId}--edit-button`,
                "aria-label": editButtonLabel
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                /**
     * It is not normally acceptable to add click handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * account for clicking on links that may be embedded within inline-edit and not
     * creating an inaccessible custom element, we can add role="presentation" so that
     * there is no negative impacts to assistive technologies.
     * (Why links are embeeded in inline-edit is for another day...)
     */ role: "presentation",
                onClick: onReadViewClick,
                onMouseDown: (e)=>{
                    startX.current = e.clientX;
                    startY.current = e.clientY;
                },
                "data-read-view-fit-container-width": readViewFitContainerWidth,
                className: (0, $bwpsq.default)([
                    "_2rko1sit _v564thzt _1h6d3acm _1dqonqa1 _189e1bk5 _1e0c1o8l _vchhusvi _1bsb1wug _p12f1osq _irr314ae",
                    readViewFitContainerWidth && "_1bsb1osq"
                ]),
                children: readView()
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a3969b97f38c61a8$export$2e2bcd8739ae039 = $a3969b97f38c61a8$var$ReadView;

});


parcelRegister("9AZKr", function(module, exports) {

$parcel$export(module.exports, "default", () => $be24aee7105b9562$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $be24aee7105b9562$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    dragLabel: {
        "id": "dashboard-edit.gadget-editable.title-editor.drag-label",
        "defaultMessage": "Drag to move gadget"
    }
});

});


parcelRegister("49IUu", function(module, exports) {

$parcel$export(module.exports, "useGadgetTitleChangeErrorFlag", () => $3d56e7ee629c6c9b$export$be3e1e1bb367fdda);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $7HGHK = parcelRequire("7HGHK");

var $c7hyj = parcelRequire("c7hyj");
const $3d56e7ee629c6c9b$export$be3e1e1bb367fdda = ()=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    return (0, $5uXOq.useCallback)(()=>{
        showFlag({
            key: (0, $7HGHK.toFlagId)('gadgetTitleError'),
            type: 'error',
            title: (0, $c7hyj.default).errorFlagTitle,
            description: (0, $c7hyj.default).errorFlagDescription,
            messageId: 'dashboard-edit.ui.gadget-editable.utils.show-flag.error',
            messageType: 'transactional',
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            actions: [
                {
                    content: (0, $c7hyj.default).errorFlagAction,
                    onClick: ()=>window.location.reload()
                }
            ]
        });
    }, [
        showFlag
    ]);
};

});
parcelRegister("c7hyj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7e18ad0be6298b7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e7e18ad0be6298b7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorFlagTitle: {
        "id": "dashboard-edit.gadget-editable.utils.error-flag-title",
        "defaultMessage": "Error saving gadget name"
    },
    errorFlagDescription: {
        "id": "dashboard-edit.gadget-editable.utils.error-flag-description",
        "defaultMessage": "Refresh the page and try again"
    },
    errorFlagAction: {
        "id": "dashboard-edit.gadget-editable.utils.error-flag-action",
        "defaultMessage": "Refresh"
    }
});

});



parcelRegister("fVBqv", function(module, exports) {

$parcel$export(module.exports, "AsyncAddGadgetPanel", () => $4367ed7a6cc463d2$export$6fe03cad6a67ebf8);

var $5uXOq = parcelRequire("5uXOq");

var $JIPqS = parcelRequire("JIPqS");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

var $wlDl0 = parcelRequire("wlDl0");

var $GQeXq = parcelRequire("GQeXq");

var $8SHRg = parcelRequire("8SHRg");

var $b6VJM = parcelRequire("b6VJM");

var $ePdfe = parcelRequire("ePdfe");

const $4367ed7a6cc463d2$export$9c81367ce7c2e6b = (0, $b7Svb.lazy)(()=>(parcelRequire("f0Wm1")), {
    moduleId: "./src/packages/global-pages/dashboard/edit/src/ui/header-editable/add-gadget-button/add-gadget-panel/main.tsx"
});
const $4367ed7a6cc463d2$export$6fe03cad6a67ebf8 = ()=>{
    const { isOpen: isRightPanelOpen } = (0, $GQeXq.useRightPanelState)();
    if (isRightPanelOpen === false) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "add-gadget",
        packageName: (0, $wlDl0.PACKAGE_NAME),
        attributes: {
            task: (0, $JIPqS.ADD_GADGET_EXPERIENCE),
            reason: 'AsyncAddGadgetPanel ErrorBoundary'
        },
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ePdfe.PanelContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b6VJM.Fallback), {
                type: (0, $b6VJM.FALLBACK_TYPE).ERROR
            })),
        withExperienceTracker: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "add-gadget-panel",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8SHRg.AddGadgetPanelSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4367ed7a6cc463d2$export$9c81367ce7c2e6b, null)));
};

});
parcelRegister("8SHRg", function(module, exports) {

$parcel$export(module.exports, "AddGadgetPanelSkeleton", () => $dd4abd02e6dc3342$export$c0396ff9a79b8c7a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $dd4abd02e6dc3342$export$c0396ff9a79b8c7a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dd4abd02e6dc3342$var$GadgetSkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dd4abd02e6dc3342$var$Skeleton, {
        height: "40px",
        width: "100%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dd4abd02e6dc3342$var$Skeleton, {
        height: "20px",
        width: "100%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dd4abd02e6dc3342$var$GadgetSkeletonItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dd4abd02e6dc3342$var$Skeleton, {
        height: "40px",
        width: "40px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dd4abd02e6dc3342$var$Skeleton, {
        height: "40px",
        width: "calc(100% - 60px)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dd4abd02e6dc3342$var$GadgetSkeletonItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dd4abd02e6dc3342$var$Skeleton, {
        height: "40px",
        width: "40px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dd4abd02e6dc3342$var$Skeleton, {
        height: "40px",
        width: "calc(100% - 60px)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dd4abd02e6dc3342$var$GadgetSkeletonItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dd4abd02e6dc3342$var$Skeleton, {
        height: "40px",
        width: "40px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dd4abd02e6dc3342$var$Skeleton, {
        height: "40px",
        width: "calc(100% - 60px)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dd4abd02e6dc3342$var$GadgetSkeletonItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dd4abd02e6dc3342$var$Skeleton, {
        height: "40px",
        width: "40px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dd4abd02e6dc3342$var$Skeleton, {
        height: "40px",
        width: "calc(100% - 60px)"
    })));
const $dd4abd02e6dc3342$var$shimmer = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dd4abd02e6dc3342$var$Skeleton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_dfjz0w": (0, $lD23V.default)(`${__cmplp.height}`),
            "--_1icprf0": (0, $lD23V.default)(`${__cmplp.width}`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _4t3i16wa _1bsbb8e1 _19pkpxbi _2hwxidpf _otyrpxbi _18u0idpf _5sag126j _1o51q7pw _tip812c5 _j7hq1en8 _1pglp3kn _bfhkm7j4 _1itkzplv _12vemgnk",
            __cmplp.className
        ])
    });
});
const $dd4abd02e6dc3342$var$GadgetSkeletonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _1bsb1osq _vchhusvi",
            __cmplp.className
        ])
    });
});
const $dd4abd02e6dc3342$var$GadgetSkeletonItemWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
});

});

parcelRegister("b6VJM", function(module, exports) {

$parcel$export(module.exports, "FALLBACK_TYPE", () => $d06366a77dbe58fd$export$a5e1f3074f2a926d);
$parcel$export(module.exports, "Fallback", () => $d06366a77dbe58fd$export$fb8d7f40caaeea67);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $eWkgo = parcelRequire("eWkgo");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");

var $7q5TP = parcelRequire("7q5TP");

var $fC09Q = parcelRequire("fC09Q");

var $koVbs = parcelRequire("koVbs");

var $xOZPZ = parcelRequire("xOZPZ");
const $d06366a77dbe58fd$export$a5e1f3074f2a926d = {
    ERROR: 'ERROR',
    NOTFOUND: 'NOTFOUND'
};
const $d06366a77dbe58fd$var$FALLBACK_ERROR_IMAGE_SIZE = 84;
const $d06366a77dbe58fd$export$fb8d7f40caaeea67 = ({ type: type })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (type === $d06366a77dbe58fd$export$a5e1f3074f2a926d.ERROR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        direction: "column",
        justifyContent: "center",
        alignItems: "center",
        xcss: $d06366a77dbe58fd$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7q5TP.default), {
        alt: formatMessage((0, $xOZPZ.default).errorTitle),
        width: $d06366a77dbe58fd$var$FALLBACK_ERROR_IMAGE_SIZE
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d06366a77dbe58fd$var$textWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        color: "color.text.accent.gray",
        size: "UNSAFE_small",
        weight: "bold"
    }, formatMessage((0, $xOZPZ.default).errorMessage))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        direction: "column",
        justifyContent: "center",
        alignItems: "center",
        xcss: $d06366a77dbe58fd$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fC09Q.default), {
        alt: formatMessage((0, $xOZPZ.default).emptyTitle),
        width: $d06366a77dbe58fd$var$FALLBACK_ERROR_IMAGE_SIZE
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d06366a77dbe58fd$var$textWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        color: "color.text.accent.gray",
        size: "UNSAFE_small",
        weight: "bold"
    }, formatMessage((0, $xOZPZ.default).emptyMessage))));
};
const $d06366a77dbe58fd$var$wrapperStyles = (0, $2s57o.xcss)({
    padding: 'space.300',
    marginBottom: 'space.200',
    textAlign: 'center',
    color: 'color.text.accent.gray'
});
const $d06366a77dbe58fd$var$textWrapperStyles = (0, $2s57o.xcss)({
    margin: 'space.300'
});

});
parcelRegister("fC09Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb376757c4acc5ab$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3pGSh")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3pGSh")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 53grvvhrxck68z6q4s7ztq4p
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/53grvvhrxck68z6q4s7ztq4p

var $dCLgq = parcelRequire("dCLgq");

var $3pGSh = parcelRequire("3pGSh");
const $bb376757c4acc5ab$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($3pGSh)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($3pGSh))
});
var $bb376757c4acc5ab$export$2e2bcd8739ae039 = $bb376757c4acc5ab$var$Illustration;
// for advanced use only
const $bb376757c4acc5ab$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    226
];

});
parcelRegister("3pGSh", function(module, exports) {
module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();

});


parcelRegister("xOZPZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1179501de393075$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c1179501de393075$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorMessage: {
        "id": "dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.fallback.error-message",
        "defaultMessage": "We're having some trouble getting all available gadgets, please try again later"
    },
    errorTitle: {
        "id": "dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.fallback.error-title",
        "defaultMessage": "Error"
    },
    emptyTitle: {
        "id": "dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.fallback.empty-title",
        "defaultMessage": "We couldn\u2019t find any gadgets."
    },
    emptyMessage: {
        "id": "dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.fallback.empty-message",
        "defaultMessage": "No gadgets matched your search. Try again with different keywords."
    }
});

});


parcelRegister("ePdfe", function(module, exports) {

$parcel$export(module.exports, "PanelContainer", () => $a07bae344cb3fd25$export$7c4d2b536147788a);
$parcel$export(module.exports, "PanelHeaderContainer", () => $a07bae344cb3fd25$export$90c3cb85c6ca5262);
$parcel$export(module.exports, "PanelContentContainer", () => $a07bae344cb3fd25$export$f69c7d78cc611ef3);
$parcel$export(module.exports, "Header", () => $a07bae344cb3fd25$export$8b251419efc915eb);
$parcel$export(module.exports, "CategoryLozengeGroup", () => $a07bae344cb3fd25$export$dd826bcc21f46caa);
$parcel$export(module.exports, "CategoryLozengeClickable", () => $a07bae344cb3fd25$export$c7b4c423388a9a6c);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $a07bae344cb3fd25$export$7c4d2b536147788a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1kl7pu5c _vchhusvi _4t3i1i8v",
            __cmplp.className
        ])
    });
});
const $a07bae344cb3fd25$export$90c3cb85c6ca5262 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vchhusvi _2lx2vrvc _1bsb1osq _kqsw1if8 _ca0qpxbi _u5f3pxbi _n3tdidpf _19bvpxbi _154iidpf _1pby18b4 _bfhkvuon",
            __cmplp.className
        ])
    });
});
const $a07bae344cb3fd25$export$f69c7d78cc611ef3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _18m91wug _1reo15vq _vchhusvi",
            __cmplp.className
        ])
    });
});
const $a07bae344cb3fd25$export$8b251419efc915eb = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyrpxbi _1e0c11p5 _yv0e1ghl _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $a07bae344cb3fd25$export$dd826bcc21f46caa = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1n261g80 _19pkpxbi",
            __cmplp.className
        ])
    });
});
const $a07bae344cb3fd25$export$c7b4c423388a9a6c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActive: isActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _19itglyw _2rkow1gv _1reo15vq _18m915vq _zulp1b66 _vchhusvi _ca0q1b66 _u5f3u2gc _n3td1b66 _19bvu2gc _1e0c116y _4cvr1h6o _4t3i1ou6 _80omtlke _19pkidpf _otyru2gc _2hwx1b66 _uiztglyw _p12f1osq _1bto1l2s _o5721q9c _s7n4jp4b",
            __cmplp.isActive ? "_bfhk4v9p" : "_bfhk1v33",
            __cmplp.isActive ? "_syazpnps" : "_syaz1gjq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("f0Wm1", function(module, exports) {

let $aee41f0c99b347a8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $aee41f0c99b347a8$var$load("einKL").then(()=>parcelRequire('l3mnF'));

});


const $0c49cfa6e72ac9c3$export$39a49c1fbe587c5b = 'addGadgetPanel';

parcelRegister("jd4if", function(module, exports) {

$parcel$export(module.exports, "HeaderEditable", () => $23e4eca6700ded4d$export$3d14c3788ac5dc14);

var $5uXOq = parcelRequire("5uXOq");

var $JIPqS = parcelRequire("JIPqS");

var $bOnpg = parcelRequire("bOnpg");

var $gYYRR = parcelRequire("gYYRR");

var $dZymr = parcelRequire("dZymr");

var $1i27D = parcelRequire("1i27D");

var $2PcTT = parcelRequire("2PcTT");

var $9jsHG = parcelRequire("9jsHG");

var $aNPat = parcelRequire("aNPat");

var $koVbs = parcelRequire("koVbs");

var $6jY6G = parcelRequire("6jY6G");


var $9OXo1 = parcelRequire("9OXo1");

var $dCm1o = parcelRequire("dCm1o");


var $jaPSU = parcelRequire("jaPSU");

var $4WQJr = parcelRequire("4WQJr");

var $j2vUH = parcelRequire("j2vUH");
const $23e4eca6700ded4d$export$3d14c3788ac5dc14 = ({ data: data, banners: banners, onLayoutSelected: onLayoutSelected })=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { isAnonymous: isAnonymous } = tenantContext;
    const { id: id, title: title, layout: layout } = data;
    const { headerItems: headerItems, toolItems: toolItems } = (0, $2PcTT.useConnectMenuItems)(id);
    const viewRoute = (0, $6jY6G.useRouteByName)('dashboard-view');
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const fireAnalytics = (0, $bOnpg.useDashboardAnalytics)();
    const onClickHandler = (0, $5uXOq.useCallback)(()=>{
        fireAnalytics({
            eventType: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e),
            action: 'clicked',
            actionSubject: 'dashboard.done-editing-button',
            actionSubjectId: (0, $JIPqS.DASHBOARD_EDIT_SOURCENAME)
        });
    }, [
        fireAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1i27D.Header), {
        banners: banners
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1i27D.HeaderTitle), null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1i27D.HeaderActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZymr.ConnectHeader), {
        items: headerItems
    }), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9jsHG.FavoriteButton), {
        dashboardId: id,
        dashboardName: title
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jaPSU.AddGadgetButton), {
        buttonType: (0, $324eda6c4db64a18$export$fdb820c8e86996c4),
        columnIndex: 0
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4WQJr.ChangeLayoutButton), {
        layout: layout,
        onLayoutSelected: onLayoutSelected
    }), viewRoute && (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aNPat.RouteLinkButton), {
        to: viewRoute,
        params: {
            dashboardId: id
        },
        appearance: "primary",
        onClick: onClickHandler
    }, formatMessage((0, $j2vUH.default).done)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aNPat.RouteLinkButtonOld), {
        appearance: "primary",
        to: viewRoute ?? undefined,
        params: {
            dashboardId: id
        },
        prefetch: "hover",
        onClick: onClickHandler
    }, formatMessage((0, $j2vUH.default).done)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gYYRR.ActionDropdown), {
        data: data,
        connectToolMenuItems: toolItems
    })));
};

});
parcelRegister("gYYRR", function(module, exports) {

$parcel$export(module.exports, "ActionDropdown", () => $255b9987b473f48f$export$d5503927a7d116d);

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $j7m8K = parcelRequire("j7m8K");
var $1eETS = parcelRequire("1eETS");
var $3jAdT = parcelRequire("3jAdT");

var $bfuFk = parcelRequire("bfuFk");

var $70rf1 = parcelRequire("70rf1");

var $JIPqS = parcelRequire("JIPqS");

var $koVbs = parcelRequire("koVbs");

var $e9QkH = parcelRequire("e9QkH");

var $9OXo1 = parcelRequire("9OXo1");

var $b8ziP = parcelRequire("b8ziP");

var $edp7U = parcelRequire("edp7U");

var $dFiez = parcelRequire("dFiez");

var $2h3Nr = parcelRequire("2h3Nr");

var $fb7AH = parcelRequire("fb7AH");

var $fqLvm = parcelRequire("fqLvm");

var $2IJzF = parcelRequire("2IJzF");

var $8AXqQ = parcelRequire("8AXqQ");

var $2EGKG = parcelRequire("2EGKG");

var $x5bVw = parcelRequire("x5bVw");
const $255b9987b473f48f$export$d5503927a7d116d = ({ data: data, connectToolMenuItems: connectToolMenuItems })=>{
    const { isAnonymous: isAnonymous, atlassianAccountId: atlassianAccountId } = (0, $9OXo1.useTenantContext)();
    const { dropdownItemClickHandler: dropdownItemClickHandler } = (0, $b8ziP.useDropdownItemOnClickHandler)();
    const dropdownTriggerButton = (0, $5uXOq.useRef)(null);
    const [, { on: modalCopyOpen }] = (0, $e9QkH.useSwitchModals)((0, $JIPqS.MODAL_ID).DASHBOARD_COPY);
    const [, { on: modalAutomaticRefreshOpen }] = (0, $e9QkH.useSwitchModals)((0, $JIPqS.MODAL_ID).AUTOMATIC_REFRESH);
    const [, { on: modalRenameAndShareOpen }] = (0, $e9QkH.useSwitchModals)((0, $JIPqS.MODAL_ID).DASHBOARD_RENAME_OR_SHARE);
    const [, { on: modalDeleteOpen }] = (0, $e9QkH.useSwitchModals)((0, $JIPqS.MODAL_ID).DASHBOARD_DELETE);
    const [, { on: modalCreateOpen }] = (0, $e9QkH.useSwitchModals)((0, $JIPqS.MODAL_ID).DASHBOARD_CREATE);
    // This is a hack to focus the trigger button after a modal is closed.
    const onModalCloseCallback = (0, $5uXOq.useCallback)(()=>{
        setTimeout(()=>{
            if (dropdownTriggerButton.current) dropdownTriggerButton.current.focus();
        }, 1);
    }, [
        dropdownTriggerButton
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!data) return null;
    const dashboardId = data.id;
    const isDashboardOwner = atlassianAccountId === data.owner;
    const viewAsWallboardUrl = `/jira/dashboards/wallboard?dashboardId=${dashboardId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2EGKG.RenameOrShareModal), {
        id: dashboardId,
        onModalCloseCallback: onModalCloseCallback
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fqLvm.CopyModal), {
        id: dashboardId,
        onModalCloseCallback: onModalCloseCallback
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2h3Nr.AutomaticRefreshModal), {
        id: dashboardId,
        onModalCloseCallback: onModalCloseCallback
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8AXqQ.DeleteModal), {
        id: dashboardId,
        onModalCloseCallback: onModalCloseCallback
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fb7AH.ConfigureWallboardModal), {
        onModalCloseCallback: onModalCloseCallback
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2IJzF.CreateModal), {
        onModalCloseCallback: onModalCloseCallback
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j7m8K.default), {
        isLoading: false,
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
                ...triggerProps,
                spacing: "default",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bfuFk))), {
                    label: formatMessage((0, $dFiez.default).moreActions),
                    LEGACY_size: "medium",
                    spacing: "spacious"
                }),
                // To utilise this `ref` for a custom trigger button, only `triggerRef` needs to be the value passed in.
                // However, we've defined a function instead so we can save the ref locally
                // and focus it when modal closes
                ref: (buttonRef)=>{
                    // This is the default call if only `triggerRef` gets passed in. We still call it.
                    if (typeof triggerRef === 'function') triggerRef(buttonRef);
                    // This is a hack so we can focus this button after a modal is closed.
                    if (dropdownTriggerButton.current === null) dropdownTriggerButton.current = buttonRef;
                }
            }),
        shouldFlip: true,
        placement: "bottom-end",
        appearance: "tall",
        testId: "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.dropdown-menu",
        defaultOpen: (0, $edp7U.getIsDropdownDefaultOpen)('action-dropdown'),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3jAdT.default), {
        title: data.title
    }, data.writable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.rename-and-share",
        onClick: modalRenameAndShareOpen
    }, formatMessage(data.systemDashboard ? (0, $dFiez.default).share : (0, $dFiez.default).renameOrShare)), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.copy",
        onClick: modalCopyOpen
    }, formatMessage((0, $dFiez.default).copy)), data.writable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.automatic-refresh",
        onClick: modalAutomaticRefreshOpen
    }, formatMessage((0, $dFiez.default).automaticRefresh)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.wallboard",
        href: viewAsWallboardUrl,
        onClick: (e)=>dropdownItemClickHandler(e, viewAsWallboardUrl, 'dashboard.view-as-wallboard-item'),
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage((0, $dFiez.default).wallboard)), isDashboardOwner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.delete",
        onClick: modalDeleteOpen
    }, formatMessage((0, $dFiez.default).moveToTrash)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $x5bVw.WallboardSlideshow), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        hasSeparator: true
    }, !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.create",
        onClick: modalCreateOpen
    }, formatMessage((0, $dFiez.default).create)), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.find",
        href: "/jira/dashboards"
    }, formatMessage((0, $dFiez.default).find))), connectToolMenuItems && connectToolMenuItems.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        testId: "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.dashboard-connect-menu-items",
        hasSeparator: true
    }, connectToolMenuItems.map(({ id: id, title: title, url: url, styleClass: styleClass })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
            key: id,
            href: url,
            UNSAFE_shouldDisableRouterLink: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            id: id,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: styleClass
        }, title)))) : null));
};

});
parcelRegister("b8ziP", function(module, exports) {

$parcel$export(module.exports, "useDropdownItemOnClickHandler", () => $7f06fd4fc0d36f11$export$b9ed61ea9e46f071);


var $lVJAU = parcelRequire("lVJAU");

var $bOnpg = parcelRequire("bOnpg");

var $cdUgf = parcelRequire("cdUgf");
const $7f06fd4fc0d36f11$export$b9ed61ea9e46f071 = ()=>{
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const fireAnalytics = (0, $bOnpg.useDashboardAnalytics)();
    const dropdownItemClickHandler = (e, url, actionSubject)=>{
        if (actionSubject) fireAnalytics({
            eventType: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e),
            actionSubject: actionSubject,
            action: 'clicked',
            actionSubjectId: 'dashboard'
        });
        if (!(0, $cdUgf.clickedWithShortcutKeys)(e)) {
            e.preventDefault();
            push(url);
        }
    };
    return {
        dropdownItemClickHandler: dropdownItemClickHandler
    };
};

});

parcelRegister("edp7U", function(module, exports) {

$parcel$export(module.exports, "getIsDropdownDefaultOpen", () => $dad419d0b39d4c21$export$638abbdcabd86e67);
/**
 * NOTE - this is to assist with VR tests so we can easily di the value for the
 * dropdowns to be opened.
 * @param _ name of your component
 * @returns false in production code
 */ const $dad419d0b39d4c21$export$638abbdcabd86e67 = (_)=>false;

});

parcelRegister("dFiez", function(module, exports) {

$parcel$export(module.exports, "default", () => $172a2c76e18069ed$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $172a2c76e18069ed$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    moreActions: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.more-actions",
        "defaultMessage": "More dashboard actions"
    },
    copy: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.copy",
        "defaultMessage": "Copy"
    },
    automaticRefresh: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.automatic-refresh",
        "defaultMessage": "Configure automatic refresh"
    },
    renameOrShare: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.rename-or-share",
        "defaultMessage": "Rename or share"
    },
    share: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.share",
        "defaultMessage": "Share dashboard"
    },
    moveToTrash: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.move-to-trash",
        "defaultMessage": "Move to trash"
    },
    find: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.find",
        "defaultMessage": "View all dashboards"
    },
    create: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.create",
        "defaultMessage": "Create a dashboard"
    },
    wallboard: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.wallboard",
        "defaultMessage": "View as wallboard"
    }
});

});

parcelRegister("2h3Nr", function(module, exports) {

$parcel$export(module.exports, "AutomaticRefreshModal", () => $de8465027ccce40b$export$47f35766b426b3bc);

var $5uXOq = parcelRequire("5uXOq");

var $1wnUy = parcelRequire("1wnUy");

var $hh0bW = parcelRequire("hh0bW");

var $JIPqS = parcelRequire("JIPqS");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $e9QkH = parcelRequire("e9QkH");

var $b7Svb = parcelRequire("b7Svb");

var $iLC4C = parcelRequire("iLC4C");

var $89bLT = parcelRequire("89bLT");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $de8465027ccce40b$var$LazyDashboardModal = (0, $b7Svb.lazy)(()=>(parcelRequire("f9y6M")), {
    moduleId: "./src/packages/global-pages/dashboard/internal-common/src/ui/dashboard-content/header/action-dropdown/modals/automatic-refresh-modal/main.tsx"
});
const $de8465027ccce40b$var$expAttributes = {
    analyticsSource: 'dashboard',
    experience: (0, $JIPqS.DASHBOARD_AUTOMATIC_REFRESH_EXPERIENCE),
    application: null,
    edition: null,
    additionalAttributes: {
        isCancel: false
    }
};
const $de8465027ccce40b$var$sendSuccessExperience = ()=>(0, $hh0bW.default)({
        ...$de8465027ccce40b$var$expAttributes,
        wasExperienceSuccesful: true
    });
const $de8465027ccce40b$var$sendFailedExperience = ()=>(0, $hh0bW.default)({
        ...$de8465027ccce40b$var$expAttributes,
        wasExperienceSuccesful: false
    });
const $de8465027ccce40b$export$47f35766b426b3bc = ({ id: id, onModalCloseCallback: onModalCloseCallback })=>{
    const [isOpen, { off: close }] = (0, $e9QkH.useSwitchModals)((0, $JIPqS.MODAL_ID).AUTOMATIC_REFRESH);
    const onFailed = (err)=>{
        const error = err || new Error('automatic refresh modal configuration failed.');
        (0, $iLC4C.handleFetchErrorAsExperience)({
            error: error,
            sendSuccessExperience: $de8465027ccce40b$var$sendSuccessExperience,
            sendFailedExperience: $de8465027ccce40b$var$sendFailedExperience,
            logErrorEvent: (0, $89bLT.logErrorEventFunc)(error, (0, $JIPqS.DASHBOARD_AUTOMATIC_REFRESH))
        });
        close();
        onModalCloseCallback?.();
    };
    const onCancel = ()=>{
        (0, $hh0bW.default)({
            ...$de8465027ccce40b$var$expAttributes,
            wasExperienceSuccesful: true,
            additionalAttributes: {
                isCancel: true
            }
        });
        close();
        onModalCloseCallback?.();
    };
    const onClose = ()=>{
        close();
        onModalCloseCallback?.();
    };
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $JIPqS.DASHBOARD_AUTOMATIC_REFRESH_EXPERIENCE),
        packageName: "dashboard",
        fallback: "flag",
        attributes: {
            task: (0, $JIPqS.DASHBOARD_AUTOMATIC_REFRESH_EXPERIENCE)
        },
        withExperienceTracker: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "dashboard-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wnUy.default), {
            isTinted: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($de8465027ccce40b$var$LazyDashboardModal, {
        id: id,
        onClose: onClose,
        onSuccess: $de8465027ccce40b$var$sendSuccessExperience,
        onCancel: onCancel,
        onFailed: onFailed
    }))) : null;
};

});
parcelRegister("89bLT", function(module, exports) {

$parcel$export(module.exports, "logErrorEventFunc", () => $98efc897ec5a605f$export$e315c4152a211ba8);

var $jcw0u = parcelRequire("jcw0u");
const $98efc897ec5a605f$export$e315c4152a211ba8 = (error, eventId)=>(reason)=>{
        if (error != null) (0, $jcw0u.default)({
            error: error,
            meta: {
                id: eventId,
                packageName: 'jiraDashboardInternalCommon'
            },
            attributes: {
                reason: reason
            }
        });
    };

});

parcelRegister("f9y6M", function(module, exports) {

let $b082277b31741638$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b082277b31741638$var$load("6Fl1t").then(()=>parcelRequire('eIgK0'));

});


parcelRegister("fb7AH", function(module, exports) {

$parcel$export(module.exports, "ConfigureWallboardModal", () => $c591fac53db599f8$export$cf7e06d150dcce6d);

var $5uXOq = parcelRequire("5uXOq");

var $1wnUy = parcelRequire("1wnUy");

var $JIPqS = parcelRequire("JIPqS");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $e9QkH = parcelRequire("e9QkH");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c591fac53db599f8$var$LazyDashboardModal = (0, $b7Svb.lazy)(()=>(parcelRequire("ftVpm")), {
    moduleId: "./src/packages/global-pages/dashboard/internal-common/src/ui/dashboard-content/header/action-dropdown/modals/configure-wallboard-modal/modal/index.tsx"
});
const $c591fac53db599f8$export$cf7e06d150dcce6d = ({ onModalCloseCallback: onModalCloseCallback })=>{
    const [isOpen, { off: close }] = (0, $e9QkH.useSwitchModals)((0, $JIPqS.MODAL_ID).CONFIGURE_WALLBOARD);
    const onModalClose = ()=>{
        close();
        onModalCloseCallback?.();
    };
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "configure-wallboard-modal",
        packageName: "dashboard",
        fallback: "flag",
        teamName: "endeavour"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "dashboard-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wnUy.default), {
            isTinted: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c591fac53db599f8$var$LazyDashboardModal, {
        onClose: onModalClose
    }))) : null;
};

});
parcelRegister("ftVpm", function(module, exports) {

let $b456187c119e0ad1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b456187c119e0ad1$var$load("1ftQg").then(()=>parcelRequire('iFntg'));

});


parcelRegister("fqLvm", function(module, exports) {

$parcel$export(module.exports, "CopyModal", () => $6aa3f9a2fe12b1cd$export$4a7ddad8989462fb);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $1wnUy = parcelRequire("1wnUy");

var $hh0bW = parcelRequire("hh0bW");

var $JIPqS = parcelRequire("JIPqS");

var $7CMCs = parcelRequire("7CMCs");

var $34Vv8 = parcelRequire("34Vv8");

var $lfTZh = parcelRequire("lfTZh");

var $e9QkH = parcelRequire("e9QkH");

var $b7Svb = parcelRequire("b7Svb");

var $lVJAU = parcelRequire("lVJAU");

var $iLC4C = parcelRequire("iLC4C");

var $89bLT = parcelRequire("89bLT");

const $6aa3f9a2fe12b1cd$var$LazyDashboardModal = (0, $34Vv8.default)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $b7Svb.lazy)(()=>(parcelRequire("dxWhV")).then(({ CopyDashboardModal: CopyDashboardModal })=>CopyDashboardModal), {
    moduleId: "./src/packages/global-pages/directories/dashboards-directory-v2/copy-dashboard-modal/src/index.tsx"
}));
const $6aa3f9a2fe12b1cd$var$expAttributes = {
    analyticsSource: 'dashboard',
    experience: (0, $JIPqS.COPY_DASHBOARD_EXPERIENCE),
    application: null,
    edition: null,
    additionalAttributes: {
        isCancel: false
    }
};
const $6aa3f9a2fe12b1cd$var$sendSuccessExperience = ()=>(0, $hh0bW.default)({
        ...$6aa3f9a2fe12b1cd$var$expAttributes,
        wasExperienceSuccesful: true
    });
const $6aa3f9a2fe12b1cd$var$sendFailedExperience = ()=>(0, $hh0bW.default)({
        ...$6aa3f9a2fe12b1cd$var$expAttributes,
        wasExperienceSuccesful: false
    });
const $6aa3f9a2fe12b1cd$export$bdd968b8df213d5c = ({ id: id, onModalCloseCallback: onModalCloseCallback })=>{
    const [isOpen, { off: close }] = (0, $e9QkH.useSwitchModals)((0, $JIPqS.MODAL_ID).DASHBOARD_COPY);
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const onSuccess = (_, response)=>{
        $6aa3f9a2fe12b1cd$var$sendSuccessExperience();
        close();
        if (response.view != null) push(response.view);
        else onModalCloseCallback?.();
    };
    const onInitiateFailed = (error)=>{
        (0, $iLC4C.handleFetchErrorAsExperience)({
            error: error || new Error('copy dashboard modal initialisation failed'),
            sendSuccessExperience: $6aa3f9a2fe12b1cd$var$sendSuccessExperience,
            sendFailedExperience: $6aa3f9a2fe12b1cd$var$sendFailedExperience,
            logErrorEvent: (0, $89bLT.logErrorEventFunc)(error, (0, $JIPqS.COPY_DASHBOARD))
        });
        close();
        onModalCloseCallback?.();
    };
    const onFailed = (error)=>{
        (0, $iLC4C.handleFetchErrorAsExperience)({
            error: error,
            sendSuccessExperience: $6aa3f9a2fe12b1cd$var$sendSuccessExperience,
            sendFailedExperience: $6aa3f9a2fe12b1cd$var$sendFailedExperience,
            logErrorEvent: (0, $89bLT.logErrorEventFunc)(error, (0, $JIPqS.COPY_DASHBOARD))
        });
        close();
        onModalCloseCallback?.();
    };
    const onCancel = ()=>{
        (0, $hh0bW.default)({
            ...$6aa3f9a2fe12b1cd$var$expAttributes,
            wasExperienceSuccesful: true,
            additionalAttributes: {
                isCancel: true
            }
        });
        close();
        onModalCloseCallback?.();
    };
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "dashboard-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wnUy.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6aa3f9a2fe12b1cd$var$LazyDashboardModal, {
        onInitiateFailed: onInitiateFailed,
        onSuccess: onSuccess,
        onFailed: onFailed,
        onCancel: onCancel,
        id: id
    })) : null;
};
const $6aa3f9a2fe12b1cd$export$4a7ddad8989462fb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $JIPqS.COPY_DASHBOARD_EXPERIENCE),
        packageName: "dashboard",
        fallback: "flag",
        attributes: {
            task: (0, $JIPqS.COPY_DASHBOARD_EXPERIENCE)
        },
        withExperienceTracker: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6aa3f9a2fe12b1cd$export$bdd968b8df213d5c, props));

});
parcelRegister("dxWhV", function(module, exports) {

let $028b8a9ddf4f0b99$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $028b8a9ddf4f0b99$var$load("h2MrD"),
    $028b8a9ddf4f0b99$var$load("bYT2S"),
    $028b8a9ddf4f0b99$var$load("5k9P8")
]).then(()=>parcelRequire('a7HF6'));

});


parcelRegister("2IJzF", function(module, exports) {

$parcel$export(module.exports, "CreateModal", () => $cdded0b8b2569776$export$204e9f8d79be983e);

var $5uXOq = parcelRequire("5uXOq");

var $1wnUy = parcelRequire("1wnUy");

var $jgE05 = parcelRequire("jgE05");

var $JIPqS = parcelRequire("JIPqS");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $gh1hi = parcelRequire("gh1hi");

var $e9QkH = parcelRequire("e9QkH");

var $lVJAU = parcelRequire("lVJAU");
const $cdded0b8b2569776$export$e85d11db57ff5836 = ({ onModalCloseCallback: onModalCloseCallback })=>{
    const [isOpen, { off: close }] = (0, $e9QkH.useSwitchModals)((0, $JIPqS.MODAL_ID).DASHBOARD_CREATE);
    const { clear: clear } = (0, $gh1hi.useDashboardResource)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const onSuccess = (_, operationResult)=>{
        clear();
        push(`/jira/dashboards/${operationResult.id}/edit`);
        close();
    };
    const onCancel = ()=>{
        close();
        onModalCloseCallback?.();
    };
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "dashboards-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wnUy.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgE05.default), {
        onSuccess: onSuccess,
        onCancel: onCancel
    })) : null;
};
const $cdded0b8b2569776$export$204e9f8d79be983e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $JIPqS.CREATE_DASHBOARD_EXPERIENCE),
        packageName: "dashboard",
        fallback: "flag",
        attributes: {
            task: (0, $JIPqS.CREATE_DASHBOARD_EXPERIENCE)
        },
        withExperienceTracker: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cdded0b8b2569776$export$e85d11db57ff5836, props));

});

parcelRegister("8AXqQ", function(module, exports) {

$parcel$export(module.exports, "DeleteModal", () => $f85fc38ca5cf0b6c$export$73392e09138fecd6);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $1wnUy = parcelRequire("1wnUy");

var $hh0bW = parcelRequire("hh0bW");

var $JIPqS = parcelRequire("JIPqS");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $gh1hi = parcelRequire("gh1hi");

var $e9QkH = parcelRequire("e9QkH");

var $b7Svb = parcelRequire("b7Svb");

var $lVJAU = parcelRequire("lVJAU");

var $iLC4C = parcelRequire("iLC4C");

var $89bLT = parcelRequire("89bLT");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f85fc38ca5cf0b6c$var$LazyDeleteModal = (0, $b7Svb.lazy)(()=>(parcelRequire("l6hVW")), {
    moduleId: "./src/packages/global-pages/directories/dashboards-directory-v2/delete-dashboard-modal/src/index.tsx"
});
const $f85fc38ca5cf0b6c$var$expAttributes = {
    analyticsSource: 'dashboard',
    experience: (0, $JIPqS.DELETE_DASHBOARD_EXPERIENCE),
    application: null,
    edition: null,
    additionalAttributes: {
        isCancel: false
    }
};
const $f85fc38ca5cf0b6c$var$sendSuccessExperience = ()=>(0, $hh0bW.default)({
        ...$f85fc38ca5cf0b6c$var$expAttributes,
        wasExperienceSuccesful: true
    });
const $f85fc38ca5cf0b6c$var$sendFailedExperience = ()=>(0, $hh0bW.default)({
        ...$f85fc38ca5cf0b6c$var$expAttributes,
        wasExperienceSuccesful: false
    });
const $f85fc38ca5cf0b6c$export$daf5ee5ed602db71 = ({ id: id, onModalCloseCallback: onModalCloseCallback })=>{
    const [isOpen, { off: close }] = (0, $e9QkH.useSwitchModals)((0, $JIPqS.MODAL_ID).DASHBOARD_DELETE);
    const { clear: clear } = (0, $gh1hi.useDashboardResource)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const onSuccess = ()=>{
        (0, $hh0bW.default)({
            ...$f85fc38ca5cf0b6c$var$expAttributes,
            wasExperienceSuccesful: true
        });
        clear();
        close();
        push('/jira/dashboards');
    };
    const onInitiateFailed = (error)=>{
        (0, $iLC4C.handleFetchErrorAsExperience)({
            error: error || new Error('delete dashboard modal initialisation failed'),
            sendSuccessExperience: $f85fc38ca5cf0b6c$var$sendSuccessExperience,
            sendFailedExperience: $f85fc38ca5cf0b6c$var$sendFailedExperience,
            logErrorEvent: (0, $89bLT.logErrorEventFunc)(error, (0, $JIPqS.DELETE_DASHBOARD))
        });
        close();
        onModalCloseCallback?.();
    };
    const onFailed = (error)=>{
        (0, $iLC4C.handleFetchErrorAsExperience)({
            error: error,
            sendSuccessExperience: $f85fc38ca5cf0b6c$var$sendSuccessExperience,
            sendFailedExperience: $f85fc38ca5cf0b6c$var$sendFailedExperience,
            logErrorEvent: (0, $89bLT.logErrorEventFunc)(error, (0, $JIPqS.DELETE_DASHBOARD))
        });
        close();
        onModalCloseCallback?.();
    };
    const onCancel = ()=>{
        (0, $hh0bW.default)({
            ...$f85fc38ca5cf0b6c$var$expAttributes,
            wasExperienceSuccesful: true,
            additionalAttributes: {
                isCancel: true
            }
        });
        close();
        onModalCloseCallback?.();
    };
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "dashboards-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wnUy.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f85fc38ca5cf0b6c$var$LazyDeleteModal, {
        onInitiateSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onInitiateFailed: onInitiateFailed,
        onSuccess: onSuccess,
        onCancel: onCancel,
        onFailed: onFailed,
        id: id
    })) : null;
};
const $f85fc38ca5cf0b6c$export$73392e09138fecd6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $JIPqS.DELETE_DASHBOARD_EXPERIENCE),
        packageName: "dashboard",
        fallback: "flag",
        attributes: {
            task: (0, $JIPqS.DELETE_DASHBOARD_EXPERIENCE)
        },
        withExperienceTracker: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f85fc38ca5cf0b6c$export$daf5ee5ed602db71, props));

});
parcelRegister("l6hVW", function(module, exports) {

let $f5c811bd24acce14$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f5c811bd24acce14$var$load("2CgxW").then(()=>parcelRequire('6ee1k'));

});


parcelRegister("2EGKG", function(module, exports) {

$parcel$export(module.exports, "RenameOrShareModal", () => $952ac229700a831b$export$a113d771e12d2a12);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $1wnUy = parcelRequire("1wnUy");

var $hh0bW = parcelRequire("hh0bW");

var $JIPqS = parcelRequire("JIPqS");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $e9QkH = parcelRequire("e9QkH");

var $b7Svb = parcelRequire("b7Svb");

var $3TUxF = parcelRequire("3TUxF");

var $iLC4C = parcelRequire("iLC4C");

var $89bLT = parcelRequire("89bLT");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $952ac229700a831b$var$LazyRenameOrShareModal = (0, $b7Svb.lazy)(()=>(parcelRequire("a3eyw")), {
    moduleId: "./src/packages/global-pages/directories/dashboards-directory-v2/edit-dashboard-modal/src/index.tsx"
});
const $952ac229700a831b$var$expAttributes = {
    analyticsSource: 'dashboard',
    experience: (0, $JIPqS.RENAME_OR_SHARE_DASHBOARD_EXPERIENCE),
    application: null,
    edition: null,
    additionalAttributes: {
        isCancel: false
    }
};
const $952ac229700a831b$var$sendSuccessExperience = ()=>(0, $hh0bW.default)({
        ...$952ac229700a831b$var$expAttributes,
        wasExperienceSuccesful: true
    });
const $952ac229700a831b$var$sendFailedExperience = ()=>(0, $hh0bW.default)({
        ...$952ac229700a831b$var$expAttributes,
        wasExperienceSuccesful: false
    });
const $952ac229700a831b$export$4f6c2201df28de83 = ({ id: id, onModalCloseCallback: onModalCloseCallback })=>{
    const [isOpen, { off: close }] = (0, $e9QkH.useSwitchModals)((0, $JIPqS.MODAL_ID).DASHBOARD_RENAME_OR_SHARE);
    const onEditDashboard = (0, $3TUxF.useEditDashboard)();
    const onSuccess = (_, response)=>{
        onEditDashboard(response);
        $952ac229700a831b$var$sendSuccessExperience();
        close();
        onModalCloseCallback?.();
    };
    const onInitiateFailed = (error)=>{
        (0, $iLC4C.handleFetchErrorAsExperience)({
            error: error || new Error('rename or share dashboard modal initialisation failed'),
            sendSuccessExperience: $952ac229700a831b$var$sendSuccessExperience,
            sendFailedExperience: $952ac229700a831b$var$sendFailedExperience,
            logErrorEvent: (0, $89bLT.logErrorEventFunc)(error, (0, $JIPqS.RENAME_OR_SHARE_DASHBOARD))
        });
        close();
        onModalCloseCallback?.();
    };
    const onFailed = (error)=>{
        (0, $iLC4C.handleFetchErrorAsExperience)({
            error: error,
            sendSuccessExperience: $952ac229700a831b$var$sendSuccessExperience,
            sendFailedExperience: $952ac229700a831b$var$sendFailedExperience,
            logErrorEvent: (0, $89bLT.logErrorEventFunc)(error, (0, $JIPqS.RENAME_OR_SHARE_DASHBOARD))
        });
        close();
        onModalCloseCallback?.();
    };
    const onCancel = ()=>{
        (0, $hh0bW.default)({
            ...$952ac229700a831b$var$expAttributes,
            wasExperienceSuccesful: true,
            additionalAttributes: {
                isCancel: true
            }
        });
        close();
        onModalCloseCallback?.();
    };
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "rename-or-share-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wnUy.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($952ac229700a831b$var$LazyRenameOrShareModal, {
        onInitiateFailed: onInitiateFailed,
        onInitiateSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onSuccess: onSuccess,
        onCancel: onCancel,
        onFailed: onFailed,
        id: id
    })) : null;
};
const $952ac229700a831b$export$a113d771e12d2a12 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $JIPqS.RENAME_OR_SHARE_DASHBOARD_EXPERIENCE),
        packageName: "dashboard",
        fallback: "flag",
        attributes: {
            task: (0, $JIPqS.RENAME_OR_SHARE_DASHBOARD_EXPERIENCE)
        },
        withExperienceTracker: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($952ac229700a831b$export$4f6c2201df28de83, props));

});
parcelRegister("3TUxF", function(module, exports) {

$parcel$export(module.exports, "useEditDashboard", () => $481cf9cc3e288e09$export$a7520122589f9056);

var $5uXOq = parcelRequire("5uXOq");

var $gh1hi = parcelRequire("gh1hi");
const $481cf9cc3e288e09$export$a7520122589f9056 = ()=>{
    const { update: update } = (0, $gh1hi.useDashboardResource)();
    return (0, $5uXOq.useCallback)((dashboardData)=>{
        if (!dashboardData) return;
        update((currentData)=>currentData && {
                ...currentData,
                title: dashboardData.name
            });
    }, [
        update
    ]);
};

});

parcelRegister("a3eyw", function(module, exports) {

let $751579b0d527af23$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $751579b0d527af23$var$load("h2MrD"),
    $751579b0d527af23$var$load("bYT2S"),
    $751579b0d527af23$var$load("XUjPB")
]).then(()=>parcelRequire('fZpfn'));

});


parcelRegister("x5bVw", function(module, exports) {

$parcel$export(module.exports, "WallboardSlideshow", () => $e8bb3a64b8086b53$export$db3bf5ee6d309e34);

var $5uXOq = parcelRequire("5uXOq");

var $1eETS = parcelRequire("1eETS");

var $70rf1 = parcelRequire("70rf1");

var $JIPqS = parcelRequire("JIPqS");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");


var $e9QkH = parcelRequire("e9QkH");

var $9OXo1 = parcelRequire("9OXo1");

var $bOnpg = parcelRequire("bOnpg");

var $b8ziP = parcelRequire("b8ziP");

var $drb8j = parcelRequire("drb8j");
const $e8bb3a64b8086b53$var$EMPTY_WALLBOARD_URL = '/';
const $e8bb3a64b8086b53$export$11aea547bd3c125e = async ()=>{
    try {
        const response = await fetch('/rest/wallboard/latest/slideshow/url', {
            method: 'GET'
        });
        if (!response.ok) throw new Error(`Error server response: ${response.status}`);
        return response.text();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // if error, then the link would be grayed out
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'viewWallboardSlideshow',
                packageName: 'jiraDashboardInternalCommon'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return $e8bb3a64b8086b53$var$EMPTY_WALLBOARD_URL;
    }
};
const $e8bb3a64b8086b53$export$db3bf5ee6d309e34 = ()=>{
    const { isAnonymous: isAnonymous } = (0, $9OXo1.useTenantContext)();
    const [wallboardSlideshowUrl, setWallboardSlideshowUrl] = (0, $5uXOq.useState)(undefined);
    const [, { on: modalWallboardOpen }] = (0, $e9QkH.useSwitchModals)((0, $JIPqS.MODAL_ID).CONFIGURE_WALLBOARD);
    const fireAnalytics = (0, $bOnpg.useDashboardAnalytics)();
    const configureWallboardSlideShowClickHandler = (0, $5uXOq.useCallback)(()=>{
        fireAnalytics({
            eventType: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e),
            actionSubjectId: 'dashboard',
            actionSubject: 'wallboard-slideshow.configure',
            action: 'clicked'
        });
        // Wrapping modalWallboardOpen() inside setTimeout
        // for the focus to be on the dropdown button before opening
        // the modal as part of accessibility ticket DAG-903
        setTimeout(()=>{
            modalWallboardOpen();
        }, 1);
    }, [
        fireAnalytics,
        modalWallboardOpen
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { dropdownItemClickHandler: dropdownItemClickHandler } = (0, $b8ziP.useDropdownItemOnClickHandler)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isAnonymous && wallboardSlideshowUrl === undefined) $e8bb3a64b8086b53$export$11aea547bd3c125e().then((url)=>{
            setWallboardSlideshowUrl(url || $e8bb3a64b8086b53$var$EMPTY_WALLBOARD_URL);
        });
    }, [
        isAnonymous,
        wallboardSlideshowUrl
    ]);
    const isViewWallboardSlideshowEnabled = wallboardSlideshowUrl !== $e8bb3a64b8086b53$var$EMPTY_WALLBOARD_URL && !isAnonymous;
    // `wallboardSlideShowUrl` can be undefined and is generated through a fetch call which may be fail,
    // so we have `EMPTY_WALLBOARD_URL` as a fallback
    const wallboardSlideshowUrlWithFallback = wallboardSlideshowUrl || $e8bb3a64b8086b53$var$EMPTY_WALLBOARD_URL;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.wallboard-slideshow.wallboard-slideshow",
        isDisabled: !isViewWallboardSlideshowEnabled,
        href: wallboardSlideshowUrlWithFallback,
        onClick: (e)=>dropdownItemClickHandler(e, wallboardSlideshowUrlWithFallback, 'dashboard.view-wallboard-slideshow-item'),
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage((0, $drb8j.default).wallboardSlideshow)), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.wallboard-slideshow.configure-wallboard",
        onClick: configureWallboardSlideShowClickHandler
    }, formatMessage((0, $drb8j.default).wallboardSetup)));
};

});
parcelRegister("drb8j", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bd6bbd173094bd4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3bd6bbd173094bd4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    wallboardSlideshow: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.wallboard-slideshow.wallboard-slideshow",
        "defaultMessage": "View wallboard slide show"
    },
    wallboardSetup: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.wallboard-slideshow.wallboard-setup",
        "defaultMessage": "Configure wallboard slide show"
    }
});

});



parcelRegister("dZymr", function(module, exports) {

$parcel$export(module.exports, "ConnectHeader", () => $fa1518cc236818d0$export$a7c3d2bbc29ad451);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cNW3X = parcelRequire("cNW3X");

var $j7m8K = parcelRequire("j7m8K");
var $1eETS = parcelRequire("1eETS");

var $gVM6m = parcelRequire("gVM6m");

var $hrlU6 = parcelRequire("hrlU6");

var $edp7U = parcelRequire("edp7U");
const $fa1518cc236818d0$export$965e85c1e0261738 = ({ item: item })=>{
    const webItemRef = (0, $5uXOq.useRef)(null);
    const onWebItemClick = ()=>{
        (0, $hrlU6.withConnectHost)((connectHost)=>{
            if (webItemRef.current) connectHost.triggerWebItem(webItemRef.current, item.styleClass, item.url);
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        id: item.id,
        appearance: "subtle",
        onClick: onWebItemClick,
        ref: webItemRef
    }, item.title);
};
const $fa1518cc236818d0$var$DropdownPressableItem = ({ item: item })=>{
    const webItemRef = (0, $5uXOq.useRef)(null);
    const onWebItemClick = ()=>{
        (0, $hrlU6.withConnectHost)((connectHost)=>{
            if (webItemRef.current) connectHost.triggerWebItem(webItemRef.current, item.styleClass, item.url);
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gVM6m.default), {
        id: item.id,
        onClick: onWebItemClick,
        ref: (ref)=>{
            if (ref) webItemRef.current = ref;
        },
        backgroundColor: "color.background.neutral.subtle"
    }, item.title);
};
const $fa1518cc236818d0$export$275428e5ee6cc209 = ({ items: items })=>{
    if (items.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j7m8K.default), {
        isLoading: false,
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
                appearance: "subtle",
                spacing: "default",
                ...triggerProps,
                ref: triggerRef
            }, "+", items.length),
        shouldFlip: true,
        placement: "bottom-end",
        testId: "dashboard-internal-common.ui.dashboard-content.header.connect-header.dropdown-menu",
        defaultOpen: (0, $edp7U.getIsDropdownDefaultOpen)('connect-header')
    }, items.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
            key: item.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa1518cc236818d0$var$DropdownPressableItem, {
            item: item
        }))));
};
const $fa1518cc236818d0$export$a7c3d2bbc29ad451 = ({ items: items })=>{
    if (!items) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa1518cc236818d0$var$ConnectHeaderWrapper, null, items.slice(0, 4).map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa1518cc236818d0$export$965e85c1e0261738, {
            item: item,
            key: item.id
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa1518cc236818d0$export$275428e5ee6cc209, {
        items: items.slice(4)
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $fa1518cc236818d0$var$ConnectHeaderWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bahesu3 _1hbsidpf _1u711b66 _y2qtidpf _fl8b1b66",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1i27D", function(module, exports) {

$parcel$export(module.exports, "HeaderTitle", () => $f69e2b51e1f910f6$export$edb76fdb8665f52);
$parcel$export(module.exports, "HeaderActions", () => $f69e2b51e1f910f6$export$223875819fd7cf93);
$parcel$export(module.exports, "Header", () => $f69e2b51e1f910f6$export$8b251419efc915eb);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $cigQb = parcelRequire("cigQb");
var $4KBRy = parcelRequire("4KBRy");

var $cS37j = parcelRequire("cS37j");

var $kSvVK = parcelRequire("kSvVK");
const $f69e2b51e1f910f6$export$edb76fdb8665f52 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4KBRy.default), {
        medium: 4,
        testId: "dashboard-internal-common.ui.dashboard-content.header.header-title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), null, children));
const $f69e2b51e1f910f6$export$223875819fd7cf93 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4KBRy.default), {
        medium: 8
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kSvVK.ActionWrapper), null, children)));
const $f69e2b51e1f910f6$export$8b251419efc915eb = ({ banners: banners, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("header", {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.header.dashboard-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cigQb.default), {
        layout: "fluid",
        spacing: "compact"
    }, children), banners && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kSvVK.BannersWrapper), null, banners));

});
parcelRegister("kSvVK", function(module, exports) {

$parcel$export(module.exports, "ActionWrapper", () => $3989dffa8d1c8135$export$3122aab815c89f9a);
$parcel$export(module.exports, "BannersWrapper", () => $3989dffa8d1c8135$export$ab656bce1543f51a);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $3989dffa8d1c8135$export$3122aab815c89f9a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _1bahesu3 _19pk1ejb _2hwxidpf _otyrpxbi _18u0idpf _xlknidpf _dgz5idpf _18sqidpf _wrjxidpf _11hyu2gc _19kautpp _412c1v6z _1sjdutpp",
            __cmplp.className
        ])
    });
});
const $3989dffa8d1c8135$export$ab656bce1543f51a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _2lx21bp4 _zum8idpf _10361ejb",
            __cmplp.className
        ])
    });
});

});


parcelRegister("2PcTT", function(module, exports) {

$parcel$export(module.exports, "useConnectMenuItems", () => $fdeff8836b607085$export$58f1b171f06c90ef);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");
const $fdeff8836b607085$export$58f1b171f06c90ef = (dashboardId)=>{
    const [connectMenuItems, setConnectMenuItems] = (0, $5uXOq.useState)({
        headerItems: [],
        toolItems: []
    });
    (0, $5uXOq.useEffect)(()=>{
        // TODO - remove this as types say it should not be necessary
        if (dashboardId == null) return;
        (async ()=>{
            const resourceUrl = `/rest/dashboards/1.0/connect/menuItems/${dashboardId}`;
            try {
                const response = await (0, $7f4tk.default)(resourceUrl);
                setConnectMenuItems(response);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $jcw0u.default)({
                    error: error,
                    meta: {
                        id: 'fetchConnectMenuItems',
                        packageName: 'jiraDashboardInternalCommon',
                        teamName: 'endeavour'
                    }
                });
            }
        })();
    }, [
        dashboardId
    ]);
    return connectMenuItems;
};

});

parcelRegister("9jsHG", function(module, exports) {

$parcel$export(module.exports, "FavoriteButton", () => $74ae53576ce577d5$export$8d5dab2ad1e19ea0);

var $5uXOq = parcelRequire("5uXOq");

var $hcObS = parcelRequire("hcObS");

var $hLZZY = parcelRequire("hLZZY");

var $eXQym = parcelRequire("eXQym");
const $74ae53576ce577d5$export$8d5dab2ad1e19ea0 = ({ dashboardId: dashboardId, dashboardName: dashboardName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hcObS.FavoriteButtonWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hLZZY.default), {
        baseUrl: "",
        itemId: dashboardId,
        itemType: (0, $eXQym.DASHBOARDS_ITEM_TYPE),
        favoriteItemName: dashboardName
    }));

});
parcelRegister("hLZZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a968ac170a325ff4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4041n = parcelRequire("4041n");


var $fH2dG = parcelRequire("fH2dG");
class $a968ac170a325ff4$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4041n.FavoriteChangeConsumer), null, (favoriteChangeContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fH2dG.FavoriteButton), {
                ...this.props,
                favoriteChangeContext: favoriteChangeContext
            }));
    }
}

});
parcelRegister("fH2dG", function(module, exports) {

$parcel$export(module.exports, "FavoriteButton", () => $e0f2aac973023e83$export$8d5dab2ad1e19ea0);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $hcObS = parcelRequire("hcObS");

var $eXQym = parcelRequire("eXQym");

var $1WPu2 = parcelRequire("1WPu2");
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $e0f2aac973023e83$var$isProduction = window.BUILD_KEY !== 'JF-TEST';
class $e0f2aac973023e83$export$8d5dab2ad1e19ea0 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isFavoriteInitial: undefined,
            favoriteItemName: undefined,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    constructor(props){
        super(props), this.onClick = (analyticsEvent)=>{
            const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType, onClick: onClick } = this.props;
            const { changeFavorite: changeFavorite } = favoriteChangeContext;
            if (changeFavorite) changeFavorite({
                id: itemId,
                type: itemType,
                value: !this.getIsFavorite()
            }, analyticsEvent);
            if (typeof onClick === 'function') onClick();
        };
        this.state = {
            isFavorite: props.isFavoriteInitial
        };
    }
    componentDidMount() {
        const { baseUrl: baseUrl, itemId: itemId, itemType: itemType } = this.props;
        if (typeof baseUrl === 'undefined' || typeof itemId === 'undefined' || typeof itemType === 'undefined') return;
        // Adding an Error here for the next dev to implement this button.
        // This error won't show in prod, but will show when running a fragment.
        if (!$e0f2aac973023e83$var$isProduction && !(0, $eXQym.VALID_ITEM_TYPES).includes(itemType)) throw new Error(`FavoriteButton: Invalid value for prop 'type'.\n You passed: "${itemType}"\n It must be one of [${JSON.stringify((0, $eXQym.VALID_ITEM_TYPES))}]\n\n`);
        if (typeof this.props.isFavoriteInitial !== 'undefined') // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        this.props.favoriteChangeContext.items[itemType][itemId] = {
            id: itemId,
            type: itemType,
            value: this.props.isFavoriteInitial,
            pending: false
        };
        if (this.getIsFavorite() === undefined) (0, $1WPu2.getFavorite)(baseUrl, {
            id: itemId,
            type: itemType
        }).then((isFavorite)=>{
            this.setState({
                isFavorite: isFavorite
            });
        });
    }
    getIsFavorite() {
        const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType } = this.props;
        let itemChanged;
        if (typeof favoriteChangeContext.items[itemType] !== 'undefined' && // @ts-expect-error - TS2532 - TS doesn't refine types with index access in this version.
        typeof favoriteChangeContext.items[itemType][itemId] !== 'undefined') // @ts-expect-error - TS2532 - TS doesn't refine types with index access in this version.
        itemChanged = favoriteChangeContext.items[itemType][itemId];
        return itemChanged ? itemChanged.value : this.state.isFavorite;
    }
    getIsPending() {
        const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType } = this.props;
        let itemChanged;
        if (typeof favoriteChangeContext.items[itemType] !== 'undefined' && // @ts-expect-error - TS2532 - TS doesn't refine types with index access in this version.
        typeof favoriteChangeContext.items[itemType][itemId] !== 'undefined') // @ts-expect-error - TS2532 - TS doesn't refine types with index access in this version.
        itemChanged = favoriteChangeContext.items[itemType][itemId];
        return itemChanged ? itemChanged.pending : false;
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "favourite-button.favorite-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hcObS.default), {
            isFavorite: this.getIsFavorite(),
            favoriteItemName: this.props.favoriteItemName,
            pending: this.getIsPending(),
            hideTooltip: this.props.hideTooltip,
            tooltipPosition: this.props.tooltipPosition,
            onClick: this.onClick,
            isShownInList: this.props.isShownInList,
            isSmall: this.props.isSmall
        }));
    }
}

});
parcelRegister("1WPu2", function(module, exports) {

$parcel$export(module.exports, "getFavorite", () => $1961b1823763022d$export$fce5eda070ce88d0);

var $eusud = parcelRequire("eusud");
const $1961b1823763022d$export$959ca2ee969adb8d = (baseUrl, request)=>`${baseUrl}/rest/internal/2/favourites/${request.type}/${request.id}`;
const $1961b1823763022d$export$fce5eda070ce88d0 = async (baseUrl, request)=>(0, $eusud.performGetRequest)($1961b1823763022d$export$959ca2ee969adb8d(baseUrl, request));

});




parcelRegister("aNPat", function(module, exports) {

$parcel$export(module.exports, "RouteLinkButtonOld", () => $bacdc7ee50699d04$export$c74dddf61fcdf9b0);
$parcel$export(module.exports, "RouteLinkButton", () => $bacdc7ee50699d04$export$64b500ddabb836a3);

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $liZ21 = parcelRequire("liZ21");

var $9VXkC = parcelRequire("9VXkC");
var $hjSul = parcelRequire("hjSul");
const $bacdc7ee50699d04$export$c74dddf61fcdf9b0 = ({ children: children, to: to, params: params, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        component: (0, $hjSul.Link),
        ...rest,
        ...to && {
            // Link would not update when 'to' prop changes, so we need to force an update with key
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            key: to.name,
            // href prop is required to be passed to the Button component for Button to render as an anchor tag
            // instead of a button tag. Remove this line and related code after this issue is fixed for AK Button.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            href: (0, $9VXkC.generatePath)(to.path, params),
            to: to,
            params: params
        }
    }, children);
const $bacdc7ee50699d04$export$64b500ddabb836a3 = ({ to: to, params: params, children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $liZ21.default), {
        ...rest,
        key: to.name,
        href: (0, $9VXkC.generatePath)(to.path, params)
    }, children);

});

const $324eda6c4db64a18$export$fdb820c8e86996c4 = 'button';
const $324eda6c4db64a18$export$e9a9f8a43cd26ad7 = 'link';

parcelRegister("jaPSU", function(module, exports) {

$parcel$export(module.exports, "AddGadgetButton", () => $f6eb6d5ae55a77cd$export$d063cb109cc3ff77);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cNW3X = parcelRequire("cNW3X");

var $JIPqS = parcelRequire("JIPqS");

var $7CMCs = parcelRequire("7CMCs");

var $koVbs = parcelRequire("koVbs");

var $GQeXq = parcelRequire("GQeXq");



var $ka8Tu = parcelRequire("ka8Tu");
const $f6eb6d5ae55a77cd$export$ac0f6789672a17a7 = ({ buttonType: buttonType, columnIndex: columnIndex })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { onOpenRightPanel: onOpenRightPanel, onFocusTrigger: onFocusTrigger } = (0, $GQeXq.useRightPanelToggle)();
    const { isTriggerFocused: isTriggerFocused } = (0, $GQeXq.useRightPanelState)();
    const buttonRef = (0, $5uXOq.useRef)(null);
    const addGadgetButtonOnClick = (0, $5uXOq.useCallback)(()=>{
        onOpenRightPanel(`${(0, $0c49cfa6e72ac9c3$export$39a49c1fbe587c5b)}-${columnIndex}`);
    }, [
        onOpenRightPanel,
        columnIndex
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        onFocusTrigger(()=>buttonRef.current?.focus?.());
    }, [
        onFocusTrigger,
        isTriggerFocused
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f6eb6d5ae55a77cd$var$AddGadgetWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        ref: buttonRef,
        appearance: buttonType === (0, $324eda6c4db64a18$export$fdb820c8e86996c4) ? 'default' : 'link',
        spacing: buttonType === (0, $324eda6c4db64a18$export$fdb820c8e86996c4) ? 'default' : 'none',
        onClick: addGadgetButtonOnClick
    }, formatMessage(buttonType === (0, $324eda6c4db64a18$export$fdb820c8e86996c4) ? (0, $ka8Tu.default).title : (0, $ka8Tu.default).linkTitle)));
};
const $f6eb6d5ae55a77cd$export$d063cb109cc3ff77 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "add-gadget",
        packageName: "dashboard",
        fallback: "flag",
        attributes: {
            task: (0, $JIPqS.ADD_GADGET_EXPERIENCE),
            reason: 'AddGadgetButton with panel ErrorBoundary'
        },
        withExperienceTracker: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f6eb6d5ae55a77cd$export$ac0f6789672a17a7, props));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $f6eb6d5ae55a77cd$var$AddGadgetWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1nu9",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ka8Tu", function(module, exports) {

$parcel$export(module.exports, "default", () => $7af260209e83a08b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7af260209e83a08b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "dashboard-edit.header-editable.add-gadget-button.title",
        "defaultMessage": "Add gadget"
    },
    linkTitle: {
        "id": "dashboard-edit.header-editable.add-gadget-button.link-title",
        "defaultMessage": "add a new gadget"
    },
    errorFlagTitle: {
        "id": "dashboard-edit.header-editable.add-gadget-button.error-flag-title",
        "defaultMessage": "Error"
    },
    errorFlagDescription: {
        "id": "dashboard-edit.header-editable.add-gadget-button.error-flag-description",
        "defaultMessage": "We cannot add any new gadgets at the moment"
    },
    errorFlagAction: {
        "id": "dashboard-edit.header-editable.add-gadget-button.error-flag-action",
        "defaultMessage": "Refresh"
    }
});

});


parcelRegister("4WQJr", function(module, exports) {

$parcel$export(module.exports, "ChangeLayoutButton", () => $dfb79944ea48976b$export$9a00daacadaaca0d);

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $9Fpaj = parcelRequire("9Fpaj");

var $lGD0O = parcelRequire("lGD0O");
const $dfb79944ea48976b$export$9a00daacadaaca0d = ({ layout: layout, onLayoutSelected: onLayoutSelected })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Fpaj.LayoutPicker), {
                onLayoutSelected: onLayoutSelected,
                activeLayout: layout
            }),
        messageId: "dashboard-edit.ui.header-editable.change-layout-button.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
                testId: "dashboard-edit.ui.header-editable.change-layout-button.layout-picker",
                ...triggerProps,
                onClick: ()=>setIsOpen(!isOpen),
                isSelected: isOpen
            }, formatMessage((0, $lGD0O.default).title)),
        placement: "bottom-end"
    });
};

});
parcelRegister("9Fpaj", function(module, exports) {

$parcel$export(module.exports, "LayoutPicker", () => $325a23a1c061fe45$export$6aaa4206f6548ae5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cNW3X = parcelRequire("cNW3X");

var $d6hqU = parcelRequire("d6hqU");

var $iW22S = parcelRequire("iW22S");

var $28UdU = parcelRequire("28UdU");

var $gyYew = parcelRequire("gyYew");

var $7Rki7 = parcelRequire("7Rki7");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $5KCCi = parcelRequire("5KCCi");

var $JIPqS = parcelRequire("JIPqS");

var $koVbs = parcelRequire("koVbs");

var $jPb9c = parcelRequire("jPb9c");
const $325a23a1c061fe45$export$6aaa4206f6548ae5 = ({ onLayoutSelected: onLayoutSelected, activeLayout: activeLayout })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const layoutComponents = {
        A: (0, (/*@__PURE__*/$parcel$interopDefault($d6hqU))),
        AA: (0, (/*@__PURE__*/$parcel$interopDefault($28UdU))),
        AAA: (0, (/*@__PURE__*/$parcel$interopDefault($iW22S))),
        BA: (0, (/*@__PURE__*/$parcel$interopDefault($gyYew))),
        AB: (0, (/*@__PURE__*/$parcel$interopDefault($7Rki7)))
    };
    const { oneColumn: oneColumn, twoColumns: twoColumns, threeColumns: threeColumns, leftSidebar: leftSidebar, rightSidebar: rightSidebar } = (0, $jPb9c.default);
    const tooltips = {
        A: oneColumn,
        AA: twoColumns,
        AAA: threeColumns,
        BA: leftSidebar,
        AB: rightSidebar
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $325a23a1c061fe45$var$pickerWrapperStyles,
        role: "radiogroup"
    }, (0, $JIPqS.LAYOUTS).map((layout)=>{
        const Layout = layoutComponents[layout];
        const isSelected = layout === activeLayout;
        const label = formatMessage(tooltips[layout]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($325a23a1c061fe45$var$LayoutWrapper, {
            key: layout,
            isSelected: isSelected
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
            content: label,
            hideTooltipOnClick: true,
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($325a23a1c061fe45$var$ButtonStyled, {
            testId: `dashboard-edit.ui.header-editable.change-layout-button.layout-picker.label.${layout}`,
            id: `layout-${layout}`,
            role: "radio",
            appearance: "subtle",
            spacing: "default",
            isSelected: isSelected,
            "aria-checked": isSelected,
            onClick: ()=>onLayoutSelected(layout),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Layout, {
                label: label
            })
        })));
    }));
};
const $325a23a1c061fe45$var$pickerWrapperStyles = (0, $2s57o.xcss)({
    padding: 'space.050'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $325a23a1c061fe45$var$LayoutWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l",
            __cmplp.isSelected && "_7dirfg4m",
            __cmplp.className
        ])
    });
});
const $325a23a1c061fe45$var$ButtonStyled = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $cNW3X.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bg41i6y",
            __cmplp.className
        ])
    });
});

});
parcelRegister("d6hqU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1f586aab487d20d6e22a2b29e7419237>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98995bba0c9c03e0$var$_react = $98995bba0c9c03e0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $98995bba0c9c03e0$var$_layoutOneColumn = $98995bba0c9c03e0$var$_interopRequireDefault((parcelRequire("iyJrc")));

var $98995bba0c9c03e0$var$_layoutSingle = $98995bba0c9c03e0$var$_interopRequireDefault((parcelRequire("99WZA")));
function $98995bba0c9c03e0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LayoutOneColumnIcon.
 * This component is LayoutOneColumnIcon, with `UNSAFE_fallbackIcon` set to "EditorLayoutSingleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for single column layout option in Confluence Editor
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $98995bba0c9c03e0$var$LayoutOneColumnIcon = (props)=>/*#__PURE__*/ $98995bba0c9c03e0$var$_react.default.createElement($98995bba0c9c03e0$var$_layoutOneColumn.default, Object.assign({
        LEGACY_fallbackIcon: $98995bba0c9c03e0$var$_layoutSingle.default
    }, props));
$98995bba0c9c03e0$var$LayoutOneColumnIcon.Name = 'LayoutOneColumnIconMigration';
var $98995bba0c9c03e0$var$_default = module.exports.default = $98995bba0c9c03e0$var$LayoutOneColumnIcon;

});
parcelRegister("iyJrc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0360336c98ea038d04b80be960c396e8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d82ea5f03b560b74$var$_react = $d82ea5f03b560b74$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d82ea5f03b560b74$var$_baseNew = $d82ea5f03b560b74$var$_interopRequireDefault((parcelRequire("enEmH")));
function $d82ea5f03b560b74$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutOneColumn".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for single column layout option in Confluence Editor
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d82ea5f03b560b74$var$LayoutOneColumnIcon = (props)=>/*#__PURE__*/ $d82ea5f03b560b74$var$_react.default.createElement($d82ea5f03b560b74$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h13.25C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375H1.375C.615 15 0 14.384 0 13.625zm1.5.125v11h13v-11z" clip-rule="evenodd"/>`
    }, props));
$d82ea5f03b560b74$var$LayoutOneColumnIcon.displayName = 'LayoutOneColumnIcon';
var $d82ea5f03b560b74$var$_default = module.exports.default = $d82ea5f03b560b74$var$LayoutOneColumnIcon;

});

parcelRegister("99WZA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6ab2b6f6ecd4126b$var$_react = $6ab2b6f6ecd4126b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $6ab2b6f6ecd4126b$var$_layoutOneColumn = $6ab2b6f6ecd4126b$var$_interopRequireDefault((parcelRequire("iyJrc")));
function $6ab2b6f6ecd4126b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6ab2b6f6ecd4126b$var$EditorLayoutSingleIcon = (props)=>/*#__PURE__*/ $6ab2b6f6ecd4126b$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><rect width="16" height="14" x="4" y="5" fill="currentcolor" rx="2"/></svg>`
    }, props, {
        newIcon: $6ab2b6f6ecd4126b$var$_layoutOneColumn.default
    }));
$6ab2b6f6ecd4126b$var$EditorLayoutSingleIcon.displayName = 'EditorLayoutSingleIcon';
var $6ab2b6f6ecd4126b$var$_default = module.exports.default = $6ab2b6f6ecd4126b$var$EditorLayoutSingleIcon;

});


parcelRegister("iW22S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::72072af5b471c7bedc305a162ce95825>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dc8f3aeeebcdb45b$var$_react = $dc8f3aeeebcdb45b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $dc8f3aeeebcdb45b$var$_layoutThreeColumns = $dc8f3aeeebcdb45b$var$_interopRequireDefault((parcelRequire("4NTwe")));

var $dc8f3aeeebcdb45b$var$_layoutThreeEqual = $dc8f3aeeebcdb45b$var$_interopRequireDefault((parcelRequire("9R5Tn")));
function $dc8f3aeeebcdb45b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LayoutThreeColumnsIcon.
 * This component is LayoutThreeColumnsIcon, with `UNSAFE_fallbackIcon` set to "EditorLayoutThreeEqualIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 3 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dc8f3aeeebcdb45b$var$LayoutThreeColumnsIcon = (props)=>/*#__PURE__*/ $dc8f3aeeebcdb45b$var$_react.default.createElement($dc8f3aeeebcdb45b$var$_layoutThreeColumns.default, Object.assign({
        LEGACY_fallbackIcon: $dc8f3aeeebcdb45b$var$_layoutThreeEqual.default
    }, props));
$dc8f3aeeebcdb45b$var$LayoutThreeColumnsIcon.Name = 'LayoutThreeColumnsIconMigration';
var $dc8f3aeeebcdb45b$var$_default = module.exports.default = $dc8f3aeeebcdb45b$var$LayoutThreeColumnsIcon;

});
parcelRegister("4NTwe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::455753a667f20f1d7529d077b0a47e9b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $37f6cdeb24d51b67$var$_react = $37f6cdeb24d51b67$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $37f6cdeb24d51b67$var$_baseNew = $37f6cdeb24d51b67$var$_interopRequireDefault((parcelRequire("enEmH")));
function $37f6cdeb24d51b67$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutThreeColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 3 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $37f6cdeb24d51b67$var$LayoutThreeColumnsIcon = (props)=>/*#__PURE__*/ $37f6cdeb24d51b67$var$_react.default.createElement($37f6cdeb24d51b67$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h1.5c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.5C.615 15 0 14.384 0 13.625zm1.5.125v11h1.25v-11zm4.25-.125C5.75 1.615 6.366 1 7.125 1h1.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.75c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h1.5v-11zm4.5-.125c0-.76.616-1.375 1.375-1.375h1.5C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.5c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h1.25v-11z" clip-rule="evenodd"/>`
    }, props));
$37f6cdeb24d51b67$var$LayoutThreeColumnsIcon.displayName = 'LayoutThreeColumnsIcon';
var $37f6cdeb24d51b67$var$_default = module.exports.default = $37f6cdeb24d51b67$var$LayoutThreeColumnsIcon;

});

parcelRegister("9R5Tn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72cda255f3001329$var$_react = $72cda255f3001329$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $72cda255f3001329$var$_layoutThreeColumns = $72cda255f3001329$var$_interopRequireDefault((parcelRequire("4NTwe")));
function $72cda255f3001329$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $72cda255f3001329$var$EditorLayoutThreeEqualIcon = (props)=>/*#__PURE__*/ $72cda255f3001329$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 5h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m6 0h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m6 0h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $72cda255f3001329$var$_layoutThreeColumns.default
    }));
$72cda255f3001329$var$EditorLayoutThreeEqualIcon.displayName = 'EditorLayoutThreeEqualIcon';
var $72cda255f3001329$var$_default = module.exports.default = $72cda255f3001329$var$EditorLayoutThreeEqualIcon;

});


parcelRegister("28UdU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d5db5debf34e76a8ad809bb3a247e273>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $18f7f0ea2bb26e4c$var$_react = $18f7f0ea2bb26e4c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $18f7f0ea2bb26e4c$var$_layoutTwoColumns = $18f7f0ea2bb26e4c$var$_interopRequireDefault((parcelRequire("esj8L")));

var $18f7f0ea2bb26e4c$var$_layoutTwoEqual = $18f7f0ea2bb26e4c$var$_interopRequireDefault((parcelRequire("9fsbk")));
function $18f7f0ea2bb26e4c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LayoutTwoColumnsIcon.
 * This component is LayoutTwoColumnsIcon, with `UNSAFE_fallbackIcon` set to "EditorLayoutTwoEqualIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $18f7f0ea2bb26e4c$var$LayoutTwoColumnsIcon = (props)=>/*#__PURE__*/ $18f7f0ea2bb26e4c$var$_react.default.createElement($18f7f0ea2bb26e4c$var$_layoutTwoColumns.default, Object.assign({
        LEGACY_fallbackIcon: $18f7f0ea2bb26e4c$var$_layoutTwoEqual.default
    }, props));
$18f7f0ea2bb26e4c$var$LayoutTwoColumnsIcon.Name = 'LayoutTwoColumnsIconMigration';
var $18f7f0ea2bb26e4c$var$_default = module.exports.default = $18f7f0ea2bb26e4c$var$LayoutTwoColumnsIcon;

});
parcelRegister("esj8L", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7a49c5b5418c2c6666b4305c3541f252>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a8628711000fef67$var$_react = $a8628711000fef67$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a8628711000fef67$var$_baseNew = $a8628711000fef67$var$_interopRequireDefault((parcelRequire("enEmH")));
function $a8628711000fef67$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutTwoColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a8628711000fef67$var$LayoutTwoColumnsIcon = (props)=>/*#__PURE__*/ $a8628711000fef67$var$_react.default.createElement($a8628711000fef67$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h4.5c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-4.5C.615 15 0 14.384 0 13.625zm1.5.125v11h4.25v-11zm7.25-.125c0-.76.616-1.375 1.375-1.375h4.5C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-4.5c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h4.25v-11z" clip-rule="evenodd"/>`
    }, props));
$a8628711000fef67$var$LayoutTwoColumnsIcon.displayName = 'LayoutTwoColumnsIcon';
var $a8628711000fef67$var$_default = module.exports.default = $a8628711000fef67$var$LayoutTwoColumnsIcon;

});

parcelRegister("9fsbk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6bbb60143640371b$var$_react = $6bbb60143640371b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $6bbb60143640371b$var$_layoutTwoColumns = $6bbb60143640371b$var$_interopRequireDefault((parcelRequire("esj8L")));
function $6bbb60143640371b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6bbb60143640371b$var$EditorLayoutTwoEqualIcon = (props)=>/*#__PURE__*/ $6bbb60143640371b$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 5h5a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m9 0h5a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $6bbb60143640371b$var$_layoutTwoColumns.default
    }));
$6bbb60143640371b$var$EditorLayoutTwoEqualIcon.displayName = 'EditorLayoutTwoEqualIcon';
var $6bbb60143640371b$var$_default = module.exports.default = $6bbb60143640371b$var$EditorLayoutTwoEqualIcon;

});


parcelRegister("gyYew", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aedd54f602e796866e525a13110f0fee>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c0ee8b630d2b6f48$var$_react = $c0ee8b630d2b6f48$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c0ee8b630d2b6f48$var$_layoutTwoColumnsSidebarLeft = $c0ee8b630d2b6f48$var$_interopRequireDefault((parcelRequire("7J7Ch")));

var $c0ee8b630d2b6f48$var$_layoutTwoLeftSidebar = $c0ee8b630d2b6f48$var$_interopRequireDefault((parcelRequire("59lZ7")));
function $c0ee8b630d2b6f48$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LayoutTwoColumnsSidebarLeftIcon.
 * This component is LayoutTwoColumnsSidebarLeftIcon, with `UNSAFE_fallbackIcon` set to "EditorLayoutTwoLeftSidebarIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout with left sidebar option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c0ee8b630d2b6f48$var$LayoutTwoColumnsSidebarLeftIcon = (props)=>/*#__PURE__*/ $c0ee8b630d2b6f48$var$_react.default.createElement($c0ee8b630d2b6f48$var$_layoutTwoColumnsSidebarLeft.default, Object.assign({
        LEGACY_fallbackIcon: $c0ee8b630d2b6f48$var$_layoutTwoLeftSidebar.default
    }, props));
$c0ee8b630d2b6f48$var$LayoutTwoColumnsSidebarLeftIcon.Name = 'LayoutTwoColumnsSidebarLeftIconMigration';
var $c0ee8b630d2b6f48$var$_default = module.exports.default = $c0ee8b630d2b6f48$var$LayoutTwoColumnsSidebarLeftIcon;

});
parcelRegister("7J7Ch", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe9a089e1f04f18f538500f4f4d79587>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0173a7d1dc51f0b2$var$_react = $0173a7d1dc51f0b2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0173a7d1dc51f0b2$var$_baseNew = $0173a7d1dc51f0b2$var$_interopRequireDefault((parcelRequire("enEmH")));
function $0173a7d1dc51f0b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutTwoColumnsSidebarLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout with left sidebar option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0173a7d1dc51f0b2$var$LayoutTwoColumnsSidebarLeftIcon = (props)=>/*#__PURE__*/ $0173a7d1dc51f0b2$var$_react.default.createElement($0173a7d1dc51f0b2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 2.375C16 1.615 15.384 1 14.625 1h-7.75C6.115 1 5.5 1.616 5.5 2.375v11.25c0 .76.616 1.375 1.375 1.375h7.75c.76 0 1.375-.616 1.375-1.375zm-1.5.125v11H7v-11zM4 2.375C4 1.615 3.384 1 2.625 1h-1.25C.615 1 0 1.616 0 2.375v11.25C0 14.385.616 15 1.375 15h1.25C3.385 15 4 14.384 4 13.625zM2.5 2.5v11h-1v-11z" clip-rule="evenodd"/>`
    }, props));
$0173a7d1dc51f0b2$var$LayoutTwoColumnsSidebarLeftIcon.displayName = 'LayoutTwoColumnsSidebarLeftIcon';
var $0173a7d1dc51f0b2$var$_default = module.exports.default = $0173a7d1dc51f0b2$var$LayoutTwoColumnsSidebarLeftIcon;

});

parcelRegister("59lZ7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3bfed8bdf488fdaa$var$_react = $3bfed8bdf488fdaa$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $3bfed8bdf488fdaa$var$_layoutTwoColumnsSidebarLeft = $3bfed8bdf488fdaa$var$_interopRequireDefault((parcelRequire("7J7Ch")));
function $3bfed8bdf488fdaa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3bfed8bdf488fdaa$var$EditorLayoutTwoLeftSidebarIcon = (props)=>/*#__PURE__*/ $3bfed8bdf488fdaa$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 5h1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m5 0h9a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $3bfed8bdf488fdaa$var$_layoutTwoColumnsSidebarLeft.default
    }));
$3bfed8bdf488fdaa$var$EditorLayoutTwoLeftSidebarIcon.displayName = 'EditorLayoutTwoLeftSidebarIcon';
var $3bfed8bdf488fdaa$var$_default = module.exports.default = $3bfed8bdf488fdaa$var$EditorLayoutTwoLeftSidebarIcon;

});


parcelRegister("7Rki7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16d8f088b3cf358ca06914d223f9660a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5b8d3911bd865660$var$_react = $5b8d3911bd865660$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5b8d3911bd865660$var$_layoutTwoColumnsSidebarRight = $5b8d3911bd865660$var$_interopRequireDefault((parcelRequire("dNaXV")));

var $5b8d3911bd865660$var$_layoutTwoRightSidebar = $5b8d3911bd865660$var$_interopRequireDefault((parcelRequire("50W7u")));
function $5b8d3911bd865660$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LayoutTwoColumnsSidebarRightIcon.
 * This component is LayoutTwoColumnsSidebarRightIcon, with `UNSAFE_fallbackIcon` set to "EditorLayoutTwoRightSidebarIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout with right sidebar option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5b8d3911bd865660$var$LayoutTwoColumnsSidebarRightIcon = (props)=>/*#__PURE__*/ $5b8d3911bd865660$var$_react.default.createElement($5b8d3911bd865660$var$_layoutTwoColumnsSidebarRight.default, Object.assign({
        LEGACY_fallbackIcon: $5b8d3911bd865660$var$_layoutTwoRightSidebar.default
    }, props));
$5b8d3911bd865660$var$LayoutTwoColumnsSidebarRightIcon.Name = 'LayoutTwoColumnsSidebarRightIconMigration';
var $5b8d3911bd865660$var$_default = module.exports.default = $5b8d3911bd865660$var$LayoutTwoColumnsSidebarRightIcon;

});
parcelRegister("dNaXV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d35efc77637aa314c1c299bca57a138a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a0a85b7ec0c0e197$var$_react = $a0a85b7ec0c0e197$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a0a85b7ec0c0e197$var$_baseNew = $a0a85b7ec0c0e197$var$_interopRequireDefault((parcelRequire("enEmH")));
function $a0a85b7ec0c0e197$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutTwoColumnsSidebarRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout with right sidebar option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a0a85b7ec0c0e197$var$LayoutTwoColumnsSidebarRightIcon = (props)=>/*#__PURE__*/ $a0a85b7ec0c0e197$var$_react.default.createElement($a0a85b7ec0c0e197$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h7.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-7.75C.615 15 0 14.384 0 13.625zm1.5.125v11H9v-11zM12 2.375C12 1.615 12.616 1 13.375 1h1.25C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.25c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h1v-11z" clip-rule="evenodd"/>`
    }, props));
$a0a85b7ec0c0e197$var$LayoutTwoColumnsSidebarRightIcon.displayName = 'LayoutTwoColumnsSidebarRightIcon';
var $a0a85b7ec0c0e197$var$_default = module.exports.default = $a0a85b7ec0c0e197$var$LayoutTwoColumnsSidebarRightIcon;

});

parcelRegister("50W7u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a6a093d4d49e9d0$var$_react = $3a6a093d4d49e9d0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $3a6a093d4d49e9d0$var$_layoutTwoColumnsSidebarRight = $3a6a093d4d49e9d0$var$_interopRequireDefault((parcelRequire("dNaXV")));
function $3a6a093d4d49e9d0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3a6a093d4d49e9d0$var$EditorLayoutTwoRightSidebarIcon = (props)=>/*#__PURE__*/ $3a6a093d4d49e9d0$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M18 5h1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1M5 5h9a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $3a6a093d4d49e9d0$var$_layoutTwoColumnsSidebarRight.default
    }));
$3a6a093d4d49e9d0$var$EditorLayoutTwoRightSidebarIcon.displayName = 'EditorLayoutTwoRightSidebarIcon';
var $3a6a093d4d49e9d0$var$_default = module.exports.default = $3a6a093d4d49e9d0$var$EditorLayoutTwoRightSidebarIcon;

});


parcelRegister("jPb9c", function(module, exports) {

$parcel$export(module.exports, "default", () => $564d95df49a37670$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $564d95df49a37670$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    oneColumn: {
        "id": "dashboard-edit.header-editable.change-layout-button.layout-picker.one-column",
        "defaultMessage": "One column"
    },
    twoColumns: {
        "id": "dashboard-edit.header-editable.change-layout-button.layout-picker.two-columns",
        "defaultMessage": "Two columns"
    },
    threeColumns: {
        "id": "dashboard-edit.header-editable.change-layout-button.layout-picker.three-columns",
        "defaultMessage": "Three columns"
    },
    leftSidebar: {
        "id": "dashboard-edit.header-editable.change-layout-button.layout-picker.left-sidebar",
        "defaultMessage": "Left sidebar"
    },
    rightSidebar: {
        "id": "dashboard-edit.header-editable.change-layout-button.layout-picker.right-sidebar",
        "defaultMessage": "Right sidebar"
    }
});

});


parcelRegister("lGD0O", function(module, exports) {

$parcel$export(module.exports, "default", () => $608d314fb191503b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $608d314fb191503b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "dashboard-edit.header-editable.change-layout-button.title",
        "defaultMessage": "Change layout"
    }
});

});


parcelRegister("j2vUH", function(module, exports) {

$parcel$export(module.exports, "default", () => $745fb374d564170e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $745fb374d564170e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    done: {
        "id": "dashboard-edit.header-editable.done",
        "defaultMessage": "Done"
    }
});

});


parcelRegister("c92ZE", function(module, exports) {

$parcel$export(module.exports, "ColumnPlaceholder", () => $d55f4cd547a10456$export$f0705bf8199f32ef);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $eWkgo = parcelRequire("eWkgo");
var $2s57o = parcelRequire("2s57o");

var $JIPqS = parcelRequire("JIPqS");

var $5HxxK = parcelRequire("5HxxK");

var $4Bpvs = parcelRequire("4Bpvs");

var $koVbs = parcelRequire("koVbs");


var $jaPSU = parcelRequire("jaPSU");

var $NMMas = parcelRequire("NMMas");
const $d55f4cd547a10456$var$GadgetPlaceholder = ({ isDraggingOver: isDraggingOver, columnIndex: columnIndex })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const heightRef = (0, $5uXOq.useRef)(null);
    const [height, setHeight] = (0, $5uXOq.useState)();
    // We want the placeholder to take up the rest of the remaining visible space
    // in the column, which we can't really do with CSS, so we'll calculate what
    // the height should be with JavaScript.
    (0, $5uXOq.useEffect)(()=>{
        if (!heightRef.current) return;
        const distanceFromTopOfWindow = heightRef.current.getBoundingClientRect().top;
        setHeight(`calc(100vh - ${distanceFromTopOfWindow}px - ${(0, $JIPqS.FOOTER_MARGIN)}px)`);
    }, [
        heightRef
    ]);
    return(// According to https://hello.atlassian.net/wiki/spaces/AF/pages/2630143294/CSS+and+Styling+Components
    // this is the correct way to handle styles that can't be known ahead of time
    // eslint-disable-next-line jira/react/no-style-attribute
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: heightRef,
        style: {
            height: height
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        direction: "column",
        justifyContent: "center",
        alignItems: "center",
        xcss: [
            $d55f4cd547a10456$var$wrapperStyles,
            isDraggingOver ? $d55f4cd547a10456$var$draggingStyles : $d55f4cd547a10456$var$notDraggingStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d55f4cd547a10456$var$imageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Bpvs.default), {
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d55f4cd547a10456$var$contentStyles
    }, formatMessage((0, $NMMas.default).description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jaPSU.AddGadgetButton), {
        buttonType: (0, $324eda6c4db64a18$export$e9a9f8a43cd26ad7),
        columnIndex: columnIndex
    })))));
};
const $d55f4cd547a10456$export$f0705bf8199f32ef = ({ customHeight: customHeight })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5HxxK.ColumnPlaceholderContextConsumer), null, (placeholderProps)=>placeholderProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d55f4cd547a10456$var$GadgetPlaceholder, {
            ...placeholderProps,
            customHeight: customHeight
        }));
const $d55f4cd547a10456$var$wrapperStyles = (0, $2s57o.xcss)({
    height: '100%',
    minHeight: '400px',
    marginBottom: 'space.200',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    border: `dashed ${"var(--ds-border-bold, #758195)"} 1px`,
    borderRadius: 'border.radius.050',
    transition: 'background-color 0.2s ease'
});
const $d55f4cd547a10456$var$notDraggingStyles = (0, $2s57o.xcss)({
    background: "var(--ds-background-input, #FFFFFF)"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
const $d55f4cd547a10456$var$draggingStyles = (0, $2s57o.xcss)({
    background: "var(--ds-background-input-hovered, #F7F8F9)"
});
const $d55f4cd547a10456$var$contentStyles = (0, $2s57o.xcss)({
    whiteSpace: 'pre-wrap',
    textAlign: 'center',
    marginTop: 'space.200',
    color: 'color.text.subtlest'
});
const $d55f4cd547a10456$var$imageStyles = (0, $2s57o.xcss)({
    width: '112px',
    marginInline: 'auto'
});

});
parcelRegister("NMMas", function(module, exports) {

$parcel$export(module.exports, "default", () => $504fdc54c0343192$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $504fdc54c0343192$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    description: {
        "id": "dashboard-edit.placeholder.description",
        "defaultMessage": "Drag a gadget to this column or "
    }
});

});


parcelRegister("hsZLS", function(module, exports) {

$parcel$export(module.exports, "useLayoutChangeErrorFlag", () => $6fa515ca378d1a90$export$c213d29262fac822);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $7HGHK = parcelRequire("7HGHK");

var $qFl2H = parcelRequire("qFl2H");
const $6fa515ca378d1a90$export$c213d29262fac822 = ()=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    return (0, $5uXOq.useCallback)(()=>{
        showFlag({
            key: (0, $7HGHK.toFlagId)('layoutChangeError'),
            type: 'error',
            title: (0, $qFl2H.default).changeLayoutErrorFlagTitle,
            description: (0, $qFl2H.default).changeLayoutErrorFlagDescription,
            messageId: 'dashboard-edit.utils.change-layout-error.show-flag.error',
            messageType: 'transactional',
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            actions: [
                {
                    content: (0, $qFl2H.default).errorFlagAction,
                    onClick: ()=>window.location.reload()
                }
            ]
        });
    }, [
        showFlag
    ]);
};

});
parcelRegister("qFl2H", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5183843c1b01a1c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a5183843c1b01a1c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    changeLayoutErrorFlagTitle: {
        "id": "dashboard-edit.utils.change-layout-error.change-layout-error-flag-title",
        "defaultMessage": "Error"
    },
    changeLayoutErrorFlagDescription: {
        "id": "dashboard-edit.utils.change-layout-error.change-layout-error-flag-description",
        "defaultMessage": "Failed to save layout, please refresh the page"
    },
    errorFlagAction: {
        "id": "dashboard-edit.utils.change-layout-error.error-flag-action",
        "defaultMessage": "Refresh"
    }
});

});




//# sourceMappingURL=dashboard-edit-entrypoint.1e6e09ba.js.map
